//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const CONFIGURATION_SERVICE_BASE_URL = new InjectionToken<string>('CONFIGURATION_SERVICE_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class WifiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllWifis(onlyNotAssignedToAService: boolean | undefined): Observable<WifiDto[]> {
        let url_ = this.baseUrl + "/api/v1/Wifi?";
        if (onlyNotAssignedToAService === null)
            throw new globalThis.Error("The parameter 'onlyNotAssignedToAService' cannot be null.");
        else if (onlyNotAssignedToAService !== undefined)
            url_ += "onlyNotAssignedToAService=" + encodeURIComponent("" + onlyNotAssignedToAService) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWifis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWifis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiDto[]>;
        }));
    }

    protected processGetAllWifis(response: HttpResponseBase): Observable<WifiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WifiDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createWifi(wifi: WifiInputDto): Observable<WifiDto> {
        let url_ = this.baseUrl + "/api/v1/Wifi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wifi);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWifi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWifi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiDto>;
        }));
    }

    protected processCreateWifi(response: HttpResponseBase): Observable<WifiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WifiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWifiForService(serviceId: string): Observable<WifiWithSubscriptionCountDto> {
        let url_ = this.baseUrl + "/api/v1/Wifi/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWifiForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWifiForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiWithSubscriptionCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiWithSubscriptionCountDto>;
        }));
    }

    protected processGetWifiForService(response: HttpResponseBase): Observable<WifiWithSubscriptionCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WifiWithSubscriptionCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWifi(wifiId: string): Observable<WifiDto> {
        let url_ = this.baseUrl + "/api/v1/Wifi/{wifiId}";
        if (wifiId === undefined || wifiId === null)
            throw new globalThis.Error("The parameter 'wifiId' must be defined.");
        url_ = url_.replace("{wifiId}", encodeURIComponent("" + wifiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWifi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWifi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiDto>;
        }));
    }

    protected processGetWifi(response: HttpResponseBase): Observable<WifiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WifiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateWifi(wifiId: string, wifi: WifiInputDto): Observable<WifiDto> {
        let url_ = this.baseUrl + "/api/v1/Wifi/{wifiId}";
        if (wifiId === undefined || wifiId === null)
            throw new globalThis.Error("The parameter 'wifiId' must be defined.");
        url_ = url_.replace("{wifiId}", encodeURIComponent("" + wifiId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wifi);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWifi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWifi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiDto>;
        }));
    }

    protected processUpdateWifi(response: HttpResponseBase): Observable<WifiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WifiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteWifi(wifiId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Wifi/{wifiId}";
        if (wifiId === undefined || wifiId === null)
            throw new globalThis.Error("The parameter 'wifiId' must be defined.");
        url_ = url_.replace("{wifiId}", encodeURIComponent("" + wifiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWifi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWifi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWifi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignWifiToService(serviceId: string, wifiId: string): Observable<WifiWithSubscriptionCountDto> {
        let url_ = this.baseUrl + "/api/v1/Wifi/for-service/{serviceId}/{wifiId}/assign-to-service";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (wifiId === undefined || wifiId === null)
            throw new globalThis.Error("The parameter 'wifiId' must be defined.");
        url_ = url_.replace("{wifiId}", encodeURIComponent("" + wifiId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignWifiToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignWifiToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiWithSubscriptionCountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiWithSubscriptionCountDto>;
        }));
    }

    protected processAssignWifiToService(response: HttpResponseBase): Observable<WifiWithSubscriptionCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WifiWithSubscriptionCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WifiSubscriptionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchSubscriptions(serviceId: string, pageableRequestDto: PageableRequestDtoOfWifiSubscriptionSearchCriteriaDto): Observable<PagedResultDtoOfWifiSubscriptionDto> {
        let url_ = this.baseUrl + "/api/v1/WifiSubscription/for-service/{serviceId}/search";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWifiSubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWifiSubscriptionDto>;
        }));
    }

    protected processSearchSubscriptions(response: HttpResponseBase): Observable<PagedResultDtoOfWifiSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWifiSubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySubscriptions(): Observable<WifiSubscriptionWithAuthenticationDto[]> {
        let url_ = this.baseUrl + "/api/v1/WifiSubscription/my-subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WifiSubscriptionWithAuthenticationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WifiSubscriptionWithAuthenticationDto[]>;
        }));
    }

    protected processGetMySubscriptions(response: HttpResponseBase): Observable<WifiSubscriptionWithAuthenticationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WifiSubscriptionWithAuthenticationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disableSubscription(serviceId: string, subscriptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/WifiSubscription/for-service/{serviceId}/{subscriptionId}/disable";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyCurrentOrNextSubscription(serviceId: string): Observable<MyServicesNextEntryDto> {
        let url_ = this.baseUrl + "/api/v1/WifiSubscription/my-next-subscription";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyCurrentOrNextSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCurrentOrNextSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyServicesNextEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyServicesNextEntryDto>;
        }));
    }

    protected processGetMyCurrentOrNextSubscription(response: HttpResponseBase): Observable<MyServicesNextEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyServicesNextEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WebcamService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWebcamById(webcamId: string): Observable<WebcamDto> {
        let url_ = this.baseUrl + "/api/v1/Webcam/{webcamId}";
        if (webcamId === undefined || webcamId === null)
            throw new globalThis.Error("The parameter 'webcamId' must be defined.");
        url_ = url_.replace("{webcamId}", encodeURIComponent("" + webcamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebcamById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebcamById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebcamDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebcamDto>;
        }));
    }

    protected processGetWebcamById(response: HttpResponseBase): Observable<WebcamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebcamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteWebcam(webcamId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Webcam/{webcamId}";
        if (webcamId === undefined || webcamId === null)
            throw new globalThis.Error("The parameter 'webcamId' must be defined.");
        url_ = url_.replace("{webcamId}", encodeURIComponent("" + webcamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWebcam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWebcam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWebcam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWebcamsByServiceId(serviceId: string): Observable<WebcamDto[]> {
        let url_ = this.baseUrl + "/api/v1/Webcam/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWebcamsByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWebcamsByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebcamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebcamDto[]>;
        }));
    }

    protected processGetWebcamsByServiceId(response: HttpResponseBase): Observable<WebcamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebcamDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveWebcamsByServiceId(serviceId: string): Observable<WebcamDto[]> {
        let url_ = this.baseUrl + "/api/v1/Webcam/public/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveWebcamsByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveWebcamsByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebcamDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebcamDto[]>;
        }));
    }

    protected processGetActiveWebcamsByServiceId(response: HttpResponseBase): Observable<WebcamDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebcamDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createWebcam(webcamDto: WebcamDto): Observable<WebcamDto> {
        let url_ = this.baseUrl + "/api/v1/Webcam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webcamDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWebcam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWebcam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebcamDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebcamDto>;
        }));
    }

    protected processCreateWebcam(response: HttpResponseBase): Observable<WebcamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebcamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateWebcam(serviceId: string, webcamId: string, webcamDto: WebcamDto): Observable<WebcamDto> {
        let url_ = this.baseUrl + "/api/v1/Webcam/for-service/{serviceId}/{webcamId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (webcamId === undefined || webcamId === null)
            throw new globalThis.Error("The parameter 'webcamId' must be defined.");
        url_ = url_.replace("{webcamId}", encodeURIComponent("" + webcamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webcamDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWebcam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWebcam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebcamDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebcamDto>;
        }));
    }

    protected processUpdateWebcam(response: HttpResponseBase): Observable<WebcamDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebcamDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateWebcam(serviceId: string, webcamId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Webcam/for-service/{serviceId}/{webcamId}/activate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (webcamId === undefined || webcamId === null)
            throw new globalThis.Error("The parameter 'webcamId' must be defined.");
        url_ = url_.replace("{webcamId}", encodeURIComponent("" + webcamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateWebcam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateWebcam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateWebcam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateWebcam(serviceId: string, webcamId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Webcam/for-service/{serviceId}/{webcamId}/deactivate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (webcamId === undefined || webcamId === null)
            throw new globalThis.Error("The parameter 'webcamId' must be defined.");
        url_ = url_.replace("{webcamId}", encodeURIComponent("" + webcamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateWebcam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateWebcam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateWebcam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    orderWebcams(serviceId: string, webcamOrderDtos: OrderDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Webcam/for-service/{serviceId}/order";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(webcamOrderDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderWebcams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderWebcams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderWebcams(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeatherService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWeatherData(measuringPointId: string): Observable<WeatherDataDto> {
        let url_ = this.baseUrl + "/api/v1/Weather/public/weather/{measuringPointId}";
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeatherData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeatherData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeatherDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeatherDataDto>;
        }));
    }

    protected processGetWeatherData(response: HttpResponseBase): Observable<WeatherDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeatherDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DumpsterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDumpsters(): Observable<DumpsterDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dumpster";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDumpsters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDumpsters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DumpsterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DumpsterDto[]>;
        }));
    }

    protected processGetDumpsters(response: HttpResponseBase): Observable<DumpsterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DumpsterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createDumpster(dumpsterInputDto: DumpsterInputDto): Observable<DumpsterDto> {
        let url_ = this.baseUrl + "/api/v1/Dumpster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dumpsterInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DumpsterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DumpsterDto>;
        }));
    }

    protected processCreateDumpster(response: HttpResponseBase): Observable<DumpsterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DumpsterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDumpstersByServiceId(serviceId: string): Observable<DumpsterDto[]> {
        let url_ = this.baseUrl + "/api/v1/Dumpster/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDumpstersByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDumpstersByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DumpsterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DumpsterDto[]>;
        }));
    }

    protected processGetDumpstersByServiceId(response: HttpResponseBase): Observable<DumpsterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DumpsterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDumpster(dumpsterId: string, dumpsterUpdateDto: DumpsterUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Dumpster/{dumpsterId}";
        if (dumpsterId === undefined || dumpsterId === null)
            throw new globalThis.Error("The parameter 'dumpsterId' must be defined.");
        url_ = url_.replace("{dumpsterId}", encodeURIComponent("" + dumpsterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dumpsterUpdateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDumpster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDumpster(dumpsterId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Dumpster/{dumpsterId}";
        if (dumpsterId === undefined || dumpsterId === null)
            throw new globalThis.Error("The parameter 'dumpsterId' must be defined.");
        url_ = url_.replace("{dumpsterId}", encodeURIComponent("" + dumpsterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDumpster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    canCustomerActivateDumpster(dumpsterId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Dumpster/{dumpsterId}/can-be-activated";
        if (dumpsterId === undefined || dumpsterId === null)
            throw new globalThis.Error("The parameter 'dumpsterId' must be defined.");
        url_ = url_.replace("{dumpsterId}", encodeURIComponent("" + dumpsterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanCustomerActivateDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanCustomerActivateDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCanCustomerActivateDumpster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateDumpster(dumpsterId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Dumpster/{dumpsterId}/activate";
        if (dumpsterId === undefined || dumpsterId === null)
            throw new globalThis.Error("The parameter 'dumpsterId' must be defined.");
        url_ = url_.replace("{dumpsterId}", encodeURIComponent("" + dumpsterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDumpster(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WasteManagementService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    exportStatistics(serviceId: string, criteria: FalconicStatisticExportCriteriaDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/WasteManagement/for-service/{serviceId}/statistics/export";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportStatistics(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    fullSearchTransactions(pageableRequestDto: PageableRequestDtoOfTransactionFullSearchInputCriteriaDto): Observable<PagedResultDtoOfTransactionFullSearchOutputDto> {
        let url_ = this.baseUrl + "/api/v1/Transaction/search/full";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFullSearchTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFullSearchTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTransactionFullSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTransactionFullSearchOutputDto>;
        }));
    }

    protected processFullSearchTransactions(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionFullSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTransactionFullSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTransactions(pageableRequestDto: PageableRequestDtoOfTransactionCriteriaDto): Observable<PagedTransactionsResultDto> {
        let url_ = this.baseUrl + "/api/v1/Transaction/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedTransactionsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedTransactionsResultDto>;
        }));
    }

    protected processSearchTransactions(response: HttpResponseBase): Observable<PagedTransactionsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedTransactionsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchMyTransactions(pageableRequestDto: PageableRequestDtoOfTransactionCriteriaDto): Observable<PagedTransactionsResultDto> {
        let url_ = this.baseUrl + "/api/v1/Transaction/search/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMyTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMyTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedTransactionsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedTransactionsResultDto>;
        }));
    }

    protected processSearchMyTransactions(response: HttpResponseBase): Observable<PagedTransactionsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedTransactionsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEwalletsCumulativeBalance(): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Transaction/sum-ewallet-balances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEwalletsCumulativeBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEwalletsCumulativeBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetEwalletsCumulativeBalance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCumulativeTotalTransactions(criteraDto: DatetimeTransactionCriteraDto): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Transaction/sum-transactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteraDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCumulativeTotalTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCumulativeTotalTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCumulativeTotalTransactions(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCashierTransaction(transactionInputDto: CashierTransactionInputDto): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/v1/Transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transactionInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCashierTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCashierTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processCreateCashierTransaction(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importTransactions(file: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Transaction/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportTransactions(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportTransactions(type: TransactionType | undefined, exportFileFormat: FileFormat | undefined, criteria: TransactionCriteriaDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Transaction/export?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (exportFileFormat === null)
            throw new globalThis.Error("The parameter 'exportFileFormat' cannot be null.");
        else if (exportFileFormat !== undefined)
            url_ += "exportFileFormat=" + encodeURIComponent("" + exportFileFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportTransactions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateTransactionReceipt(transactionId: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Transaction/receipt?";
        if (transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTransactionReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTransactionReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateTransactionReceipt(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TariffService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTariffForServiceAndCustomer(serviceId: string, customerId: string): Observable<TariffDto> {
        let url_ = this.baseUrl + "/api/v1/Tariff/for-service/{serviceId}/for-customer/{customerId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTariffForServiceAndCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTariffForServiceAndCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TariffDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TariffDto>;
        }));
    }

    protected processGetTariffForServiceAndCustomer(response: HttpResponseBase): Observable<TariffDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TariffDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTariffsForService(serviceId: string): Observable<TariffDto[]> {
        let url_ = this.baseUrl + "/api/v1/Tariff/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTariffsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTariffsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TariffDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TariffDto[]>;
        }));
    }

    protected processGetTariffsForService(response: HttpResponseBase): Observable<TariffDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TariffDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTariff(serviceId: string, tariffInputDto: TariffInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Tariff/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tariffInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTariff(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTariff(serviceId: string, id: string, tariffInputDto: TariffInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Tariff/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tariffInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTariff(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTariff(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Tariff/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTariff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTariff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTariff(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SurveyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<SurveyLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Survey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLightDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveyLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSurvey(surveyInputDto: SurveyInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Survey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateSurvey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSurvey(surveyId: string): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSurvey(surveyId: string, surveyInputDto: SurveyInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSurvey(surveyId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishSurvey(surveyId: string, surveyPublishInputDto: SurveyPublishInputDto): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/v1/Survey/publish/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyPublishInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processPublishSurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadIllustration(surveyId: string, image: FileParameter | null | undefined): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}/image";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadIllustration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadIllustration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processUploadIllustration(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentToSurvey(surveyId: string, title: string | null | undefined, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}/document";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDocumentToSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(surveyId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}/document";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDocument(surveyId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}/document/{documentId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocument(surveyId: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/{surveyId}/document/{documentId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    orderSurveys(orderDtos: OrderDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderSurveys(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllActive(): Observable<SurveyLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Survey/my-surveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLightDto[]>;
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<SurveyLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySurvey(surveyId: string): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/v1/Survey/my-surveys/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetMySurvey(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySurveyDocuments(surveyId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Survey/my-surveys/{surveyId}/document";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySurveyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySurveyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetMySurveyDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadMySurveyDocument(surveyId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Survey/my-surveys/{surveyId}/document/{documentId}";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMySurveyDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMySurveyDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMySurveyDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addReadStatus(surveyId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Survey/my-surveys/{surveyId}/read";
        if (surveyId === undefined || surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddReadStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatisticsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    serviceHourlyUsageByDaysOfWeek(inputDto: ServiceStatisticsInputDto): Observable<ServiceHourlyUsageByDaysOfWeekDto> {
        let url_ = this.baseUrl + "/api/v1/Statistics/services/transactions/hourly-usage-by-days-of-week";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceHourlyUsageByDaysOfWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceHourlyUsageByDaysOfWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceHourlyUsageByDaysOfWeekDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceHourlyUsageByDaysOfWeekDto>;
        }));
    }

    protected processServiceHourlyUsageByDaysOfWeek(response: HttpResponseBase): Observable<ServiceHourlyUsageByDaysOfWeekDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceHourlyUsageByDaysOfWeekDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SiteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSites(): Observable<SiteDto[]> {
        let url_ = this.baseUrl + "/api/v1/Site";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteDto[]>;
        }));
    }

    protected processGetSites(response: HttpResponseBase): Observable<SiteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSite(siteInputDto: SiteInputDto): Observable<SiteDto> {
        let url_ = this.baseUrl + "/api/v1/Site";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteDto>;
        }));
    }

    protected processCreateSite(response: HttpResponseBase): Observable<SiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSite(siteId: string, siteUpdateInputDto: SiteUpdateInputDto): Observable<SiteDto> {
        let url_ = this.baseUrl + "/api/v1/Site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(siteUpdateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteDto>;
        }));
    }

    protected processUpdateSite(response: HttpResponseBase): Observable<SiteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSite(siteId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllServicesByCategory(): Observable<ServiceCategoryWithServicesDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/public/by-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServicesByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServicesByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryWithServicesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryWithServicesDto[]>;
        }));
    }

    protected processGetAllServicesByCategory(response: HttpResponseBase): Observable<ServiceCategoryWithServicesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCategoryWithServicesDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getService(serviceId: string): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/v1/Service/public/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processGetService(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllServices(): Observable<ServiceLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLightDto[]>;
        }));
    }

    protected processGetAllServices(response: HttpResponseBase): Observable<ServiceLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyServices(): Observable<MyServiceDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/my-services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyServiceDto[]>;
        }));
    }

    protected processGetMyServices(response: HttpResponseBase): Observable<MyServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MyServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceNames(): Observable<ServiceLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/service-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLightDto[]>;
        }));
    }

    protected processGetServiceNames(response: HttpResponseBase): Observable<ServiceLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getServiceNamesForServiceType(serviceType: ServiceType): Observable<ServiceLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/service-names/{serviceType}";
        if (serviceType === undefined || serviceType === null)
            throw new globalThis.Error("The parameter 'serviceType' must be defined.");
        url_ = url_.replace("{serviceType}", encodeURIComponent("" + serviceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceNamesForServiceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceNamesForServiceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLightDto[]>;
        }));
    }

    protected processGetServiceNamesForServiceType(response: HttpResponseBase): Observable<ServiceLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExploitantCandidates(): Observable<BackofficeLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Service/exploitant-candidates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExploitantCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExploitantCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeLightDto[]>;
        }));
    }

    protected processGetExploitantCandidates(response: HttpResponseBase): Observable<BackofficeLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackofficeLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createService(input: ServiceInputDto): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/v1/Service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processCreateService(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteService(serviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateService(serviceId: string, input: ServiceInputDto): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/v1/Service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processUpdateService(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    orderServices(orderDtos: OrderDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Service/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderServices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadServiceImage(serviceId: string, imageFile: FileParameter | null | undefined): Observable<ServiceImageDto> {
        let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/image";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadServiceImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadServiceImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceImageDto>;
        }));
    }

    protected processUploadServiceImage(response: HttpResponseBase): Observable<ServiceImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAvailabilitiesForDumpster(deviceId: string | undefined): Observable<KocoAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/v1/ServiceInfo/waste/availabilities?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailabilitiesForDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailabilitiesForDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KocoAvailabilityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KocoAvailabilityDto[]>;
        }));
    }

    protected processGetAvailabilitiesForDumpster(response: HttpResponseBase): Observable<KocoAvailabilityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KocoAvailabilityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWhitelistedUsersForDumpster(deviceId: string | undefined, pageableRequestDto: PageableRequestDto): Observable<PagedResultDtoOfDumpsterUserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/ServiceInfo/waste/whitelist?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWhitelistedUsersForDumpster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWhitelistedUsersForDumpster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDumpsterUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDumpsterUserInfoDto>;
        }));
    }

    protected processGetWhitelistedUsersForDumpster(response: HttpResponseBase): Observable<PagedResultDtoOfDumpsterUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDumpsterUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getServiceConfig(id: string): Observable<ServiceConfigDto> {
        let url_ = this.baseUrl + "/api/v1/ServiceConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceConfigDto>;
        }));
    }

    protected processGetServiceConfig(response: HttpResponseBase): Observable<ServiceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteServiceConfig(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ServiceConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServiceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServiceConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteServiceConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllServiceConfigs(availableForCreation: boolean | undefined): Observable<ServiceConfigDto[]> {
        let url_ = this.baseUrl + "/api/v1/ServiceConfig?";
        if (availableForCreation === null)
            throw new globalThis.Error("The parameter 'availableForCreation' cannot be null.");
        else if (availableForCreation !== undefined)
            url_ += "availableForCreation=" + encodeURIComponent("" + availableForCreation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceConfigDto[]>;
        }));
    }

    protected processGetAllServiceConfigs(response: HttpResponseBase): Observable<ServiceConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceConfigDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createServiceConfig(serviceConfigInputDto: ServiceConfigInputDto): Observable<ServiceConfigDto> {
        let url_ = this.baseUrl + "/api/v1/ServiceConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceConfigInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceConfigDto>;
        }));
    }

    protected processCreateServiceConfig(response: HttpResponseBase): Observable<ServiceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCategories(): Observable<ServiceCategoryDto[]> {
        let url_ = this.baseUrl + "/api/v1/ServiceCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryDto[]>;
        }));
    }

    protected processGetCategories(response: HttpResponseBase): Observable<ServiceCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCategory(categoryDto: ServiceCategoryDto): Observable<ServiceCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/ServiceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(categoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCategoryDto>;
        }));
    }

    protected processCreateCategory(response: HttpResponseBase): Observable<ServiceCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCategory(categoryId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ServiceCategory/{categoryId}";
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomRoleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllCustomRoles(includeDisabledRoles: boolean | undefined): Observable<CustomRoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/CustomRole?";
        if (includeDisabledRoles === null)
            throw new globalThis.Error("The parameter 'includeDisabledRoles' cannot be null.");
        else if (includeDisabledRoles !== undefined)
            url_ += "includeDisabledRoles=" + encodeURIComponent("" + includeDisabledRoles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomRoleDto[]>;
        }));
    }

    protected processGetAllCustomRoles(response: HttpResponseBase): Observable<CustomRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomRoleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomRole(input: CustomRoleInputDto): Observable<CustomRoleDto> {
        let url_ = this.baseUrl + "/api/v1/CustomRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomRoleDto>;
        }));
    }

    protected processCreateCustomRole(response: HttpResponseBase): Observable<CustomRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomRole(roleKey: string, input: CustomRoleInputDto): Observable<CustomRoleDto> {
        let url_ = this.baseUrl + "/api/v1/CustomRole/{roleKey}";
        if (roleKey === undefined || roleKey === null)
            throw new globalThis.Error("The parameter 'roleKey' must be defined.");
        url_ = url_.replace("{roleKey}", encodeURIComponent("" + roleKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomRoleDto>;
        }));
    }

    protected processUpdateCustomRole(response: HttpResponseBase): Observable<CustomRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(roleKey: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomRole/{roleKey}";
        if (roleKey === undefined || roleKey === null)
            throw new globalThis.Error("The parameter 'roleKey' must be defined.");
        url_ = url_.replace("{roleKey}", encodeURIComponent("" + roleKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enableCustomRole(roleKey: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomRole/{roleKey}/enable";
        if (roleKey === undefined || roleKey === null)
            throw new globalThis.Error("The parameter 'roleKey' must be defined.");
        url_ = url_.replace("{roleKey}", encodeURIComponent("" + roleKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableCustomRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableCustomRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableCustomRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disableCustomRole(roleKey: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomRole/{roleKey}/disable";
        if (roleKey === undefined || roleKey === null)
            throw new globalThis.Error("The parameter 'roleKey' must be defined.");
        url_ = url_.replace("{roleKey}", encodeURIComponent("" + roleKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableCustomRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableCustomRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableCustomRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PushRegistrationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    registerTokenForVisitor(registrationToken: string, email: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PushRegistration/public/register/{registrationToken}";
        if (registrationToken === undefined || registrationToken === null)
            throw new globalThis.Error("The parameter 'registrationToken' must be defined.");
        url_ = url_.replace("{registrationToken}", encodeURIComponent("" + registrationToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTokenForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTokenForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterTokenForVisitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerToken(registrationToken: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PushRegistration/register/{registrationToken}";
        if (registrationToken === undefined || registrationToken === null)
            throw new globalThis.Error("The parameter 'registrationToken' must be defined.");
        url_ = url_.replace("{registrationToken}", encodeURIComponent("" + registrationToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PurchaseService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    purchaseService(serviceId: string, customerId: string | undefined, purchaseInputDto: PurchaseInputDto): Observable<PurchaseDto> {
        let url_ = this.baseUrl + "/api/v1/Purchase/for-service/{serviceId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchaseInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseDto>;
        }));
    }

    protected processPurchaseService(response: HttpResponseBase): Observable<PurchaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    purchaseServiceForCustomer(purchaseInputDto: PurchaseInputDto): Observable<PurchaseDto> {
        let url_ = this.baseUrl + "/api/v1/Purchase/my-purchases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchaseInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurchaseServiceForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseServiceForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseDto>;
        }));
    }

    protected processPurchaseServiceForCustomer(response: HttpResponseBase): Observable<PurchaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicLightingControlService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLightZonesScheduleForServiceId(serviceId: string): Observable<LightZoneScheduleDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightZonesScheduleForServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightZonesScheduleForServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneScheduleDto[]>;
        }));
    }

    protected processGetLightZonesScheduleForServiceId(response: HttpResponseBase): Observable<LightZoneScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightZoneScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scheduleLightZoneControlMode(serviceId: string, zoneId: string, lightZoneScheduleInputDto: LightZoneScheduleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/zone/{zoneId}/schedule";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightZoneScheduleInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleLightZoneControlMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleLightZoneControlMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScheduleLightZoneControlMode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLightZoneControlModeSchedule(serviceId: string, zoneScheduleId: string, lightZoneScheduleDto: LightZoneScheduleUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/{zoneScheduleId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneScheduleId === undefined || zoneScheduleId === null)
            throw new globalThis.Error("The parameter 'zoneScheduleId' must be defined.");
        url_ = url_.replace("{zoneScheduleId}", encodeURIComponent("" + zoneScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightZoneScheduleDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLightZoneControlModeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLightZoneControlModeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLightZoneControlModeSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLightZoneControlModeSchedule(serviceId: string, zoneScheduleId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/{zoneScheduleId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneScheduleId === undefined || zoneScheduleId === null)
            throw new globalThis.Error("The parameter 'zoneScheduleId' must be defined.");
        url_ = url_.replace("{zoneScheduleId}", encodeURIComponent("" + zoneScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLightZoneControlModeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLightZoneControlModeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLightZoneControlModeSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applyAutomaticModeForZoneId(serviceId: string, zoneId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/zone/{zoneId}/set-automatic-mode";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyAutomaticModeForZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyAutomaticModeForZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyAutomaticModeForZoneId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forceOnModeForZoneId(serviceId: string, zoneId: string, durationInSeconds: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/zone/{zoneId}/set-on-mode";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(durationInSeconds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceOnModeForZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceOnModeForZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceOnModeForZoneId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forceOffModeForZoneId(serviceId: string, zoneId: string, durationInSeconds: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingControl/for-service/{serviceId}/zone/{zoneId}/set-off-mode";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(durationInSeconds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceOffModeForZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceOffModeForZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceOffModeForZoneId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicLightingExternalLightService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getExternalLightById(serviceId: string, provider: PublicLightingProvider, externalId: string): Observable<ExternalLightDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingExternalLight/for-service/{serviceId}/{externalId}/for-provider/{provider}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        if (externalId === undefined || externalId === null)
            throw new globalThis.Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalLightById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalLightById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLightDto>;
        }));
    }

    protected processGetExternalLightById(response: HttpResponseBase): Observable<ExternalLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNotLinkedExternalLightsOfProvider(serviceId: string, provider: PublicLightingProvider): Observable<ExternalLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingExternalLight/for-service/{serviceId}/not-linked/for-provider/{provider}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotLinkedExternalLightsOfProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotLinkedExternalLightsOfProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLightDto[]>;
        }));
    }

    protected processGetNotLinkedExternalLightsOfProvider(response: HttpResponseBase): Observable<ExternalLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicLightingLightService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLightById(serviceId: string, lightId: string): Observable<LightCompleteDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/{lightId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (lightId === undefined || lightId === null)
            throw new globalThis.Error("The parameter 'lightId' must be defined.");
        url_ = url_.replace("{lightId}", encodeURIComponent("" + lightId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightCompleteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightCompleteDto>;
        }));
    }

    protected processGetLightById(response: HttpResponseBase): Observable<LightCompleteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LightCompleteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLight(serviceId: string, lightId: string, lightInputDto: LightInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/{lightId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (lightId === undefined || lightId === null)
            throw new globalThis.Error("The parameter 'lightId' must be defined.");
        url_ = url_.replace("{lightId}", encodeURIComponent("" + lightId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLight(serviceId: string, lightId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/{lightId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (lightId === undefined || lightId === null)
            throw new globalThis.Error("The parameter 'lightId' must be defined.");
        url_ = url_.replace("{lightId}", encodeURIComponent("" + lightId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightsWithStateByServiceId(serviceId: string): Observable<LightWithStateDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/with-state";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightsWithStateByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightsWithStateByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightWithStateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightWithStateDto[]>;
        }));
    }

    protected processGetLightsWithStateByServiceId(response: HttpResponseBase): Observable<LightWithStateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightWithStateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightsByServiceId(serviceId: string): Observable<LightDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightsByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightsByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightDto[]>;
        }));
    }

    protected processGetLightsByServiceId(response: HttpResponseBase): Observable<LightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLight(serviceId: string, lightInputDto: LightInputDto): Observable<LightDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightDto>;
        }));
    }

    protected processCreateLight(response: HttpResponseBase): Observable<LightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightsByServiceIdAndZoneId(serviceId: string, zoneId: string): Observable<LightDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/for-zone/{zoneId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightsByServiceIdAndZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightsByServiceIdAndZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightDto[]>;
        }));
    }

    protected processGetLightsByServiceIdAndZoneId(response: HttpResponseBase): Observable<LightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightsByServiceIdNotAssignedToZone(serviceId: string): Observable<LightDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/not-assigned-to-zone";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightsByServiceIdNotAssignedToZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightsByServiceIdNotAssignedToZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightDto[]>;
        }));
    }

    protected processGetLightsByServiceIdNotAssignedToZone(response: HttpResponseBase): Observable<LightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchLightsByServiceId(serviceId: string, pageableRequestDto: PageableRequestDtoOfLightCriteriaDto): Observable<PagedResultDtoOfLightTableDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/for-service/{serviceId}/search";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchLightsByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchLightsByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLightTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLightTableDto>;
        }));
    }

    protected processSearchLightsByServiceId(response: HttpResponseBase): Observable<PagedResultDtoOfLightTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLightTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importLightsFromFile(file: FileParameter | null | undefined): Observable<ImportResultOfImportLightDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingLight/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportLightsFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportLightsFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportResultOfImportLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportResultOfImportLightDto>;
        }));
    }

    protected processImportLightsFromFile(response: HttpResponseBase): Observable<ImportResultOfImportLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportResultOfImportLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicLightingZoneService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getLightZonesByServiceId(serviceId: string): Observable<LightZoneDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightZonesByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightZonesByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneDto[]>;
        }));
    }

    protected processGetLightZonesByServiceId(response: HttpResponseBase): Observable<LightZoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightZoneDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createLightZone(serviceId: string, lightZoneInputDto: LightZoneInputDto): Observable<LightZoneDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightZoneInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLightZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLightZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneDto>;
        }));
    }

    protected processCreateLightZone(response: HttpResponseBase): Observable<LightZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LightZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightZonesWithLightCountByServiceId(serviceId: string): Observable<LightZoneWithLightCountDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}/with-light-count";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightZonesWithLightCountByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightZonesWithLightCountByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneWithLightCountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneWithLightCountDto[]>;
        }));
    }

    protected processGetLightZonesWithLightCountByServiceId(response: HttpResponseBase): Observable<LightZoneWithLightCountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightZoneWithLightCountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLightZonesWithLightCountAndModeByServiceId(serviceId: string): Observable<LightZoneWithLightCountAndModeDto[]> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}/with-light-count-and-mode";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLightZonesWithLightCountAndModeByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLightZonesWithLightCountAndModeByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneWithLightCountAndModeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneWithLightCountAndModeDto[]>;
        }));
    }

    protected processGetLightZonesWithLightCountAndModeByServiceId(response: HttpResponseBase): Observable<LightZoneWithLightCountAndModeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LightZoneWithLightCountAndModeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLightZone(serviceId: string, lightZoneId: string, lightZoneEditInputDto: LightZoneInputDto): Observable<LightZoneDto> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}/{lightZoneId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (lightZoneId === undefined || lightZoneId === null)
            throw new globalThis.Error("The parameter 'lightZoneId' must be defined.");
        url_ = url_.replace("{lightZoneId}", encodeURIComponent("" + lightZoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightZoneEditInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLightZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLightZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LightZoneDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LightZoneDto>;
        }));
    }

    protected processUpdateLightZone(response: HttpResponseBase): Observable<LightZoneDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LightZoneDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLightZone(serviceId: string, lightZoneId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}/{lightZoneId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (lightZoneId === undefined || lightZoneId === null)
            throw new globalThis.Error("The parameter 'lightZoneId' must be defined.");
        url_ = url_.replace("{lightZoneId}", encodeURIComponent("" + lightZoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLightZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLightZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLightZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignLightsToZone(serviceId: string, zoneId: string, lightsId: string[]): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PublicLightingZone/for-service/{serviceId}/{zoneId}/assign-lights";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lightsId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignLightsToZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignLightsToZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignLightsToZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PointOfSaleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getPointsOfSale(): Observable<PointOfSaleDto[]> {
        let url_ = this.baseUrl + "/api/v1/PointOfSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointsOfSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointsOfSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointOfSaleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointOfSaleDto[]>;
        }));
    }

    protected processGetPointsOfSale(response: HttpResponseBase): Observable<PointOfSaleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PointOfSaleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createPointOfSale(pointOfSale: PointOfSaleInputDto): Observable<PointOfSaleDto> {
        let url_ = this.baseUrl + "/api/v1/PointOfSale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pointOfSale);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePointOfSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePointOfSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointOfSaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointOfSaleDto>;
        }));
    }

    protected processCreatePointOfSale(response: HttpResponseBase): Observable<PointOfSaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PointOfSaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPointsOfSaleByServiceId(serviceId: string): Observable<PointOfSaleDto[]> {
        let url_ = this.baseUrl + "/api/v1/PointOfSale/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointsOfSaleByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointsOfSaleByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointOfSaleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointOfSaleDto[]>;
        }));
    }

    protected processGetPointsOfSaleByServiceId(response: HttpResponseBase): Observable<PointOfSaleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PointOfSaleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePointOfSale(pointOfSaleId: string, pointOfSaleInput: PointOfSaleUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PointOfSale/{pointOfSaleId}";
        if (pointOfSaleId === undefined || pointOfSaleId === null)
            throw new globalThis.Error("The parameter 'pointOfSaleId' must be defined.");
        url_ = url_.replace("{pointOfSaleId}", encodeURIComponent("" + pointOfSaleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pointOfSaleInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePointOfSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePointOfSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePointOfSale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePointOfSale(pointOfSaleId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/PointOfSale/{pointOfSaleId}";
        if (pointOfSaleId === undefined || pointOfSaleId === null)
            throw new globalThis.Error("The parameter 'pointOfSaleId' must be defined.");
        url_ = url_.replace("{pointOfSaleId}", encodeURIComponent("" + pointOfSaleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePointOfSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePointOfSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePointOfSale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllPermissions(): Observable<PermissionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Permission";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDto[]>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OfficeHourService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOfficeHours(): Observable<OfficeHoursDto> {
        let url_ = this.baseUrl + "/api/v1/OfficeHour";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfficeHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfficeHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeHoursDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeHoursDto>;
        }));
    }

    protected processGetOfficeHours(response: HttpResponseBase): Observable<OfficeHoursDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeHoursDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setOfficeHour(officeHour: OfficeHourDto): Observable<OfficeHourDto> {
        let url_ = this.baseUrl + "/api/v1/OfficeHour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(officeHour);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOfficeHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOfficeHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeHourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeHourDto>;
        }));
    }

    protected processSetOfficeHour(response: HttpResponseBase): Observable<OfficeHourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeHourDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOfficeHourException(officeHourException: OfficeHourExceptionInputDto): Observable<OfficeHourExceptionDto> {
        let url_ = this.baseUrl + "/api/v1/OfficeHour/exception";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(officeHourException);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOfficeHourException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOfficeHourException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeHourExceptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeHourExceptionDto>;
        }));
    }

    protected processCreateOfficeHourException(response: HttpResponseBase): Observable<OfficeHourExceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeHourExceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOfficeHourException(officeHourExceptionId: string, officeHourException: OfficeHourExceptionInputDto): Observable<OfficeHourExceptionDto> {
        let url_ = this.baseUrl + "/api/v1/OfficeHour/exception/{officeHourExceptionId}";
        if (officeHourExceptionId === undefined || officeHourExceptionId === null)
            throw new globalThis.Error("The parameter 'officeHourExceptionId' must be defined.");
        url_ = url_.replace("{officeHourExceptionId}", encodeURIComponent("" + officeHourExceptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(officeHourException);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOfficeHourException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOfficeHourException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfficeHourExceptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfficeHourExceptionDto>;
        }));
    }

    protected processUpdateOfficeHourException(response: HttpResponseBase): Observable<OfficeHourExceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficeHourExceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOfficeHourException(officeHourExceptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/OfficeHour/exception/{officeHourExceptionId}";
        if (officeHourExceptionId === undefined || officeHourExceptionId === null)
            throw new globalThis.Error("The parameter 'officeHourExceptionId' must be defined.");
        url_ = url_.replace("{officeHourExceptionId}", encodeURIComponent("" + officeHourExceptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOfficeHourException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOfficeHourException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOfficeHourException(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MooringPlaceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllMooringPlaces(serviceId: string): Observable<MooringPlaceLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMooringPlaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMooringPlaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceLightDto[]>;
        }));
    }

    protected processGetAllMooringPlaces(response: HttpResponseBase): Observable<MooringPlaceLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MooringPlaceLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createMooringPlace(serviceId: string, mooringPlaceDto: MooringPlaceDto): Observable<MooringPlaceDto> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mooringPlaceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMooringPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMooringPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceDto>;
        }));
    }

    protected processCreateMooringPlace(response: HttpResponseBase): Observable<MooringPlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MooringPlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMooringPlace(serviceId: string, mooringPlaceId: string): Observable<MooringPlaceWithOwnerDto> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}/{mooringPlaceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (mooringPlaceId === undefined || mooringPlaceId === null)
            throw new globalThis.Error("The parameter 'mooringPlaceId' must be defined.");
        url_ = url_.replace("{mooringPlaceId}", encodeURIComponent("" + mooringPlaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMooringPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMooringPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceWithOwnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceWithOwnerDto>;
        }));
    }

    protected processGetMooringPlace(response: HttpResponseBase): Observable<MooringPlaceWithOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MooringPlaceWithOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMooringPlace(serviceId: string, mooringPlaceId: string, mooringPlaceDto: MooringPlaceDto): Observable<MooringPlaceDto> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}/{mooringPlaceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (mooringPlaceId === undefined || mooringPlaceId === null)
            throw new globalThis.Error("The parameter 'mooringPlaceId' must be defined.");
        url_ = url_.replace("{mooringPlaceId}", encodeURIComponent("" + mooringPlaceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mooringPlaceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMooringPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMooringPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceDto>;
        }));
    }

    protected processUpdateMooringPlace(response: HttpResponseBase): Observable<MooringPlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MooringPlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMooringPlace(serviceId: string, mooringPlaceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}/{mooringPlaceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (mooringPlaceId === undefined || mooringPlaceId === null)
            throw new globalThis.Error("The parameter 'mooringPlaceId' must be defined.");
        url_ = url_.replace("{mooringPlaceId}", encodeURIComponent("" + mooringPlaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMooringPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMooringPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMooringPlace(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMooringPlaceBoatsForCustomer(serviceId: string, customerId: string): Observable<MooringPlaceBoatDto[]> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}/for-customer/{customerId}/boats";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMooringPlaceBoatsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMooringPlaceBoatsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceBoatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceBoatDto[]>;
        }));
    }

    protected processGetMooringPlaceBoatsForCustomer(response: HttpResponseBase): Observable<MooringPlaceBoatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MooringPlaceBoatDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyMooringPlaceBoats(): Observable<MooringPlaceBoatDto[]> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/my-boats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMooringPlaceBoats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMooringPlaceBoats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MooringPlaceBoatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MooringPlaceBoatDto[]>;
        }));
    }

    protected processGetMyMooringPlaceBoats(response: HttpResponseBase): Observable<MooringPlaceBoatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MooringPlaceBoatDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchMooringPlaces(serviceId: string, pageableRequestDto: PageableRequestDtoOfMooringPlaceCriteriaDto): Observable<PagedResultDtoOfMooringPlaceLightDto> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/for-service/{serviceId}/search";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMooringPlaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMooringPlaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMooringPlaceLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMooringPlaceLightDto>;
        }));
    }

    protected processSearchMooringPlaces(response: HttpResponseBase): Observable<PagedResultDtoOfMooringPlaceLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMooringPlaceLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importMooringPlaceFromFile(file: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/MooringPlace/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMooringPlaceFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMooringPlaceFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportMooringPlaceFromFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeasuringPointService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMeasuringPointWithStateById(id: string, serviceId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/public/for-service/{serviceId}/{id}/with-state";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasuringPointWithStateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasuringPointWithStateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processGetMeasuringPointWithStateById(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get20FirstForService(serviceId: string, measuringPointId: string | null | undefined, customerId: string | null | undefined, language: string | undefined, measuringPointType: MeasuringPointType | null | undefined): Observable<MeasuringPointLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId !== undefined && measuringPointId !== null)
            url_ += "MeasuringPointId=" + encodeURIComponent("" + measuringPointId) + "&";
        if (customerId !== undefined && customerId !== null)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        if (measuringPointType !== undefined && measuringPointType !== null)
            url_ += "MeasuringPointType=" + encodeURIComponent("" + measuringPointType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet20FirstForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet20FirstForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto[]>;
        }));
    }

    protected processGet20FirstForService(response: HttpResponseBase): Observable<MeasuringPointLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringPointLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminMeasuringPointsForService(serviceId: string, language: string | undefined): Observable<MeasuringPointLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/public/for-service/{serviceId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (language === null)
            throw new globalThis.Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminMeasuringPointsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminMeasuringPointsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto[]>;
        }));
    }

    protected processGetAdminMeasuringPointsForService(response: HttpResponseBase): Observable<MeasuringPointLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasuringPointLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchMeasuringPoints(searchMeasuringPointDto: SearchMeasuringPointDto): Observable<SearchMeasuringPointResultDto[]> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchMeasuringPointDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMeasuringPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMeasuringPoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMeasuringPointResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMeasuringPointResultDto[]>;
        }));
    }

    protected processSearchMeasuringPoints(response: HttpResponseBase): Observable<SearchMeasuringPointResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchMeasuringPointResultDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignMeasuringPointToService(serviceId: string, measuringPointId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/assign-to-service";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMeasuringPointToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMeasuringPointToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processAssignMeasuringPointToService(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignMeasuringPointToCustomer(serviceId: string, measuringPointId: string, customerId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/assign-to-customer/{customerId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMeasuringPointToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMeasuringPointToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processAssignMeasuringPointToCustomer(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignMeasuringPointToServiceAndCustomer(serviceId: string, measuringPointId: string, customerId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/assign-to-service-and-customer/{customerId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMeasuringPointToServiceAndCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMeasuringPointToServiceAndCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processAssignMeasuringPointToServiceAndCustomer(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reassignMeasuringPointCustomer(serviceId: string, measuringPointId: string, customerId: string, unassignMeasuringPointId: string | undefined): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/reassign-customer/{customerId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (unassignMeasuringPointId === null)
            throw new globalThis.Error("The parameter 'unassignMeasuringPointId' cannot be null.");
        else if (unassignMeasuringPointId !== undefined)
            url_ += "unassignMeasuringPointId=" + encodeURIComponent("" + unassignMeasuringPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignMeasuringPointCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignMeasuringPointCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processReassignMeasuringPointCustomer(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignCurrentCustomerFromMeasuringPoint(serviceId: string, measuringPointId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/unassign-from-customer";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignCurrentCustomerFromMeasuringPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignCurrentCustomerFromMeasuringPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processUnassignCurrentCustomerFromMeasuringPoint(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignCurrentServiceFromMeasuringPoint(serviceId: string, measuringPointId: string): Observable<MeasuringPointLightDto> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/unassign-from-service";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignCurrentServiceFromMeasuringPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignCurrentServiceFromMeasuringPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MeasuringPointLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MeasuringPointLightDto>;
        }));
    }

    protected processUnassignCurrentServiceFromMeasuringPoint(response: HttpResponseBase): Observable<MeasuringPointLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasuringPointLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateMeasuringPoint(measuringPointId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/{measuringPointId}/activate";
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateMeasuringPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateMeasuringPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processActivateMeasuringPoint(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateMeasuringPointForService(serviceId: string, measuringPointId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/activate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateMeasuringPointForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateMeasuringPointForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processActivateMeasuringPointForService(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateMeasuringPoint(measuringPointId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/{measuringPointId}/deactivate";
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateMeasuringPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateMeasuringPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeactivateMeasuringPoint(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateMeasuringPointForService(serviceId: string, measuringPointId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/for-service/{serviceId}/{measuringPointId}/deactivate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateMeasuringPointForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateMeasuringPointForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDeactivateMeasuringPointForService(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importMeasuringPointFromExcelFile(excelFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/MeasuringPoint/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMeasuringPointFromExcelFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMeasuringPointFromExcelFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportMeasuringPointFromExcelFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeasureTypeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    importMeasureTypeFromFile(excelFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/MeasureType/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportMeasureTypeFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportMeasureTypeFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportMeasureTypeFromFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeasureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    resetMeasure(measureId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Measure/{measureId}/reset";
        if (measureId === undefined || measureId === null)
            throw new globalThis.Error("The parameter 'measureId' must be defined.");
        url_ = url_.replace("{measureId}", encodeURIComponent("" + measureId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetMeasure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MapService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMap(serviceId: string): Observable<MapDto> {
        let url_ = this.baseUrl + "/api/v1/Map/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapDto>;
        }));
    }

    protected processGetMap(response: HttpResponseBase): Observable<MapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadMapFile(serviceId: string, map: FileParameter | null | undefined): Observable<MapDto> {
        let url_ = this.baseUrl + "/api/v1/Map/for-service/{serviceId}/mapfile";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (map !== null && map !== undefined)
            content_.append("map", map.data, map.fileName ? map.fileName : "map");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMapFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMapFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapDto>;
        }));
    }

    protected processUploadMapFile(response: HttpResponseBase): Observable<MapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveMapCoordinates(serviceId: string, mapCoordinatesDto: MapCoordinatesDto): Observable<MapDto> {
        let url_ = this.baseUrl + "/api/v1/Map/for-service/{serviceId}/coordinates";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapCoordinatesDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMapCoordinates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMapCoordinates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapDto>;
        }));
    }

    protected processSaveMapCoordinates(response: HttpResponseBase): Observable<MapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    computeProjectionMn95ToSvg(xBottomRight: number | undefined, yBottomRight: number | undefined): Observable<MapProjectionDto> {
        let url_ = this.baseUrl + "/api/v1/Map/mn95-svg-projection?";
        if (xBottomRight === null)
            throw new globalThis.Error("The parameter 'xBottomRight' cannot be null.");
        else if (xBottomRight !== undefined)
            url_ += "xBottomRight=" + encodeURIComponent("" + xBottomRight) + "&";
        if (yBottomRight === null)
            throw new globalThis.Error("The parameter 'yBottomRight' cannot be null.");
        else if (yBottomRight !== undefined)
            url_ += "yBottomRight=" + encodeURIComponent("" + yBottomRight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeProjectionMn95ToSvg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeProjectionMn95ToSvg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapProjectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapProjectionDto>;
        }));
    }

    protected processComputeProjectionMn95ToSvg(response: HttpResponseBase): Observable<MapProjectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapProjectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    computeProjectionSvgToMn95(xBottomRight: number | undefined, yBottomRight: number | undefined): Observable<MapProjectionDto> {
        let url_ = this.baseUrl + "/api/v1/Map/svg-mn95-projection?";
        if (xBottomRight === null)
            throw new globalThis.Error("The parameter 'xBottomRight' cannot be null.");
        else if (xBottomRight !== undefined)
            url_ += "xBottomRight=" + encodeURIComponent("" + xBottomRight) + "&";
        if (yBottomRight === null)
            throw new globalThis.Error("The parameter 'yBottomRight' cannot be null.");
        else if (yBottomRight !== undefined)
            url_ += "yBottomRight=" + encodeURIComponent("" + yBottomRight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComputeProjectionSvgToMn95(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComputeProjectionSvgToMn95(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapProjectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapProjectionDto>;
        }));
    }

    protected processComputeProjectionSvgToMn95(response: HttpResponseBase): Observable<MapProjectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapProjectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ItemToBookService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllItemsForService(serviceId: string): Observable<ItemToBookDto[]> {
        let url_ = this.baseUrl + "/api/v1/ItemToBook/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllItemsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllItemsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookDto[]>;
        }));
    }

    protected processGetAllItemsForService(response: HttpResponseBase): Observable<ItemToBookDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemToBookDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createItem(serviceId: string, itemToBookDto: ItemToBookDto): Observable<ItemToBookDto> {
        let url_ = this.baseUrl + "/api/v1/ItemToBook/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemToBookDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookDto>;
        }));
    }

    protected processCreateItem(response: HttpResponseBase): Observable<ItemToBookDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemToBookDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateItem(serviceId: string, itemId: string, itemToBookDto: ItemToBookDto): Observable<ItemToBookDto> {
        let url_ = this.baseUrl + "/api/v1/ItemToBook/for-service/{serviceId}/{itemId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemToBookDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookDto>;
        }));
    }

    protected processUpdateItem(response: HttpResponseBase): Observable<ItemToBookDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemToBookDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteItem(serviceId: string, itemId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ItemToBook/for-service/{serviceId}/{itemId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ItemToBookQuestionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(itemToBookId: string): Observable<ItemToBookQuestionDto[]> {
        let url_ = this.baseUrl + "/api/v1/ItemToBookQuestion/public/for-item-to-book/{itemToBookId}";
        if (itemToBookId === undefined || itemToBookId === null)
            throw new globalThis.Error("The parameter 'itemToBookId' must be defined.");
        url_ = url_.replace("{itemToBookId}", encodeURIComponent("" + itemToBookId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookQuestionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ItemToBookQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemToBookQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(serviceId: string, id: string): Observable<ItemToBookQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/ItemToBookQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookQuestionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ItemToBookQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemToBookQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(serviceId: string, id: string, updateInputDto: ItemToBookQuestionInputDto): Observable<ItemToBookQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/ItemToBookQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookQuestionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ItemToBookQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemToBookQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ItemToBookQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(serviceId: string, itemToBookId: string, createInputDto: ItemToBookQuestionInputDto): Observable<ItemToBookQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/ItemToBookQuestion/for-service/{serviceId}/for-item-to-book/{itemToBookId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (itemToBookId === undefined || itemToBookId === null)
            throw new globalThis.Error("The parameter 'itemToBookId' must be defined.");
        url_ = url_.replace("{itemToBookId}", encodeURIComponent("" + itemToBookId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ItemToBookQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ItemToBookQuestionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ItemToBookQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemToBookQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IotRegisterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMyAlarmRegisters(): Observable<IotRegisterDto[]> {
        let url_ = this.baseUrl + "/api/v1/IotRegister/my-alarm-registers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAlarmRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAlarmRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IotRegisterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IotRegisterDto[]>;
        }));
    }

    protected processGetMyAlarmRegisters(response: HttpResponseBase): Observable<IotRegisterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IotRegisterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchIotRegisters(iotRegisterSearchCriteriaDto: IotRegisterSearchCriteriaDto): Observable<IotRegisterDto[]> {
        let url_ = this.baseUrl + "/api/v1/IotRegister/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(iotRegisterSearchCriteriaDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchIotRegisters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchIotRegisters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IotRegisterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IotRegisterDto[]>;
        }));
    }

    protected processSearchIotRegisters(response: HttpResponseBase): Observable<IotRegisterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IotRegisterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importIoTRegisterFromFile(file: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/IotRegister/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportIoTRegisterFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportIoTRegisterFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportIoTRegisterFromFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InformationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<InformationLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationLightDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InformationLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InformationLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createInformation(informationInputDto: InformationInputDto): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(informationInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateInformation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInformation(informationId: string): Observable<InformationDto> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationDto>;
        }));
    }

    protected processGetInformation(response: HttpResponseBase): Observable<InformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateInformation(informationId: string, informationInputDto: InformationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(informationInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteInformation(informationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getActiveBanner(): Observable<BannerDto> {
        let url_ = this.baseUrl + "/api/v1/Information/active-banner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BannerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BannerDto>;
        }));
    }

    protected processGetActiveBanner(response: HttpResponseBase): Observable<BannerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BannerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBanner(informationId: string, bannerInputDto: BannerInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/banner";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bannerInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBanner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishInformation(informationId: string, informationPublishInputDto: InformationPublishInputDto): Observable<InformationDto> {
        let url_ = this.baseUrl + "/api/v1/Information/publish/{informationId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(informationPublishInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationDto>;
        }));
    }

    protected processPublishInformation(response: HttpResponseBase): Observable<InformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadIllustration(informationId: string, image: FileParameter | null | undefined): Observable<ImageDto> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/image";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadIllustration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadIllustration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageDto>;
        }));
    }

    protected processUploadIllustration(response: HttpResponseBase): Observable<ImageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentToInformation(informationId: string, title: string | null | undefined, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/document";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDocumentToInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(informationId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/document";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDocument(informationId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/document/{documentId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocument(informationId: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/{informationId}/document/{documentId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllActive(): Observable<InformationLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Information/my-informations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationLightDto[]>;
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<InformationLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InformationLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyInformation(informationId: string): Observable<InformationDto> {
        let url_ = this.baseUrl + "/api/v1/Information/my-informations/{informationId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationDto>;
        }));
    }

    protected processGetMyInformation(response: HttpResponseBase): Observable<InformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyInformationDocuments(informationId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Information/my-informations/{informationId}/document";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyInformationDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyInformationDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetMyInformationDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadMyInformationDocument(informationId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Information/my-informations/{informationId}/document/{documentId}";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMyInformationDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMyInformationDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMyInformationDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addReadStatus(informationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Information/my-informations/{informationId}/read";
        if (informationId === undefined || informationId === null)
            throw new globalThis.Error("The parameter 'informationId' must be defined.");
        url_ = url_.replace("{informationId}", encodeURIComponent("" + informationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddReadStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HydrowashWashingTrackService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllTracks(serviceId: string): Observable<HydrowashWashingTrackDto[]> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTracks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTracks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydrowashWashingTrackDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydrowashWashingTrackDto[]>;
        }));
    }

    protected processGetAllTracks(response: HttpResponseBase): Observable<HydrowashWashingTrackDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HydrowashWashingTrackDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTrack(serviceId: string, hydrowashWashingTrackDto: HydrowashWashingTrackDto): Observable<HydrowashWashingTrackDto> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hydrowashWashingTrackDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydrowashWashingTrackDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydrowashWashingTrackDto>;
        }));
    }

    protected processCreateTrack(response: HttpResponseBase): Observable<HydrowashWashingTrackDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydrowashWashingTrackDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTrack(serviceId: string, trackId: string): Observable<HydrowashWashingTrackDto> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/for-service/{serviceId}/{trackId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (trackId === undefined || trackId === null)
            throw new globalThis.Error("The parameter 'trackId' must be defined.");
        url_ = url_.replace("{trackId}", encodeURIComponent("" + trackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydrowashWashingTrackDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydrowashWashingTrackDto>;
        }));
    }

    protected processGetTrack(response: HttpResponseBase): Observable<HydrowashWashingTrackDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydrowashWashingTrackDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTrack(serviceId: string, trackId: string, hydrowashWashingTrackDto: HydrowashWashingTrackDto): Observable<HydrowashWashingTrackDto> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/for-service/{serviceId}/{trackId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (trackId === undefined || trackId === null)
            throw new globalThis.Error("The parameter 'trackId' must be defined.");
        url_ = url_.replace("{trackId}", encodeURIComponent("" + trackId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hydrowashWashingTrackDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydrowashWashingTrackDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydrowashWashingTrackDto>;
        }));
    }

    protected processUpdateTrack(response: HttpResponseBase): Observable<HydrowashWashingTrackDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydrowashWashingTrackDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTrack(serviceId: string, trackId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/for-service/{serviceId}/{trackId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (trackId === undefined || trackId === null)
            throw new globalThis.Error("The parameter 'trackId' must be defined.");
        url_ = url_.replace("{trackId}", encodeURIComponent("" + trackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTrack(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateTrack(trackId: string, amount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/HydrowashWashingTrack/activate/{trackId}?";
        if (trackId === undefined || trackId === null)
            throw new globalThis.Error("The parameter 'trackId' must be defined.");
        url_ = url_.replace("{trackId}", encodeURIComponent("" + trackId));
        if (amount === null)
            throw new globalThis.Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateTrack(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HighlightedServiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getHighlightedServicesForVisitor(): Observable<HighlightedServiceDto[]> {
        let url_ = this.baseUrl + "/api/v1/HighlightedService/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHighlightedServicesForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHighlightedServicesForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HighlightedServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HighlightedServiceDto[]>;
        }));
    }

    protected processGetHighlightedServicesForVisitor(response: HttpResponseBase): Observable<HighlightedServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HighlightedServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHighlightedServices(): Observable<HighlightedServiceDto[]> {
        let url_ = this.baseUrl + "/api/v1/HighlightedService";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHighlightedServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHighlightedServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HighlightedServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HighlightedServiceDto[]>;
        }));
    }

    protected processGetHighlightedServices(response: HttpResponseBase): Observable<HighlightedServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HighlightedServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createHighlightedService(highlightedServiceInputDto: HighlightedServiceInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/HighlightedService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(highlightedServiceInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHighlightedService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHighlightedService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateHighlightedService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteHighlightedService(highlightedServiceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/HighlightedService/{highlightedServiceId}";
        if (highlightedServiceId === undefined || highlightedServiceId === null)
            throw new globalThis.Error("The parameter 'highlightedServiceId' must be defined.");
        url_ = url_.replace("{highlightedServiceId}", encodeURIComponent("" + highlightedServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHighlightedService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHighlightedService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHighlightedService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EwalletService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchEwallet(pageableRequestDto: PageableRequestDtoOfEwalletCriteriaDto): Observable<PagedResultDtoOfCustomerEwalletDto> {
        let url_ = this.baseUrl + "/api/v1/Ewallet/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEwallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEwallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerEwalletDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerEwalletDto>;
        }));
    }

    protected processSearchEwallet(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerEwalletDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerEwalletDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEwallets(criteria: EwalletCriteriaDto): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Ewallet/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEwallets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEwallets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportEwallets(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportEwalletTransactions(walletId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Ewallet/{walletId}/transactions/export";
        if (walletId === undefined || walletId === null)
            throw new globalThis.Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEwalletTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEwalletTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportEwalletTransactions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EwalletClosureScheduleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllFutureScheduledClosures(): Observable<EwalletClosureScheduleDto[]> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/scheduled-in-future";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFutureScheduledClosures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFutureScheduledClosures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletClosureScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletClosureScheduleDto[]>;
        }));
    }

    protected processGetAllFutureScheduledClosures(response: HttpResponseBase): Observable<EwalletClosureScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EwalletClosureScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createScheduledClosure(inputDto: EwalletClosureScheduleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateScheduledClosure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateScheduledClosure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateScheduledClosure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateScheduledClosure(id: string, inputDto: EwalletClosureScheduleInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledClosure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledClosure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateScheduledClosure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteScheduledClosure(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScheduledClosure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScheduledClosure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteScheduledClosure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPeriodicModes(): Observable<EwalletClosurePeriodicModeDto[]> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/periodic-modes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodicModes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodicModes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletClosurePeriodicModeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletClosurePeriodicModeDto[]>;
        }));
    }

    protected processGetPeriodicModes(response: HttpResponseBase): Observable<EwalletClosurePeriodicModeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EwalletClosurePeriodicModeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enablePeriodicScheduleMode(mode: EwalletClosureScheduleMode): Observable<EwalletClosurePeriodicModeDto> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/periodic-modes/{mode}/enable";
        if (mode === undefined || mode === null)
            throw new globalThis.Error("The parameter 'mode' must be defined.");
        url_ = url_.replace("{mode}", encodeURIComponent("" + mode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnablePeriodicScheduleMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnablePeriodicScheduleMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletClosurePeriodicModeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletClosurePeriodicModeDto>;
        }));
    }

    protected processEnablePeriodicScheduleMode(response: HttpResponseBase): Observable<EwalletClosurePeriodicModeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EwalletClosurePeriodicModeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    disablePeriodicScheduleMode(mode: EwalletClosureScheduleMode): Observable<EwalletClosurePeriodicModeDto> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureSchedule/periodic-modes/{mode}/disable";
        if (mode === undefined || mode === null)
            throw new globalThis.Error("The parameter 'mode' must be defined.");
        url_ = url_.replace("{mode}", encodeURIComponent("" + mode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisablePeriodicScheduleMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisablePeriodicScheduleMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletClosurePeriodicModeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletClosurePeriodicModeDto>;
        }));
    }

    protected processDisablePeriodicScheduleMode(response: HttpResponseBase): Observable<EwalletClosurePeriodicModeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EwalletClosurePeriodicModeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EwalletClosureDocumentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEwalletClosureDocuments(): Observable<EwalletClosureDocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureDocument";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEwalletClosureDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEwalletClosureDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletClosureDocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletClosureDocumentDto[]>;
        }));
    }

    protected processGetEwalletClosureDocuments(response: HttpResponseBase): Observable<EwalletClosureDocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EwalletClosureDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadEwalletClosureDocument(documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/EwalletClosureDocument/download/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEwalletClosureDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEwalletClosureDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEwalletClosureDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllEquipmentCategories(): Observable<EquipmentCategoryDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEquipmentCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEquipmentCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentCategoryDto[]>;
        }));
    }

    protected processGetAllEquipmentCategories(response: HttpResponseBase): Observable<EquipmentCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEquipmentCategory(equipmentCategoryDto: EquipmentCategoryDto): Observable<EquipmentCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentCategoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEquipmentCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEquipmentCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentCategoryDto>;
        }));
    }

    protected processCreateEquipmentCategory(response: HttpResponseBase): Observable<EquipmentCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEquipmentCategory(equipmentCategoryId: string, equipmentCategoryDto: EquipmentCategoryDto): Observable<EquipmentCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentCategory/{equipmentCategoryId}";
        if (equipmentCategoryId === undefined || equipmentCategoryId === null)
            throw new globalThis.Error("The parameter 'equipmentCategoryId' must be defined.");
        url_ = url_.replace("{equipmentCategoryId}", encodeURIComponent("" + equipmentCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentCategoryDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEquipmentCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEquipmentCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentCategoryDto>;
        }));
    }

    protected processUpdateEquipmentCategory(response: HttpResponseBase): Observable<EquipmentCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEquipmentCategory(equipmentCategoryId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentCategory/{equipmentCategoryId}";
        if (equipmentCategoryId === undefined || equipmentCategoryId === null)
            throw new globalThis.Error("The parameter 'equipmentCategoryId' must be defined.");
        url_ = url_.replace("{equipmentCategoryId}", encodeURIComponent("" + equipmentCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEquipmentCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEquipmentCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEquipmentCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentContractService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getContracts(): Observable<EquipmentContractDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContracts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentContractDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentContractDto[]>;
        }));
    }

    protected processGetContracts(response: HttpResponseBase): Observable<EquipmentContractDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentContractDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createContractForEquipment(equipmentId: string, contractType: ContractType | undefined, contractDto: EquipmentContractInputDto): Observable<EquipmentContractDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{equipmentId}?";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        if (contractType === null)
            throw new globalThis.Error("The parameter 'contractType' cannot be null.");
        else if (contractType !== undefined)
            url_ += "contractType=" + encodeURIComponent("" + contractType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contractDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContractForEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContractForEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentContractDto>;
        }));
    }

    protected processCreateContractForEquipment(response: HttpResponseBase): Observable<EquipmentContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateContract(contractId: string, contractDto: EquipmentContractDto): Observable<EquipmentContractDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contractDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentContractDto>;
        }));
    }

    protected processUpdateContract(response: HttpResponseBase): Observable<EquipmentContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    linkContractToEquipment(contractId: string, equipmentId: string | undefined, contractType: ContractType | undefined): Observable<EquipmentContractDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/link/{contractId}?";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' cannot be null.");
        else if (equipmentId !== undefined)
            url_ += "equipmentId=" + encodeURIComponent("" + equipmentId) + "&";
        if (contractType === null)
            throw new globalThis.Error("The parameter 'contractType' cannot be null.");
        else if (contractType !== undefined)
            url_ += "contractType=" + encodeURIComponent("" + contractType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkContractToEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkContractToEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentContractDto>;
        }));
    }

    protected processLinkContractToEquipment(response: HttpResponseBase): Observable<EquipmentContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlinkContractFormEquipment(contractId: string, equipmentId: string | undefined, contractType: ContractType | undefined, confirmed: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/unlink/{contractId}?";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' cannot be null.");
        else if (equipmentId !== undefined)
            url_ += "equipmentId=" + encodeURIComponent("" + equipmentId) + "&";
        if (contractType === null)
            throw new globalThis.Error("The parameter 'contractType' cannot be null.");
        else if (contractType !== undefined)
            url_ += "contractType=" + encodeURIComponent("" + contractType) + "&";
        if (confirmed === null)
            throw new globalThis.Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkContractFormEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkContractFormEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUnlinkContractFormEquipment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentToContract(contractId: string, title: string | null | undefined, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{contractId}/document";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDocumentToContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(contractId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{contractId}/document";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDocument(contractId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{contractId}/document/{documentId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocument(contractId: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentContract/{contractId}/document/{documentId}";
        if (contractId === undefined || contractId === null)
            throw new globalThis.Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchEquipments(pageableRequestDto: PageableRequestDtoOfEquipmentCriteriaDto): Observable<PagedResultDtoOfEquipmentLightDto> {
        let url_ = this.baseUrl + "/api/v1/Equipment/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEquipments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEquipments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEquipmentLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEquipmentLightDto>;
        }));
    }

    protected processSearchEquipments(response: HttpResponseBase): Observable<PagedResultDtoOfEquipmentLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEquipmentLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEquipmentById(equipmentId: string): Observable<EquipmentDto> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentDto>;
        }));
    }

    protected processGetEquipmentById(response: HttpResponseBase): Observable<EquipmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEquipment(equipmentId: string, equipmentDto: EquipmentInputDto): Observable<EquipmentDto> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentDto>;
        }));
    }

    protected processUpdateEquipment(response: HttpResponseBase): Observable<EquipmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEquipment(equipmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEquipment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEquipment(equipmentDto: EquipmentInputDto): Observable<EquipmentDto> {
        let url_ = this.baseUrl + "/api/v1/Equipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentDto>;
        }));
    }

    protected processCreateEquipment(response: HttpResponseBase): Observable<EquipmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentToEquipment(equipmentId: string, title: string | null | undefined, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}/document";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToEquipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToEquipment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDocumentToEquipment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(equipmentId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}/document";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDocument(equipmentId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}/document/{documentId}";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocument(equipmentId: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Equipment/{equipmentId}/document/{documentId}";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined.");
        url_ = url_.replace("{equipmentId}", encodeURIComponent("" + equipmentId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentEventService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEquipmentEventsForPeriod(dateTimeFrom: Date | undefined, dateTimeTo: Date | undefined): Observable<EquipmentEventLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent?";
        if (dateTimeFrom === null)
            throw new globalThis.Error("The parameter 'dateTimeFrom' cannot be null.");
        else if (dateTimeFrom !== undefined)
            url_ += "dateTimeFrom=" + encodeURIComponent(dateTimeFrom ? "" + dateTimeFrom.toISOString() : "") + "&";
        if (dateTimeTo === null)
            throw new globalThis.Error("The parameter 'dateTimeTo' cannot be null.");
        else if (dateTimeTo !== undefined)
            url_ += "dateTimeTo=" + encodeURIComponent(dateTimeTo ? "" + dateTimeTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipmentEventsForPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentEventsForPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentEventLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentEventLightDto[]>;
        }));
    }

    protected processGetEquipmentEventsForPeriod(response: HttpResponseBase): Observable<EquipmentEventLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentEventLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEquipmentEvent(equipmentEventDto: EquipmentEventInputDto): Observable<EquipmentEventDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEquipmentEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEquipmentEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentEventDto>;
        }));
    }

    protected processCreateEquipmentEvent(response: HttpResponseBase): Observable<EquipmentEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEquipmentEventById(equipmentEventId: string): Observable<EquipmentEventDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent/{equipmentEventId}";
        if (equipmentEventId === undefined || equipmentEventId === null)
            throw new globalThis.Error("The parameter 'equipmentEventId' must be defined.");
        url_ = url_.replace("{equipmentEventId}", encodeURIComponent("" + equipmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipmentEventById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentEventById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentEventDto>;
        }));
    }

    protected processGetEquipmentEventById(response: HttpResponseBase): Observable<EquipmentEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEquipmentEvent(equipmentEventId: string, equipmentEventDto: EquipmentEventInputDto): Observable<EquipmentEventDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent/{equipmentEventId}";
        if (equipmentEventId === undefined || equipmentEventId === null)
            throw new globalThis.Error("The parameter 'equipmentEventId' must be defined.");
        url_ = url_.replace("{equipmentEventId}", encodeURIComponent("" + equipmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentEventDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEquipmentEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEquipmentEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentEventDto>;
        }));
    }

    protected processUpdateEquipmentEvent(response: HttpResponseBase): Observable<EquipmentEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEquipmentEvent(equipmentEventId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent/{equipmentEventId}";
        if (equipmentEventId === undefined || equipmentEventId === null)
            throw new globalThis.Error("The parameter 'equipmentEventId' must be defined.");
        url_ = url_.replace("{equipmentEventId}", encodeURIComponent("" + equipmentEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEquipmentEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEquipmentEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEquipmentEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchEquipmentEvents(searchTerm: string | undefined): Observable<EquipmentEventLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentEvent/search?";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEquipmentEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEquipmentEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentEventLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentEventLightDto[]>;
        }));
    }

    protected processSearchEquipmentEvents(response: HttpResponseBase): Observable<EquipmentEventLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentEventLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EquipmentInterventionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchEquipmentInterventions(pageableRequestDto: PageableRequestDtoOfEquipmentInterventionCriteriaDto): Observable<PagedResultDtoOfEquipmentInterventionLightDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEquipmentInterventions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEquipmentInterventions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEquipmentInterventionLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEquipmentInterventionLightDto>;
        }));
    }

    protected processSearchEquipmentInterventions(response: HttpResponseBase): Observable<PagedResultDtoOfEquipmentInterventionLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEquipmentInterventionLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEquipmentInterventionById(equipmentInterventionId: string): Observable<EquipmentInterventionDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{equipmentInterventionId}";
        if (equipmentInterventionId === undefined || equipmentInterventionId === null)
            throw new globalThis.Error("The parameter 'equipmentInterventionId' must be defined.");
        url_ = url_.replace("{equipmentInterventionId}", encodeURIComponent("" + equipmentInterventionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipmentInterventionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentInterventionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentInterventionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentInterventionDto>;
        }));
    }

    protected processGetEquipmentInterventionById(response: HttpResponseBase): Observable<EquipmentInterventionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentInterventionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateEquipmentIntervention(equipmentInterventionId: string, equipmentInterventionInputDto: EquipmentInterventionInputDto): Observable<EquipmentInterventionDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{equipmentInterventionId}";
        if (equipmentInterventionId === undefined || equipmentInterventionId === null)
            throw new globalThis.Error("The parameter 'equipmentInterventionId' must be defined.");
        url_ = url_.replace("{equipmentInterventionId}", encodeURIComponent("" + equipmentInterventionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentInterventionInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEquipmentIntervention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEquipmentIntervention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentInterventionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentInterventionDto>;
        }));
    }

    protected processUpdateEquipmentIntervention(response: HttpResponseBase): Observable<EquipmentInterventionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentInterventionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEquipmentIntervention(equipmentInterventionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{equipmentInterventionId}";
        if (equipmentInterventionId === undefined || equipmentInterventionId === null)
            throw new globalThis.Error("The parameter 'equipmentInterventionId' must be defined.");
        url_ = url_.replace("{equipmentInterventionId}", encodeURIComponent("" + equipmentInterventionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEquipmentIntervention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEquipmentIntervention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEquipmentIntervention(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createEquipmentIntervention(equipmentInterventionInputDto: EquipmentInterventionInputDto): Observable<EquipmentInterventionDto> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentInterventionInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEquipmentIntervention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEquipmentIntervention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentInterventionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentInterventionDto>;
        }));
    }

    protected processCreateEquipmentIntervention(response: HttpResponseBase): Observable<EquipmentInterventionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentInterventionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addDocumentToIntervention(interventionId: string, title: string | null | undefined, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{interventionId}/document";
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToIntervention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToIntervention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDocumentToIntervention(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(interventionId: string): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{interventionId}/document";
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadDocument(interventionId: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{interventionId}/document/{documentId}";
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteDocument(interventionId: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EquipmentIntervention/{interventionId}/document/{documentId}";
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EnergyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getDataForCustomerCockpit(measuringPointId: string, dateFrom: string | undefined, dateTo: string | undefined): Observable<CustomerCockpitDataDto> {
        let url_ = this.baseUrl + "/api/v1/Energy/customer-cockpit/{measuringPointId}?";
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "from=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "to=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForCustomerCockpit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForCustomerCockpit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerCockpitDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerCockpitDataDto>;
        }));
    }

    protected processGetDataForCustomerCockpit(response: HttpResponseBase): Observable<CustomerCockpitDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerCockpitDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailablePeriodRangeForCurrentCustomerAndMeasuringPoint(measuringPointId: string): Observable<AvailablePeriodRangeDto> {
        let url_ = this.baseUrl + "/api/v1/Energy/customer-cockpit/{measuringPointId}/available-period-range";
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailablePeriodRangeForCurrentCustomerAndMeasuringPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailablePeriodRangeForCurrentCustomerAndMeasuringPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailablePeriodRangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailablePeriodRangeDto>;
        }));
    }

    protected processGetAvailablePeriodRangeForCurrentCustomerAndMeasuringPoint(response: HttpResponseBase): Observable<AvailablePeriodRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailablePeriodRangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataForCustomerCockpitWithCustomer(serviceId: string, measuringPointId: string, customerId: string | null | undefined, dateFrom: string | undefined, dateTo: string | undefined): Observable<CustomerCockpitDataDto> {
        let url_ = this.baseUrl + "/api/v1/Energy/for-service/{serviceId}/customer-cockpit-with-customer/{measuringPointId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (customerId !== undefined && customerId !== null)
            url_ += "customer=" + encodeURIComponent("" + customerId) + "&";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "from=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "to=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForCustomerCockpitWithCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForCustomerCockpitWithCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerCockpitDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerCockpitDataDto>;
        }));
    }

    protected processGetDataForCustomerCockpitWithCustomer(response: HttpResponseBase): Observable<CustomerCockpitDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerCockpitDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataForStateCockpit(serviceId: string, measuringPointId: string): Observable<StateCockpitDataDto> {
        let url_ = this.baseUrl + "/api/v1/Energy/for-service/{serviceId}/state-cockpit/{measuringPointId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForStateCockpit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForStateCockpit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateCockpitDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateCockpitDataDto>;
        }));
    }

    protected processGetDataForStateCockpit(response: HttpResponseBase): Observable<StateCockpitDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateCockpitDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDataForConsumptionCockpit(serviceId: string, measuringPointId: string, dateFrom: string | undefined, dateTo: string | undefined): Observable<ConsumptionCockpitDataDto> {
        let url_ = this.baseUrl + "/api/v1/Energy/for-service/{serviceId}/consumption-cockpit/{measuringPointId}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (measuringPointId === undefined || measuringPointId === null)
            throw new globalThis.Error("The parameter 'measuringPointId' must be defined.");
        url_ = url_.replace("{measuringPointId}", encodeURIComponent("" + measuringPointId));
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "from=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "to=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataForConsumptionCockpit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataForConsumptionCockpit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsumptionCockpitDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsumptionCockpitDataDto>;
        }));
    }

    protected processGetDataForConsumptionCockpit(response: HttpResponseBase): Observable<ConsumptionCockpitDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsumptionCockpitDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    downloadInstructionsManualDocument(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Document/public/download/instructions-manual";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInstructionsManualDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInstructionsManualDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInstructionsManualDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DatatransService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    paymentRequest(datatransPaymentRequestInputDto: DatatransPaymentRequestInputDto): Observable<DatatransPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/pay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datatransPaymentRequestInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatatransPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatatransPaymentRequestDto>;
        }));
    }

    protected processPaymentRequest(response: HttpResponseBase): Observable<DatatransPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatatransPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paymentRequestForVisitor(datatransPaymentRequestInputDto: DatatransPaymentRequestInputDto): Observable<DatatransPaymentRequestDto> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/public/pay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(datatransPaymentRequestInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentRequestForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentRequestForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatatransPaymentRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatatransPaymentRequestDto>;
        }));
    }

    protected processPaymentRequestForVisitor(response: HttpResponseBase): Observable<DatatransPaymentRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatatransPaymentRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    configuration(): Observable<DatatransConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/public/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DatatransConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DatatransConfigurationDto>;
        }));
    }

    protected processConfiguration(response: HttpResponseBase): Observable<DatatransConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatatransConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paymentHook(token: string | undefined, signature: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/paymentHook?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Datatrans-Signature": signature !== undefined && signature !== null ? "" + signature : "",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentHook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentHook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPaymentHook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    handleTransactionSuccessCallback(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/handle/success";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleTransactionSuccessCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleTransactionSuccessCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandleTransactionSuccessCallback(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    handleTransactionCancelCallback(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/handle/cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleTransactionCancelCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleTransactionCancelCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandleTransactionCancelCallback(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    handleTransactionErrorCallback(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Datatrans/handle/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleTransactionErrorCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleTransactionErrorCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processHandleTransactionErrorCallback(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEwalletByCustomerId(customerId: string): Observable<EwalletDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/ewallet";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEwalletByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEwalletByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletDto>;
        }));
    }

    protected processGetEwalletByCustomerId(response: HttpResponseBase): Observable<EwalletDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EwalletDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyEwallet(): Observable<EwalletDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/ewallet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyEwallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyEwallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletDto>;
        }));
    }

    protected processGetMyEwallet(response: HttpResponseBase): Observable<EwalletDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EwalletDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchTransactionsByCustomerId(customerId: string, pageableRequestDto: PageableRequestDtoOfCustomerTransactionCriteriaDto): Observable<PagedResultDtoOfTransactionDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/transactions/search";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTransactionsByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTransactionsByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTransactionDto>;
        }));
    }

    protected processSearchTransactionsByCustomerId(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchMyTransactions(pageableRequestDto: PageableRequestDtoOfCustomerTransactionCriteriaDto): Observable<PagedResultDtoOfTransactionDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/transactions/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMyTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMyTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTransactionDto>;
        }));
    }

    protected processSearchMyTransactions(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCustomers(pageableRequestDto: PageableRequestDtoOfCustomerCriteriaDto): Observable<PagedResultDtoOfCustomerLightDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerLightDto>;
        }));
    }

    protected processSearchCustomers(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomer(customerId: string): Observable<CustomerInputDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerInputDto>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<CustomerInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCustomer(customerId: string, customerInput: CustomerInputDto): Observable<CustomerInputDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerInputDto>;
        }));
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<CustomerInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCustomer(customerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerName(customerId: string): Observable<CustomerNameDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/customer-name";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerNameDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerNameDto>;
        }));
    }

    protected processGetCustomerName(response: HttpResponseBase): Observable<CustomerNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerNameDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerAuditEntries(customerId: string, pageableRequestDto: PageableRequestDto): Observable<PagedResultDtoOfCustomerAuditEntryDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/audits";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerAuditEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerAuditEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerAuditEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerAuditEntryDto>;
        }));
    }

    protected processGetCustomerAuditEntries(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerAuditEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerAuditEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCustomer(searchTerm: string): Observable<SearchCustomerDto[]> {
        let url_ = this.baseUrl + "/api/v1/Customer/search/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCustomerDto[]>;
        }));
    }

    protected processSearchCustomer(response: HttpResponseBase): Observable<SearchCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchCustomerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMe(): Observable<CustomerMeInputDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerMeInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerMeInputDto>;
        }));
    }

    protected processGetMe(response: HttpResponseBase): Observable<CustomerMeInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerMeInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMe(customerInput: CustomerMeInputDto): Observable<CustomerMeInputDto> {
        let url_ = this.baseUrl + "/api/v1/Customer/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerMeInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerMeInputDto>;
        }));
    }

    protected processUpdateMe(response: HttpResponseBase): Observable<CustomerMeInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerMeInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getNextCustomerNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/Customer/next-customer-number";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextCustomerNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextCustomerNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNextCustomerNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCustomer(customerInputDto: CustomerInputDto): Observable<CustomerLightDto> {
        let url_ = this.baseUrl + "/api/v1/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerLightDto>;
        }));
    }

    protected processCreateCustomer(response: HttpResponseBase): Observable<CustomerLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateCustomer(customerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/activate";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateCustomer(customerId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/deactivate";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomerNotDeletableReasons(customerId: string): Observable<number[]> {
        let url_ = this.baseUrl + "/api/v1/Customer/{customerId}/can-be-deleted";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerNotDeletableReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerNotDeletableReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetCustomerNotDeletableReasons(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importCustomerFromFile(file: FileParameter | null | undefined): Observable<ImportCustomer[]> {
        let url_ = this.baseUrl + "/api/v1/Customer/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCustomerFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCustomerFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportCustomer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportCustomer[]>;
        }));
    }

    protected processImportCustomerFromFile(response: HttpResponseBase): Observable<ImportCustomer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportCustomer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportCustomers(roleDtos: CustomRoleDto[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Customer/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportCustomers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCustomerInfoByCardUid(uid: string | undefined): Observable<EwalletCustomerInfoDto> {
        let url_ = this.baseUrl + "/api/v1/CustomerInfo/for-cash-machine?";
        if (uid === null)
            throw new globalThis.Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerInfoByCardUid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerInfoByCardUid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EwalletCustomerInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EwalletCustomerInfoDto>;
        }));
    }

    protected processGetCustomerInfoByCardUid(response: HttpResponseBase): Observable<EwalletCustomerInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EwalletCustomerInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPointOfSaleCustomerInfo(posId: string | undefined, cardNumber: string | null | undefined, cardUid: string | null | undefined): Observable<PointOfSaleCustomerInfoDto> {
        let url_ = this.baseUrl + "/api/v1/CustomerInfo/for-pos?";
        if (posId === null)
            throw new globalThis.Error("The parameter 'posId' cannot be null.");
        else if (posId !== undefined)
            url_ += "posId=" + encodeURIComponent("" + posId) + "&";
        if (cardNumber !== undefined && cardNumber !== null)
            url_ += "cardNumber=" + encodeURIComponent("" + cardNumber) + "&";
        if (cardUid !== undefined && cardUid !== null)
            url_ += "cardUid=" + encodeURIComponent("" + cardUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointOfSaleCustomerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointOfSaleCustomerInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PointOfSaleCustomerInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PointOfSaleCustomerInfoDto>;
        }));
    }

    protected processGetPointOfSaleCustomerInfo(response: HttpResponseBase): Observable<PointOfSaleCustomerInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PointOfSaleCustomerInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDumpsterUserInfoForCard(deviceId: string | undefined, cardUid: string | undefined): Observable<DumpsterUserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/CustomerInfo/for-dumpster-for-card?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (cardUid === null)
            throw new globalThis.Error("The parameter 'cardUid' cannot be null.");
        else if (cardUid !== undefined)
            url_ += "cardUid=" + encodeURIComponent("" + cardUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDumpsterUserInfoForCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDumpsterUserInfoForCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DumpsterUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DumpsterUserInfoDto>;
        }));
    }

    protected processGetDumpsterUserInfoForCard(response: HttpResponseBase): Observable<DumpsterUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DumpsterUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDumpsterUserInfoForUser(deviceId: string | undefined, customerId: string | undefined): Observable<DumpsterUserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/CustomerInfo/for-dumpster-for-user?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (customerId === null)
            throw new globalThis.Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDumpsterUserInfoForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDumpsterUserInfoForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DumpsterUserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DumpsterUserInfoDto>;
        }));
    }

    protected processGetDumpsterUserInfoForUser(response: HttpResponseBase): Observable<DumpsterUserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DumpsterUserInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerAlarmService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchAlarms(pageableRequestDto: PageableRequestDtoOfCustomerAlarmSearchCriteriaDto): Observable<PagedResultDtoOfCustomerAlarmDto> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarm/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlarms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlarms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCustomerAlarmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCustomerAlarmDto>;
        }));
    }

    protected processSearchAlarms(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerAlarmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerAlarmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerAlarmSubscriptionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getMySubscriptions(): Observable<CustomerAlarmSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/my-subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAlarmSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAlarmSubscriptionDto[]>;
        }));
    }

    protected processGetMySubscriptions(response: HttpResponseBase): Observable<CustomerAlarmSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAlarmSubscriptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSubscriptionTerminationDate(subscriptionId: string): Observable<Date> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/{subscriptionId}/next-termination-date";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionTerminationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionTerminationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetSubscriptionTerminationDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createSubscription(subscriptionInputDto: CustomerAlarmSubscriptionInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSubscription(subscriptionId: string, subscriptionDto: CustomerAlarmSubscriptionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateSubscription(subscriptionId: string, subscriptionDto: CustomerAlarmSubscriptionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/{subscriptionId}/terminate";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateSubscription(subscriptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/{subscriptionId}/activate";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateSubscription(subscriptionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CustomerAlarmSubscription/{subscriptionId}/deactivate";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningBillingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllToBillForService(serviceId: string): Observable<CraningBookingToBillDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningBilling/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllToBillForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllToBillForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingToBillDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingToBillDto[]>;
        }));
    }

    protected processGetAllToBillForService(response: HttpResponseBase): Observable<CraningBookingToBillDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningBookingToBillDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createCraningBilling(serviceId: string, input: CraningBillingInputDto): Observable<CraningBillingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBilling/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCraningBilling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCraningBilling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBillingDto>;
        }));
    }

    protected processCreateCraningBilling(response: HttpResponseBase): Observable<CraningBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBillingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBillForSlotIdForExploitant(serviceId: string, slotId: number): Observable<CraningBillingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBilling/for-service/{serviceId}/for-slot/{slotId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (slotId === undefined || slotId === null)
            throw new globalThis.Error("The parameter 'slotId' must be defined.");
        url_ = url_.replace("{slotId}", encodeURIComponent("" + slotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForSlotIdForExploitant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForSlotIdForExploitant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBillingDto>;
        }));
    }

    protected processGetBillForSlotIdForExploitant(response: HttpResponseBase): Observable<CraningBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBillingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBillForSlotId(slotId: number): Observable<CraningBillingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBilling/for-slot/{slotId}";
        if (slotId === undefined || slotId === null)
            throw new globalThis.Error("The parameter 'slotId' must be defined.");
        url_ = url_.replace("{slotId}", encodeURIComponent("" + slotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForSlotId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForSlotId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBillingDto>;
        }));
    }

    protected processGetBillForSlotId(response: HttpResponseBase): Observable<CraningBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBillingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadCraningBillingReport(serviceId: string, id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/CraningBilling/for-service/{serviceId}/{id}/report";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCraningBillingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCraningBillingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCraningBillingReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningBookingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getForBookingSlotForAdmin(serviceId: string, bookingSlotId: number): Observable<CraningBookingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin/for-booking-slot/{bookingSlotId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (bookingSlotId === undefined || bookingSlotId === null)
            throw new globalThis.Error("The parameter 'bookingSlotId' must be defined.");
        url_ = url_.replace("{bookingSlotId}", encodeURIComponent("" + bookingSlotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForBookingSlotForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForBookingSlotForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingDto>;
        }));
    }

    protected processGetForBookingSlotForAdmin(response: HttpResponseBase): Observable<CraningBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForBookingSlot(bookingSlotId: number): Observable<CraningBookingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-booking-slot/{bookingSlotId}";
        if (bookingSlotId === undefined || bookingSlotId === null)
            throw new globalThis.Error("The parameter 'bookingSlotId' must be defined.");
        url_ = url_.replace("{bookingSlotId}", encodeURIComponent("" + bookingSlotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForBookingSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForBookingSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingDto>;
        }));
    }

    protected processGetForBookingSlot(response: HttpResponseBase): Observable<CraningBookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getForAdmin(serviceId: string, id: number): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processGetForAdmin(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteForAdmin(serviceId: string, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteForAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: number): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: number, updateInputDto: CraningBookingInputDto): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCraningBookings(serviceId: string, from: Date, to: Date): Observable<CraningBookingWithSlotDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCraningBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCraningBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto[]>;
        }));
    }

    protected processGetCraningBookings(response: HttpResponseBase): Observable<CraningBookingWithSlotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningBookingWithSlotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyNextCraningBookingForService(serviceId: string): Observable<MyServicesNextEntryDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/my-bookings/for-service/{serviceId}/next";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNextCraningBookingForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNextCraningBookingForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyServicesNextEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyServicesNextEntryDto>;
        }));
    }

    protected processGetMyNextCraningBookingForService(response: HttpResponseBase): Observable<MyServicesNextEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyServicesNextEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyNextCraningBookingSlotForService(serviceId: string): Observable<CraningBookingSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/my-bookings/for-service/{serviceId}/next/slot";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNextCraningBookingSlotForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNextCraningBookingSlotForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingSlotDto>;
        }));
    }

    protected processGetMyNextCraningBookingSlotForService(response: HttpResponseBase): Observable<CraningBookingSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    countPlannedCraningBookings(serviceId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/my-bookings/for-service/{serviceId}/count-planned";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountPlannedCraningBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountPlannedCraningBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountPlannedCraningBookings(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createForAdmin(serviceId: string, createInputDto: CraningBookingInputDto): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processCreateForAdmin(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(createInputDto: CraningBookingInputDto): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createForVisitor(createInputDto: CraningBookingInputDto): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/public";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processCreateForVisitor(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateForAdmin(serviceId: string, id: number, forBilling: boolean, updateInputDto: CraningBookingInputDto): Observable<CraningBookingWithSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBooking/for-service/{serviceId}/admin/{id}/{forBilling}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (forBilling === undefined || forBilling === null)
            throw new globalThis.Error("The parameter 'forBilling' must be defined.");
        url_ = url_.replace("{forBilling}", encodeURIComponent("" + forBilling));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingWithSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingWithSlotDto>;
        }));
    }

    protected processUpdateForAdmin(response: HttpResponseBase): Observable<CraningBookingWithSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingWithSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningBookingSlotService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCraningSlot(serviceId: string, id: number): Observable<CraningBookingSlotDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCraningSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCraningSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingSlotDto>;
        }));
    }

    protected processGetCraningSlot(response: HttpResponseBase): Observable<CraningBookingSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningBookingSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCraningBookingSlot(serviceId: string, id: number, parameters: CraningBookingSlotInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCraningBookingSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCraningBookingSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCraningBookingSlot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCraningBookingSlot(serviceId: string, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCraningBookingSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCraningBookingSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCraningBookingSlot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAdminCraningSlots(serviceId: string, from: Date, to: Date, stateFilter: CraningBookingSlotState[] | null | undefined, searchTerms: string | null | undefined): Observable<CraningBookingSlotItemDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/admin/{from}/{to}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        if (stateFilter !== undefined && stateFilter !== null)
            stateFilter && stateFilter.forEach(item => { url_ += "state-filter=" + encodeURIComponent("" + item) + "&"; });
        if (searchTerms !== undefined && searchTerms !== null)
            url_ += "search-terms=" + encodeURIComponent("" + searchTerms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminCraningSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminCraningSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingSlotItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingSlotItemDto[]>;
        }));
    }

    protected processGetAdminCraningSlots(response: HttpResponseBase): Observable<CraningBookingSlotItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningBookingSlotItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCraningSlots(serviceId: string, from: Date, to: Date, stateFilter: CraningBookingSlotState[] | null | undefined): Observable<CraningBookingSlotItemDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/{from}/{to}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        if (stateFilter !== undefined && stateFilter !== null)
            stateFilter && stateFilter.forEach(item => { url_ += "state-filter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCraningSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCraningSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingSlotItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingSlotItemDto[]>;
        }));
    }

    protected processGetCraningSlots(response: HttpResponseBase): Observable<CraningBookingSlotItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningBookingSlotItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCraningBookingSlotGroup(serviceId: string, from: Date, to: Date): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCraningBookingSlotGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCraningBookingSlotGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteCraningBookingSlotGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPublicCraningSlots(serviceId: string, from: Date, to: Date, stateFilter: CraningBookingSlotState[] | null | undefined): Observable<CraningBookingSlotAnonymousItemDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/public/for-service/{serviceId}/{from}/{to}?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        if (stateFilter !== undefined && stateFilter !== null)
            stateFilter && stateFilter.forEach(item => { url_ += "state-filter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicCraningSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicCraningSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningBookingSlotAnonymousItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningBookingSlotAnonymousItemDto[]>;
        }));
    }

    protected processGetPublicCraningSlots(response: HttpResponseBase): Observable<CraningBookingSlotAnonymousItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningBookingSlotAnonymousItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateCraningBookingSlots(serviceId: string, parameters: GeneratingCraningBookingSlotsInputDto): Observable<GeneratingCraningBookingSlotsOutputDto> {
        let url_ = this.baseUrl + "/api/v1/CraningBookingSlot/for-service/{serviceId}/generate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCraningBookingSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCraningBookingSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratingCraningBookingSlotsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratingCraningBookingSlotsOutputDto>;
        }));
    }

    protected processGenerateCraningBookingSlots(response: HttpResponseBase): Observable<GeneratingCraningBookingSlotsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneratingCraningBookingSlotsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningServiceService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(serviceId: string): Observable<CraningServiceDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningService/public/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CraningServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningServiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(serviceId: string, id: string): Observable<CraningServiceDto> {
        let url_ = this.baseUrl + "/api/v1/CraningService/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CraningServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(serviceId: string, id: string, updateInputDto: CraningServiceInputDto): Observable<CraningServiceDto> {
        let url_ = this.baseUrl + "/api/v1/CraningService/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CraningServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningService/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(serviceId: string, createInputDto: CraningServiceInputDto): Observable<CraningServiceDto> {
        let url_ = this.baseUrl + "/api/v1/CraningService/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CraningServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningServicePricingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(craningServiceId: string): Observable<CraningServicePricingDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningServicePricing/public/for-craning-service/{craningServiceId}";
        if (craningServiceId === undefined || craningServiceId === null)
            throw new globalThis.Error("The parameter 'craningServiceId' must be defined.");
        url_ = url_.replace("{craningServiceId}", encodeURIComponent("" + craningServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServicePricingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServicePricingDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CraningServicePricingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningServicePricingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(serviceId: string, id: string): Observable<CraningServicePricingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServicePricing/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServicePricingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServicePricingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CraningServicePricingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServicePricingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(serviceId: string, id: string, updateInputDto: CraningServicePricingInputDto): Observable<CraningServicePricingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServicePricing/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServicePricingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServicePricingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CraningServicePricingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServicePricingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningServicePricing/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(serviceId: string, craningServiceId: string, createInputDto: CraningServicePricingInputDto): Observable<CraningServicePricingDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServicePricing/for-service/{serviceId}/for-craning-service/{craningServiceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (craningServiceId === undefined || craningServiceId === null)
            throw new globalThis.Error("The parameter 'craningServiceId' must be defined.");
        url_ = url_.replace("{craningServiceId}", encodeURIComponent("" + craningServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServicePricingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServicePricingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CraningServicePricingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServicePricingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CraningServiceQuestionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(craningServiceId: string): Observable<CraningServiceQuestionDto[]> {
        let url_ = this.baseUrl + "/api/v1/CraningServiceQuestion/public/for-craning-service/{craningServiceId}";
        if (craningServiceId === undefined || craningServiceId === null)
            throw new globalThis.Error("The parameter 'craningServiceId' must be defined.");
        url_ = url_.replace("{craningServiceId}", encodeURIComponent("" + craningServiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceQuestionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CraningServiceQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraningServiceQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(serviceId: string, id: string): Observable<CraningServiceQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServiceQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceQuestionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CraningServiceQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(serviceId: string, id: string, updateInputDto: CraningServiceQuestionInputDto): Observable<CraningServiceQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServiceQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceQuestionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CraningServiceQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CraningServiceQuestion/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(serviceId: string, craningServiceId: string, createInputDto: CraningServiceQuestionInputDto): Observable<CraningServiceQuestionDto> {
        let url_ = this.baseUrl + "/api/v1/CraningServiceQuestion/for-service/{serviceId}/for-craning-service/{craningServiceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (craningServiceId === undefined || craningServiceId === null)
            throw new globalThis.Error("The parameter 'craningServiceId' must be defined.");
        url_ = url_.replace("{craningServiceId}", encodeURIComponent("" + craningServiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CraningServiceQuestionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CraningServiceQuestionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CraningServiceQuestionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CraningServiceQuestionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCustomerConfiguration(): Observable<CustomerConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/Configuration/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerConfigurationDto>;
        }));
    }

    protected processGetCustomerConfiguration(response: HttpResponseBase): Observable<CustomerConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isFalconicActive(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Configuration/public/falconic/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsFalconicActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsFalconicActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsFalconicActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationChannelService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hasUnreadContentForCustomer(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/CommunicationChannel/has-unread-content";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasUnreadContentForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasUnreadContentForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasUnreadContentForCustomer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContactConfigurationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getContactConfiguration(): Observable<ContactConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/ContactConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactConfigurationDto>;
        }));
    }

    protected processGetContactConfiguration(response: HttpResponseBase): Observable<ContactConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveContactConfiguration(configurationDto: ContactConfigurationDto): Observable<ContactConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/ContactConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configurationDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContactConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContactConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactConfigurationDto>;
        }));
    }

    protected processSaveContactConfiguration(response: HttpResponseBase): Observable<ContactConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getContactCgu(): Observable<CguDto> {
        let url_ = this.baseUrl + "/api/v1/ContactConfiguration/cgu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactCgu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactCgu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CguDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CguDto>;
        }));
    }

    protected processGetContactCgu(response: HttpResponseBase): Observable<CguDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CguDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hasAccessToContact(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/ContactConfiguration/hasAccess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAccessToContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAccessToContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAccessToContact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sendContactMail(mailDto: ContactMailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendContactMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendContactMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendContactMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiagnosticService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    generateReceiptTest(to: string[] | undefined, transactionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Diagnostic/generate-receipt-test?";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            to && to.forEach(item => { url_ += "to=" + encodeURIComponent("" + item) + "&"; });
        if (transactionId === null)
            throw new globalThis.Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReceiptTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReceiptTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateReceiptTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendEmailTest(to: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Diagnostic/send-email-test?";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendPushTest(tokens: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Diagnostic/send-push-test?";
        if (tokens === null)
            throw new globalThis.Error("The parameter 'tokens' cannot be null.");
        else if (tokens !== undefined)
            tokens && tokens.forEach(item => { url_ += "tokens=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPushTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPushTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPushTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChargingStationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getChargingStationsForService(serviceId: string): Observable<ChargingStationDto[]> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/public/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChargingStationsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChargingStationsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargingStationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargingStationDto[]>;
        }));
    }

    protected processGetChargingStationsForService(response: HttpResponseBase): Observable<ChargingStationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChargingStationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChargingStationByExternalId(serviceId: string, chargingStationExternalId: string): Observable<ChargingStationDto> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/public/for-service/{serviceId}/{chargingStationId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (chargingStationExternalId === undefined || chargingStationExternalId === null)
            throw new globalThis.Error("The parameter 'chargingStationExternalId' must be defined.");
        url_ = url_.replace("{chargingStationId}", encodeURIComponent("" + chargingStationExternalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChargingStationByExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChargingStationByExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargingStationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargingStationDto>;
        }));
    }

    protected processGetChargingStationByExternalId(response: HttpResponseBase): Observable<ChargingStationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChargingStationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChargingStationEvseStatesForService(serviceId: string): Observable<ChargingStationEvseStateDto[]> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/public/for-service/{serviceId}/evse-states";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChargingStationEvseStatesForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChargingStationEvseStatesForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargingStationEvseStateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargingStationEvseStateDto[]>;
        }));
    }

    protected processGetChargingStationEvseStatesForService(response: HttpResponseBase): Observable<ChargingStationEvseStateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChargingStationEvseStateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChargingStationEvseState(chargingStationId: string, evseIndex: number): Observable<ChargingStationEvseStatus> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/public/for-charging-station/{chargingStationId}/evse-states/{evseIndex}";
        if (chargingStationId === undefined || chargingStationId === null)
            throw new globalThis.Error("The parameter 'chargingStationId' must be defined.");
        url_ = url_.replace("{chargingStationId}", encodeURIComponent("" + chargingStationId));
        if (evseIndex === undefined || evseIndex === null)
            throw new globalThis.Error("The parameter 'evseIndex' must be defined.");
        url_ = url_.replace("{evseIndex}", encodeURIComponent("" + evseIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChargingStationEvseState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChargingStationEvseState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargingStationEvseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargingStationEvseStatus>;
        }));
    }

    protected processGetChargingStationEvseState(response: HttpResponseBase): Observable<ChargingStationEvseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChargingStation(serviceId: string, chargingStationInputDto: ChargingStationInputDto): Observable<ChargingStationDto> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chargingStationInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateChargingStation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateChargingStation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChargingStationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChargingStationDto>;
        }));
    }

    protected processCreateChargingStation(response: HttpResponseBase): Observable<ChargingStationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChargingStationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateChargingStation(serviceId: string, chargingStationId: string, chargingStationInputDto: ChargingStationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/for-service/{serviceId}/{chargingStationId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (chargingStationId === undefined || chargingStationId === null)
            throw new globalThis.Error("The parameter 'chargingStationId' must be defined.");
        url_ = url_.replace("{chargingStationId}", encodeURIComponent("" + chargingStationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chargingStationInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateChargingStation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChargingStation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateChargingStation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteChargingStation(serviceId: string, chargingStationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/for-service/{serviceId}/{chargingStationId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (chargingStationId === undefined || chargingStationId === null)
            throw new globalThis.Error("The parameter 'chargingStationId' must be defined.");
        url_ = url_.replace("{chargingStationId}", encodeURIComponent("" + chargingStationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteChargingStation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChargingStation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteChargingStation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unlockEvse(serviceId: string, chargingStationId: string, evseIndex: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingStation/for-service/{serviceId}/{chargingStationId}/evse/{evseIndex}/unlock";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (chargingStationId === undefined || chargingStationId === null)
            throw new globalThis.Error("The parameter 'chargingStationId' must be defined.");
        url_ = url_.replace("{chargingStationId}", encodeURIComponent("" + chargingStationId));
        if (evseIndex === undefined || evseIndex === null)
            throw new globalThis.Error("The parameter 'evseIndex' must be defined.");
        url_ = url_.replace("{evseIndex}", encodeURIComponent("" + evseIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockEvse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockEvse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockEvse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChargingProcessService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchMyChargingProcesses(pageableRequestDto: PageableRequestDtoOfChargingProcessSearchCriteriaDto): Observable<PagedResultDtoOfChargingProcessDto> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMyChargingProcesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMyChargingProcesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChargingProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChargingProcessDto>;
        }));
    }

    protected processSearchMyChargingProcesses(response: HttpResponseBase): Observable<PagedResultDtoOfChargingProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChargingProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchChargingProcessesForService(serviceId: string, pageableRequestDto: PageableRequestDtoOfChargingProcessSearchCriteriaDto): Observable<PagedResultDtoOfChargingProcessDto> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/for-service/{serviceId}/search";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchChargingProcessesForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchChargingProcessesForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfChargingProcessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfChargingProcessDto>;
        }));
    }

    protected processSearchChargingProcessesForService(response: HttpResponseBase): Observable<PagedResultDtoOfChargingProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfChargingProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateChargingProcess(consumeServicePayloadDto: ConsumeServicePayloadDtoOfChargingProcessInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consumeServicePayloadDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateChargingProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateChargingProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateChargingProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateChargingProcessForVisitor(consumeServicePayloadDto: ConsumeServicePayloadDtoOfChargingProcessInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/public/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consumeServicePayloadDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateChargingProcessForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateChargingProcessForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateChargingProcessForVisitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateMyChargingProcess(chargingProcessId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/{chargingProcessId}/deactivate";
        if (chargingProcessId === undefined || chargingProcessId === null)
            throw new globalThis.Error("The parameter 'chargingProcessId' must be defined.");
        url_ = url_.replace("{chargingProcessId}", encodeURIComponent("" + chargingProcessId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateMyChargingProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateMyChargingProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateMyChargingProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateChargingProcessForService(serviceId: string, chargingProcessId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/for-service/{serviceId}/{chargingProcessId}/deactivate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (chargingProcessId === undefined || chargingProcessId === null)
            throw new globalThis.Error("The parameter 'chargingProcessId' must be defined.");
        url_ = url_.replace("{chargingProcessId}", encodeURIComponent("" + chargingProcessId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateChargingProcessForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateChargingProcessForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateChargingProcessForService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateChargingProcessForVisitor(chargingProcessId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ChargingProcess/public/{chargingProcessId}/deactivate";
        if (chargingProcessId === undefined || chargingProcessId === null)
            throw new globalThis.Error("The parameter 'chargingProcessId' must be defined.");
        url_ = url_.replace("{chargingProcessId}", encodeURIComponent("" + chargingProcessId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateChargingProcessForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateChargingProcessForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateChargingProcessForVisitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CardService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCardsForCustomerForService(serviceId: string, customerId: string): Observable<CardLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Card/for-service/{serviceId}/for-customer/{customerId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardsForCustomerForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardsForCustomerForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardLightDto[]>;
        }));
    }

    protected processGetCardsForCustomerForService(response: HttpResponseBase): Observable<CardLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createRfidCard(cardDto: CardDto): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRfidCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRfidCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processCreateRfidCard(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRfidCard(cardNumber: string, cardDto: CardDto): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/{cardNumber}";
        if (cardNumber === undefined || cardNumber === null)
            throw new globalThis.Error("The parameter 'cardNumber' must be defined.");
        url_ = url_.replace("{cardNumber}", encodeURIComponent("" + cardNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRfidCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRfidCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processUpdateRfidCard(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteRfidCard(cardNumber: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Card/{cardNumber}";
        if (cardNumber === undefined || cardNumber === null)
            throw new globalThis.Error("The parameter 'cardNumber' must be defined.");
        url_ = url_.replace("{cardNumber}", encodeURIComponent("" + cardNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRfidCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRfidCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRfidCard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchRfidCards(pageableRequestDto: PageableRequestDtoOfRfidCardCriteriaDto): Observable<PagedResultDtoOfCardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchRfidCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRfidCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCardDto>;
        }));
    }

    protected processSearchRfidCards(response: HttpResponseBase): Observable<PagedResultDtoOfCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchUnassignedRfidCards(searchTerm: string): Observable<CardDto[]> {
        let url_ = this.baseUrl + "/api/v1/Card/search-unassigned/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUnassignedRfidCards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUnassignedRfidCards(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto[]>;
        }));
    }

    protected processSearchUnassignedRfidCards(response: HttpResponseBase): Observable<CardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignRfidCardToCustomer(customerId: string, cardDto: CardDto): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/assign/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignRfidCardToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignRfidCardToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processAssignRfidCardToCustomer(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignRfidCard(cardDto: CardDto): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/unassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cardDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignRfidCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignRfidCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processUnassignRfidCard(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isRfidCardAlreadyAssigned(uid: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Card/uid/{uid}/is-assigned";
        if (uid === undefined || uid === null)
            throw new globalThis.Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRfidCardAlreadyAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRfidCardAlreadyAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsRfidCardAlreadyAssigned(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importRfidCardsFromFile(excelFile: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Card/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportRfidCardsFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportRfidCardsFromFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportRfidCardsFromFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyVirtualCard(): Observable<VirtualCardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/my-virtual-card";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyVirtualCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyVirtualCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VirtualCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VirtualCardDto>;
        }));
    }

    protected processGetMyVirtualCard(response: HttpResponseBase): Observable<VirtualCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualCardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVirtualCardForCustomer(customerId: string): Observable<VirtualCardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/for-customer/{customerId}/virtual-card";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVirtualCardForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVirtualCardForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VirtualCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VirtualCardDto>;
        }));
    }

    protected processGetVirtualCardForCustomer(response: HttpResponseBase): Observable<VirtualCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualCardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    regenerateMyVirtualCard(): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/my-virtual-card/regenerate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateMyVirtualCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateMyVirtualCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processRegenerateMyVirtualCard(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    regenerateVirtualCardForCustomer(customerId: string): Observable<CardDto> {
        let url_ = this.baseUrl + "/api/v1/Card/for-customer/{customerId}/virtual-card/regenerate";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateVirtualCardForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateVirtualCardForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CardDto>;
        }));
    }

    protected processRegenerateVirtualCardForCustomer(response: HttpResponseBase): Observable<CardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BookingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBooking(serviceId: string, id: string): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processGetBooking(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBooking(serviceId: string, id: string, bookingInputDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelBooking(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyBooking(bookingId: string): Observable<BookingDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingDto>;
        }));
    }

    protected processGetMyBooking(response: HttpResponseBase): Observable<BookingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllBookings(serviceId: string): Observable<BookingLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/all";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingLightDto[]>;
        }));
    }

    protected processGetAllBookings(response: HttpResponseBase): Observable<BookingLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBookingsForService(serviceId: string, from: Date, to: Date): Observable<BookingLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingLightDto[]>;
        }));
    }

    protected processGetBookingsForService(response: HttpResponseBase): Observable<BookingLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyBookingsForService(serviceId: string, from: Date, to: Date): Observable<BookingLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyBookingsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyBookingsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingLightDto[]>;
        }));
    }

    protected processGetMyBookingsForService(response: HttpResponseBase): Observable<BookingLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBookingsForServiceWithoutCustomerData(serviceId: string, from: Date, to: Date): Observable<BookingLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/public/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingsForServiceWithoutCustomerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingsForServiceWithoutCustomerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingLightDto[]>;
        }));
    }

    protected processGetBookingsForServiceWithoutCustomerData(response: HttpResponseBase): Observable<BookingLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyNextBookingForService(serviceId: string): Observable<MyServicesNextEntryDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/for-service/{serviceId}/next";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNextBookingForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNextBookingForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MyServicesNextEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MyServicesNextEntryDto>;
        }));
    }

    protected processGetMyNextBookingForService(response: HttpResponseBase): Observable<MyServicesNextEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyServicesNextEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchBookingsForService(serviceId: string, searchTerm: string | undefined): Observable<BookingLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/search?";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBookingsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBookingsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingLightDto[]>;
        }));
    }

    protected processSearchBookingsForService(response: HttpResponseBase): Observable<BookingLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBooking(serviceId: string, bookingDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBookingForCustomer(bookingDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBookingForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBookingForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBookingForCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBookingForVisitor(bookingInputDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/public";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBookingForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBookingForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBookingForVisitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBookingForCustomer(id: string, bookingInputDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBookingForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBookingForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBookingForCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelBookingForCustomer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBookingForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBookingForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelBookingForCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelPartialRecurringBookingForAdmin(serviceId: string, id: string, from: Date, to: Date): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/recurring/{id}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPartialRecurringBookingForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPartialRecurringBookingForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPartialRecurringBookingForAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelPartialRecurringBookingForCustomer(id: string, from: Date, to: Date): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/my-bookings/recurring/{id}/{from}/{to}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPartialRecurringBookingForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPartialRecurringBookingForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPartialRecurringBookingForCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBlocking(serviceId: string, bookingInputDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/blocking";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlocking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlocking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBlocking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBlocking(serviceId: string, id: string, bookingInputDto: BookingInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/blocking/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBlocking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBlocking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBlocking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBlocking(serviceId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/for-service/{serviceId}/blocking/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlocking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlocking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBlocking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOverlappingBookings(bookingId: string, bookingInputDto: BookingInputDto): Observable<BookingConflictDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/public/overlapping/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverlappingBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverlappingBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingConflictDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingConflictDto[]>;
        }));
    }

    protected processGetOverlappingBookings(response: HttpResponseBase): Observable<BookingConflictDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingConflictDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPriceOfNewBooking(newBookingInputDto: BookingInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Booking/public/price-of-booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newBookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceOfNewBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceOfNewBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPriceOfNewBooking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPriceOfBookingChange(bookingId: string, newBookingInputDto: BookingInputDto): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/Booking/public/price-of-booking-change/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newBookingInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPriceOfBookingChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPriceOfBookingChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPriceOfBookingChange(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BookingServiceConfigService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBookingServiceConfigForService(serviceId: string): Observable<BookingServiceConfigDto> {
        let url_ = this.baseUrl + "/api/v1/BookingServiceConfig/public/service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingServiceConfigForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingServiceConfigForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingServiceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingServiceConfigDto>;
        }));
    }

    protected processGetBookingServiceConfigForService(response: HttpResponseBase): Observable<BookingServiceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingServiceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBookingServiceConfigForService(serviceId: string, bookingConfig: BookingServiceConfigInputDto): Observable<BookingServiceConfigDto> {
        let url_ = this.baseUrl + "/api/v1/BookingServiceConfig/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBookingServiceConfigForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBookingServiceConfigForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingServiceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingServiceConfigDto>;
        }));
    }

    protected processCreateBookingServiceConfigForService(response: HttpResponseBase): Observable<BookingServiceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingServiceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBookingServiceConfigForService(serviceId: string, bookingConfig: BookingServiceConfigInputDto): Observable<BookingServiceConfigDto> {
        let url_ = this.baseUrl + "/api/v1/BookingServiceConfig/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBookingServiceConfigForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBookingServiceConfigForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingServiceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingServiceConfigDto>;
        }));
    }

    protected processUpdateBookingServiceConfigForService(response: HttpResponseBase): Observable<BookingServiceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingServiceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BookingSlotService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getBookingSlotsForAdmin(serviceId: string, from: Date, to: Date): Observable<BookingSlotDto[]> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingSlotsForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingSlotsForAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingSlotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingSlotDto[]>;
        }));
    }

    protected processGetBookingSlotsForAdmin(response: HttpResponseBase): Observable<BookingSlotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingSlotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBookingSlotGroup(serviceId: string, from: Date, to: Date): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBookingSlotGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBookingSlotGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteBookingSlotGroup(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBookingSlotsForCustomer(serviceId: string, from: Date, to: Date): Observable<BookingSlotDto[]> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/my-bookings/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingSlotsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingSlotsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingSlotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingSlotDto[]>;
        }));
    }

    protected processGetBookingSlotsForCustomer(response: HttpResponseBase): Observable<BookingSlotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingSlotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBookingSlotsForVisitor(serviceId: string, from: Date, to: Date): Observable<BookingSlotDto[]> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/public/for-service/{serviceId}/{from}/{to}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (from === undefined || from === null)
            throw new globalThis.Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
        if (to === undefined || to === null)
            throw new globalThis.Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBookingSlotsForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBookingSlotsForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingSlotDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingSlotDto[]>;
        }));
    }

    protected processGetBookingSlotsForVisitor(response: HttpResponseBase): Observable<BookingSlotDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BookingSlotDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBookingSlot(serviceId: string, id: number, parameters: BookingSlotInputDto): Observable<BookingSlotDto> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBookingSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBookingSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingSlotDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingSlotDto>;
        }));
    }

    protected processUpdateBookingSlot(response: HttpResponseBase): Observable<BookingSlotDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingSlotDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBookingSlot(serviceId: string, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/for-service/{serviceId}/{id}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBookingSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBookingSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBookingSlot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateBookingSlots(serviceId: string, parameters: GeneratingBookingSlotsInputDto): Observable<GeneratingBookingSlotsOutputDto> {
        let url_ = this.baseUrl + "/api/v1/BookingSlot/for-service/{serviceId}/generate";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBookingSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBookingSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneratingBookingSlotsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneratingBookingSlotsOutputDto>;
        }));
    }

    protected processGenerateBookingSlots(response: HttpResponseBase): Observable<GeneratingBookingSlotsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneratingBookingSlotsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BillingService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchBillings(pageableRequestDto: PageableRequestDtoOfBillingCriteriaDto): Observable<PagedResultDtoOfBillingDto> {
        let url_ = this.baseUrl + "/api/v1/Billing/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBillings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBillings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBillingDto>;
        }));
    }

    protected processSearchBillings(response: HttpResponseBase): Observable<PagedResultDtoOfBillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeBillingState(billingStateDto: BillingStateDto): Observable<BillingDto> {
        let url_ = this.baseUrl + "/api/v1/Billing/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(billingStateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeBillingState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeBillingState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillingDto>;
        }));
    }

    protected processChangeBillingState(response: HttpResponseBase): Observable<BillingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BackofficeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllBackoffices(property: string | null | undefined, direction: SortDirection | undefined): Observable<BackofficeLightDto[]> {
        let url_ = this.baseUrl + "/api/v1/Backoffice?";
        if (property !== undefined && property !== null)
            url_ += "Property=" + encodeURIComponent("" + property) + "&";
        if (direction === null)
            throw new globalThis.Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBackoffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBackoffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeLightDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeLightDto[]>;
        }));
    }

    protected processGetAllBackoffices(response: HttpResponseBase): Observable<BackofficeLightDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BackofficeLightDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createBackoffice(backofficeInputDto: BackofficeInputDto): Observable<BackofficeLightDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(backofficeInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeLightDto>;
        }));
    }

    protected processCreateBackoffice(response: HttpResponseBase): Observable<BackofficeLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackofficeLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchBackoffices(criteria: SearchBackofficeCriteriaDto): Observable<SearchBackofficeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBackoffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBackoffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchBackofficeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchBackofficeDto[]>;
        }));
    }

    protected processSearchBackoffices(response: HttpResponseBase): Observable<SearchBackofficeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchBackofficeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBackoffice(id: string): Observable<BackofficeInputDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeInputDto>;
        }));
    }

    protected processGetBackoffice(response: HttpResponseBase): Observable<BackofficeInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackofficeInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBackoffice(id: string, backofficeInputDto: BackofficeInputDto): Observable<BackofficeLightDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(backofficeInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeLightDto>;
        }));
    }

    protected processUpdateBackoffice(response: HttpResponseBase): Observable<BackofficeLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackofficeLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteBackoffice(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBackoffice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMe(): Observable<BackofficeMeDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeMeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeMeDto>;
        }));
    }

    protected processGetMe(response: HttpResponseBase): Observable<BackofficeMeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackofficeMeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMe(backofficeMeInputDto: BackofficeMeInputDto): Observable<BackofficeMeInputDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(backofficeMeInputDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackofficeMeInputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackofficeMeInputDto>;
        }));
    }

    protected processUpdateMe(response: HttpResponseBase): Observable<BackofficeMeInputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackofficeMeInputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBackofficeAuditEntries(backofficeId: string, pageableRequestDto: PageableRequestDto): Observable<PagedResultDtoOfBackofficeAuditEntryDto> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/{backofficeId}/audits";
        if (backofficeId === undefined || backofficeId === null)
            throw new globalThis.Error("The parameter 'backofficeId' must be defined.");
        url_ = url_.replace("{backofficeId}", encodeURIComponent("" + backofficeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBackofficeAuditEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackofficeAuditEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBackofficeAuditEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBackofficeAuditEntryDto>;
        }));
    }

    protected processGetBackofficeAuditEntries(response: HttpResponseBase): Observable<PagedResultDtoOfBackofficeAuditEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBackofficeAuditEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportBackoffices(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Backoffice/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBackoffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBackoffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExportBackoffices(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AvailabilityRangeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAvailabilityRangesForService(serviceId: string): Observable<AvailabilityRangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/AvailabilityRange/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailabilityRangesForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailabilityRangesForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailabilityRangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailabilityRangeDto[]>;
        }));
    }

    protected processGetAvailabilityRangesForService(response: HttpResponseBase): Observable<AvailabilityRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityRangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAvailabilityRange(serviceId: string, availabilityRangeDto: AvailabilityRangeDto): Observable<AvailabilityRangeDto> {
        let url_ = this.baseUrl + "/api/v1/AvailabilityRange/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(availabilityRangeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAvailabilityRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAvailabilityRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailabilityRangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailabilityRangeDto>;
        }));
    }

    protected processCreateAvailabilityRange(response: HttpResponseBase): Observable<AvailabilityRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityRangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAvailabilityRange(serviceId: string, availabilityRangeId: string, availabilityRangeDto: AvailabilityRangeDto): Observable<AvailabilityRangeDto> {
        let url_ = this.baseUrl + "/api/v1/AvailabilityRange/for-service/{serviceId}/{availabilityRangeId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (availabilityRangeId === undefined || availabilityRangeId === null)
            throw new globalThis.Error("The parameter 'availabilityRangeId' must be defined.");
        url_ = url_.replace("{availabilityRangeId}", encodeURIComponent("" + availabilityRangeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(availabilityRangeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAvailabilityRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAvailabilityRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailabilityRangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailabilityRangeDto>;
        }));
    }

    protected processUpdateAvailabilityRange(response: HttpResponseBase): Observable<AvailabilityRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityRangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAvailabilityRange(serviceId: string, availabilityRangeId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AvailabilityRange/for-service/{serviceId}/{availabilityRangeId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (availabilityRangeId === undefined || availabilityRangeId === null)
            throw new globalThis.Error("The parameter 'availabilityRangeId' must be defined.");
        url_ = url_.replace("{availabilityRangeId}", encodeURIComponent("" + availabilityRangeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAvailabilityRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAvailabilityRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAvailabilityRange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    hasActiveAlert(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Alert/has-active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasActiveAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasActiveAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasActiveAlert(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlerts(pageableRequest: PageableRequestDtoOfAlertSearchCriteriaDto): Observable<PagedResultDtoOfAlertLightDto> {
        let url_ = this.baseUrl + "/api/v1/Alert/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlertLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlertLightDto>;
        }));
    }

    protected processSearchAlerts(response: HttpResponseBase): Observable<PagedResultDtoOfAlertLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlertLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlertHistory(pageableRequest: PageableRequestDtoOfAlertHistorySearchCriteriaDto): Observable<PagedResultDtoOfAlertHistoryLightDto> {
        let url_ = this.baseUrl + "/api/v1/Alert/search-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlertHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlertHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlertHistoryLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlertHistoryLightDto>;
        }));
    }

    protected processSearchAlertHistory(response: HttpResponseBase): Observable<PagedResultDtoOfAlertHistoryLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlertHistoryLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releaseAlert(alertId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Alert/{alertId}/release";
        if (alertId === undefined || alertId === null)
            throw new globalThis.Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseAlert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseAlert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlertDevicesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAlertDevice(id: string): Observable<AlertDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDeviceDto>;
        }));
    }

    protected processGetAlertDevice(response: HttpResponseBase): Observable<AlertDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAlertDevice(id: string, alertDevice: AlertDeviceInputDto): Observable<AlertDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertDevice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDeviceDto>;
        }));
    }

    protected processUpdateAlertDevice(response: HttpResponseBase): Observable<AlertDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAlertDevice(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlertDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAlertDevice(alertDevice: AlertDeviceInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertDevice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAlertDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlertDevices(pageableRequest: PageableRequestDtoOfAlertDeviceSearchCriteriaDto): Observable<PagedResultDtoOfAlertDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlertDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlertDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlertDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlertDeviceDto>;
        }));
    }

    protected processSearchAlertDevices(response: HttpResponseBase): Observable<PagedResultDtoOfAlertDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlertDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateAlertDevice(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/{deviceId}/activate";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateAlertDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateAlertDevice(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlertDevices/{deviceId}/deactivate";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateAlertDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateAlertDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateAlertDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlarmService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAlarm(id: number): Observable<AlarmDto> {
        let url_ = this.baseUrl + "/api/v1/Alarm/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDto>;
        }));
    }

    protected processGetAlarm(response: HttpResponseBase): Observable<AlarmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    hasActiveAlarm(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/Alarm/has-active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasActiveAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasActiveAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasActiveAlarm(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlarms(pageableRequest: PageableRequestDtoOfAlarmSearchCriteriaDto): Observable<PagedResultDtoOfAlarmLightDto> {
        let url_ = this.baseUrl + "/api/v1/Alarm/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlarms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlarms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlarmLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlarmLightDto>;
        }));
    }

    protected processSearchAlarms(response: HttpResponseBase): Observable<PagedResultDtoOfAlarmLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlarmLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlarmHistory(pageableRequest: PageableRequestDtoOfAlarmHistorySearchCriteriaDto): Observable<PagedResultDtoOfAlarmHistoryLightDto> {
        let url_ = this.baseUrl + "/api/v1/Alarm/search-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlarmHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlarmHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlarmHistoryLightDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlarmHistoryLightDto>;
        }));
    }

    protected processSearchAlarmHistory(response: HttpResponseBase): Observable<PagedResultDtoOfAlarmHistoryLightDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlarmHistoryLightDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAlarmInProgressAlarm(alarmId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Alarm/in-progress/{alarmId}";
        if (alarmId === undefined || alarmId === null)
            throw new globalThis.Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAlarmInProgressAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAlarmInProgressAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAlarmInProgressAlarm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releaseAlarm(alarmId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Alarm/release/{alarmId}";
        if (alarmId === undefined || alarmId === null)
            throw new globalThis.Error("The parameter 'alarmId' must be defined.");
        url_ = url_.replace("{alarmId}", encodeURIComponent("" + alarmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseAlarm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseAlarm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseAlarm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlarmDevicesService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAlarmDevice(id: string): Observable<AlarmDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDeviceDto>;
        }));
    }

    protected processGetAlarmDevice(response: HttpResponseBase): Observable<AlarmDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAlarmDevice(id: string, alarmDevice: AlarmDeviceInputDto): Observable<AlarmDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmDevice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDeviceDto>;
        }));
    }

    protected processUpdateAlarmDevice(response: HttpResponseBase): Observable<AlarmDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAlarmDevice(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlarmDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchAlarmDevices(pageableRequest: PageableRequestDtoOfAlarmDeviceSearchCriteriaDto): Observable<PagedResultDtoOfAlarmDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchAlarmDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAlarmDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAlarmDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlarmDeviceDto>;
        }));
    }

    protected processSearchAlarmDevices(response: HttpResponseBase): Observable<PagedResultDtoOfAlarmDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAlarmDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAlarmDevice(alarmDevice: AlarmDeviceInputDto): Observable<AlarmDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmDevice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDeviceDto>;
        }));
    }

    protected processCreateAlarmDevice(response: HttpResponseBase): Observable<AlarmDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateAlarmDevice(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/activate/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateAlarmDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateAlarmDevice(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/deactivate/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateAlarmDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateAlarmDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateAlarmDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createAlarmDeviceReceiver(alarmDeviceReceiver: AlarmDeviceReceiverInputDto): Observable<AlarmDeviceReceiverDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/receiver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmDeviceReceiver);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlarmDeviceReceiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlarmDeviceReceiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDeviceReceiverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDeviceReceiverDto>;
        }));
    }

    protected processCreateAlarmDeviceReceiver(response: HttpResponseBase): Observable<AlarmDeviceReceiverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDeviceReceiverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAlarmDeviceReceiver(id: string, alarmDeviceReceiver: AlarmDeviceReceiverInputDto): Observable<AlarmDeviceReceiverDto> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/receiver/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alarmDeviceReceiver);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAlarmDeviceReceiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAlarmDeviceReceiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlarmDeviceReceiverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlarmDeviceReceiverDto>;
        }));
    }

    protected processUpdateAlarmDeviceReceiver(response: HttpResponseBase): Observable<AlarmDeviceReceiverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlarmDeviceReceiverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAlarmDeviceReceiver(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AlarmDevices/receiver/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlarmDeviceReceiver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlarmDeviceReceiver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlarmDeviceReceiver(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchMyActivations(pageableRequestDto: PageableRequestDtoOfActivationSearchCriteriaDto): Observable<PagedResultDtoOfActivationDto> {
        let url_ = this.baseUrl + "/api/v1/Activation/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMyActivations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMyActivations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActivationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActivationDto>;
        }));
    }

    protected processSearchMyActivations(response: HttpResponseBase): Observable<PagedResultDtoOfActivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchActivationsForService(serviceId: string, pageableRequestDto: PageableRequestDtoOfActivationSearchCriteriaDto): Observable<PagedResultDtoOfActivationDto> {
        let url_ = this.baseUrl + "/api/v1/Activation/for-service/{serviceId}/search";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pageableRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchActivationsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchActivationsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActivationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActivationDto>;
        }));
    }

    protected processSearchActivationsForService(response: HttpResponseBase): Observable<PagedResultDtoOfActivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateServiceForVisitor(activationInput: ActivationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/public/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateServiceForVisitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateServiceForVisitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateServiceForVisitor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateService(activationInput: ActivationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateServiceForAnother(serviceId: string, activationInput: ActivationInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/for-service/{serviceId}/activate-for-another";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activationInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateServiceForAnother(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateServiceForAnother(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateServiceForAnother(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    extendMyActivation(activationId: string, totalDuration: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/extend/{activationId}/duration/{totalDuration}";
        if (activationId === undefined || activationId === null)
            throw new globalThis.Error("The parameter 'activationId' must be defined.");
        url_ = url_.replace("{activationId}", encodeURIComponent("" + activationId));
        if (totalDuration === undefined || totalDuration === null)
            throw new globalThis.Error("The parameter 'totalDuration' must be defined.");
        url_ = url_.replace("{totalDuration}", encodeURIComponent("" + totalDuration));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendMyActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendMyActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendMyActivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    extendActivationForService(serviceId: string, activationId: string, totalDuration: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/for-service/{serviceId}/extend/{activationId}/duration/{totalDuration}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (activationId === undefined || activationId === null)
            throw new globalThis.Error("The parameter 'activationId' must be defined.");
        url_ = url_.replace("{activationId}", encodeURIComponent("" + activationId));
        if (totalDuration === undefined || totalDuration === null)
            throw new globalThis.Error("The parameter 'totalDuration' must be defined.");
        url_ = url_.replace("{totalDuration}", encodeURIComponent("" + totalDuration));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendActivationForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendActivationForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendActivationForService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateMyActivation(activationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/terminate/{activationId}";
        if (activationId === undefined || activationId === null)
            throw new globalThis.Error("The parameter 'activationId' must be defined.");
        url_ = url_.replace("{activationId}", encodeURIComponent("" + activationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateMyActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateMyActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateMyActivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    terminateActivationForService(serviceId: string, activationId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Activation/for-service/{serviceId}/terminate/{activationId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (activationId === undefined || activationId === null)
            throw new globalThis.Error("The parameter 'activationId' must be defined.");
        url_ = url_.replace("{activationId}", encodeURIComponent("" + activationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTerminateActivationForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTerminateActivationForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTerminateActivationForService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccessControlService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(CONFIGURATION_SERVICE_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllDoorsGroup(serviceId: string): Observable<MorpheanDoorGroupDto[]> {
        let url_ = this.baseUrl + "/api/v1/AccessControl/for-service/{serviceId}/all-door-groups";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDoorsGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDoorsGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MorpheanDoorGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MorpheanDoorGroupDto[]>;
        }));
    }

    protected processGetAllDoorsGroup(response: HttpResponseBase): Observable<MorpheanDoorGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MorpheanDoorGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDoorGroupsForService(serviceId: string): Observable<MorpheanDoorGroupDto[]> {
        let url_ = this.baseUrl + "/api/v1/AccessControl/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoorGroupsForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoorGroupsForService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MorpheanDoorGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MorpheanDoorGroupDto[]>;
        }));
    }

    protected processGetDoorGroupsForService(response: HttpResponseBase): Observable<MorpheanDoorGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MorpheanDoorGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignDoorGroup(serviceId: string, morpheanDoorGroupDto: MorpheanDoorGroupDto): Observable<MorpheanDoorGroupDto> {
        let url_ = this.baseUrl + "/api/v1/AccessControl/for-service/{serviceId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(morpheanDoorGroupDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDoorGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDoorGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MorpheanDoorGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MorpheanDoorGroupDto>;
        }));
    }

    protected processAssignDoorGroup(response: HttpResponseBase): Observable<MorpheanDoorGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MorpheanDoorGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignDoorGroup(serviceId: string, doorGroupId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AccessControl/for-service/{serviceId}/{doorGroupId}";
        if (serviceId === undefined || serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' must be defined.");
        url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
        if (doorGroupId === undefined || doorGroupId === null)
            throw new globalThis.Error("The parameter 'doorGroupId' must be defined.");
        url_ = url_.replace("{doorGroupId}", encodeURIComponent("" + doorGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignDoorGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignDoorGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignDoorGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class WifiDto implements IWifiDto {
    id?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ruckusWifiNetworkId?: string;
    ssid?: string | null;
    serviceId?: string | null;

    constructor(data?: IWifiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.ruckusWifiNetworkId = _data["ruckusWifiNetworkId"] !== undefined ? _data["ruckusWifiNetworkId"] : null as any;
            this.ssid = _data["ssid"] !== undefined ? _data["ssid"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): WifiDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["ruckusWifiNetworkId"] = this.ruckusWifiNetworkId !== undefined ? this.ruckusWifiNetworkId : null as any;
        data["ssid"] = this.ssid !== undefined ? this.ssid : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IWifiDto {
    id?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ruckusWifiNetworkId?: string;
    ssid?: string | null;
    serviceId?: string | null;
}

export class WifiWithSubscriptionCountDto implements IWifiWithSubscriptionCountDto {
    id?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ssid?: string | null;
    subscriptionCount?: number;

    constructor(data?: IWifiWithSubscriptionCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.ssid = _data["ssid"] !== undefined ? _data["ssid"] : null as any;
            this.subscriptionCount = _data["subscriptionCount"] !== undefined ? _data["subscriptionCount"] : null as any;
        }
    }

    static fromJS(data: any): WifiWithSubscriptionCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiWithSubscriptionCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["ssid"] = this.ssid !== undefined ? this.ssid : null as any;
        data["subscriptionCount"] = this.subscriptionCount !== undefined ? this.subscriptionCount : null as any;
        return data;
    }
}

export interface IWifiWithSubscriptionCountDto {
    id?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ssid?: string | null;
    subscriptionCount?: number;
}

export class WifiInputDto implements IWifiInputDto {
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ruckusWifiNetworkId?: string;
    ssid?: string;

    constructor(data?: IWifiInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.ruckusWifiNetworkId = _data["ruckusWifiNetworkId"] !== undefined ? _data["ruckusWifiNetworkId"] : null as any;
            this.ssid = _data["ssid"] !== undefined ? _data["ssid"] : null as any;
        }
    }

    static fromJS(data: any): WifiInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["ruckusWifiNetworkId"] = this.ruckusWifiNetworkId !== undefined ? this.ruckusWifiNetworkId : null as any;
        data["ssid"] = this.ssid !== undefined ? this.ssid : null as any;
        return data;
    }
}

export interface IWifiInputDto {
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    ruckusWifiNetworkId?: string;
    ssid?: string;
}

export class PagedResultDtoOfWifiSubscriptionDto implements IPagedResultDtoOfWifiSubscriptionDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: WifiSubscriptionDto[];

    constructor(data?: IPagedResultDtoOfWifiSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(WifiSubscriptionDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWifiSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWifiSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfWifiSubscriptionDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: WifiSubscriptionDto[];
}

export class WifiSubscriptionDto implements IWifiSubscriptionDto {
    id?: string;
    wifiId?: string;
    serviceNameFR?: string;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;
    customer?: string | null;
    customerId?: string;
    state?: WifiSubscriptionState;
    startDateTime?: Date;
    endDateTime?: Date;

    constructor(data?: IWifiSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.wifiId = _data["wifiId"] !== undefined ? _data["wifiId"] : null as any;
            this.serviceNameFR = _data["serviceNameFR"] !== undefined ? _data["serviceNameFR"] : null as any;
            this.serviceNameDE = _data["serviceNameDE"] !== undefined ? _data["serviceNameDE"] : null as any;
            this.serviceNameEN = _data["serviceNameEN"] !== undefined ? _data["serviceNameEN"] : null as any;
            this.serviceNameIT = _data["serviceNameIT"] !== undefined ? _data["serviceNameIT"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): WifiSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["wifiId"] = this.wifiId !== undefined ? this.wifiId : null as any;
        data["serviceNameFR"] = this.serviceNameFR !== undefined ? this.serviceNameFR : null as any;
        data["serviceNameDE"] = this.serviceNameDE !== undefined ? this.serviceNameDE : null as any;
        data["serviceNameEN"] = this.serviceNameEN !== undefined ? this.serviceNameEN : null as any;
        data["serviceNameIT"] = this.serviceNameIT !== undefined ? this.serviceNameIT : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IWifiSubscriptionDto {
    id?: string;
    wifiId?: string;
    serviceNameFR?: string;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;
    customer?: string | null;
    customerId?: string;
    state?: WifiSubscriptionState;
    startDateTime?: Date;
    endDateTime?: Date;
}

export enum WifiSubscriptionState {
    Reserved = "Reserved",
    OnGoing = "OnGoing",
    Disabled = "Disabled",
    Expired = "Expired",
}

export class PageableRequestDto implements IPageableRequestDto {
    page!: number;
    pageSize!: number;

    constructor(data?: IPageableRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
        }
    }

    static fromJS(data: any): PageableRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        return data;
    }
}

export interface IPageableRequestDto {
    page: number;
    pageSize: number;
}

export class PageableRequestDtoOfWifiSubscriptionSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfWifiSubscriptionSearchCriteriaDto {
    criteria?: WifiSubscriptionSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfWifiSubscriptionSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? WifiSubscriptionSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfWifiSubscriptionSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfWifiSubscriptionSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfWifiSubscriptionSearchCriteriaDto extends IPageableRequestDto {
    criteria?: WifiSubscriptionSearchCriteriaDto | null;
}

export class WifiSubscriptionSearchCriteriaDto implements IWifiSubscriptionSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    serviceIds?: string[] | null;
    from?: Date | null;
    to?: Date | null;
    customerId?: string | null;
    state?: WifiSubscriptionState | null;

    constructor(data?: IWifiSubscriptionSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
            else {
                this.serviceIds = null as any;
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): WifiSubscriptionSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiSubscriptionSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IWifiSubscriptionSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    serviceIds?: string[] | null;
    from?: Date | null;
    to?: Date | null;
    customerId?: string | null;
    state?: WifiSubscriptionState | null;
}

export class SortCriteriaDto implements ISortCriteriaDto {
    property?: string | null;
    direction?: SortDirection;

    constructor(data?: ISortCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"] !== undefined ? _data["property"] : null as any;
            this.direction = _data["direction"] !== undefined ? _data["direction"] : null as any;
        }
    }

    static fromJS(data: any): SortCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SortCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property !== undefined ? this.property : null as any;
        data["direction"] = this.direction !== undefined ? this.direction : null as any;
        return data;
    }
}

export interface ISortCriteriaDto {
    property?: string | null;
    direction?: SortDirection;
}

export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc",
}

export class WifiSubscriptionWithAuthenticationDto implements IWifiSubscriptionWithAuthenticationDto {
    id?: string;
    serviceNameFR?: string;
    serviceNameDE?: string;
    serviceNameEN?: string;
    serviceNameIT?: string;
    wifiSsid?: string;
    password?: string;
    disabled?: boolean;
    startDateTime?: Date;
    endDateTime?: Date;

    constructor(data?: IWifiSubscriptionWithAuthenticationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceNameFR = _data["serviceNameFR"] !== undefined ? _data["serviceNameFR"] : null as any;
            this.serviceNameDE = _data["serviceNameDE"] !== undefined ? _data["serviceNameDE"] : null as any;
            this.serviceNameEN = _data["serviceNameEN"] !== undefined ? _data["serviceNameEN"] : null as any;
            this.serviceNameIT = _data["serviceNameIT"] !== undefined ? _data["serviceNameIT"] : null as any;
            this.wifiSsid = _data["wifiSsid"] !== undefined ? _data["wifiSsid"] : null as any;
            this.password = _data["password"] !== undefined ? _data["password"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): WifiSubscriptionWithAuthenticationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WifiSubscriptionWithAuthenticationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceNameFR"] = this.serviceNameFR !== undefined ? this.serviceNameFR : null as any;
        data["serviceNameDE"] = this.serviceNameDE !== undefined ? this.serviceNameDE : null as any;
        data["serviceNameEN"] = this.serviceNameEN !== undefined ? this.serviceNameEN : null as any;
        data["serviceNameIT"] = this.serviceNameIT !== undefined ? this.serviceNameIT : null as any;
        data["wifiSsid"] = this.wifiSsid !== undefined ? this.wifiSsid : null as any;
        data["password"] = this.password !== undefined ? this.password : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IWifiSubscriptionWithAuthenticationDto {
    id?: string;
    serviceNameFR?: string;
    serviceNameDE?: string;
    serviceNameEN?: string;
    serviceNameIT?: string;
    wifiSsid?: string;
    password?: string;
    disabled?: boolean;
    startDateTime?: Date;
    endDateTime?: Date;
}

export class MyServicesNextEntryDto implements IMyServicesNextEntryDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string | null;
    endTime?: string | null;
    entryType?: MyServicesNextEntryType;

    constructor(data?: IMyServicesNextEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.entryType = _data["entryType"] !== undefined ? _data["entryType"] : null as any;
        }
    }

    static fromJS(data: any): MyServicesNextEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyServicesNextEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["entryType"] = this.entryType !== undefined ? this.entryType : null as any;
        return data;
    }
}

export interface IMyServicesNextEntryDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string | null;
    endTime?: string | null;
    entryType?: MyServicesNextEntryType;
}

export enum MyServicesNextEntryType {
    Subscription = "Subscription",
    Booking = "Booking",
}

export class WebcamDto implements IWebcamDto {
    id?: string | null;
    serviceId?: string | null;
    locationFR?: string;
    locationDE?: string;
    locationIT?: string;
    locationEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    imageUrl?: string;
    active?: boolean;
    position?: number;

    constructor(data?: IWebcamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.locationFR = _data["locationFR"] !== undefined ? _data["locationFR"] : null as any;
            this.locationDE = _data["locationDE"] !== undefined ? _data["locationDE"] : null as any;
            this.locationIT = _data["locationIT"] !== undefined ? _data["locationIT"] : null as any;
            this.locationEN = _data["locationEN"] !== undefined ? _data["locationEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
        }
    }

    static fromJS(data: any): WebcamDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebcamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["locationFR"] = this.locationFR !== undefined ? this.locationFR : null as any;
        data["locationDE"] = this.locationDE !== undefined ? this.locationDE : null as any;
        data["locationIT"] = this.locationIT !== undefined ? this.locationIT : null as any;
        data["locationEN"] = this.locationEN !== undefined ? this.locationEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        return data;
    }
}

export interface IWebcamDto {
    id?: string | null;
    serviceId?: string | null;
    locationFR?: string;
    locationDE?: string;
    locationIT?: string;
    locationEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    imageUrl?: string;
    active?: boolean;
    position?: number;
}

export class OrderDto implements IOrderDto {
    id?: string;
    position?: number;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        return data;
    }
}

export interface IOrderDto {
    id?: string;
    position?: number;
}

export class WeatherDataDto implements IWeatherDataDto {
    weatherMeasures?: WeatherMeasureDto[];
    weatherSwellMeasure?: WeatherSwellMeasureDto | null;
    weatherTrendMeasures?: WeatherTrendMeasureDto[];
    weatherWindDirectionMeasure?: WeatherWindDirectionMeasureDto | null;

    constructor(data?: IWeatherDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["weatherMeasures"])) {
                this.weatherMeasures = [] as any;
                for (let item of _data["weatherMeasures"])
                    this.weatherMeasures!.push(WeatherMeasureDto.fromJS(item));
            }
            else {
                this.weatherMeasures = null as any;
            }
            this.weatherSwellMeasure = _data["weatherSwellMeasure"] ? WeatherSwellMeasureDto.fromJS(_data["weatherSwellMeasure"]) : null as any;
            if (Array.isArray(_data["weatherTrendMeasures"])) {
                this.weatherTrendMeasures = [] as any;
                for (let item of _data["weatherTrendMeasures"])
                    this.weatherTrendMeasures!.push(WeatherTrendMeasureDto.fromJS(item));
            }
            else {
                this.weatherTrendMeasures = null as any;
            }
            this.weatherWindDirectionMeasure = _data["weatherWindDirectionMeasure"] ? WeatherWindDirectionMeasureDto.fromJS(_data["weatherWindDirectionMeasure"]) : null as any;
        }
    }

    static fromJS(data: any): WeatherDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weatherMeasures)) {
            data["weatherMeasures"] = [];
            for (let item of this.weatherMeasures)
                data["weatherMeasures"].push(item ? item.toJSON() : null as any);
        }
        data["weatherSwellMeasure"] = this.weatherSwellMeasure ? this.weatherSwellMeasure.toJSON() : null as any;
        if (Array.isArray(this.weatherTrendMeasures)) {
            data["weatherTrendMeasures"] = [];
            for (let item of this.weatherTrendMeasures)
                data["weatherTrendMeasures"].push(item ? item.toJSON() : null as any);
        }
        data["weatherWindDirectionMeasure"] = this.weatherWindDirectionMeasure ? this.weatherWindDirectionMeasure.toJSON() : null as any;
        return data;
    }
}

export interface IWeatherDataDto {
    weatherMeasures?: WeatherMeasureDto[];
    weatherSwellMeasure?: WeatherSwellMeasureDto | null;
    weatherTrendMeasures?: WeatherTrendMeasureDto[];
    weatherWindDirectionMeasure?: WeatherWindDirectionMeasureDto | null;
}

export class WeatherMeasureDto implements IWeatherMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    unit?: string;
    value?: number | null;
    minDateTime?: Date | null;
    minValue?: number | null;
    maxDateTime?: Date | null;
    maxValue?: number | null;

    constructor(data?: IWeatherMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.minDateTime = _data["minDateTime"] ? new Date(_data["minDateTime"].toString()) : null as any;
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : null as any;
            this.maxDateTime = _data["maxDateTime"] ? new Date(_data["maxDateTime"].toString()) : null as any;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : null as any;
        }
    }

    static fromJS(data: any): WeatherMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["minDateTime"] = this.minDateTime ? this.minDateTime.toISOString() : null as any;
        data["minValue"] = this.minValue !== undefined ? this.minValue : null as any;
        data["maxDateTime"] = this.maxDateTime ? this.maxDateTime.toISOString() : null as any;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : null as any;
        return data;
    }
}

export interface IWeatherMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    unit?: string;
    value?: number | null;
    minDateTime?: Date | null;
    minValue?: number | null;
    maxDateTime?: Date | null;
    maxValue?: number | null;
}

export class WeatherSwellMeasureDto implements IWeatherSwellMeasureDto {
    unitHeight?: string;
    unitPeriod?: string;
    height?: number | null;
    period?: number | null;

    constructor(data?: IWeatherSwellMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitHeight = _data["unitHeight"] !== undefined ? _data["unitHeight"] : null as any;
            this.unitPeriod = _data["unitPeriod"] !== undefined ? _data["unitPeriod"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.period = _data["period"] !== undefined ? _data["period"] : null as any;
        }
    }

    static fromJS(data: any): WeatherSwellMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherSwellMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitHeight"] = this.unitHeight !== undefined ? this.unitHeight : null as any;
        data["unitPeriod"] = this.unitPeriod !== undefined ? this.unitPeriod : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["period"] = this.period !== undefined ? this.period : null as any;
        return data;
    }
}

export interface IWeatherSwellMeasureDto {
    unitHeight?: string;
    unitPeriod?: string;
    height?: number | null;
    period?: number | null;
}

export class WeatherTrendMeasureDto implements IWeatherTrendMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    weatherTrend?: WeatherTrend | null;

    constructor(data?: IWeatherTrendMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.weatherTrend = _data["weatherTrend"] !== undefined ? _data["weatherTrend"] : null as any;
        }
    }

    static fromJS(data: any): WeatherTrendMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherTrendMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["weatherTrend"] = this.weatherTrend !== undefined ? this.weatherTrend : null as any;
        return data;
    }
}

export interface IWeatherTrendMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    weatherTrend?: WeatherTrend | null;
}

export enum WeatherTrend {
    Up = "Up",
    Down = "Down",
}

export class WeatherWindDirectionMeasureDto implements IWeatherWindDirectionMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    unit?: string;
    windDirectionDegree?: number | null;
    windDirection?: string | null;

    constructor(data?: IWeatherWindDirectionMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
            this.windDirectionDegree = _data["windDirectionDegree"] !== undefined ? _data["windDirectionDegree"] : null as any;
            this.windDirection = _data["windDirection"] !== undefined ? _data["windDirection"] : null as any;
        }
    }

    static fromJS(data: any): WeatherWindDirectionMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherWindDirectionMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        data["windDirectionDegree"] = this.windDirectionDegree !== undefined ? this.windDirectionDegree : null as any;
        data["windDirection"] = this.windDirection !== undefined ? this.windDirection : null as any;
        return data;
    }
}

export interface IWeatherWindDirectionMeasureDto {
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    unit?: string;
    windDirectionDegree?: number | null;
    windDirection?: string | null;
}

export class DumpsterDto implements IDumpsterDto {
    deviceId?: string;
    dumpsterProvider?: DumpsterProvider;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    deviceState?: DeviceStateEnum | null;
    lastStateChanged?: Date | null;
    serviceId?: string;

    constructor(data?: IDumpsterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : null as any;
            this.dumpsterProvider = _data["dumpsterProvider"] !== undefined ? _data["dumpsterProvider"] : null as any;
            this.tenantCode = _data["tenantCode"] !== undefined ? _data["tenantCode"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.deviceState = _data["deviceState"] !== undefined ? _data["deviceState"] : null as any;
            this.lastStateChanged = _data["lastStateChanged"] ? new Date(_data["lastStateChanged"].toString()) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): DumpsterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DumpsterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null as any;
        data["dumpsterProvider"] = this.dumpsterProvider !== undefined ? this.dumpsterProvider : null as any;
        data["tenantCode"] = this.tenantCode !== undefined ? this.tenantCode : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["deviceState"] = this.deviceState !== undefined ? this.deviceState : null as any;
        data["lastStateChanged"] = this.lastStateChanged ? this.lastStateChanged.toISOString() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IDumpsterDto {
    deviceId?: string;
    dumpsterProvider?: DumpsterProvider;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    deviceState?: DeviceStateEnum | null;
    lastStateChanged?: Date | null;
    serviceId?: string;
}

export enum DumpsterProvider {
    Bochflow = "Bochflow",
    Falconic = "Falconic",
    Koco = "Koco",
}

export enum DeviceStateEnum {
    Unknown = "Unknown",
    Ready = "Ready",
    Error = "Error",
}

export class DumpsterInputDto implements IDumpsterInputDto {
    deviceId?: string;
    dumpsterProvider!: DumpsterProvider;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;

    constructor(data?: IDumpsterInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : null as any;
            this.dumpsterProvider = _data["dumpsterProvider"] !== undefined ? _data["dumpsterProvider"] : null as any;
            this.tenantCode = _data["tenantCode"] !== undefined ? _data["tenantCode"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): DumpsterInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DumpsterInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null as any;
        data["dumpsterProvider"] = this.dumpsterProvider !== undefined ? this.dumpsterProvider : null as any;
        data["tenantCode"] = this.tenantCode !== undefined ? this.tenantCode : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IDumpsterInputDto {
    deviceId?: string;
    dumpsterProvider: DumpsterProvider;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;
}

export class DumpsterUpdateDto implements IDumpsterUpdateDto {
    deviceId?: string;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;

    constructor(data?: IDumpsterUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : null as any;
            this.tenantCode = _data["tenantCode"] !== undefined ? _data["tenantCode"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
        }
    }

    static fromJS(data: any): DumpsterUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DumpsterUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null as any;
        data["tenantCode"] = this.tenantCode !== undefined ? this.tenantCode : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        return data;
    }
}

export interface IDumpsterUpdateDto {
    deviceId?: string;
    tenantCode?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
}

export class FalconicStatisticExportCriteriaDto implements IFalconicStatisticExportCriteriaDto {
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IFalconicStatisticExportCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): FalconicStatisticExportCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FalconicStatisticExportCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IFalconicStatisticExportCriteriaDto {
    from?: Date | null;
    to?: Date | null;
}

export class PagedResultDtoOfTransactionFullSearchOutputDto implements IPagedResultDtoOfTransactionFullSearchOutputDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: TransactionFullSearchOutputDto[];

    constructor(data?: IPagedResultDtoOfTransactionFullSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransactionFullSearchOutputDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionFullSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionFullSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTransactionFullSearchOutputDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: TransactionFullSearchOutputDto[];
}

export class TransactionFullSearchOutputDto implements ITransactionFullSearchOutputDto {
    id?: string;
    dateTime?: Date;
    amount?: number;
    serviceNameFR?: string | null;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;
    customerId?: string | null;
    customerCards?: CardIdentifierDto[];
    technicalComment?: string | null;

    constructor(data?: ITransactionFullSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.serviceNameFR = _data["serviceNameFR"] !== undefined ? _data["serviceNameFR"] : null as any;
            this.serviceNameDE = _data["serviceNameDE"] !== undefined ? _data["serviceNameDE"] : null as any;
            this.serviceNameEN = _data["serviceNameEN"] !== undefined ? _data["serviceNameEN"] : null as any;
            this.serviceNameIT = _data["serviceNameIT"] !== undefined ? _data["serviceNameIT"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            if (Array.isArray(_data["customerCards"])) {
                this.customerCards = [] as any;
                for (let item of _data["customerCards"])
                    this.customerCards!.push(CardIdentifierDto.fromJS(item));
            }
            else {
                this.customerCards = null as any;
            }
            this.technicalComment = _data["technicalComment"] !== undefined ? _data["technicalComment"] : null as any;
        }
    }

    static fromJS(data: any): TransactionFullSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFullSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["serviceNameFR"] = this.serviceNameFR !== undefined ? this.serviceNameFR : null as any;
        data["serviceNameDE"] = this.serviceNameDE !== undefined ? this.serviceNameDE : null as any;
        data["serviceNameEN"] = this.serviceNameEN !== undefined ? this.serviceNameEN : null as any;
        data["serviceNameIT"] = this.serviceNameIT !== undefined ? this.serviceNameIT : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        if (Array.isArray(this.customerCards)) {
            data["customerCards"] = [];
            for (let item of this.customerCards)
                data["customerCards"].push(item ? item.toJSON() : null as any);
        }
        data["technicalComment"] = this.technicalComment !== undefined ? this.technicalComment : null as any;
        return data;
    }
}

export interface ITransactionFullSearchOutputDto {
    id?: string;
    dateTime?: Date;
    amount?: number;
    serviceNameFR?: string | null;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;
    customerId?: string | null;
    customerCards?: CardIdentifierDto[];
    technicalComment?: string | null;
}

export class CardIdentifierDto implements ICardIdentifierDto {
    cardNumber?: string;
    uid?: string;

    constructor(data?: ICardIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
        }
    }

    static fromJS(data: any): CardIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        return data;
    }
}

export interface ICardIdentifierDto {
    cardNumber?: string;
    uid?: string;
}

export class PageableRequestDtoOfTransactionFullSearchInputCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfTransactionFullSearchInputCriteriaDto {
    criteria?: TransactionFullSearchInputCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfTransactionFullSearchInputCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? TransactionFullSearchInputCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfTransactionFullSearchInputCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfTransactionFullSearchInputCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfTransactionFullSearchInputCriteriaDto extends IPageableRequestDto {
    criteria?: TransactionFullSearchInputCriteriaDto | null;
}

export class TransactionFullSearchInputCriteriaDto implements ITransactionFullSearchInputCriteriaDto {
    searchCriteriaDto?: TransactionFullSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: ITransactionFullSearchInputCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? TransactionFullSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): TransactionFullSearchInputCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFullSearchInputCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface ITransactionFullSearchInputCriteriaDto {
    searchCriteriaDto?: TransactionFullSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class TransactionFullSearchCriteriaDto implements ITransactionFullSearchCriteriaDto {
    searchTerms?: string | null;
    serviceIds?: string[] | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;

    constructor(data?: ITransactionFullSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
            else {
                this.serviceIds = null as any;
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.amountFrom = _data["amountFrom"] !== undefined ? _data["amountFrom"] : null as any;
            this.amountTo = _data["amountTo"] !== undefined ? _data["amountTo"] : null as any;
        }
    }

    static fromJS(data: any): TransactionFullSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionFullSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["amountFrom"] = this.amountFrom !== undefined ? this.amountFrom : null as any;
        data["amountTo"] = this.amountTo !== undefined ? this.amountTo : null as any;
        return data;
    }
}

export interface ITransactionFullSearchCriteriaDto {
    searchTerms?: string | null;
    serviceIds?: string[] | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;
}

export class PagedResultDtoOfTransactionDto implements IPagedResultDtoOfTransactionDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: TransactionDto[];

    constructor(data?: IPagedResultDtoOfTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TransactionDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfTransactionDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: TransactionDto[];
}

export class PagedTransactionsResultDto extends PagedResultDtoOfTransactionDto implements IPagedTransactionsResultDto {
    totalAmount?: number;

    constructor(data?: IPagedTransactionsResultDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
        }
    }

    static override fromJS(data: any): PagedTransactionsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedTransactionsResultDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPagedTransactionsResultDto extends IPagedResultDtoOfTransactionDto {
    totalAmount?: number;
}

export class TransactionDto implements ITransactionDto {
    id?: string;
    customerId?: string | null;
    customer?: string | null;
    ewalletId?: string | null;
    transactionSource?: TransactionSource;
    transactionType?: TransactionType;
    ePaymentMethod?: string | null;
    paymentMethod?: PaymentMethod | null;
    consumptionType?: ConsumptionType | null;
    dateTime?: Date;
    amount?: number;
    ewalletBalanceAfter?: number | null;
    technicalComment?: string | null;
    userComment?: string | null;
    serviceId?: string | null;
    serviceNameFR?: string | null;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.ewalletId = _data["ewalletId"] !== undefined ? _data["ewalletId"] : null as any;
            this.transactionSource = _data["transactionSource"] !== undefined ? _data["transactionSource"] : null as any;
            this.transactionType = _data["transactionType"] !== undefined ? _data["transactionType"] : null as any;
            this.ePaymentMethod = _data["ePaymentMethod"] !== undefined ? _data["ePaymentMethod"] : null as any;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : null as any;
            this.consumptionType = _data["consumptionType"] !== undefined ? _data["consumptionType"] : null as any;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.ewalletBalanceAfter = _data["ewalletBalanceAfter"] !== undefined ? _data["ewalletBalanceAfter"] : null as any;
            this.technicalComment = _data["technicalComment"] !== undefined ? _data["technicalComment"] : null as any;
            this.userComment = _data["userComment"] !== undefined ? _data["userComment"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.serviceNameFR = _data["serviceNameFR"] !== undefined ? _data["serviceNameFR"] : null as any;
            this.serviceNameDE = _data["serviceNameDE"] !== undefined ? _data["serviceNameDE"] : null as any;
            this.serviceNameEN = _data["serviceNameEN"] !== undefined ? _data["serviceNameEN"] : null as any;
            this.serviceNameIT = _data["serviceNameIT"] !== undefined ? _data["serviceNameIT"] : null as any;
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["ewalletId"] = this.ewalletId !== undefined ? this.ewalletId : null as any;
        data["transactionSource"] = this.transactionSource !== undefined ? this.transactionSource : null as any;
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : null as any;
        data["ePaymentMethod"] = this.ePaymentMethod !== undefined ? this.ePaymentMethod : null as any;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : null as any;
        data["consumptionType"] = this.consumptionType !== undefined ? this.consumptionType : null as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["ewalletBalanceAfter"] = this.ewalletBalanceAfter !== undefined ? this.ewalletBalanceAfter : null as any;
        data["technicalComment"] = this.technicalComment !== undefined ? this.technicalComment : null as any;
        data["userComment"] = this.userComment !== undefined ? this.userComment : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["serviceNameFR"] = this.serviceNameFR !== undefined ? this.serviceNameFR : null as any;
        data["serviceNameDE"] = this.serviceNameDE !== undefined ? this.serviceNameDE : null as any;
        data["serviceNameEN"] = this.serviceNameEN !== undefined ? this.serviceNameEN : null as any;
        data["serviceNameIT"] = this.serviceNameIT !== undefined ? this.serviceNameIT : null as any;
        return data;
    }
}

export interface ITransactionDto {
    id?: string;
    customerId?: string | null;
    customer?: string | null;
    ewalletId?: string | null;
    transactionSource?: TransactionSource;
    transactionType?: TransactionType;
    ePaymentMethod?: string | null;
    paymentMethod?: PaymentMethod | null;
    consumptionType?: ConsumptionType | null;
    dateTime?: Date;
    amount?: number;
    ewalletBalanceAfter?: number | null;
    technicalComment?: string | null;
    userComment?: string | null;
    serviceId?: string | null;
    serviceNameFR?: string | null;
    serviceNameDE?: string | null;
    serviceNameEN?: string | null;
    serviceNameIT?: string | null;
}

export enum TransactionSource {
    Unknown = "Unknown",
    CashMachine = "CashMachine",
    Cash = "Cash",
    Ebanking = "Ebanking",
    Billing = "Billing",
    EWallet = "EWallet",
    PointOfSale = "PointOfSale",
}

export enum TransactionType {
    EWalletCredit = "EWalletCredit",
    ServiceConsumption = "ServiceConsumption",
}

export enum PaymentMethod {
    Cash = "Cash",
    Card = "Card",
}

export enum ConsumptionType {
    Purchase = "Purchase",
    IotActivation = "IotActivation",
    Reservation = "Reservation",
    Subscription = "Subscription",
    RecurringBilling = "RecurringBilling",
    Consumption = "Consumption",
}

export class PageableRequestDtoOfTransactionCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfTransactionCriteriaDto {
    criteria?: TransactionCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfTransactionCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? TransactionCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfTransactionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfTransactionCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfTransactionCriteriaDto extends IPageableRequestDto {
    criteria?: TransactionCriteriaDto | null;
}

export class TransactionCriteriaDto implements ITransactionCriteriaDto {
    searchCriteriaDto?: TransactionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: ITransactionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? TransactionSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): TransactionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface ITransactionCriteriaDto {
    searchCriteriaDto?: TransactionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class TransactionSearchCriteriaDto implements ITransactionSearchCriteriaDto {
    transactionSources?: TransactionSource[] | null;
    transactionType?: TransactionType | null;
    consumptionTypes?: ConsumptionType[] | null;
    ePaymentMethod?: string | null;
    cashMachinePaymentMethods?: PaymentMethod[] | null;
    serviceIds?: string[] | null;
    customerId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;

    constructor(data?: ITransactionSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionSources"])) {
                this.transactionSources = [] as any;
                for (let item of _data["transactionSources"])
                    this.transactionSources!.push(item);
            }
            else {
                this.transactionSources = null as any;
            }
            this.transactionType = _data["transactionType"] !== undefined ? _data["transactionType"] : null as any;
            if (Array.isArray(_data["consumptionTypes"])) {
                this.consumptionTypes = [] as any;
                for (let item of _data["consumptionTypes"])
                    this.consumptionTypes!.push(item);
            }
            else {
                this.consumptionTypes = null as any;
            }
            this.ePaymentMethod = _data["ePaymentMethod"] !== undefined ? _data["ePaymentMethod"] : null as any;
            if (Array.isArray(_data["cashMachinePaymentMethods"])) {
                this.cashMachinePaymentMethods = [] as any;
                for (let item of _data["cashMachinePaymentMethods"])
                    this.cashMachinePaymentMethods!.push(item);
            }
            else {
                this.cashMachinePaymentMethods = null as any;
            }
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
            else {
                this.serviceIds = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.amountFrom = _data["amountFrom"] !== undefined ? _data["amountFrom"] : null as any;
            this.amountTo = _data["amountTo"] !== undefined ? _data["amountTo"] : null as any;
        }
    }

    static fromJS(data: any): TransactionSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionSources)) {
            data["transactionSources"] = [];
            for (let item of this.transactionSources)
                data["transactionSources"].push(item);
        }
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : null as any;
        if (Array.isArray(this.consumptionTypes)) {
            data["consumptionTypes"] = [];
            for (let item of this.consumptionTypes)
                data["consumptionTypes"].push(item);
        }
        data["ePaymentMethod"] = this.ePaymentMethod !== undefined ? this.ePaymentMethod : null as any;
        if (Array.isArray(this.cashMachinePaymentMethods)) {
            data["cashMachinePaymentMethods"] = [];
            for (let item of this.cashMachinePaymentMethods)
                data["cashMachinePaymentMethods"].push(item);
        }
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["amountFrom"] = this.amountFrom !== undefined ? this.amountFrom : null as any;
        data["amountTo"] = this.amountTo !== undefined ? this.amountTo : null as any;
        return data;
    }
}

export interface ITransactionSearchCriteriaDto {
    transactionSources?: TransactionSource[] | null;
    transactionType?: TransactionType | null;
    consumptionTypes?: ConsumptionType[] | null;
    ePaymentMethod?: string | null;
    cashMachinePaymentMethods?: PaymentMethod[] | null;
    serviceIds?: string[] | null;
    customerId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;
}

export class DatetimeTransactionCriteraDto implements IDatetimeTransactionCriteraDto {
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IDatetimeTransactionCriteraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DatetimeTransactionCriteraDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatetimeTransactionCriteraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IDatetimeTransactionCriteraDto {
    from?: Date | null;
    to?: Date | null;
}

export class CashierTransactionInputDto implements ICashierTransactionInputDto {
    customerId?: string | null;
    ewalletId?: string | null;
    serviceId?: string | null;
    transactionSource?: TransactionSource;
    transactionType?: TransactionType;
    paymentMethod?: PaymentMethod | null;
    amount?: number;
    userComment?: string | null;

    constructor(data?: ICashierTransactionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.ewalletId = _data["ewalletId"] !== undefined ? _data["ewalletId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.transactionSource = _data["transactionSource"] !== undefined ? _data["transactionSource"] : null as any;
            this.transactionType = _data["transactionType"] !== undefined ? _data["transactionType"] : null as any;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.userComment = _data["userComment"] !== undefined ? _data["userComment"] : null as any;
        }
    }

    static fromJS(data: any): CashierTransactionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashierTransactionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["ewalletId"] = this.ewalletId !== undefined ? this.ewalletId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["transactionSource"] = this.transactionSource !== undefined ? this.transactionSource : null as any;
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : null as any;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["userComment"] = this.userComment !== undefined ? this.userComment : null as any;
        return data;
    }
}

export interface ICashierTransactionInputDto {
    customerId?: string | null;
    ewalletId?: string | null;
    serviceId?: string | null;
    transactionSource?: TransactionSource;
    transactionType?: TransactionType;
    paymentMethod?: PaymentMethod | null;
    amount?: number;
    userComment?: string | null;
}

export enum FileFormat {
    Csv = "Csv",
    Excel = "Excel",
    Pdf = "Pdf",
    Text = "Text",
    Word = "Word",
}

export class TariffDto implements ITariffDto {
    id?: string;
    serviceId?: string;
    tariffConfigId?: string;
    timeOfPayment?: TimeOfPayment;
    paymentTypes?: PaymentTypes[];
    billingRecurrence?: BillingRecurrence | null;
    defaultTariff?: boolean;
    nightRate?: boolean;
    nightRateFrom?: string | null;
    nightRateTo?: string | null;
    validityFrom?: Date | null;
    validityTo?: Date | null;
    customRoles?: string[];
    customUnitFR?: string | null;
    customUnitDE?: string | null;
    customUnitEN?: string | null;
    customUnitIT?: string | null;
    tariffConfig?: TariffConfigDto;
    tariffPrices?: TariffPriceDto[];

    constructor(data?: ITariffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.tariffConfigId = _data["tariffConfigId"] !== undefined ? _data["tariffConfigId"] : null as any;
            this.timeOfPayment = _data["timeOfPayment"] !== undefined ? _data["timeOfPayment"] : null as any;
            if (Array.isArray(_data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of _data["paymentTypes"])
                    this.paymentTypes!.push(item);
            }
            else {
                this.paymentTypes = null as any;
            }
            this.billingRecurrence = _data["billingRecurrence"] !== undefined ? _data["billingRecurrence"] : null as any;
            this.defaultTariff = _data["defaultTariff"] !== undefined ? _data["defaultTariff"] : null as any;
            this.nightRate = _data["nightRate"] !== undefined ? _data["nightRate"] : null as any;
            this.nightRateFrom = _data["nightRateFrom"] !== undefined ? _data["nightRateFrom"] : null as any;
            this.nightRateTo = _data["nightRateTo"] !== undefined ? _data["nightRateTo"] : null as any;
            this.validityFrom = _data["validityFrom"] ? new Date(_data["validityFrom"].toString()) : null as any;
            this.validityTo = _data["validityTo"] ? new Date(_data["validityTo"].toString()) : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(item);
            }
            else {
                this.customRoles = null as any;
            }
            this.customUnitFR = _data["customUnitFR"] !== undefined ? _data["customUnitFR"] : null as any;
            this.customUnitDE = _data["customUnitDE"] !== undefined ? _data["customUnitDE"] : null as any;
            this.customUnitEN = _data["customUnitEN"] !== undefined ? _data["customUnitEN"] : null as any;
            this.customUnitIT = _data["customUnitIT"] !== undefined ? _data["customUnitIT"] : null as any;
            this.tariffConfig = _data["tariffConfig"] ? TariffConfigDto.fromJS(_data["tariffConfig"]) : null as any;
            if (Array.isArray(_data["tariffPrices"])) {
                this.tariffPrices = [] as any;
                for (let item of _data["tariffPrices"])
                    this.tariffPrices!.push(TariffPriceDto.fromJS(item));
            }
            else {
                this.tariffPrices = null as any;
            }
        }
    }

    static fromJS(data: any): TariffDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["tariffConfigId"] = this.tariffConfigId !== undefined ? this.tariffConfigId : null as any;
        data["timeOfPayment"] = this.timeOfPayment !== undefined ? this.timeOfPayment : null as any;
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item);
        }
        data["billingRecurrence"] = this.billingRecurrence !== undefined ? this.billingRecurrence : null as any;
        data["defaultTariff"] = this.defaultTariff !== undefined ? this.defaultTariff : null as any;
        data["nightRate"] = this.nightRate !== undefined ? this.nightRate : null as any;
        data["nightRateFrom"] = this.nightRateFrom !== undefined ? this.nightRateFrom : null as any;
        data["nightRateTo"] = this.nightRateTo !== undefined ? this.nightRateTo : null as any;
        data["validityFrom"] = this.validityFrom ? this.validityFrom.toISOString() : null as any;
        data["validityTo"] = this.validityTo ? this.validityTo.toISOString() : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item);
        }
        data["customUnitFR"] = this.customUnitFR !== undefined ? this.customUnitFR : null as any;
        data["customUnitDE"] = this.customUnitDE !== undefined ? this.customUnitDE : null as any;
        data["customUnitEN"] = this.customUnitEN !== undefined ? this.customUnitEN : null as any;
        data["customUnitIT"] = this.customUnitIT !== undefined ? this.customUnitIT : null as any;
        data["tariffConfig"] = this.tariffConfig ? this.tariffConfig.toJSON() : null as any;
        if (Array.isArray(this.tariffPrices)) {
            data["tariffPrices"] = [];
            for (let item of this.tariffPrices)
                data["tariffPrices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITariffDto {
    id?: string;
    serviceId?: string;
    tariffConfigId?: string;
    timeOfPayment?: TimeOfPayment;
    paymentTypes?: PaymentTypes[];
    billingRecurrence?: BillingRecurrence | null;
    defaultTariff?: boolean;
    nightRate?: boolean;
    nightRateFrom?: string | null;
    nightRateTo?: string | null;
    validityFrom?: Date | null;
    validityTo?: Date | null;
    customRoles?: string[];
    customUnitFR?: string | null;
    customUnitDE?: string | null;
    customUnitEN?: string | null;
    customUnitIT?: string | null;
    tariffConfig?: TariffConfigDto;
    tariffPrices?: TariffPriceDto[];
}

export enum TimeOfPayment {
    Reservation = "Reservation",
    Activation = "Activation",
    Consumption = "Consumption",
    Periodic = "Periodic",
}

export enum PaymentTypes {
    Wallet = "Wallet",
    Billing = "Billing",
    Ebanking = "Ebanking",
    Cash = "Cash",
}

export enum BillingRecurrence {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Seasonal = "Seasonal",
    Biannual = "Biannual",
    Annual = "Annual",
}

export class TariffConfigDto implements ITariffConfigDto {
    id?: string;
    tariffType?: TariffType;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    tariffConfigUnits?: TariffConfigUnitDto[];

    constructor(data?: ITariffConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tariffType = _data["tariffType"] !== undefined ? _data["tariffType"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            if (Array.isArray(_data["tariffConfigUnits"])) {
                this.tariffConfigUnits = [] as any;
                for (let item of _data["tariffConfigUnits"])
                    this.tariffConfigUnits!.push(TariffConfigUnitDto.fromJS(item));
            }
            else {
                this.tariffConfigUnits = null as any;
            }
        }
    }

    static fromJS(data: any): TariffConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tariffType"] = this.tariffType !== undefined ? this.tariffType : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        if (Array.isArray(this.tariffConfigUnits)) {
            data["tariffConfigUnits"] = [];
            for (let item of this.tariffConfigUnits)
                data["tariffConfigUnits"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITariffConfigDto {
    id?: string;
    tariffType?: TariffType;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    tariffConfigUnits?: TariffConfigUnitDto[];
}

export enum TariffType {
    Flat = "Flat",
    Consumption = "Consumption",
    Duration = "Duration",
    ConsumptionAndDuration = "ConsumptionAndDuration",
    Prepaid = "Prepaid",
    FlatAndConsumption = "FlatAndConsumption",
    FlatAndDuration = "FlatAndDuration",
    FlatAndConsumptionAndDuration = "FlatAndConsumptionAndDuration",
    Items = "Items",
}

export class TariffConfigUnitDto implements ITariffConfigUnitDto {
    id?: string;
    unitEnumName?: string;
    unitEnumValue?: string;

    constructor(data?: ITariffConfigUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.unitEnumName = _data["unitEnumName"] !== undefined ? _data["unitEnumName"] : null as any;
            this.unitEnumValue = _data["unitEnumValue"] !== undefined ? _data["unitEnumValue"] : null as any;
        }
    }

    static fromJS(data: any): TariffConfigUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffConfigUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["unitEnumName"] = this.unitEnumName !== undefined ? this.unitEnumName : null as any;
        data["unitEnumValue"] = this.unitEnumValue !== undefined ? this.unitEnumValue : null as any;
        return data;
    }
}

export interface ITariffConfigUnitDto {
    id?: string;
    unitEnumName?: string;
    unitEnumValue?: string;
}

export class TariffPriceDto implements ITariffPriceDto {
    id?: string;
    tariffId?: string;
    tariffConfigUnitId?: string | null;
    priceByUnit?: number;
    nightRate?: boolean;
    tariffConfigUnit?: TariffConfigUnitDto | null;

    constructor(data?: ITariffPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.tariffId = _data["tariffId"] !== undefined ? _data["tariffId"] : null as any;
            this.tariffConfigUnitId = _data["tariffConfigUnitId"] !== undefined ? _data["tariffConfigUnitId"] : null as any;
            this.priceByUnit = _data["priceByUnit"] !== undefined ? _data["priceByUnit"] : null as any;
            this.nightRate = _data["nightRate"] !== undefined ? _data["nightRate"] : null as any;
            this.tariffConfigUnit = _data["tariffConfigUnit"] ? TariffConfigUnitDto.fromJS(_data["tariffConfigUnit"]) : null as any;
        }
    }

    static fromJS(data: any): TariffPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["tariffId"] = this.tariffId !== undefined ? this.tariffId : null as any;
        data["tariffConfigUnitId"] = this.tariffConfigUnitId !== undefined ? this.tariffConfigUnitId : null as any;
        data["priceByUnit"] = this.priceByUnit !== undefined ? this.priceByUnit : null as any;
        data["nightRate"] = this.nightRate !== undefined ? this.nightRate : null as any;
        data["tariffConfigUnit"] = this.tariffConfigUnit ? this.tariffConfigUnit.toJSON() : null as any;
        return data;
    }
}

export interface ITariffPriceDto {
    id?: string;
    tariffId?: string;
    tariffConfigUnitId?: string | null;
    priceByUnit?: number;
    nightRate?: boolean;
    tariffConfigUnit?: TariffConfigUnitDto | null;
}

export class TariffInputDto implements ITariffInputDto {
    serviceId?: string;
    tariffConfigId?: string;
    timeOfPayment?: TimeOfPayment;
    paymentTypes?: PaymentTypes[];
    billingRecurrence?: BillingRecurrence | null;
    defaultTariff?: boolean;
    nightRate?: boolean;
    nightRateFrom?: string | null;
    nightRateTo?: string | null;
    validityFrom?: Date | null;
    validityTo?: Date | null;
    customRoles?: string[];
    customUnitFR?: string | null;
    customUnitDE?: string | null;
    customUnitEN?: string | null;
    customUnitIT?: string | null;
    tariffPrices?: TariffPriceInputDto[];

    constructor(data?: ITariffInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.tariffConfigId = _data["tariffConfigId"] !== undefined ? _data["tariffConfigId"] : null as any;
            this.timeOfPayment = _data["timeOfPayment"] !== undefined ? _data["timeOfPayment"] : null as any;
            if (Array.isArray(_data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of _data["paymentTypes"])
                    this.paymentTypes!.push(item);
            }
            else {
                this.paymentTypes = null as any;
            }
            this.billingRecurrence = _data["billingRecurrence"] !== undefined ? _data["billingRecurrence"] : null as any;
            this.defaultTariff = _data["defaultTariff"] !== undefined ? _data["defaultTariff"] : null as any;
            this.nightRate = _data["nightRate"] !== undefined ? _data["nightRate"] : null as any;
            this.nightRateFrom = _data["nightRateFrom"] !== undefined ? _data["nightRateFrom"] : null as any;
            this.nightRateTo = _data["nightRateTo"] !== undefined ? _data["nightRateTo"] : null as any;
            this.validityFrom = _data["validityFrom"] ? new Date(_data["validityFrom"].toString()) : null as any;
            this.validityTo = _data["validityTo"] ? new Date(_data["validityTo"].toString()) : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(item);
            }
            else {
                this.customRoles = null as any;
            }
            this.customUnitFR = _data["customUnitFR"] !== undefined ? _data["customUnitFR"] : null as any;
            this.customUnitDE = _data["customUnitDE"] !== undefined ? _data["customUnitDE"] : null as any;
            this.customUnitEN = _data["customUnitEN"] !== undefined ? _data["customUnitEN"] : null as any;
            this.customUnitIT = _data["customUnitIT"] !== undefined ? _data["customUnitIT"] : null as any;
            if (Array.isArray(_data["tariffPrices"])) {
                this.tariffPrices = [] as any;
                for (let item of _data["tariffPrices"])
                    this.tariffPrices!.push(TariffPriceInputDto.fromJS(item));
            }
            else {
                this.tariffPrices = null as any;
            }
        }
    }

    static fromJS(data: any): TariffInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["tariffConfigId"] = this.tariffConfigId !== undefined ? this.tariffConfigId : null as any;
        data["timeOfPayment"] = this.timeOfPayment !== undefined ? this.timeOfPayment : null as any;
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item);
        }
        data["billingRecurrence"] = this.billingRecurrence !== undefined ? this.billingRecurrence : null as any;
        data["defaultTariff"] = this.defaultTariff !== undefined ? this.defaultTariff : null as any;
        data["nightRate"] = this.nightRate !== undefined ? this.nightRate : null as any;
        data["nightRateFrom"] = this.nightRateFrom !== undefined ? this.nightRateFrom : null as any;
        data["nightRateTo"] = this.nightRateTo !== undefined ? this.nightRateTo : null as any;
        data["validityFrom"] = this.validityFrom ? this.validityFrom.toISOString() : null as any;
        data["validityTo"] = this.validityTo ? this.validityTo.toISOString() : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item);
        }
        data["customUnitFR"] = this.customUnitFR !== undefined ? this.customUnitFR : null as any;
        data["customUnitDE"] = this.customUnitDE !== undefined ? this.customUnitDE : null as any;
        data["customUnitEN"] = this.customUnitEN !== undefined ? this.customUnitEN : null as any;
        data["customUnitIT"] = this.customUnitIT !== undefined ? this.customUnitIT : null as any;
        if (Array.isArray(this.tariffPrices)) {
            data["tariffPrices"] = [];
            for (let item of this.tariffPrices)
                data["tariffPrices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITariffInputDto {
    serviceId?: string;
    tariffConfigId?: string;
    timeOfPayment?: TimeOfPayment;
    paymentTypes?: PaymentTypes[];
    billingRecurrence?: BillingRecurrence | null;
    defaultTariff?: boolean;
    nightRate?: boolean;
    nightRateFrom?: string | null;
    nightRateTo?: string | null;
    validityFrom?: Date | null;
    validityTo?: Date | null;
    customRoles?: string[];
    customUnitFR?: string | null;
    customUnitDE?: string | null;
    customUnitEN?: string | null;
    customUnitIT?: string | null;
    tariffPrices?: TariffPriceInputDto[];
}

export class TariffPriceInputDto implements ITariffPriceInputDto {
    tariffConfigUnitId?: string | null;
    priceByUnit?: number;
    nightRate?: boolean;

    constructor(data?: ITariffPriceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariffConfigUnitId = _data["tariffConfigUnitId"] !== undefined ? _data["tariffConfigUnitId"] : null as any;
            this.priceByUnit = _data["priceByUnit"] !== undefined ? _data["priceByUnit"] : null as any;
            this.nightRate = _data["nightRate"] !== undefined ? _data["nightRate"] : null as any;
        }
    }

    static fromJS(data: any): TariffPriceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPriceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariffConfigUnitId"] = this.tariffConfigUnitId !== undefined ? this.tariffConfigUnitId : null as any;
        data["priceByUnit"] = this.priceByUnit !== undefined ? this.priceByUnit : null as any;
        data["nightRate"] = this.nightRate !== undefined ? this.nightRate : null as any;
        return data;
    }
}

export interface ITariffPriceInputDto {
    tariffConfigUnitId?: string | null;
    priceByUnit?: number;
    nightRate?: boolean;
}

export class SurveyLightDto implements ISurveyLightDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    nbTargetCustomers?: number;
    customerReadPercent?: number;
    customerReadCount?: number;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    surveyState?: InformationState;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    resultState?: InformationState;
    order?: number;

    constructor(data?: ISurveyLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.nbTargetCustomers = _data["nbTargetCustomers"] !== undefined ? _data["nbTargetCustomers"] : null as any;
            this.customerReadPercent = _data["customerReadPercent"] !== undefined ? _data["customerReadPercent"] : null as any;
            this.customerReadCount = _data["customerReadCount"] !== undefined ? _data["customerReadCount"] : null as any;
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.endPublicationDate = _data["endPublicationDate"] ? new Date(_data["endPublicationDate"].toString()) : null as any;
            this.surveyState = _data["surveyState"] !== undefined ? _data["surveyState"] : null as any;
            this.resultsPublicationDate = _data["resultsPublicationDate"] ? new Date(_data["resultsPublicationDate"].toString()) : null as any;
            this.resultsEndPublicationDate = _data["resultsEndPublicationDate"] ? new Date(_data["resultsEndPublicationDate"].toString()) : null as any;
            this.resultState = _data["resultState"] !== undefined ? _data["resultState"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
        }
    }

    static fromJS(data: any): SurveyLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["nbTargetCustomers"] = this.nbTargetCustomers !== undefined ? this.nbTargetCustomers : null as any;
        data["customerReadPercent"] = this.customerReadPercent !== undefined ? this.customerReadPercent : null as any;
        data["customerReadCount"] = this.customerReadCount !== undefined ? this.customerReadCount : null as any;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["endPublicationDate"] = this.endPublicationDate ? this.endPublicationDate.toISOString() : null as any;
        data["surveyState"] = this.surveyState !== undefined ? this.surveyState : null as any;
        data["resultsPublicationDate"] = this.resultsPublicationDate ? this.resultsPublicationDate.toISOString() : null as any;
        data["resultsEndPublicationDate"] = this.resultsEndPublicationDate ? this.resultsEndPublicationDate.toISOString() : null as any;
        data["resultState"] = this.resultState !== undefined ? this.resultState : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        return data;
    }
}

export interface ISurveyLightDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    nbTargetCustomers?: number;
    customerReadPercent?: number;
    customerReadCount?: number;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    surveyState?: InformationState;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    resultState?: InformationState;
    order?: number;
}

export enum InformationState {
    Unplanned = "Unplanned",
    Past = "Past",
    Ongoing = "Ongoing",
    Planned = "Planned",
}

export class SurveyDto implements ISurveyDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionEN?: string;
    descriptionIT?: string;
    resultContentFR?: string | null;
    resultContentDE?: string | null;
    resultContentEN?: string | null;
    resultContentIT?: string | null;
    surveyUrl?: string;
    resultIllustrationUrl?: string | null;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    surveyState?: InformationState;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;
    resultState?: InformationState | null;
    order?: number;
    publicationNotificationSent?: boolean;
    resultPublicationNotificationSent?: boolean;
    customRoles?: CustomRoleDto[];

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.resultContentFR = _data["resultContentFR"] !== undefined ? _data["resultContentFR"] : null as any;
            this.resultContentDE = _data["resultContentDE"] !== undefined ? _data["resultContentDE"] : null as any;
            this.resultContentEN = _data["resultContentEN"] !== undefined ? _data["resultContentEN"] : null as any;
            this.resultContentIT = _data["resultContentIT"] !== undefined ? _data["resultContentIT"] : null as any;
            this.surveyUrl = _data["surveyUrl"] !== undefined ? _data["surveyUrl"] : null as any;
            this.resultIllustrationUrl = _data["resultIllustrationUrl"] !== undefined ? _data["resultIllustrationUrl"] : null as any;
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.endPublicationDate = _data["endPublicationDate"] ? new Date(_data["endPublicationDate"].toString()) : null as any;
            this.surveyState = _data["surveyState"] !== undefined ? _data["surveyState"] : null as any;
            this.resultsPublicationDate = _data["resultsPublicationDate"] ? new Date(_data["resultsPublicationDate"].toString()) : null as any;
            this.resultsEndPublicationDate = _data["resultsEndPublicationDate"] ? new Date(_data["resultsEndPublicationDate"].toString()) : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
            this.resultState = _data["resultState"] !== undefined ? _data["resultState"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            this.publicationNotificationSent = _data["publicationNotificationSent"] !== undefined ? _data["publicationNotificationSent"] : null as any;
            this.resultPublicationNotificationSent = _data["resultPublicationNotificationSent"] !== undefined ? _data["resultPublicationNotificationSent"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["resultContentFR"] = this.resultContentFR !== undefined ? this.resultContentFR : null as any;
        data["resultContentDE"] = this.resultContentDE !== undefined ? this.resultContentDE : null as any;
        data["resultContentEN"] = this.resultContentEN !== undefined ? this.resultContentEN : null as any;
        data["resultContentIT"] = this.resultContentIT !== undefined ? this.resultContentIT : null as any;
        data["surveyUrl"] = this.surveyUrl !== undefined ? this.surveyUrl : null as any;
        data["resultIllustrationUrl"] = this.resultIllustrationUrl !== undefined ? this.resultIllustrationUrl : null as any;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["endPublicationDate"] = this.endPublicationDate ? this.endPublicationDate.toISOString() : null as any;
        data["surveyState"] = this.surveyState !== undefined ? this.surveyState : null as any;
        data["resultsPublicationDate"] = this.resultsPublicationDate ? this.resultsPublicationDate.toISOString() : null as any;
        data["resultsEndPublicationDate"] = this.resultsEndPublicationDate ? this.resultsEndPublicationDate.toISOString() : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        data["resultState"] = this.resultState !== undefined ? this.resultState : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        data["publicationNotificationSent"] = this.publicationNotificationSent !== undefined ? this.publicationNotificationSent : null as any;
        data["resultPublicationNotificationSent"] = this.resultPublicationNotificationSent !== undefined ? this.resultPublicationNotificationSent : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISurveyDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionEN?: string;
    descriptionIT?: string;
    resultContentFR?: string | null;
    resultContentDE?: string | null;
    resultContentEN?: string | null;
    resultContentIT?: string | null;
    surveyUrl?: string;
    resultIllustrationUrl?: string | null;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    surveyState?: InformationState;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;
    resultState?: InformationState | null;
    order?: number;
    publicationNotificationSent?: boolean;
    resultPublicationNotificationSent?: boolean;
    customRoles?: CustomRoleDto[];
}

export class CustomRoleDto implements ICustomRoleDto {
    roleKey?: string;
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;
    isBase?: boolean;

    constructor(data?: ICustomRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleKey = _data["roleKey"] !== undefined ? _data["roleKey"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.isBase = _data["isBase"] !== undefined ? _data["isBase"] : null as any;
        }
    }

    static fromJS(data: any): CustomRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleKey"] = this.roleKey !== undefined ? this.roleKey : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["isBase"] = this.isBase !== undefined ? this.isBase : null as any;
        return data;
    }
}

export interface ICustomRoleDto {
    roleKey?: string;
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;
    isBase?: boolean;
}

export class SurveyInputDto implements ISurveyInputDto {
    titleFR?: string;
    titleDE?: string | null;
    titleIT?: string | null;
    titleEN?: string | null;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    resultContentFR?: string | null;
    resultContentDE?: string | null;
    resultContentEN?: string | null;
    resultContentIT?: string | null;
    surveyUrl?: string;
    resultIllustrationUrl?: string | null;
    order?: number;
    customRoles?: CustomRoleDto[];

    constructor(data?: ISurveyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.resultContentFR = _data["resultContentFR"] !== undefined ? _data["resultContentFR"] : null as any;
            this.resultContentDE = _data["resultContentDE"] !== undefined ? _data["resultContentDE"] : null as any;
            this.resultContentEN = _data["resultContentEN"] !== undefined ? _data["resultContentEN"] : null as any;
            this.resultContentIT = _data["resultContentIT"] !== undefined ? _data["resultContentIT"] : null as any;
            this.surveyUrl = _data["surveyUrl"] !== undefined ? _data["surveyUrl"] : null as any;
            this.resultIllustrationUrl = _data["resultIllustrationUrl"] !== undefined ? _data["resultIllustrationUrl"] : null as any;
            this.order = _data["order"] !== undefined ? _data["order"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
        }
    }

    static fromJS(data: any): SurveyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["resultContentFR"] = this.resultContentFR !== undefined ? this.resultContentFR : null as any;
        data["resultContentDE"] = this.resultContentDE !== undefined ? this.resultContentDE : null as any;
        data["resultContentEN"] = this.resultContentEN !== undefined ? this.resultContentEN : null as any;
        data["resultContentIT"] = this.resultContentIT !== undefined ? this.resultContentIT : null as any;
        data["surveyUrl"] = this.surveyUrl !== undefined ? this.surveyUrl : null as any;
        data["resultIllustrationUrl"] = this.resultIllustrationUrl !== undefined ? this.resultIllustrationUrl : null as any;
        data["order"] = this.order !== undefined ? this.order : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISurveyInputDto {
    titleFR?: string;
    titleDE?: string | null;
    titleIT?: string | null;
    titleEN?: string | null;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    resultContentFR?: string | null;
    resultContentDE?: string | null;
    resultContentEN?: string | null;
    resultContentIT?: string | null;
    surveyUrl?: string;
    resultIllustrationUrl?: string | null;
    order?: number;
    customRoles?: CustomRoleDto[];
}

export class SurveyPublishInputDto implements ISurveyPublishInputDto {
    publicationDate?: Date;
    endPublicationDate?: Date | null;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;

    constructor(data?: ISurveyPublishInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.endPublicationDate = _data["endPublicationDate"] ? new Date(_data["endPublicationDate"].toString()) : null as any;
            this.resultsPublicationDate = _data["resultsPublicationDate"] ? new Date(_data["resultsPublicationDate"].toString()) : null as any;
            this.resultsEndPublicationDate = _data["resultsEndPublicationDate"] ? new Date(_data["resultsEndPublicationDate"].toString()) : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
        }
    }

    static fromJS(data: any): SurveyPublishInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyPublishInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["endPublicationDate"] = this.endPublicationDate ? this.endPublicationDate.toISOString() : null as any;
        data["resultsPublicationDate"] = this.resultsPublicationDate ? this.resultsPublicationDate.toISOString() : null as any;
        data["resultsEndPublicationDate"] = this.resultsEndPublicationDate ? this.resultsEndPublicationDate.toISOString() : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        return data;
    }
}

export interface ISurveyPublishInputDto {
    publicationDate?: Date;
    endPublicationDate?: Date | null;
    resultsPublicationDate?: Date | null;
    resultsEndPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;
}

export class ImageDto implements IImageDto {
    illustrationUrl?: string | null;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.illustrationUrl = _data["illustrationUrl"] !== undefined ? _data["illustrationUrl"] : null as any;
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["illustrationUrl"] = this.illustrationUrl !== undefined ? this.illustrationUrl : null as any;
        return data;
    }
}

export interface IImageDto {
    illustrationUrl?: string | null;
}

export class DocumentDto implements IDocumentDto {
    id?: string;
    title?: string;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IDocumentDto {
    id?: string;
    title?: string;
}

export class ServiceHourlyUsageByDaysOfWeekDto implements IServiceHourlyUsageByDaysOfWeekDto {
    usageData?: ServiceHourlyUsage[];

    constructor(data?: IServiceHourlyUsageByDaysOfWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usageData"])) {
                this.usageData = [] as any;
                for (let item of _data["usageData"])
                    this.usageData!.push(ServiceHourlyUsage.fromJS(item));
            }
            else {
                this.usageData = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceHourlyUsageByDaysOfWeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceHourlyUsageByDaysOfWeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usageData)) {
            data["usageData"] = [];
            for (let item of this.usageData)
                data["usageData"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceHourlyUsageByDaysOfWeekDto {
    usageData?: ServiceHourlyUsage[];
}

export class ServiceHourlyUsage implements IServiceHourlyUsage {
    key?: number;
    dayOfWeek?: number;
    hourOfDay?: number;
    transactionsCount?: number;

    constructor(data?: IServiceHourlyUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.dayOfWeek = _data["dayOfWeek"] !== undefined ? _data["dayOfWeek"] : null as any;
            this.hourOfDay = _data["hourOfDay"] !== undefined ? _data["hourOfDay"] : null as any;
            this.transactionsCount = _data["transactionsCount"] !== undefined ? _data["transactionsCount"] : null as any;
        }
    }

    static fromJS(data: any): ServiceHourlyUsage {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceHourlyUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["dayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : null as any;
        data["hourOfDay"] = this.hourOfDay !== undefined ? this.hourOfDay : null as any;
        data["transactionsCount"] = this.transactionsCount !== undefined ? this.transactionsCount : null as any;
        return data;
    }
}

export interface IServiceHourlyUsage {
    key?: number;
    dayOfWeek?: number;
    hourOfDay?: number;
    transactionsCount?: number;
}

export class ServiceStatisticsInputDto implements IServiceStatisticsInputDto {
    serviceId?: string;
    dateFrom?: Date | null;
    dateTo?: Date | null;

    constructor(data?: IServiceStatisticsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : null as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ServiceStatisticsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStatisticsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : null as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : null as any;
        return data;
    }
}

export interface IServiceStatisticsInputDto {
    serviceId?: string;
    dateFrom?: Date | null;
    dateTo?: Date | null;
}

export class SiteDto implements ISiteDto {
    id?: string;
    code?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;

    constructor(data?: ISiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
        }
    }

    static fromJS(data: any): SiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        return data;
    }
}

export interface ISiteDto {
    id?: string;
    code?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
}

export class SiteInputDto implements ISiteInputDto {
    code!: string;
    nameFR!: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;

    constructor(data?: ISiteInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
        }
    }

    static fromJS(data: any): SiteInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        return data;
    }
}

export interface ISiteInputDto {
    code: string;
    nameFR: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
}

export class SiteUpdateInputDto implements ISiteUpdateInputDto {
    nameFR!: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;

    constructor(data?: ISiteUpdateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
        }
    }

    static fromJS(data: any): SiteUpdateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiteUpdateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        return data;
    }
}

export interface ISiteUpdateInputDto {
    nameFR: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
}

export class ServiceCategoryWithServicesDto implements IServiceCategoryWithServicesDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    imageUrl?: string;
    services?: ServiceLightDto[];

    constructor(data?: IServiceCategoryWithServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceLightDto.fromJS(item));
            }
            else {
                this.services = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceCategoryWithServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryWithServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceCategoryWithServicesDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    imageUrl?: string;
    services?: ServiceLightDto[];
}

export class ServiceLightDto implements IServiceLightDto {
    serviceId?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    iconUrl?: string | null;

    constructor(data?: IServiceLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.iconUrl = _data["iconUrl"] !== undefined ? _data["iconUrl"] : null as any;
        }
    }

    static fromJS(data: any): ServiceLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["iconUrl"] = this.iconUrl !== undefined ? this.iconUrl : null as any;
        return data;
    }
}

export interface IServiceLightDto {
    serviceId?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    iconUrl?: string | null;
}

export class ServiceDto implements IServiceDto {
    serviceId?: string;
    serviceConfig?: ServiceConfigDto;
    code?: string | null;
    active?: boolean;
    bookable?: boolean;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    categoryId?: string | null;
    instructionFR?: string | null;
    instructionDE?: string | null;
    instructionEN?: string | null;
    instructionIT?: string | null;
    imageUrl?: string | null;
    authenticationMethods?: AuthenticationMethods[];
    minimalWalletBalanceRequired?: number;
    amountToReserveForServiceConsumption?: number | null;
    impulseDuration?: number | null;
    maxImpulseDuration?: number | null;
    impulseDurationUnit?: ImpulseDurationUnit | null;
    tariffs?: TariffDto[];
    availabilityRanges?: AvailabilityRangeDto[];
    items?: ItemToBookDto[];
    customRoles?: CustomRoleDto[];
    backoffices?: BackofficeLightDto[];

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.serviceConfig = _data["serviceConfig"] ? ServiceConfigDto.fromJS(_data["serviceConfig"]) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.bookable = _data["bookable"] !== undefined ? _data["bookable"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.instructionFR = _data["instructionFR"] !== undefined ? _data["instructionFR"] : null as any;
            this.instructionDE = _data["instructionDE"] !== undefined ? _data["instructionDE"] : null as any;
            this.instructionEN = _data["instructionEN"] !== undefined ? _data["instructionEN"] : null as any;
            this.instructionIT = _data["instructionIT"] !== undefined ? _data["instructionIT"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
            if (Array.isArray(_data["authenticationMethods"])) {
                this.authenticationMethods = [] as any;
                for (let item of _data["authenticationMethods"])
                    this.authenticationMethods!.push(item);
            }
            else {
                this.authenticationMethods = null as any;
            }
            this.minimalWalletBalanceRequired = _data["minimalWalletBalanceRequired"] !== undefined ? _data["minimalWalletBalanceRequired"] : null as any;
            this.amountToReserveForServiceConsumption = _data["amountToReserveForServiceConsumption"] !== undefined ? _data["amountToReserveForServiceConsumption"] : null as any;
            this.impulseDuration = _data["impulseDuration"] !== undefined ? _data["impulseDuration"] : null as any;
            this.maxImpulseDuration = _data["maxImpulseDuration"] !== undefined ? _data["maxImpulseDuration"] : null as any;
            this.impulseDurationUnit = _data["impulseDurationUnit"] !== undefined ? _data["impulseDurationUnit"] : null as any;
            if (Array.isArray(_data["tariffs"])) {
                this.tariffs = [] as any;
                for (let item of _data["tariffs"])
                    this.tariffs!.push(TariffDto.fromJS(item));
            }
            else {
                this.tariffs = null as any;
            }
            if (Array.isArray(_data["availabilityRanges"])) {
                this.availabilityRanges = [] as any;
                for (let item of _data["availabilityRanges"])
                    this.availabilityRanges!.push(AvailabilityRangeDto.fromJS(item));
            }
            else {
                this.availabilityRanges = null as any;
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemToBookDto.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
            if (Array.isArray(_data["backoffices"])) {
                this.backoffices = [] as any;
                for (let item of _data["backoffices"])
                    this.backoffices!.push(BackofficeLightDto.fromJS(item));
            }
            else {
                this.backoffices = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["serviceConfig"] = this.serviceConfig ? this.serviceConfig.toJSON() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["bookable"] = this.bookable !== undefined ? this.bookable : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["instructionFR"] = this.instructionFR !== undefined ? this.instructionFR : null as any;
        data["instructionDE"] = this.instructionDE !== undefined ? this.instructionDE : null as any;
        data["instructionEN"] = this.instructionEN !== undefined ? this.instructionEN : null as any;
        data["instructionIT"] = this.instructionIT !== undefined ? this.instructionIT : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        if (Array.isArray(this.authenticationMethods)) {
            data["authenticationMethods"] = [];
            for (let item of this.authenticationMethods)
                data["authenticationMethods"].push(item);
        }
        data["minimalWalletBalanceRequired"] = this.minimalWalletBalanceRequired !== undefined ? this.minimalWalletBalanceRequired : null as any;
        data["amountToReserveForServiceConsumption"] = this.amountToReserveForServiceConsumption !== undefined ? this.amountToReserveForServiceConsumption : null as any;
        data["impulseDuration"] = this.impulseDuration !== undefined ? this.impulseDuration : null as any;
        data["maxImpulseDuration"] = this.maxImpulseDuration !== undefined ? this.maxImpulseDuration : null as any;
        data["impulseDurationUnit"] = this.impulseDurationUnit !== undefined ? this.impulseDurationUnit : null as any;
        if (Array.isArray(this.tariffs)) {
            data["tariffs"] = [];
            for (let item of this.tariffs)
                data["tariffs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.availabilityRanges)) {
            data["availabilityRanges"] = [];
            for (let item of this.availabilityRanges)
                data["availabilityRanges"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.backoffices)) {
            data["backoffices"] = [];
            for (let item of this.backoffices)
                data["backoffices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceDto {
    serviceId?: string;
    serviceConfig?: ServiceConfigDto;
    code?: string | null;
    active?: boolean;
    bookable?: boolean;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    categoryId?: string | null;
    instructionFR?: string | null;
    instructionDE?: string | null;
    instructionEN?: string | null;
    instructionIT?: string | null;
    imageUrl?: string | null;
    authenticationMethods?: AuthenticationMethods[];
    minimalWalletBalanceRequired?: number;
    amountToReserveForServiceConsumption?: number | null;
    impulseDuration?: number | null;
    maxImpulseDuration?: number | null;
    impulseDurationUnit?: ImpulseDurationUnit | null;
    tariffs?: TariffDto[];
    availabilityRanges?: AvailabilityRangeDto[];
    items?: ItemToBookDto[];
    customRoles?: CustomRoleDto[];
    backoffices?: BackofficeLightDto[];
}

export class ServiceConfigDto implements IServiceConfigDto {
    id?: string;
    serviceType?: ServiceType;
    dayAndNightTariff?: boolean;
    canUserChooseUnit?: boolean;
    iconUrl?: string;
    unique?: boolean;
    tariffConfigs?: TariffConfigDto[];

    constructor(data?: IServiceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.dayAndNightTariff = _data["dayAndNightTariff"] !== undefined ? _data["dayAndNightTariff"] : null as any;
            this.canUserChooseUnit = _data["canUserChooseUnit"] !== undefined ? _data["canUserChooseUnit"] : null as any;
            this.iconUrl = _data["iconUrl"] !== undefined ? _data["iconUrl"] : null as any;
            this.unique = _data["unique"] !== undefined ? _data["unique"] : null as any;
            if (Array.isArray(_data["tariffConfigs"])) {
                this.tariffConfigs = [] as any;
                for (let item of _data["tariffConfigs"])
                    this.tariffConfigs!.push(TariffConfigDto.fromJS(item));
            }
            else {
                this.tariffConfigs = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["dayAndNightTariff"] = this.dayAndNightTariff !== undefined ? this.dayAndNightTariff : null as any;
        data["canUserChooseUnit"] = this.canUserChooseUnit !== undefined ? this.canUserChooseUnit : null as any;
        data["iconUrl"] = this.iconUrl !== undefined ? this.iconUrl : null as any;
        data["unique"] = this.unique !== undefined ? this.unique : null as any;
        if (Array.isArray(this.tariffConfigs)) {
            data["tariffConfigs"] = [];
            for (let item of this.tariffConfigs)
                data["tariffConfigs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceConfigDto {
    id?: string;
    serviceType?: ServiceType;
    dayAndNightTariff?: boolean;
    canUserChooseUnit?: boolean;
    iconUrl?: string;
    unique?: boolean;
    tariffConfigs?: TariffConfigDto[];
}

export enum ServiceType {
    Default = "Default",
    LegacyFalconicDumpster = "LegacyFalconicDumpster",
    Hydrowash = "Hydrowash",
    MooringPlace = "MooringPlace",
    AccessControl = "AccessControl",
    Bookable = "Bookable",
    TimeLimited = "TimeLimited",
    Energy = "Energy",
    Wifi = "Wifi",
    UserAlarm = "UserAlarm",
    CraningAndWinterizing = "CraningAndWinterizing",
    Webcam = "Webcam",
    Weather = "Weather",
    PointOfSale = "PointOfSale",
    LegacyKocoDumpster = "LegacyKocoDumpster",
    PublicLighting = "PublicLighting",
    ChargingStations = "ChargingStations",
    WasteManagement = "WasteManagement",
}

export enum AuthenticationMethods {
    None = "None",
    Qrcode = "Qrcode",
    Rfid = "Rfid",
}

export enum ImpulseDurationUnit {
    Second = "Second",
    Minute = "Minute",
    Hour = "Hour",
    Day = "Day",
    Millisecond = "Millisecond",
}

export class AvailabilityRangeDto implements IAvailabilityRangeDto {
    id?: string | null;
    startDate?: Date;
    endDate?: Date | null;
    days?: Day[];
    startTime?: string;
    endTime?: string;
    serviceId?: string;

    constructor(data?: IAvailabilityRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): AvailabilityRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IAvailabilityRangeDto {
    id?: string | null;
    startDate?: Date;
    endDate?: Date | null;
    days?: Day[];
    startTime?: string;
    endTime?: string;
    serviceId?: string;
}

export enum Day {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class ItemToBookDto implements IItemToBookDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    measuringPoint?: MeasuringPointLightDto | null;
    serviceId?: string;

    constructor(data?: IItemToBookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.measuringPoint = _data["measuringPoint"] ? MeasuringPointLightDto.fromJS(_data["measuringPoint"]) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): ItemToBookDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemToBookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["measuringPoint"] = this.measuringPoint ? this.measuringPoint.toJSON() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IItemToBookDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    measuringPoint?: MeasuringPointLightDto | null;
    serviceId?: string;
}

export class MeasuringPointLightDto implements IMeasuringPointLightDto {
    id?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    measuringPointUsageState?: MeasuringPointUsageState;
    customer?: CustomerLightDto | null;

    constructor(data?: IMeasuringPointLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.measuringPointUsageState = _data["measuringPointUsageState"] !== undefined ? _data["measuringPointUsageState"] : null as any;
            this.customer = _data["customer"] ? CustomerLightDto.fromJS(_data["customer"]) : null as any;
        }
    }

    static fromJS(data: any): MeasuringPointLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringPointLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["measuringPointUsageState"] = this.measuringPointUsageState !== undefined ? this.measuringPointUsageState : null as any;
        data["customer"] = this.customer ? this.customer.toJSON() : null as any;
        return data;
    }
}

export interface IMeasuringPointLightDto {
    id?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    measuringPointUsageState?: MeasuringPointUsageState;
    customer?: CustomerLightDto | null;
}

export enum MeasuringPointUsageState {
    Unknown = "Unknown",
    Free = "Free",
    Busy = "Busy",
    Error = "Error",
}

export class CustomerLightDto implements ICustomerLightDto {
    id?: string;
    customerNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    city?: string;
    street?: string;
    postalCode?: string;
    cards?: CardDto[];
    customRoles?: CustomRoleDto[];
    accountEnabled?: boolean;

    constructor(data?: ICustomerLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardDto.fromJS(item));
            }
            else {
                this.cards = null as any;
            }
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
        }
    }

    static fromJS(data: any): CustomerLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        return data;
    }
}

export interface ICustomerLightDto {
    id?: string;
    customerNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    city?: string;
    street?: string;
    postalCode?: string;
    cards?: CardDto[];
    customRoles?: CustomRoleDto[];
    accountEnabled?: boolean;
}

export class CardDto implements ICardDto {
    cardNumber?: string;
    uid?: string;
    cardState?: CardState;
    customerId?: string | null;
    customerClientNumber?: string | null;
    customerFirstName?: string | null;
    customerLastName?: string | null;

    constructor(data?: ICardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.cardState = _data["cardState"] !== undefined ? _data["cardState"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customerClientNumber = _data["customerClientNumber"] !== undefined ? _data["customerClientNumber"] : null as any;
            this.customerFirstName = _data["customerFirstName"] !== undefined ? _data["customerFirstName"] : null as any;
            this.customerLastName = _data["customerLastName"] !== undefined ? _data["customerLastName"] : null as any;
        }
    }

    static fromJS(data: any): CardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["cardState"] = this.cardState !== undefined ? this.cardState : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customerClientNumber"] = this.customerClientNumber !== undefined ? this.customerClientNumber : null as any;
        data["customerFirstName"] = this.customerFirstName !== undefined ? this.customerFirstName : null as any;
        data["customerLastName"] = this.customerLastName !== undefined ? this.customerLastName : null as any;
        return data;
    }
}

export interface ICardDto {
    cardNumber?: string;
    uid?: string;
    cardState?: CardState;
    customerId?: string | null;
    customerClientNumber?: string | null;
    customerFirstName?: string | null;
    customerLastName?: string | null;
}

export enum CardState {
    Unassigned = "Unassigned",
    Assigned = "Assigned",
    Broken = "Broken",
    Lost = "Lost",
    Virtual = "Virtual",
}

export class BackofficeLightDto implements IBackofficeLightDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    accountEnabled?: boolean;

    constructor(data?: IBackofficeLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
        }
    }

    static fromJS(data: any): BackofficeLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        return data;
    }
}

export interface IBackofficeLightDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    accountEnabled?: boolean;
}

export class MyServiceDto implements IMyServiceDto {
    serviceId?: string;
    serviceConfig?: ServiceConfigDto;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    active?: boolean;
    nextEntry?: MyServicesNextEntryDto | null;

    constructor(data?: IMyServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.serviceConfig = _data["serviceConfig"] ? ServiceConfigDto.fromJS(_data["serviceConfig"]) : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.nextEntry = _data["nextEntry"] ? MyServicesNextEntryDto.fromJS(_data["nextEntry"]) : null as any;
        }
    }

    static fromJS(data: any): MyServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["serviceConfig"] = this.serviceConfig ? this.serviceConfig.toJSON() : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["nextEntry"] = this.nextEntry ? this.nextEntry.toJSON() : null as any;
        return data;
    }
}

export interface IMyServiceDto {
    serviceId?: string;
    serviceConfig?: ServiceConfigDto;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    active?: boolean;
    nextEntry?: MyServicesNextEntryDto | null;
}

export class ServiceInputDto implements IServiceInputDto {
    serviceConfigId?: string;
    code?: string;
    active?: boolean;
    bookable?: boolean;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    categoryId?: string;
    instructionFR?: string | null;
    instructionDE?: string | null;
    instructionEN?: string | null;
    instructionIT?: string | null;
    authenticationMethods?: AuthenticationMethods[];
    minimalWalletBalanceRequired?: number;
    amountToReserveForServiceConsumption?: number | null;
    impulseDuration?: number | null;
    maxImpulseDuration?: number | null;
    impulseDurationUnit?: ImpulseDurationUnit | null;
    customRoles?: CustomRoleDto[];
    backofficeIds?: string[];

    constructor(data?: IServiceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceConfigId = _data["serviceConfigId"] !== undefined ? _data["serviceConfigId"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.bookable = _data["bookable"] !== undefined ? _data["bookable"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.instructionFR = _data["instructionFR"] !== undefined ? _data["instructionFR"] : null as any;
            this.instructionDE = _data["instructionDE"] !== undefined ? _data["instructionDE"] : null as any;
            this.instructionEN = _data["instructionEN"] !== undefined ? _data["instructionEN"] : null as any;
            this.instructionIT = _data["instructionIT"] !== undefined ? _data["instructionIT"] : null as any;
            if (Array.isArray(_data["authenticationMethods"])) {
                this.authenticationMethods = [] as any;
                for (let item of _data["authenticationMethods"])
                    this.authenticationMethods!.push(item);
            }
            else {
                this.authenticationMethods = null as any;
            }
            this.minimalWalletBalanceRequired = _data["minimalWalletBalanceRequired"] !== undefined ? _data["minimalWalletBalanceRequired"] : null as any;
            this.amountToReserveForServiceConsumption = _data["amountToReserveForServiceConsumption"] !== undefined ? _data["amountToReserveForServiceConsumption"] : null as any;
            this.impulseDuration = _data["impulseDuration"] !== undefined ? _data["impulseDuration"] : null as any;
            this.maxImpulseDuration = _data["maxImpulseDuration"] !== undefined ? _data["maxImpulseDuration"] : null as any;
            this.impulseDurationUnit = _data["impulseDurationUnit"] !== undefined ? _data["impulseDurationUnit"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
            if (Array.isArray(_data["backofficeIds"])) {
                this.backofficeIds = [] as any;
                for (let item of _data["backofficeIds"])
                    this.backofficeIds!.push(item);
            }
            else {
                this.backofficeIds = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceConfigId"] = this.serviceConfigId !== undefined ? this.serviceConfigId : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["bookable"] = this.bookable !== undefined ? this.bookable : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["instructionFR"] = this.instructionFR !== undefined ? this.instructionFR : null as any;
        data["instructionDE"] = this.instructionDE !== undefined ? this.instructionDE : null as any;
        data["instructionEN"] = this.instructionEN !== undefined ? this.instructionEN : null as any;
        data["instructionIT"] = this.instructionIT !== undefined ? this.instructionIT : null as any;
        if (Array.isArray(this.authenticationMethods)) {
            data["authenticationMethods"] = [];
            for (let item of this.authenticationMethods)
                data["authenticationMethods"].push(item);
        }
        data["minimalWalletBalanceRequired"] = this.minimalWalletBalanceRequired !== undefined ? this.minimalWalletBalanceRequired : null as any;
        data["amountToReserveForServiceConsumption"] = this.amountToReserveForServiceConsumption !== undefined ? this.amountToReserveForServiceConsumption : null as any;
        data["impulseDuration"] = this.impulseDuration !== undefined ? this.impulseDuration : null as any;
        data["maxImpulseDuration"] = this.maxImpulseDuration !== undefined ? this.maxImpulseDuration : null as any;
        data["impulseDurationUnit"] = this.impulseDurationUnit !== undefined ? this.impulseDurationUnit : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.backofficeIds)) {
            data["backofficeIds"] = [];
            for (let item of this.backofficeIds)
                data["backofficeIds"].push(item);
        }
        return data;
    }
}

export interface IServiceInputDto {
    serviceConfigId?: string;
    code?: string;
    active?: boolean;
    bookable?: boolean;
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    categoryId?: string;
    instructionFR?: string | null;
    instructionDE?: string | null;
    instructionEN?: string | null;
    instructionIT?: string | null;
    authenticationMethods?: AuthenticationMethods[];
    minimalWalletBalanceRequired?: number;
    amountToReserveForServiceConsumption?: number | null;
    impulseDuration?: number | null;
    maxImpulseDuration?: number | null;
    impulseDurationUnit?: ImpulseDurationUnit | null;
    customRoles?: CustomRoleDto[];
    backofficeIds?: string[];
}

export class ServiceImageDto implements IServiceImageDto {
    imageUrl?: string | null;

    constructor(data?: IServiceImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
        }
    }

    static fromJS(data: any): ServiceImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        return data;
    }
}

export interface IServiceImageDto {
    imageUrl?: string | null;
}

export class KocoAvailabilityDto implements IKocoAvailabilityDto {
    startDate?: Date;
    endDate?: Date | null;
    days?: DayOfWeek;
    startTime?: string;
    endTime?: string;

    constructor(data?: IKocoAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.days = _data["days"] !== undefined ? _data["days"] : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
        }
    }

    static fromJS(data: any): KocoAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new KocoAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["days"] = this.days !== undefined ? this.days : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        return data;
    }
}

export interface IKocoAvailabilityDto {
    startDate?: Date;
    endDate?: Date | null;
    days?: DayOfWeek;
    startTime?: string;
    endTime?: string;
}

export enum DayOfWeek {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export class PagedResultDtoOfDumpsterUserInfoDto implements IPagedResultDtoOfDumpsterUserInfoDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: DumpsterUserInfoDto[];

    constructor(data?: IPagedResultDtoOfDumpsterUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DumpsterUserInfoDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDumpsterUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDumpsterUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfDumpsterUserInfoDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: DumpsterUserInfoDto[];
}

export class DumpsterUserInfoDto implements IDumpsterUserInfoDto {
    cardUids?: string[];
    customerId?: string;
    firstName?: string;
    lastName?: string;
    balance?: number;
    isAuthorized?: boolean;
    deviceId?: string | null;
    addressDto?: AddressDto | null;
    householdSize?: number | null;
    siteCodes?: string[];

    constructor(data?: IDumpsterUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cardUids"])) {
                this.cardUids = [] as any;
                for (let item of _data["cardUids"])
                    this.cardUids!.push(item);
            }
            else {
                this.cardUids = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : null as any;
            this.isAuthorized = _data["isAuthorized"] !== undefined ? _data["isAuthorized"] : null as any;
            this.deviceId = _data["deviceId"] !== undefined ? _data["deviceId"] : null as any;
            this.addressDto = _data["addressDto"] ? AddressDto.fromJS(_data["addressDto"]) : null as any;
            this.householdSize = _data["householdSize"] !== undefined ? _data["householdSize"] : null as any;
            if (Array.isArray(_data["siteCodes"])) {
                this.siteCodes = [] as any;
                for (let item of _data["siteCodes"])
                    this.siteCodes!.push(item);
            }
            else {
                this.siteCodes = null as any;
            }
        }
    }

    static fromJS(data: any): DumpsterUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DumpsterUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cardUids)) {
            data["cardUids"] = [];
            for (let item of this.cardUids)
                data["cardUids"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["balance"] = this.balance !== undefined ? this.balance : null as any;
        data["isAuthorized"] = this.isAuthorized !== undefined ? this.isAuthorized : null as any;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null as any;
        data["addressDto"] = this.addressDto ? this.addressDto.toJSON() : null as any;
        data["householdSize"] = this.householdSize !== undefined ? this.householdSize : null as any;
        if (Array.isArray(this.siteCodes)) {
            data["siteCodes"] = [];
            for (let item of this.siteCodes)
                data["siteCodes"].push(item);
        }
        return data;
    }
}

export interface IDumpsterUserInfoDto {
    cardUids?: string[];
    customerId?: string;
    firstName?: string;
    lastName?: string;
    balance?: number;
    isAuthorized?: boolean;
    deviceId?: string | null;
    addressDto?: AddressDto | null;
    householdSize?: number | null;
    siteCodes?: string[];
}

export class AddressDto implements IAddressDto {
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }
}

export interface IAddressDto {
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
}

export class ServiceConfigInputDto implements IServiceConfigInputDto {
    serviceType?: ServiceType;
    dayAndNightTariff?: boolean;
    canUserChooseUnit?: boolean;
    iconUrl?: string;
    unique?: boolean;
    tariffConfigs?: TariffConfigInputDto[];

    constructor(data?: IServiceConfigInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.dayAndNightTariff = _data["dayAndNightTariff"] !== undefined ? _data["dayAndNightTariff"] : null as any;
            this.canUserChooseUnit = _data["canUserChooseUnit"] !== undefined ? _data["canUserChooseUnit"] : null as any;
            this.iconUrl = _data["iconUrl"] !== undefined ? _data["iconUrl"] : null as any;
            this.unique = _data["unique"] !== undefined ? _data["unique"] : null as any;
            if (Array.isArray(_data["tariffConfigs"])) {
                this.tariffConfigs = [] as any;
                for (let item of _data["tariffConfigs"])
                    this.tariffConfigs!.push(TariffConfigInputDto.fromJS(item));
            }
            else {
                this.tariffConfigs = null as any;
            }
        }
    }

    static fromJS(data: any): ServiceConfigInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConfigInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["dayAndNightTariff"] = this.dayAndNightTariff !== undefined ? this.dayAndNightTariff : null as any;
        data["canUserChooseUnit"] = this.canUserChooseUnit !== undefined ? this.canUserChooseUnit : null as any;
        data["iconUrl"] = this.iconUrl !== undefined ? this.iconUrl : null as any;
        data["unique"] = this.unique !== undefined ? this.unique : null as any;
        if (Array.isArray(this.tariffConfigs)) {
            data["tariffConfigs"] = [];
            for (let item of this.tariffConfigs)
                data["tariffConfigs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IServiceConfigInputDto {
    serviceType?: ServiceType;
    dayAndNightTariff?: boolean;
    canUserChooseUnit?: boolean;
    iconUrl?: string;
    unique?: boolean;
    tariffConfigs?: TariffConfigInputDto[];
}

export class TariffConfigInputDto implements ITariffConfigInputDto {
    tariffType?: TariffType;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    tariffConfigUnits?: TariffConfigUnitInputDto[];

    constructor(data?: ITariffConfigInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariffType = _data["tariffType"] !== undefined ? _data["tariffType"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            if (Array.isArray(_data["tariffConfigUnits"])) {
                this.tariffConfigUnits = [] as any;
                for (let item of _data["tariffConfigUnits"])
                    this.tariffConfigUnits!.push(TariffConfigUnitInputDto.fromJS(item));
            }
            else {
                this.tariffConfigUnits = null as any;
            }
        }
    }

    static fromJS(data: any): TariffConfigInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffConfigInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariffType"] = this.tariffType !== undefined ? this.tariffType : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        if (Array.isArray(this.tariffConfigUnits)) {
            data["tariffConfigUnits"] = [];
            for (let item of this.tariffConfigUnits)
                data["tariffConfigUnits"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITariffConfigInputDto {
    tariffType?: TariffType;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    tariffConfigUnits?: TariffConfigUnitInputDto[];
}

export class TariffConfigUnitInputDto implements ITariffConfigUnitInputDto {
    unitEnumName?: string;
    unitEnumValue?: string;

    constructor(data?: ITariffConfigUnitInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitEnumName = _data["unitEnumName"] !== undefined ? _data["unitEnumName"] : null as any;
            this.unitEnumValue = _data["unitEnumValue"] !== undefined ? _data["unitEnumValue"] : null as any;
        }
    }

    static fromJS(data: any): TariffConfigUnitInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TariffConfigUnitInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitEnumName"] = this.unitEnumName !== undefined ? this.unitEnumName : null as any;
        data["unitEnumValue"] = this.unitEnumValue !== undefined ? this.unitEnumValue : null as any;
        return data;
    }
}

export interface ITariffConfigUnitInputDto {
    unitEnumName?: string;
    unitEnumValue?: string;
}

export class ServiceCategoryDto implements IServiceCategoryDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    imageUrl?: string;

    constructor(data?: IServiceCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null as any;
        }
    }

    static fromJS(data: any): ServiceCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null as any;
        return data;
    }
}

export interface IServiceCategoryDto {
    id?: string | null;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    imageUrl?: string;
}

export class CustomRoleInputDto implements ICustomRoleInputDto {
    roleKey?: string;
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;

    constructor(data?: ICustomRoleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleKey = _data["roleKey"] !== undefined ? _data["roleKey"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
        }
    }

    static fromJS(data: any): CustomRoleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomRoleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleKey"] = this.roleKey !== undefined ? this.roleKey : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        return data;
    }
}

export interface ICustomRoleInputDto {
    roleKey?: string;
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;
}

export class PurchaseDto implements IPurchaseDto {
    purchaseId?: string;
    amount?: number;
    serviceId?: string;

    constructor(data?: IPurchaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"] !== undefined ? _data["purchaseId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): PurchaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId !== undefined ? this.purchaseId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IPurchaseDto {
    purchaseId?: string;
    amount?: number;
    serviceId?: string;
}

export class PurchaseInputDto implements IPurchaseInputDto {
    serviceId?: string;
    reservationTime?: Date;
    tariffId?: string;
    tariffConfigUnitId?: string;
    qty?: number;
    paymentType?: PaymentTypes;

    constructor(data?: IPurchaseInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.reservationTime = _data["reservationTime"] ? new Date(_data["reservationTime"].toString()) : null as any;
            this.tariffId = _data["tariffId"] !== undefined ? _data["tariffId"] : null as any;
            this.tariffConfigUnitId = _data["tariffConfigUnitId"] !== undefined ? _data["tariffConfigUnitId"] : null as any;
            this.qty = _data["qty"] !== undefined ? _data["qty"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
        }
    }

    static fromJS(data: any): PurchaseInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["reservationTime"] = this.reservationTime ? this.reservationTime.toISOString() : null as any;
        data["tariffId"] = this.tariffId !== undefined ? this.tariffId : null as any;
        data["tariffConfigUnitId"] = this.tariffConfigUnitId !== undefined ? this.tariffConfigUnitId : null as any;
        data["qty"] = this.qty !== undefined ? this.qty : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        return data;
    }
}

export interface IPurchaseInputDto {
    serviceId?: string;
    reservationTime?: Date;
    tariffId?: string;
    tariffConfigUnitId?: string;
    qty?: number;
    paymentType?: PaymentTypes;
}

export class LightZoneScheduleDto implements ILightZoneScheduleDto {
    id?: string;
    lightZoneId?: string;
    lightZoneCode?: string;
    serviceId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: DayOfWeek;
    startTime?: string;
    endTime?: string | null;

    constructor(data?: ILightZoneScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
            this.lightZoneCode = _data["lightZoneCode"] !== undefined ? _data["lightZoneCode"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.days = _data["days"] !== undefined ? _data["days"] : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        data["lightZoneCode"] = this.lightZoneCode !== undefined ? this.lightZoneCode : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["days"] = this.days !== undefined ? this.days : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        return data;
    }
}

export interface ILightZoneScheduleDto {
    id?: string;
    lightZoneId?: string;
    lightZoneCode?: string;
    serviceId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: DayOfWeek;
    startTime?: string;
    endTime?: string | null;
}

export enum PublicLightingControlMode {
    Automatic = "Automatic",
    ForceOn = "ForceOn",
    ForceOff = "ForceOff",
}

export class LightZoneScheduleInputDto implements ILightZoneScheduleInputDto {
    lightZoneId?: string;
    lightZoneServiceId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: Day[];
    startTime?: string;
    endTime?: string | null;

    constructor(data?: ILightZoneScheduleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
            this.lightZoneServiceId = _data["lightZoneServiceId"] !== undefined ? _data["lightZoneServiceId"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneScheduleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneScheduleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        data["lightZoneServiceId"] = this.lightZoneServiceId !== undefined ? this.lightZoneServiceId : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        return data;
    }
}

export interface ILightZoneScheduleInputDto {
    lightZoneId?: string;
    lightZoneServiceId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: Day[];
    startTime?: string;
    endTime?: string | null;
}

export class LightZoneScheduleUpdateDto implements ILightZoneScheduleUpdateDto {
    id?: string;
    lightZoneId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: Day[];
    startTime?: string;
    endTime?: string | null;

    constructor(data?: ILightZoneScheduleUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneScheduleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneScheduleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        return data;
    }
}

export interface ILightZoneScheduleUpdateDto {
    id?: string;
    lightZoneId?: string;
    mode?: PublicLightingControlMode;
    startDate?: Date;
    endDate?: Date;
    days?: Day[];
    startTime?: string;
    endTime?: string | null;
}

export class ExternalLightDto implements IExternalLightDto {
    publicLightingProvider?: PublicLightingProvider;
    externalId?: string;
    name?: string;
    description?: string | null;
    externalCoordinates?: string;
    publicLightingState?: PublicLightingState;
    intensity?: number | null;
    totalConsumption?: number | null;

    constructor(data?: IExternalLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicLightingProvider = _data["publicLightingProvider"] !== undefined ? _data["publicLightingProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.externalCoordinates = _data["externalCoordinates"] !== undefined ? _data["externalCoordinates"] : null as any;
            this.publicLightingState = _data["publicLightingState"] !== undefined ? _data["publicLightingState"] : null as any;
            this.intensity = _data["intensity"] !== undefined ? _data["intensity"] : null as any;
            this.totalConsumption = _data["totalConsumption"] !== undefined ? _data["totalConsumption"] : null as any;
        }
    }

    static fromJS(data: any): ExternalLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicLightingProvider"] = this.publicLightingProvider !== undefined ? this.publicLightingProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["externalCoordinates"] = this.externalCoordinates !== undefined ? this.externalCoordinates : null as any;
        data["publicLightingState"] = this.publicLightingState !== undefined ? this.publicLightingState : null as any;
        data["intensity"] = this.intensity !== undefined ? this.intensity : null as any;
        data["totalConsumption"] = this.totalConsumption !== undefined ? this.totalConsumption : null as any;
        return data;
    }
}

export interface IExternalLightDto {
    publicLightingProvider?: PublicLightingProvider;
    externalId?: string;
    name?: string;
    description?: string | null;
    externalCoordinates?: string;
    publicLightingState?: PublicLightingState;
    intensity?: number | null;
    totalConsumption?: number | null;
}

export enum PublicLightingProvider {
    Exedra = "Exedra",
    InteractLighting = "InteractLighting",
    Novalight = "Novalight",
}

export enum PublicLightingState {
    Unknown = "Unknown",
    Connected = "Connected",
    Disconnected = "Disconnected",
}

export class LightCompleteDto implements ILightCompleteDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    externalName?: string | null;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;
    externalCoordinates?: string;
    totalConsumption?: number | null;
    intensity?: number | null;
    publicLightingState?: PublicLightingState | null;
    externalStatus?: PublicLightingExternalStatus | null;
    alarmId?: number | null;
    lastDataUpdate?: Date | null;

    constructor(data?: ILightCompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lightProvider = _data["lightProvider"] !== undefined ? _data["lightProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.externalName = _data["externalName"] !== undefined ? _data["externalName"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.lightZoneCode = _data["lightZoneCode"] !== undefined ? _data["lightZoneCode"] : null as any;
            this.externalCoordinates = _data["externalCoordinates"] !== undefined ? _data["externalCoordinates"] : null as any;
            this.totalConsumption = _data["totalConsumption"] !== undefined ? _data["totalConsumption"] : null as any;
            this.intensity = _data["intensity"] !== undefined ? _data["intensity"] : null as any;
            this.publicLightingState = _data["publicLightingState"] !== undefined ? _data["publicLightingState"] : null as any;
            this.externalStatus = _data["externalStatus"] !== undefined ? _data["externalStatus"] : null as any;
            this.alarmId = _data["alarmId"] !== undefined ? _data["alarmId"] : null as any;
            this.lastDataUpdate = _data["lastDataUpdate"] ? new Date(_data["lastDataUpdate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): LightCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lightProvider"] = this.lightProvider !== undefined ? this.lightProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["externalName"] = this.externalName !== undefined ? this.externalName : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["lightZoneCode"] = this.lightZoneCode !== undefined ? this.lightZoneCode : null as any;
        data["externalCoordinates"] = this.externalCoordinates !== undefined ? this.externalCoordinates : null as any;
        data["totalConsumption"] = this.totalConsumption !== undefined ? this.totalConsumption : null as any;
        data["intensity"] = this.intensity !== undefined ? this.intensity : null as any;
        data["publicLightingState"] = this.publicLightingState !== undefined ? this.publicLightingState : null as any;
        data["externalStatus"] = this.externalStatus !== undefined ? this.externalStatus : null as any;
        data["alarmId"] = this.alarmId !== undefined ? this.alarmId : null as any;
        data["lastDataUpdate"] = this.lastDataUpdate ? this.lastDataUpdate.toISOString() : null as any;
        return data;
    }
}

export interface ILightCompleteDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    externalName?: string | null;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;
    externalCoordinates?: string;
    totalConsumption?: number | null;
    intensity?: number | null;
    publicLightingState?: PublicLightingState | null;
    externalStatus?: PublicLightingExternalStatus | null;
    alarmId?: number | null;
    lastDataUpdate?: Date | null;
}

export enum PublicLightingExternalStatus {
    Available = "Available",
    NotAvailable = "NotAvailable",
    NotExisting = "NotExisting",
}

export class LightWithStateDto implements ILightWithStateDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    code?: string;
    longitude?: number;
    latitude?: number;
    externalState?: PublicLightingExternalState | null;
    externalStatus?: PublicLightingExternalStatus | null;
    serviceId?: string;
    lightZoneId?: string | null;

    constructor(data?: ILightWithStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lightProvider = _data["lightProvider"] !== undefined ? _data["lightProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.externalState = _data["externalState"] !== undefined ? _data["externalState"] : null as any;
            this.externalStatus = _data["externalStatus"] !== undefined ? _data["externalStatus"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
        }
    }

    static fromJS(data: any): LightWithStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightWithStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lightProvider"] = this.lightProvider !== undefined ? this.lightProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["externalState"] = this.externalState !== undefined ? this.externalState : null as any;
        data["externalStatus"] = this.externalStatus !== undefined ? this.externalStatus : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        return data;
    }
}

export interface ILightWithStateDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    code?: string;
    longitude?: number;
    latitude?: number;
    externalState?: PublicLightingExternalState | null;
    externalStatus?: PublicLightingExternalStatus | null;
    serviceId?: string;
    lightZoneId?: string | null;
}

export enum PublicLightingExternalState {
    Unknown = "Unknown",
    On = "On",
    Off = "Off",
    Alarm = "Alarm",
}

export class LightDto implements ILightDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    longitude?: number;
    latitude?: number;
    serviceId?: string;
    lightZoneId?: string | null;

    constructor(data?: ILightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lightProvider = _data["lightProvider"] !== undefined ? _data["lightProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
        }
    }

    static fromJS(data: any): LightDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lightProvider"] = this.lightProvider !== undefined ? this.lightProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        return data;
    }
}

export interface ILightDto {
    id?: string;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    longitude?: number;
    latitude?: number;
    serviceId?: string;
    lightZoneId?: string | null;
}

export class PagedResultDtoOfLightTableDto implements IPagedResultDtoOfLightTableDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: LightTableDto[];

    constructor(data?: IPagedResultDtoOfLightTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(LightTableDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLightTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLightTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfLightTableDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: LightTableDto[];
}

export class LightTableDto implements ILightTableDto {
    id?: string;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;

    constructor(data?: ILightTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.lightZoneCode = _data["lightZoneCode"] !== undefined ? _data["lightZoneCode"] : null as any;
        }
    }

    static fromJS(data: any): LightTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["lightZoneCode"] = this.lightZoneCode !== undefined ? this.lightZoneCode : null as any;
        return data;
    }
}

export interface ILightTableDto {
    id?: string;
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;
}

export class PageableRequestDtoOfLightCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfLightCriteriaDto {
    criteria?: LightCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfLightCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? LightCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfLightCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfLightCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfLightCriteriaDto extends IPageableRequestDto {
    criteria?: LightCriteriaDto | null;
}

export class LightCriteriaDto implements ILightCriteriaDto {
    searchCriteriaDto?: LightSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;

    constructor(data?: ILightCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? LightSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
        }
    }

    static fromJS(data: any): LightCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        return data;
    }
}

export interface ILightCriteriaDto {
    searchCriteriaDto?: LightSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;
}

export class LightSearchCriteriaDto implements ILightSearchCriteriaDto {
    code?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;

    constructor(data?: ILightSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.lightZoneCode = _data["lightZoneCode"] !== undefined ? _data["lightZoneCode"] : null as any;
        }
    }

    static fromJS(data: any): LightSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["lightZoneCode"] = this.lightZoneCode !== undefined ? this.lightZoneCode : null as any;
        return data;
    }
}

export interface ILightSearchCriteriaDto {
    code?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    lightZoneCode?: string | null;
}

export class LightInputDto implements ILightInputDto {
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    latitude?: number;
    longitude?: number;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    serviceId?: string;
    lightZoneId?: string | null;

    constructor(data?: ILightInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.lightProvider = _data["lightProvider"] !== undefined ? _data["lightProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
        }
    }

    static fromJS(data: any): LightInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["lightProvider"] = this.lightProvider !== undefined ? this.lightProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        return data;
    }
}

export interface ILightInputDto {
    code?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    latitude?: number;
    longitude?: number;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
    serviceId?: string;
    lightZoneId?: string | null;
}

export class ImportResultOfImportLightDto implements IImportResultOfImportLightDto {
    importedEntries?: RowEntryOfImportLightDto[];
    notImportedEntries?: RowEntryWithErrorOfImportLightDto[];

    constructor(data?: IImportResultOfImportLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["importedEntries"])) {
                this.importedEntries = [] as any;
                for (let item of _data["importedEntries"])
                    this.importedEntries!.push(RowEntryOfImportLightDto.fromJS(item));
            }
            else {
                this.importedEntries = null as any;
            }
            if (Array.isArray(_data["notImportedEntries"])) {
                this.notImportedEntries = [] as any;
                for (let item of _data["notImportedEntries"])
                    this.notImportedEntries!.push(RowEntryWithErrorOfImportLightDto.fromJS(item));
            }
            else {
                this.notImportedEntries = null as any;
            }
        }
    }

    static fromJS(data: any): ImportResultOfImportLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportResultOfImportLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importedEntries)) {
            data["importedEntries"] = [];
            for (let item of this.importedEntries)
                data["importedEntries"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.notImportedEntries)) {
            data["notImportedEntries"] = [];
            for (let item of this.notImportedEntries)
                data["notImportedEntries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IImportResultOfImportLightDto {
    importedEntries?: RowEntryOfImportLightDto[];
    notImportedEntries?: RowEntryWithErrorOfImportLightDto[];
}

export class RowEntryOfImportLightDto implements IRowEntryOfImportLightDto {
    row?: number;
    entry?: ImportLightDto | null;

    constructor(data?: IRowEntryOfImportLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"] !== undefined ? _data["row"] : null as any;
            this.entry = _data["entry"] ? ImportLightDto.fromJS(_data["entry"]) : null as any;
        }
    }

    static fromJS(data: any): RowEntryOfImportLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowEntryOfImportLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row !== undefined ? this.row : null as any;
        data["entry"] = this.entry ? this.entry.toJSON() : null as any;
        return data;
    }
}

export interface IRowEntryOfImportLightDto {
    row?: number;
    entry?: ImportLightDto | null;
}

export class ImportLightDto implements IImportLightDto {
    serviceId?: string;
    lightCode?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    longitude?: number;
    latitude?: number;
    lightZoneCode?: string | null;
    lightZoneId?: string | null;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;

    constructor(data?: IImportLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightCode = _data["lightCode"] !== undefined ? _data["lightCode"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.lightZoneCode = _data["lightZoneCode"] !== undefined ? _data["lightZoneCode"] : null as any;
            this.lightZoneId = _data["lightZoneId"] !== undefined ? _data["lightZoneId"] : null as any;
            this.lightProvider = _data["lightProvider"] !== undefined ? _data["lightProvider"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
        }
    }

    static fromJS(data: any): ImportLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightCode"] = this.lightCode !== undefined ? this.lightCode : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["lightZoneCode"] = this.lightZoneCode !== undefined ? this.lightZoneCode : null as any;
        data["lightZoneId"] = this.lightZoneId !== undefined ? this.lightZoneId : null as any;
        data["lightProvider"] = this.lightProvider !== undefined ? this.lightProvider : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        return data;
    }
}

export interface IImportLightDto {
    serviceId?: string;
    lightCode?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    longitude?: number;
    latitude?: number;
    lightZoneCode?: string | null;
    lightZoneId?: string | null;
    lightProvider?: PublicLightingProvider | null;
    externalId?: string | null;
}

export class RowEntryWithErrorOfImportLightDto extends RowEntryOfImportLightDto implements IRowEntryWithErrorOfImportLightDto {
    error?: BusinessCode;
    errorDetails?: { [key: string]: any; };

    constructor(data?: IRowEntryWithErrorOfImportLightDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            if (_data["errorDetails"]) {
                this.errorDetails = {} as any;
                for (let key in _data["errorDetails"]) {
                    if (_data["errorDetails"].hasOwnProperty(key))
                        (this.errorDetails as any)![key] = _data["errorDetails"][key] !== undefined ? _data["errorDetails"][key] : null as any;
                }
            }
            else {
                this.errorDetails = null as any;
            }
        }
    }

    static override fromJS(data: any): RowEntryWithErrorOfImportLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new RowEntryWithErrorOfImportLightDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error !== undefined ? this.error : null as any;
        if (this.errorDetails) {
            data["errorDetails"] = {};
            for (let key in this.errorDetails) {
                if (this.errorDetails.hasOwnProperty(key))
                    (data["errorDetails"] as any)[key] = this.errorDetails[key] !== undefined ? this.errorDetails[key] : null as any;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRowEntryWithErrorOfImportLightDto extends IRowEntryOfImportLightDto {
    error?: BusinessCode;
    errorDetails?: { [key: string]: any; };
}

export enum BusinessCode {
    ImportAlreadyInProgress = "ImportAlreadyInProgress",
    InvalidContentType = "InvalidContentType",
    InvalidImageContentType = "InvalidImageContentType",
    InvalidWeightUnitType = "InvalidWeightUnitType",
    InvalidAreaUnitType = "InvalidAreaUnitType",
    InvalidDurationUnitType = "InvalidDurationUnitType",
    InvalidEnergyUnitType = "InvalidEnergyUnitType",
    InvalidLengthUnitType = "InvalidLengthUnitType",
    InvalidPeriodUnitType = "InvalidPeriodUnitType",
    InvalidVolumeUnitType = "InvalidVolumeUnitType",
    NotEnoughMoneyBusinessCode = "NotEnoughMoneyBusinessCode",
    DbUpdateConcurrencyExceptionCode = "DbUpdateConcurrencyExceptionCode",
    UnableToPersistDataInDatabase = "UnableToPersistDataInDatabase",
    CashierTransactionWithoutPaymentMethod = "CashierTransactionWithoutPaymentMethod",
    CashierTransactionInvalidTransactionSource = "CashierTransactionInvalidTransactionSource",
    UnableToCreateDatatransPaymentRequest = "UnableToCreateDatatransPaymentRequest",
    DatatransAmountNotValidForService = "DatatransAmountNotValidForService",
    InvalidAmountToSettleDatatransTransaction = "InvalidAmountToSettleDatatransTransaction",
    NoRefnoForEbankingPayment = "NoRefnoForEbankingPayment",
    EwalletNotFoundForCustomerError = "EwalletNotFoundForCustomerError",
    EwalletNotEnoughAmountForCustomerError = "EwalletNotEnoughAmountForCustomerError",
    MinimumWalletCreditAmountHasNotBeenReached = "MinimumWalletCreditAmountHasNotBeenReached",
    EwalletScheduledClosureMustNotBeInPast = "EwalletScheduledClosureMustNotBeInPast",
    MooringPlaceAlreadyExist = "MooringPlaceAlreadyExist",
    DeviceAlreadyRegisteredForPushForAnotherCustomer = "DeviceAlreadyRegisteredForPushForAnotherCustomer",
    SendMailUnableToFindCustomerInformation = "SendMailUnableToFindCustomerInformation",
    MeasuringPointIsAlreadyAssignedToAService = "MeasuringPointIsAlreadyAssignedToAService",
    MeasuringPointIsAlreadyAssignedToACustomer = "MeasuringPointIsAlreadyAssignedToACustomer",
    MeasuringPointIsAlreadyLinkedToAnItemToBook = "MeasuringPointIsAlreadyLinkedToAnItemToBook",
    MeasureCannotBeReset = "MeasureCannotBeReset",
    MeasuringPointDoesNotContainsPowerConsummationMeasure = "MeasuringPointDoesNotContainsPowerConsummationMeasure",
    UnassignNothingOnMeasuringPoint = "UnassignNothingOnMeasuringPoint",
    UnableToUnassignMeasuringPointWithActiveCustomerAlarmSubscription = "UnableToUnassignMeasuringPointWithActiveCustomerAlarmSubscription",
    UnableToMoveMeasuringPointWithActiveCustomerAlarmSubscription = "UnableToMoveMeasuringPointWithActiveCustomerAlarmSubscription",
    UnableToMoveMeasuringPointToAnAssignedMeasuringPoint = "UnableToMoveMeasuringPointToAnAssignedMeasuringPoint",
    MeasuringPointContainsMoreThanOneStateRegister = "MeasuringPointContainsMoreThanOneStateRegister",
    CustomerHasMoreThanOneMeasuringPointForTheService = "CustomerHasMoreThanOneMeasuringPointForTheService",
    UnableToUnassignMeasuringPointLinkedToReservableObject = "UnableToUnassignMeasuringPointLinkedToReservableObject",
    MeasuringPointIsNotAssignedToAService = "MeasuringPointIsNotAssignedToAService",
    SourceAndTargetMeasuringPointsAreNotAssignedToSameService = "SourceAndTargetMeasuringPointsAreNotAssignedToSameService",
    SourceMeasuringPointIsNotAssignedToCustomer = "SourceMeasuringPointIsNotAssignedToCustomer",
    MeasuringPointIsNotAssignedToACustomer = "MeasuringPointIsNotAssignedToACustomer",
    MeasuringPointIsAssignedToACustomer = "MeasuringPointIsAssignedToACustomer",
    ServiceLinkedToThisCategory = "ServiceLinkedToThisCategory",
    UnableToUploadImageToAzureBlobStorage = "UnableToUploadImageToAzureBlobStorage",
    ServiceConfigIsLinkedToService = "ServiceConfigIsLinkedToService",
    CanNotDeleteItemBecauseIsBooked = "CanNotDeleteItemBecauseIsBooked",
    BookingOverlaps = "BookingOverlaps",
    UnableToCreateBookingForAnother = "UnableToCreateBookingForAnother",
    UnableToUpdateBookingForAnother = "UnableToUpdateBookingForAnother",
    UnableToCancelBookingForAnother = "UnableToCancelBookingForAnother",
    UnableToRetrieveBookingForAnother = "UnableToRetrieveBookingForAnother",
    BookingDurationExceedsMaxDuration = "BookingDurationExceedsMaxDuration",
    BookingMaxPlannedBookingsReached = "BookingMaxPlannedBookingsReached",
    BookingMaxSimultaneousBookingsReached = "BookingMaxSimultaneousBookingsReached",
    BookingRecurringBookingPartialCancelInvalidDateRange = "BookingRecurringBookingPartialCancelInvalidDateRange",
    UnableToCancelNotRecurringBooking = "UnableToCancelNotRecurringBooking",
    BookingRecurringBookingPartialCancelDateRangeOutsideBookingRange = "BookingRecurringBookingPartialCancelDateRangeOutsideBookingRange",
    BookingRecurringBookingPartialCancelCanNotCancelOngoingBooking = "BookingRecurringBookingPartialCancelCanNotCancelOngoingBooking",
    UnableToPartiallyCancelRecurringBookingForAnother = "UnableToPartiallyCancelRecurringBookingForAnother",
    BookingDateExceedsLimitDate = "BookingDateExceedsLimitDate",
    BookingStartDateInPast = "BookingStartDateInPast",
    UnableToCancelBookingOutsideCancellationPeriod = "UnableToCancelBookingOutsideCancellationPeriod",
    ServiceCodeAlreadyExist = "ServiceCodeAlreadyExist",
    ServiceIsNotBookable = "ServiceIsNotBookable",
    ServiceImpulseDurationShouldNotExceedBookingDuration = "ServiceImpulseDurationShouldNotExceedBookingDuration",
    ServiceInitialBookingDurationShouldNotBeGreaterThanMaxBookingDuration = "ServiceInitialBookingDurationShouldNotBeGreaterThanMaxBookingDuration",
    ServiceAmountToReserveForServiceConsumptionShouldNotBeNull = "ServiceAmountToReserveForServiceConsumptionShouldNotBeNull",
    ServiceIsNotAvailable = "ServiceIsNotAvailable",
    UnableToDeleteServiceIfCurrentBookingExists = "UnableToDeleteServiceIfCurrentBookingExists",
    UnableToDeleteServiceIfCurrentSubscriptionExists = "UnableToDeleteServiceIfCurrentSubscriptionExists",
    UnableToDeleteServiceIfActive = "UnableToDeleteServiceIfActive",
    UnableToDeleteServiceIfWeatherStationExists = "UnableToDeleteServiceIfWeatherStationExists",
    UnableToCreateUserInAd = "UnableToCreateUserInAd",
    UnableToCreateUserInDb = "UnableToCreateUserInDb",
    UnableToUpdateUserInDb = "UnableToUpdateUserInDb",
    UnableToUpdateUserInAd = "UnableToUpdateUserInAd",
    UnableToDeleteUserInAd = "UnableToDeleteUserInAd",
    CustomerMailAlreadyExist = "CustomerMailAlreadyExist",
    UserCustomerNumberAlreadyExist = "UserCustomerNumberAlreadyExist",
    UserRfidCardNotFound = "UserRfidCardNotFound",
    RfidStateError = "RfidStateError",
    RfidCardNumberAlreadyExist = "RfidCardNumberAlreadyExist",
    RfidCardUidAlreadyExist = "RfidCardUidAlreadyExist",
    UnableToCreateVirtualCard = "UnableToCreateVirtualCard",
    CustomerHouseholdSizeRequired = "CustomerHouseholdSizeRequired",
    ImportCustomerHouseholdSizeRequired = "ImportCustomerHouseholdSizeRequired",
    ImportCustomerSameMail = "ImportCustomerSameMail",
    ImportCustomerSameCustomerNumber = "ImportCustomerSameCustomerNumber",
    ImportCustomerSameRfidCardNumber = "ImportCustomerSameRfidCardNumber",
    ImportCustomerBaseRoleDoesNotExist = "ImportCustomerBaseRoleDoesNotExist",
    ImportCustomerCustomRoleDoesNotExist = "ImportCustomerCustomRoleDoesNotExist",
    ImportCustomerRfidCardAlreadyAssigned = "ImportCustomerRfidCardAlreadyAssigned",
    ImportCustomerCustomerNumberCannotBeEmpty = "ImportCustomerCustomerNumberCannotBeEmpty",
    ImportCustomerFirstNameTooLong = "ImportCustomerFirstNameTooLong",
    ImportCustomerLastNameTooLong = "ImportCustomerLastNameTooLong",
    ImportCustomerSiteDoesNotExist = "ImportCustomerSiteDoesNotExist",
    BackofficeMailAlreadyExist = "BackofficeMailAlreadyExist",
    UnableToCreateBackofficeInAd = "UnableToCreateBackofficeInAd",
    UnableToCreateBackofficeInDb = "UnableToCreateBackofficeInDb",
    BackofficePermissionNotFound = "BackofficePermissionNotFound",
    BackofficeNotFound = "BackofficeNotFound",
    UnableToUpdateBackofficeInDb = "UnableToUpdateBackofficeInDb",
    ExploitantNotFound = "ExploitantNotFound",
    ExploitantIsDisabled = "ExploitantIsDisabled",
    ExploitantCannotBeSuperAdmin = "ExploitantCannotBeSuperAdmin",
    ExploitantCannotModifyAdminFields = "ExploitantCannotModifyAdminFields",
    UnableToReadExcelFile = "UnableToReadExcelFile",
    ExcelReaderSheetNameNotExist = "ExcelReaderSheetNameNotExist",
    ExcelReaderInvalidLine = "ExcelReaderInvalidLine",
    DuplicateLinesInExcelFile = "DuplicateLinesInExcelFile",
    NotSupportedFileFormat = "NotSupportedFileFormat",
    ExcelInvalidEmptyString = "ExcelInvalidEmptyString",
    ExcelInvalidNullValue = "ExcelInvalidNullValue",
    ExcelInvalidIntValue = "ExcelInvalidIntValue",
    ExcelInvalidUri = "ExcelInvalidUri",
    ExcelInvalidDoubleValue = "ExcelInvalidDoubleValue",
    ExcelInvalidLongValue = "ExcelInvalidLongValue",
    ExcelInvalidFloatValue = "ExcelInvalidFloatValue",
    ExcelInvalidDecimalValue = "ExcelInvalidDecimalValue",
    ExcelInvalidEnumValue = "ExcelInvalidEnumValue",
    ExcelStringTooLong = "ExcelStringTooLong",
    ExcelInvalidNumberOfDecimals = "ExcelInvalidNumberOfDecimals",
    ExcelInvalidGuid = "ExcelInvalidGuid",
    ExcelInvalidDateValue = "ExcelInvalidDateValue",
    ExcelMissingColumn = "ExcelMissingColumn",
    HydrowashWashingTrackIdAlreadyExist = "HydrowashWashingTrackIdAlreadyExist",
    HydrowashWashingTrackAlreadyInUse = "HydrowashWashingTrackAlreadyInUse",
    HydrowashWashingTrackIsInError = "HydrowashWashingTrackIsInError",
    HydrowashWashingTrackCannotBeActivated = "HydrowashWashingTrackCannotBeActivated",
    UnableToCreateActivationForAnother = "UnableToCreateActivationForAnother",
    UnableToActivateABusyMeasuringPoint = "UnableToActivateABusyMeasuringPoint",
    UnableToActivateIfServiceIsNotActive = "UnableToActivateIfServiceIsNotActive",
    UnableToActivateIfCustomerCannotAccessService = "UnableToActivateIfCustomerCannotAccessService",
    UnableToExtendActivationOfTerminatedActivation = "UnableToExtendActivationOfTerminatedActivation",
    UnableToExceedMaxImpulseDuration = "UnableToExceedMaxImpulseDuration",
    UnableToTerminateActivationForAnother = "UnableToTerminateActivationForAnother",
    UnableToActivateIfMeasuringPointHasNoService = "UnableToActivateIfMeasuringPointHasNoService",
    UnableToExtendActivationForAnother = "UnableToExtendActivationForAnother",
    WifiCannotBeDeletedWhenAssignedToService = "WifiCannotBeDeletedWhenAssignedToService",
    WifiIsAlreadyAssignedToAnotherService = "WifiIsAlreadyAssignedToAnotherService",
    WifiContainsSubscriptions = "WifiContainsSubscriptions",
    WifiSubscriptionAlreadyDisabled = "WifiSubscriptionAlreadyDisabled",
    NoWifiNetworkAssignedToService = "NoWifiNetworkAssignedToService",
    CustomerAlarmAlreadyExistForIotRegister = "CustomerAlarmAlreadyExistForIotRegister",
    AlarmDeviceAlreadyExistForIotRegister = "AlarmDeviceAlreadyExistForIotRegister",
    AlarmDeviceReceiverAlreadyExistForDevice = "AlarmDeviceReceiverAlreadyExistForDevice",
    AlarmDeviceCannotBeDeletedBecauseAlarmStillActive = "AlarmDeviceCannotBeDeletedBecauseAlarmStillActive",
    AlarmSolvedCannotBeSetInProgress = "AlarmSolvedCannotBeSetInProgress",
    AlarmDeviceCannotBeDisabledBecauseAlarmStillActive = "AlarmDeviceCannotBeDisabledBecauseAlarmStillActive",
    OfficeHourOpeningPeriodNotValid = "OfficeHourOpeningPeriodNotValid",
    OfficeHourExceptionPeriodNotValid = "OfficeHourExceptionPeriodNotValid",
    OfficeHourExceptionEndDateMustNotBeInPast = "OfficeHourExceptionEndDateMustNotBeInPast",
    CraningServicePricingNonConsistentMinMaxValues = "CraningServicePricingNonConsistentMinMaxValues",
    CraningServicePricingMinValueNotValid = "CraningServicePricingMinValueNotValid",
    CraningServicePricingMaxValueNotValid = "CraningServicePricingMaxValueNotValid",
    CraningServicePricingValueRangeNotValid = "CraningServicePricingValueRangeNotValid",
    CraningServicePricingRangeAlreadyUsed = "CraningServicePricingRangeAlreadyUsed",
    CraningServicePricingAlreadyExistingFlatPricing = "CraningServicePricingAlreadyExistingFlatPricing",
    CraningServicePricingPriceNotValid = "CraningServicePricingPriceNotValid",
    CraningServicePricingNoConsistentPricingType = "CraningServicePricingNoConsistentPricingType",
    CraningServicePricingPriceNotPossibleToChangePricingType = "CraningServicePricingPriceNotPossibleToChangePricingType",
    QuestionAnswerTypeNotValid = "QuestionAnswerTypeNotValid",
    QuestionCannotUpdateAnswerType = "QuestionCannotUpdateAnswerType",
    CraningBookingSlotStartDateMustNotBeInPast = "CraningBookingSlotStartDateMustNotBeInPast",
    CraningBookingSlotDatePeriodNotValid = "CraningBookingSlotDatePeriodNotValid",
    CraningBookingSlotTimePeriodNotValid = "CraningBookingSlotTimePeriodNotValid",
    CraningBookingSlotAtLeastADayMustBeSelected = "CraningBookingSlotAtLeastADayMustBeSelected",
    CraningBookingSlotStateNotValid = "CraningBookingSlotStateNotValid",
    CraningBookingSlotDurationNotValid = "CraningBookingSlotDurationNotValid",
    CraningBookingSlotOnlyFreeOrBlockedCanBeDeleted = "CraningBookingSlotOnlyFreeOrBlockedCanBeDeleted",
    CraningBookingSlotChangesLeadToConflicts = "CraningBookingSlotChangesLeadToConflicts",
    CraningBookingNotPossibleForTodayAndTomorrow = "CraningBookingNotPossibleForTodayAndTomorrow",
    CraningBookingAlreadyUsedSlot = "CraningBookingAlreadyUsedSlot",
    CraningBookingNotAssignableSlot = "CraningBookingNotAssignableSlot",
    CraningBookingNotPossibleToChangeCustomer = "CraningBookingNotPossibleToChangeCustomer",
    CraningBookingAllVisitorFieldsMustBeFillIn = "CraningBookingAllVisitorFieldsMustBeFillIn",
    CraningBookingVisitorCanNotHaveMooringPlace = "CraningBookingVisitorCanNotHaveMooringPlace",
    CraningBookingAllVisitorBoatFieldsMustBeFillIn = "CraningBookingAllVisitorBoatFieldsMustBeFillIn",
    CraningBookingAtLeastOneServiceMustBeSelected = "CraningBookingAtLeastOneServiceMustBeSelected",
    CraningBookingServiceCannotBeSelectedMoreThanOne = "CraningBookingServiceCannotBeSelectedMoreThanOne",
    CraningBookingServiceDoesNotExist = "CraningBookingServiceDoesNotExist",
    CraningBookingQuestionCannotBeAnsweredMoreThanOne = "CraningBookingQuestionCannotBeAnsweredMoreThanOne",
    CraningBookingAllQuestionsMustBeAnswered = "CraningBookingAllQuestionsMustBeAnswered",
    CraningBookingAnswerToNotExistingQuestion = "CraningBookingAnswerToNotExistingQuestion",
    CraningBookingNotValidBooleanAnswer = "CraningBookingNotValidBooleanAnswer",
    CraningBookingNotValidNumberAnswer = "CraningBookingNotValidNumberAnswer",
    CraningBookingAllVisitorFieldsMustBeEmptyForCustomer = "CraningBookingAllVisitorFieldsMustBeEmptyForCustomer",
    CraningBookingAllVisitorBoatFieldsMustBeEmptyForMooringPlace = "CraningBookingAllVisitorBoatFieldsMustBeEmptyForMooringPlace",
    CraningBookingEWalletCannotBeUsedForVisitor = "CraningBookingEWalletCannotBeUsedForVisitor",
    CraningBookingMaxActiveBookingHasBeenReached = "CraningBookingMaxActiveBookingHasBeenReached",
    CraningBookingForVisitorCannotBePaidWithEWallet = "CraningBookingForVisitorCannotBePaidWithEWallet",
    CraningBookingNotPossibleToMovePassedBooking = "CraningBookingNotPossibleToMovePassedBooking",
    CraningBookingNotPossibleToMoveToAnotherService = "CraningBookingNotPossibleToMoveToAnotherService",
    CraningBookingNotPossibleToMoveForBilling = "CraningBookingNotPossibleToMoveForBilling",
    CraningBookingNotPossibleToBillFutureBooking = "CraningBookingNotPossibleToBillFutureBooking",
    CraningBookingNotPossibleToDeleteForTodayAndTomorrow = "CraningBookingNotPossibleToDeleteForTodayAndTomorrow",
    CraningBookingNotPossibleToDeleteIfInvoiced = "CraningBookingNotPossibleToDeleteIfInvoiced",
    CraningBookingNotPossibleToMoveByCustomer = "CraningBookingNotPossibleToMoveByCustomer",
    CraningBookingServiceNotPossibleToDeleteIfBooked = "CraningBookingServiceNotPossibleToDeleteIfBooked",
    AlertDeviceCannotBeDeletedBecauseAlertStillActive = "AlertDeviceCannotBeDeletedBecauseAlertStillActive",
    AlertDeviceCannotBeDisabledBecauseAlertStillActive = "AlertDeviceCannotBeDisabledBecauseAlertStillActive",
    DefaultTariffAlreadyExists = "DefaultTariffAlreadyExists",
    DefaultTariffDoesNotExist = "DefaultTariffDoesNotExist",
    TariffPeriodConflict = "TariffPeriodConflict",
    UnableToUpdateDefaultTariffFlag = "UnableToUpdateDefaultTariffFlag",
    TariffShouldHaveTwoPrices = "TariffShouldHaveTwoPrices",
    TariffShouldHaveOnePrice = "TariffShouldHaveOnePrice",
    TariffShouldHaveOnlyOnePaymentType = "TariffShouldHaveOnlyOnePaymentType",
    UnableToChangeTariffConfig = "UnableToChangeTariffConfig",
    NightRateIsNotAvailableForTheService = "NightRateIsNotAvailableForTheService",
    TariffShouldHaveThreePrices = "TariffShouldHaveThreePrices",
    DayAndNightTariffShouldHaveSameNumberOfPrices = "DayAndNightTariffShouldHaveSameNumberOfPrices",
    TariffTypeAndTimeOfPaymentMismatch = "TariffTypeAndTimeOfPaymentMismatch",
    UnableToDeleteServiceIfWebcamExists = "UnableToDeleteServiceIfWebcamExists",
    UnableToDeleteEquipmentCategoryIfEquipmentExist = "UnableToDeleteEquipmentCategoryIfEquipmentExist",
    UnableToDeleteCustomerIfActive = "UnableToDeleteCustomerIfActive",
    UnableToDeleteCustomerIfAssignedRfidCard = "UnableToDeleteCustomerIfAssignedRfidCard",
    UnableToDeleteCustomerIfNotEmptyEwallet = "UnableToDeleteCustomerIfNotEmptyEwallet",
    UnableToDeleteCustomerIfExistingBooking = "UnableToDeleteCustomerIfExistingBooking",
    UnableToDeleteCustomerIfExistingCraningBooking = "UnableToDeleteCustomerIfExistingCraningBooking",
    UnableToDeleteCustomerIfExistingMooringPlace = "UnableToDeleteCustomerIfExistingMooringPlace",
    UnableToDeleteCustomerIfExistingMeasuringPoint = "UnableToDeleteCustomerIfExistingMeasuringPoint",
    UnableToDeleteCustomerIfExistingCustomerAlarmSubscription = "UnableToDeleteCustomerIfExistingCustomerAlarmSubscription",
    UnableToDeleteCustomerIfExistingWifiSubscription = "UnableToDeleteCustomerIfExistingWifiSubscription",
    UnableToDeleteCustomerIfExistingBillingToPay = "UnableToDeleteCustomerIfExistingBillingToPay",
    UnableToDeleteCustomerIfExistingCraningBillingToPay = "UnableToDeleteCustomerIfExistingCraningBillingToPay",
    UnableToDeleteOwnBackoffice = "UnableToDeleteOwnBackoffice",
    UnitEnumNameDoesNotExists = "UnitEnumNameDoesNotExists",
    UnitEnumValueDoesNotExists = "UnitEnumValueDoesNotExists",
    TariffTypeUnavailableForServiceType = "TariffTypeUnavailableForServiceType",
    TariffUnitUnavailableForServiceType = "TariffUnitUnavailableForServiceType",
    TariffUnitUnavailableForTariffType = "TariffUnitUnavailableForTariffType",
    TariffUnitAlreadyChosen = "TariffUnitAlreadyChosen",
    TariffConsumptionAndDurationNeedTwoUnits = "TariffConsumptionAndDurationNeedTwoUnits",
    MultipleTariffUnitsUnsupportedForTariffType = "MultipleTariffUnitsUnsupportedForTariffType",
    DayAndNightTariffUnavailableForServiceType = "DayAndNightTariffUnavailableForServiceType",
    TariffFlatAndConsumptionAndDurationNeedsTwoDifferentUnitTypes = "TariffFlatAndConsumptionAndDurationNeedsTwoDifferentUnitTypes",
    TariffFlatAndDurationNeedsOneUnitType = "TariffFlatAndDurationNeedsOneUnitType",
    PointOfSalePosIdAlreadyExist = "PointOfSalePosIdAlreadyExist",
    UnableToDeleteServiceIfPosExists = "UnableToDeleteServiceIfPosExists",
    PosCreditAmountMustBePositive = "PosCreditAmountMustBePositive",
    RoleLinkedToUser = "RoleLinkedToUser",
    RoleLinkedToService = "RoleLinkedToService",
    UnableToDisableMandatoryRole = "UnableToDisableMandatoryRole",
    RolesOrPermissionsEditionNotAllowed = "RolesOrPermissionsEditionNotAllowed",
    DumpsterDeviceIdAlreadyExist = "DumpsterDeviceIdAlreadyExist",
    UnableToDeleteServiceIfDumpsterExists = "UnableToDeleteServiceIfDumpsterExists",
    ImportMeasuringPointExistingNumericId = "ImportMeasuringPointExistingNumericId",
    LightZoneCodeAlreadyExists = "LightZoneCodeAlreadyExists",
    LightCodeAlreadyExists = "LightCodeAlreadyExists",
    LightProviderIdAlreadyExists = "LightProviderIdAlreadyExists",
    LightZoneServiceIdCannotBeChanged = "LightZoneServiceIdCannotBeChanged",
    LightZoneScheduleCannotOverlap = "LightZoneScheduleCannotOverlap",
    EndTimeShouldBeProvidedIfModeIsNotAutomatic = "EndTimeShouldBeProvidedIfModeIsNotAutomatic",
    AtLeastADayMustBeScheduled = "AtLeastADayMustBeScheduled",
    PeriodShouldNotExceed12HourWhenOverlappingWinterTimeChange = "PeriodShouldNotExceed12HourWhenOverlappingWinterTimeChange",
    AtLeastOnePeriodShouldBeScheduled = "AtLeastOnePeriodShouldBeScheduled",
    DurationShouldNotExceed24Hours = "DurationShouldNotExceed24Hours",
    DurationShouldBePositive = "DurationShouldBePositive",
    DurationShouldNotExceed12Hours = "DurationShouldNotExceed12Hours",
    ImportLightUnknownServiceId = "ImportLightUnknownServiceId",
    ImportLightUnknownLightZoneCode = "ImportLightUnknownLightZoneCode",
    ImportLightBothOrNeitherLightProviderAndExternalIdMustBeDefined = "ImportLightBothOrNeitherLightProviderAndExternalIdMustBeDefined",
    ImportLightAlreadyExistingLightCodeInFile = "ImportLightAlreadyExistingLightCodeInFile",
    ImportLightAlreadyExistingLightCodeInDatabase = "ImportLightAlreadyExistingLightCodeInDatabase",
    ImportLightAlreadyExistingExternalIdForProviderInFile = "ImportLightAlreadyExistingExternalIdForProviderInFile",
    ImportLightAlreadyExistingExternalIdForProviderInDatabase = "ImportLightAlreadyExistingExternalIdForProviderInDatabase",
    BookingSlotStartDateMustNotBeInPast = "BookingSlotStartDateMustNotBeInPast",
    BookingSlotDatePeriodNotValid = "BookingSlotDatePeriodNotValid",
    BookingSlotTimePeriodNotValid = "BookingSlotTimePeriodNotValid",
    BookingSlotAtLeastADayMustBeSelected = "BookingSlotAtLeastADayMustBeSelected",
    BookingSlotStateNotValid = "BookingSlotStateNotValid",
    BookingSlotDurationNotValid = "BookingSlotDurationNotValid",
    BookingSlotAlreadyUsed = "BookingSlotAlreadyUsed",
    BookingSlotOnlyFreeOrBlockedCanBeDeleted = "BookingSlotOnlyFreeOrBlockedCanBeDeleted",
    BookedBookingSlotStateCanNotBeUpdated = "BookedBookingSlotStateCanNotBeUpdated",
    BookingSlotChangesLeadToConflicts = "BookingSlotChangesLeadToConflicts",
    ServiceBookingModeMustBeFree = "ServiceBookingModeMustBeFree",
    ServiceBookingModeMustBeSlots = "ServiceBookingModeMustBeSlots",
    ChargingStationIdAlreadyExists = "ChargingStationIdAlreadyExists",
    UnableToDeleteServiceIfChargingStationExists = "UnableToDeleteServiceIfChargingStationExists",
    UnableToDeleteChargingStationIfInProgressChargingProcessExists = "UnableToDeleteChargingStationIfInProgressChargingProcessExists",
    UnableToStartChargingProcess = "UnableToStartChargingProcess",
    ChargingStationLinkedToChargingProcessDoesNotExist = "ChargingStationLinkedToChargingProcessDoesNotExist",
    UnableToStopChargingProcess = "UnableToStopChargingProcess",
    UnableToTerminateChargingProcessForAnother = "UnableToTerminateChargingProcessForAnother",
    EaazeResponseError = "EaazeResponseError",
    UnableToActiveBannerBecauseAnotherBannerIsActive = "UnableToActiveBannerBecauseAnotherBannerIsActive",
    SiteCodeAlreadyExists = "SiteCodeAlreadyExists",
    CommonEmailNotValid = "CommonEmailNotValid",
    CommonPhoneNumberNotValid = "CommonPhoneNumberNotValid",
    CommonInvalidInputData = "CommonInvalidInputData",
    CommonRequestTimeout = "CommonRequestTimeout",
}

export class LightZoneDto implements ILightZoneDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;

    constructor(data?: ILightZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface ILightZoneDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;
}

export class LightZoneWithLightCountDto implements ILightZoneWithLightCountDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;
    lightCount?: number;

    constructor(data?: ILightZoneWithLightCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightCount = _data["lightCount"] !== undefined ? _data["lightCount"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneWithLightCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneWithLightCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightCount"] = this.lightCount !== undefined ? this.lightCount : null as any;
        return data;
    }
}

export interface ILightZoneWithLightCountDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;
    lightCount?: number;
}

export class LightZoneWithLightCountAndModeDto implements ILightZoneWithLightCountAndModeDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;
    lightCount?: number;
    controlMode?: PublicLightingControlMode;

    constructor(data?: ILightZoneWithLightCountAndModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.lightCount = _data["lightCount"] !== undefined ? _data["lightCount"] : null as any;
            this.controlMode = _data["controlMode"] !== undefined ? _data["controlMode"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneWithLightCountAndModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneWithLightCountAndModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["lightCount"] = this.lightCount !== undefined ? this.lightCount : null as any;
        data["controlMode"] = this.controlMode !== undefined ? this.controlMode : null as any;
        return data;
    }
}

export interface ILightZoneWithLightCountAndModeDto {
    id?: string;
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionIT?: string;
    descriptionEN?: string;
    serviceId?: string;
    lightCount?: number;
    controlMode?: PublicLightingControlMode;
}

export class LightZoneInputDto implements ILightZoneInputDto {
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;

    constructor(data?: ILightZoneInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): LightZoneInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LightZoneInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface ILightZoneInputDto {
    code?: string;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;
}

export class PointOfSaleDto implements IPointOfSaleDto {
    posId?: string;
    serviceId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;

    constructor(data?: IPointOfSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.posId = _data["posId"] !== undefined ? _data["posId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
        }
    }

    static fromJS(data: any): PointOfSaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posId"] = this.posId !== undefined ? this.posId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        return data;
    }
}

export interface IPointOfSaleDto {
    posId?: string;
    serviceId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
}

export class PointOfSaleInputDto implements IPointOfSaleInputDto {
    serviceId?: string;
    posId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;

    constructor(data?: IPointOfSaleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.posId = _data["posId"] !== undefined ? _data["posId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
        }
    }

    static fromJS(data: any): PointOfSaleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSaleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["posId"] = this.posId !== undefined ? this.posId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        return data;
    }
}

export interface IPointOfSaleInputDto {
    serviceId?: string;
    posId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
}

export class PointOfSaleUpdateDto implements IPointOfSaleUpdateDto {
    posId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;

    constructor(data?: IPointOfSaleUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.posId = _data["posId"] !== undefined ? _data["posId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
        }
    }

    static fromJS(data: any): PointOfSaleUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSaleUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posId"] = this.posId !== undefined ? this.posId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        return data;
    }
}

export interface IPointOfSaleUpdateDto {
    posId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
}

export class PermissionDto implements IPermissionDto {
    id?: string;
    key?: string;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        return data;
    }
}

export interface IPermissionDto {
    id?: string;
    key?: string;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
}

export class OfficeHoursDto implements IOfficeHoursDto {
    officeHour?: OfficeHourDto;
    exceptions?: OfficeHourExceptionDto[];

    constructor(data?: IOfficeHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeHour = _data["officeHour"] ? OfficeHourDto.fromJS(_data["officeHour"]) : null as any;
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(OfficeHourExceptionDto.fromJS(item));
            }
            else {
                this.exceptions = null as any;
            }
        }
    }

    static fromJS(data: any): OfficeHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeHour"] = this.officeHour ? this.officeHour.toJSON() : null as any;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IOfficeHoursDto {
    officeHour?: OfficeHourDto;
    exceptions?: OfficeHourExceptionDto[];
}

export class OfficeHourDto implements IOfficeHourDto {
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    sunday?: boolean;
    startHour?: string;
    endHour?: string;

    constructor(data?: IOfficeHourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monday = _data["monday"] !== undefined ? _data["monday"] : null as any;
            this.tuesday = _data["tuesday"] !== undefined ? _data["tuesday"] : null as any;
            this.wednesday = _data["wednesday"] !== undefined ? _data["wednesday"] : null as any;
            this.thursday = _data["thursday"] !== undefined ? _data["thursday"] : null as any;
            this.friday = _data["friday"] !== undefined ? _data["friday"] : null as any;
            this.saturday = _data["saturday"] !== undefined ? _data["saturday"] : null as any;
            this.sunday = _data["sunday"] !== undefined ? _data["sunday"] : null as any;
            this.startHour = _data["startHour"] !== undefined ? _data["startHour"] : null as any;
            this.endHour = _data["endHour"] !== undefined ? _data["endHour"] : null as any;
        }
    }

    static fromJS(data: any): OfficeHourDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeHourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monday"] = this.monday !== undefined ? this.monday : null as any;
        data["tuesday"] = this.tuesday !== undefined ? this.tuesday : null as any;
        data["wednesday"] = this.wednesday !== undefined ? this.wednesday : null as any;
        data["thursday"] = this.thursday !== undefined ? this.thursday : null as any;
        data["friday"] = this.friday !== undefined ? this.friday : null as any;
        data["saturday"] = this.saturday !== undefined ? this.saturday : null as any;
        data["sunday"] = this.sunday !== undefined ? this.sunday : null as any;
        data["startHour"] = this.startHour !== undefined ? this.startHour : null as any;
        data["endHour"] = this.endHour !== undefined ? this.endHour : null as any;
        return data;
    }
}

export interface IOfficeHourDto {
    monday?: boolean;
    tuesday?: boolean;
    wednesday?: boolean;
    thursday?: boolean;
    friday?: boolean;
    saturday?: boolean;
    sunday?: boolean;
    startHour?: string;
    endHour?: string;
}

export class OfficeHourExceptionInputDto implements IOfficeHourExceptionInputDto {
    startHour?: string;
    endHour?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IOfficeHourExceptionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startHour = _data["startHour"] !== undefined ? _data["startHour"] : null as any;
            this.endHour = _data["endHour"] !== undefined ? _data["endHour"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): OfficeHourExceptionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeHourExceptionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startHour"] = this.startHour !== undefined ? this.startHour : null as any;
        data["endHour"] = this.endHour !== undefined ? this.endHour : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        return data;
    }
}

export interface IOfficeHourExceptionInputDto {
    startHour?: string;
    endHour?: string;
    startDate?: Date;
    endDate?: Date;
}

export class OfficeHourExceptionDto extends OfficeHourExceptionInputDto implements IOfficeHourExceptionDto {
    id?: string;

    constructor(data?: IOfficeHourExceptionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): OfficeHourExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfficeHourExceptionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IOfficeHourExceptionDto extends IOfficeHourExceptionInputDto {
    id?: string;
}

export class MooringPlaceLightDto implements IMooringPlaceLightDto {
    placeId?: string;
    placeNum?: string;
    pontoon?: string;
    placeType?: string;
    latitude?: number;
    longitude?: number;
    boatRegistrationNumber?: string | null;
    sublet?: boolean;
    owner?: string | null;
    customerId?: string | null;

    constructor(data?: IMooringPlaceLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : null as any;
            this.placeNum = _data["placeNum"] !== undefined ? _data["placeNum"] : null as any;
            this.pontoon = _data["pontoon"] !== undefined ? _data["pontoon"] : null as any;
            this.placeType = _data["placeType"] !== undefined ? _data["placeType"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
            this.sublet = _data["sublet"] !== undefined ? _data["sublet"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId !== undefined ? this.placeId : null as any;
        data["placeNum"] = this.placeNum !== undefined ? this.placeNum : null as any;
        data["pontoon"] = this.pontoon !== undefined ? this.pontoon : null as any;
        data["placeType"] = this.placeType !== undefined ? this.placeType : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        data["sublet"] = this.sublet !== undefined ? this.sublet : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IMooringPlaceLightDto {
    placeId?: string;
    placeNum?: string;
    pontoon?: string;
    placeType?: string;
    latitude?: number;
    longitude?: number;
    boatRegistrationNumber?: string | null;
    sublet?: boolean;
    owner?: string | null;
    customerId?: string | null;
}

export class MooringPlaceDto implements IMooringPlaceDto {
    placeId?: string;
    placeNum?: string;
    pontoon?: string;
    placeType?: string;
    placeLengthInMeter?: number;
    placeWidthInMeter?: number;
    boatRegistrationNumber?: string | null;
    boatLengthInMeter?: number | null;
    boatWidthInMeter?: number | null;
    boatWeightInKg?: number | null;
    latitude?: number;
    longitude?: number;
    draft?: number | null;
    boatType?: BoatType;
    sublet?: boolean;
    remark?: string | null;
    customerId?: string | null;

    constructor(data?: IMooringPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : null as any;
            this.placeNum = _data["placeNum"] !== undefined ? _data["placeNum"] : null as any;
            this.pontoon = _data["pontoon"] !== undefined ? _data["pontoon"] : null as any;
            this.placeType = _data["placeType"] !== undefined ? _data["placeType"] : null as any;
            this.placeLengthInMeter = _data["placeLengthInMeter"] !== undefined ? _data["placeLengthInMeter"] : null as any;
            this.placeWidthInMeter = _data["placeWidthInMeter"] !== undefined ? _data["placeWidthInMeter"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
            this.boatLengthInMeter = _data["boatLengthInMeter"] !== undefined ? _data["boatLengthInMeter"] : null as any;
            this.boatWidthInMeter = _data["boatWidthInMeter"] !== undefined ? _data["boatWidthInMeter"] : null as any;
            this.boatWeightInKg = _data["boatWeightInKg"] !== undefined ? _data["boatWeightInKg"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : null as any;
            this.boatType = _data["boatType"] !== undefined ? _data["boatType"] : null as any;
            this.sublet = _data["sublet"] !== undefined ? _data["sublet"] : null as any;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId !== undefined ? this.placeId : null as any;
        data["placeNum"] = this.placeNum !== undefined ? this.placeNum : null as any;
        data["pontoon"] = this.pontoon !== undefined ? this.pontoon : null as any;
        data["placeType"] = this.placeType !== undefined ? this.placeType : null as any;
        data["placeLengthInMeter"] = this.placeLengthInMeter !== undefined ? this.placeLengthInMeter : null as any;
        data["placeWidthInMeter"] = this.placeWidthInMeter !== undefined ? this.placeWidthInMeter : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        data["boatLengthInMeter"] = this.boatLengthInMeter !== undefined ? this.boatLengthInMeter : null as any;
        data["boatWidthInMeter"] = this.boatWidthInMeter !== undefined ? this.boatWidthInMeter : null as any;
        data["boatWeightInKg"] = this.boatWeightInKg !== undefined ? this.boatWeightInKg : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["draft"] = this.draft !== undefined ? this.draft : null as any;
        data["boatType"] = this.boatType !== undefined ? this.boatType : null as any;
        data["sublet"] = this.sublet !== undefined ? this.sublet : null as any;
        data["remark"] = this.remark !== undefined ? this.remark : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IMooringPlaceDto {
    placeId?: string;
    placeNum?: string;
    pontoon?: string;
    placeType?: string;
    placeLengthInMeter?: number;
    placeWidthInMeter?: number;
    boatRegistrationNumber?: string | null;
    boatLengthInMeter?: number | null;
    boatWidthInMeter?: number | null;
    boatWeightInKg?: number | null;
    latitude?: number;
    longitude?: number;
    draft?: number | null;
    boatType?: BoatType;
    sublet?: boolean;
    remark?: string | null;
    customerId?: string | null;
}

export class MooringPlaceWithOwnerDto extends MooringPlaceDto implements IMooringPlaceWithOwnerDto {
    owner?: MooringPlaceOwnerDto | null;

    constructor(data?: IMooringPlaceWithOwnerDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.owner = _data["owner"] ? MooringPlaceOwnerDto.fromJS(_data["owner"]) : null as any;
        }
    }

    static override fromJS(data: any): MooringPlaceWithOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceWithOwnerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IMooringPlaceWithOwnerDto extends IMooringPlaceDto {
    owner?: MooringPlaceOwnerDto | null;
}

export class MooringPlaceOwnerDto implements IMooringPlaceOwnerDto {
    id?: string;
    customerNumber?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;

    constructor(data?: IMooringPlaceOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        return data;
    }
}

export interface IMooringPlaceOwnerDto {
    id?: string;
    customerNumber?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
}

export enum Title {
    NotSpecified = "NotSpecified",
    Mister = "Mister",
    Madam = "Madam",
}

export enum BoatType {
    Unknown = "Unknown",
    Motor = "Motor",
    Sailing = "Sailing",
}

export class MooringPlaceBoatDto implements IMooringPlaceBoatDto {
    placeId?: string;
    customerId?: string | null;
    owner?: string | null;
    boatType?: BoatType;
    boatRegistrationNumber?: string | null;
    boatLengthInMeter?: number | null;
    boatWidthInMeter?: number | null;
    boatWeightInKg?: number | null;

    constructor(data?: IMooringPlaceBoatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.owner = _data["owner"] !== undefined ? _data["owner"] : null as any;
            this.boatType = _data["boatType"] !== undefined ? _data["boatType"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
            this.boatLengthInMeter = _data["boatLengthInMeter"] !== undefined ? _data["boatLengthInMeter"] : null as any;
            this.boatWidthInMeter = _data["boatWidthInMeter"] !== undefined ? _data["boatWidthInMeter"] : null as any;
            this.boatWeightInKg = _data["boatWeightInKg"] !== undefined ? _data["boatWeightInKg"] : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceBoatDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceBoatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId !== undefined ? this.placeId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["owner"] = this.owner !== undefined ? this.owner : null as any;
        data["boatType"] = this.boatType !== undefined ? this.boatType : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        data["boatLengthInMeter"] = this.boatLengthInMeter !== undefined ? this.boatLengthInMeter : null as any;
        data["boatWidthInMeter"] = this.boatWidthInMeter !== undefined ? this.boatWidthInMeter : null as any;
        data["boatWeightInKg"] = this.boatWeightInKg !== undefined ? this.boatWeightInKg : null as any;
        return data;
    }
}

export interface IMooringPlaceBoatDto {
    placeId?: string;
    customerId?: string | null;
    owner?: string | null;
    boatType?: BoatType;
    boatRegistrationNumber?: string | null;
    boatLengthInMeter?: number | null;
    boatWidthInMeter?: number | null;
    boatWeightInKg?: number | null;
}

export class PagedResultDtoOfMooringPlaceLightDto implements IPagedResultDtoOfMooringPlaceLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: MooringPlaceLightDto[];

    constructor(data?: IPagedResultDtoOfMooringPlaceLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(MooringPlaceLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMooringPlaceLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMooringPlaceLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfMooringPlaceLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: MooringPlaceLightDto[];
}

export class PageableRequestDtoOfMooringPlaceCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfMooringPlaceCriteriaDto {
    criteria?: MooringPlaceCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfMooringPlaceCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? MooringPlaceCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfMooringPlaceCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfMooringPlaceCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfMooringPlaceCriteriaDto extends IPageableRequestDto {
    criteria?: MooringPlaceCriteriaDto | null;
}

export class MooringPlaceCriteriaDto implements IMooringPlaceCriteriaDto {
    searchCriteriaDto?: MooringPlaceSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;

    constructor(data?: IMooringPlaceCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? MooringPlaceSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        return data;
    }
}

export interface IMooringPlaceCriteriaDto {
    searchCriteriaDto?: MooringPlaceSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;
}

export class MooringPlaceSearchCriteriaDto implements IMooringPlaceSearchCriteriaDto {
    placeId?: string | null;
    placeNum?: string | null;
    pontoon?: string | null;
    placeType?: string | null;
    boatRegistrationNumber?: string | null;
    customerId?: string | null;

    constructor(data?: IMooringPlaceSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"] !== undefined ? _data["placeId"] : null as any;
            this.placeNum = _data["placeNum"] !== undefined ? _data["placeNum"] : null as any;
            this.pontoon = _data["pontoon"] !== undefined ? _data["pontoon"] : null as any;
            this.placeType = _data["placeType"] !== undefined ? _data["placeType"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): MooringPlaceSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MooringPlaceSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId !== undefined ? this.placeId : null as any;
        data["placeNum"] = this.placeNum !== undefined ? this.placeNum : null as any;
        data["pontoon"] = this.pontoon !== undefined ? this.pontoon : null as any;
        data["placeType"] = this.placeType !== undefined ? this.placeType : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IMooringPlaceSearchCriteriaDto {
    placeId?: string | null;
    placeNum?: string | null;
    pontoon?: string | null;
    placeType?: string | null;
    boatRegistrationNumber?: string | null;
    customerId?: string | null;
}

export enum MeasuringPointType {
    Admin = "Admin",
    Customer = "Customer",
}

export class SearchMeasuringPointResultDto implements ISearchMeasuringPointResultDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    hardwareName?: string;
    measuringPointType?: MeasuringPointType;
    customer?: CustomerLightDto | null;

    constructor(data?: ISearchMeasuringPointResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.numericId = _data["numericId"] !== undefined ? _data["numericId"] : null as any;
            this.technicalId = _data["technicalId"] !== undefined ? _data["technicalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.hardwareName = _data["hardwareName"] !== undefined ? _data["hardwareName"] : null as any;
            this.measuringPointType = _data["measuringPointType"] !== undefined ? _data["measuringPointType"] : null as any;
            this.customer = _data["customer"] ? CustomerLightDto.fromJS(_data["customer"]) : null as any;
        }
    }

    static fromJS(data: any): SearchMeasuringPointResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMeasuringPointResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["numericId"] = this.numericId !== undefined ? this.numericId : null as any;
        data["technicalId"] = this.technicalId !== undefined ? this.technicalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["hardwareName"] = this.hardwareName !== undefined ? this.hardwareName : null as any;
        data["measuringPointType"] = this.measuringPointType !== undefined ? this.measuringPointType : null as any;
        data["customer"] = this.customer ? this.customer.toJSON() : null as any;
        return data;
    }
}

export interface ISearchMeasuringPointResultDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    hardwareName?: string;
    measuringPointType?: MeasuringPointType;
    customer?: CustomerLightDto | null;
}

export class SearchMeasuringPointDto implements ISearchMeasuringPointDto {
    name?: string | null;
    language?: string;
    serviceId?: string | null;
    customerId?: string | null;
    measuringPointTypes?: MeasuringPointType[] | null;
    serviceUnassignedOnly?: boolean;
    itemToBookUnassignedOnly?: boolean | null;
    userUnassignedOnly?: boolean | null;
    includeMeasuringPointWithHistoricalAssignments?: boolean;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: ISearchMeasuringPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            if (Array.isArray(_data["measuringPointTypes"])) {
                this.measuringPointTypes = [] as any;
                for (let item of _data["measuringPointTypes"])
                    this.measuringPointTypes!.push(item);
            }
            else {
                this.measuringPointTypes = null as any;
            }
            this.serviceUnassignedOnly = _data["serviceUnassignedOnly"] !== undefined ? _data["serviceUnassignedOnly"] : null as any;
            this.itemToBookUnassignedOnly = _data["itemToBookUnassignedOnly"] !== undefined ? _data["itemToBookUnassignedOnly"] : null as any;
            this.userUnassignedOnly = _data["userUnassignedOnly"] !== undefined ? _data["userUnassignedOnly"] : null as any;
            this.includeMeasuringPointWithHistoricalAssignments = _data["includeMeasuringPointWithHistoricalAssignments"] !== undefined ? _data["includeMeasuringPointWithHistoricalAssignments"] : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): SearchMeasuringPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMeasuringPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        if (Array.isArray(this.measuringPointTypes)) {
            data["measuringPointTypes"] = [];
            for (let item of this.measuringPointTypes)
                data["measuringPointTypes"].push(item);
        }
        data["serviceUnassignedOnly"] = this.serviceUnassignedOnly !== undefined ? this.serviceUnassignedOnly : null as any;
        data["itemToBookUnassignedOnly"] = this.itemToBookUnassignedOnly !== undefined ? this.itemToBookUnassignedOnly : null as any;
        data["userUnassignedOnly"] = this.userUnassignedOnly !== undefined ? this.userUnassignedOnly : null as any;
        data["includeMeasuringPointWithHistoricalAssignments"] = this.includeMeasuringPointWithHistoricalAssignments !== undefined ? this.includeMeasuringPointWithHistoricalAssignments : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface ISearchMeasuringPointDto {
    name?: string | null;
    language?: string;
    serviceId?: string | null;
    customerId?: string | null;
    measuringPointTypes?: MeasuringPointType[] | null;
    serviceUnassignedOnly?: boolean;
    itemToBookUnassignedOnly?: boolean | null;
    userUnassignedOnly?: boolean | null;
    includeMeasuringPointWithHistoricalAssignments?: boolean;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class MapDto implements IMapDto {
    mapUrl?: string | null;
    mapCoordinates?: MapCoordinatesDto;
    serviceId?: string;

    constructor(data?: IMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapUrl = _data["mapUrl"] !== undefined ? _data["mapUrl"] : null as any;
            this.mapCoordinates = _data["mapCoordinates"] ? MapCoordinatesDto.fromJS(_data["mapCoordinates"]) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): MapDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapUrl"] = this.mapUrl !== undefined ? this.mapUrl : null as any;
        data["mapCoordinates"] = this.mapCoordinates ? this.mapCoordinates.toJSON() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IMapDto {
    mapUrl?: string | null;
    mapCoordinates?: MapCoordinatesDto;
    serviceId?: string;
}

export class MapCoordinatesDto implements IMapCoordinatesDto {
    longitudeTr?: number;
    latitudeTr?: number;
    longitudeTl?: number;
    latitudeTl?: number;
    longitudeBl?: number;
    latitudeBl?: number;
    longitudeBr?: number;
    latitudeBr?: number;

    constructor(data?: IMapCoordinatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitudeTr = _data["longitudeTr"] !== undefined ? _data["longitudeTr"] : null as any;
            this.latitudeTr = _data["latitudeTr"] !== undefined ? _data["latitudeTr"] : null as any;
            this.longitudeTl = _data["longitudeTl"] !== undefined ? _data["longitudeTl"] : null as any;
            this.latitudeTl = _data["latitudeTl"] !== undefined ? _data["latitudeTl"] : null as any;
            this.longitudeBl = _data["longitudeBl"] !== undefined ? _data["longitudeBl"] : null as any;
            this.latitudeBl = _data["latitudeBl"] !== undefined ? _data["latitudeBl"] : null as any;
            this.longitudeBr = _data["longitudeBr"] !== undefined ? _data["longitudeBr"] : null as any;
            this.latitudeBr = _data["latitudeBr"] !== undefined ? _data["latitudeBr"] : null as any;
        }
    }

    static fromJS(data: any): MapCoordinatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapCoordinatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitudeTr"] = this.longitudeTr !== undefined ? this.longitudeTr : null as any;
        data["latitudeTr"] = this.latitudeTr !== undefined ? this.latitudeTr : null as any;
        data["longitudeTl"] = this.longitudeTl !== undefined ? this.longitudeTl : null as any;
        data["latitudeTl"] = this.latitudeTl !== undefined ? this.latitudeTl : null as any;
        data["longitudeBl"] = this.longitudeBl !== undefined ? this.longitudeBl : null as any;
        data["latitudeBl"] = this.latitudeBl !== undefined ? this.latitudeBl : null as any;
        data["longitudeBr"] = this.longitudeBr !== undefined ? this.longitudeBr : null as any;
        data["latitudeBr"] = this.latitudeBr !== undefined ? this.latitudeBr : null as any;
        return data;
    }
}

export interface IMapCoordinatesDto {
    longitudeTr?: number;
    latitudeTr?: number;
    longitudeTl?: number;
    latitudeTl?: number;
    longitudeBl?: number;
    latitudeBl?: number;
    longitudeBr?: number;
    latitudeBr?: number;
}

export class MapProjectionDto implements IMapProjectionDto {
    x1?: number;
    x2?: number;
    x3?: number;
    x4?: number;
    x5?: number;
    x6?: number;

    constructor(data?: IMapProjectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x1 = _data["x1"] !== undefined ? _data["x1"] : null as any;
            this.x2 = _data["x2"] !== undefined ? _data["x2"] : null as any;
            this.x3 = _data["x3"] !== undefined ? _data["x3"] : null as any;
            this.x4 = _data["x4"] !== undefined ? _data["x4"] : null as any;
            this.x5 = _data["x5"] !== undefined ? _data["x5"] : null as any;
            this.x6 = _data["x6"] !== undefined ? _data["x6"] : null as any;
        }
    }

    static fromJS(data: any): MapProjectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapProjectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x1"] = this.x1 !== undefined ? this.x1 : null as any;
        data["x2"] = this.x2 !== undefined ? this.x2 : null as any;
        data["x3"] = this.x3 !== undefined ? this.x3 : null as any;
        data["x4"] = this.x4 !== undefined ? this.x4 : null as any;
        data["x5"] = this.x5 !== undefined ? this.x5 : null as any;
        data["x6"] = this.x6 !== undefined ? this.x6 : null as any;
        return data;
    }
}

export interface IMapProjectionDto {
    x1?: number;
    x2?: number;
    x3?: number;
    x4?: number;
    x5?: number;
    x6?: number;
}

export class ItemToBookQuestionDto implements IItemToBookQuestionDto {
    id?: string;
    questionFR?: string;
    questionDE?: string;
    questionIT?: string;
    questionEN?: string;
    answerType?: ItemToBookAnswerType;

    constructor(data?: IItemToBookQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.questionFR = _data["questionFR"] !== undefined ? _data["questionFR"] : null as any;
            this.questionDE = _data["questionDE"] !== undefined ? _data["questionDE"] : null as any;
            this.questionIT = _data["questionIT"] !== undefined ? _data["questionIT"] : null as any;
            this.questionEN = _data["questionEN"] !== undefined ? _data["questionEN"] : null as any;
            this.answerType = _data["answerType"] !== undefined ? _data["answerType"] : null as any;
        }
    }

    static fromJS(data: any): ItemToBookQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemToBookQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["questionFR"] = this.questionFR !== undefined ? this.questionFR : null as any;
        data["questionDE"] = this.questionDE !== undefined ? this.questionDE : null as any;
        data["questionIT"] = this.questionIT !== undefined ? this.questionIT : null as any;
        data["questionEN"] = this.questionEN !== undefined ? this.questionEN : null as any;
        data["answerType"] = this.answerType !== undefined ? this.answerType : null as any;
        return data;
    }
}

export interface IItemToBookQuestionDto {
    id?: string;
    questionFR?: string;
    questionDE?: string;
    questionIT?: string;
    questionEN?: string;
    answerType?: ItemToBookAnswerType;
}

export enum ItemToBookAnswerType {
    Boolean = "Boolean",
    Text = "Text",
    Number = "Number",
}

export class ItemToBookQuestionInputDto implements IItemToBookQuestionInputDto {
    questionFR?: string;
    questionDE?: string | null;
    questionIT?: string | null;
    questionEN?: string | null;
    answerType?: ItemToBookAnswerType;

    constructor(data?: IItemToBookQuestionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionFR = _data["questionFR"] !== undefined ? _data["questionFR"] : null as any;
            this.questionDE = _data["questionDE"] !== undefined ? _data["questionDE"] : null as any;
            this.questionIT = _data["questionIT"] !== undefined ? _data["questionIT"] : null as any;
            this.questionEN = _data["questionEN"] !== undefined ? _data["questionEN"] : null as any;
            this.answerType = _data["answerType"] !== undefined ? _data["answerType"] : null as any;
        }
    }

    static fromJS(data: any): ItemToBookQuestionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemToBookQuestionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionFR"] = this.questionFR !== undefined ? this.questionFR : null as any;
        data["questionDE"] = this.questionDE !== undefined ? this.questionDE : null as any;
        data["questionIT"] = this.questionIT !== undefined ? this.questionIT : null as any;
        data["questionEN"] = this.questionEN !== undefined ? this.questionEN : null as any;
        data["answerType"] = this.answerType !== undefined ? this.answerType : null as any;
        return data;
    }
}

export interface IItemToBookQuestionInputDto {
    questionFR?: string;
    questionDE?: string | null;
    questionIT?: string | null;
    questionEN?: string | null;
    answerType?: ItemToBookAnswerType;
}

export class IotRegisterDto implements IIotRegisterDto {
    id?: string;
    name?: string;
    description?: string | null;
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    location?: string | null;
    registerType?: RegisterType;
    measuringPoint?: MeasuringPointDto;

    constructor(data?: IIotRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.registerType = _data["registerType"] !== undefined ? _data["registerType"] : null as any;
            this.measuringPoint = _data["measuringPoint"] ? MeasuringPointDto.fromJS(_data["measuringPoint"]) : null as any;
        }
    }

    static fromJS(data: any): IotRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new IotRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["registerType"] = this.registerType !== undefined ? this.registerType : null as any;
        data["measuringPoint"] = this.measuringPoint ? this.measuringPoint.toJSON() : null as any;
        return data;
    }
}

export interface IIotRegisterDto {
    id?: string;
    name?: string;
    description?: string | null;
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
    location?: string | null;
    registerType?: RegisterType;
    measuringPoint?: MeasuringPointDto;
}

export enum RegisterType {
    Unknown = "Unknown",
    IdentificationFeedback = "IdentificationFeedback",
    Information = "Information",
    Alarm = "Alarm",
    HistoricUsage = "HistoricUsage",
    CurrentUsage = "CurrentUsage",
    Identification = "Identification",
    State = "State",
    ActivationConsumption = "ActivationConsumption",
    IdentificationToStart = "IdentificationToStart",
    IdentificationToStop = "IdentificationToStop",
    IdentificationForceDuration = "IdentificationForceDuration",
    StateForceDuration = "StateForceDuration",
}

export class MeasuringPointDto implements IMeasuringPointDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    hardwareName?: string;
    measuringPointState?: MeasuringPointState;
    measuringPointStateChangeSource?: MeasuringPointStateChangeSource;
    lastStateChanged?: Date | null;
    customerId?: string | null;
    serviceId?: string | null;

    constructor(data?: IMeasuringPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.numericId = _data["numericId"] !== undefined ? _data["numericId"] : null as any;
            this.technicalId = _data["technicalId"] !== undefined ? _data["technicalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.hardwareName = _data["hardwareName"] !== undefined ? _data["hardwareName"] : null as any;
            this.measuringPointState = _data["measuringPointState"] !== undefined ? _data["measuringPointState"] : null as any;
            this.measuringPointStateChangeSource = _data["measuringPointStateChangeSource"] !== undefined ? _data["measuringPointStateChangeSource"] : null as any;
            this.lastStateChanged = _data["lastStateChanged"] ? new Date(_data["lastStateChanged"].toString()) : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): MeasuringPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["numericId"] = this.numericId !== undefined ? this.numericId : null as any;
        data["technicalId"] = this.technicalId !== undefined ? this.technicalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["hardwareName"] = this.hardwareName !== undefined ? this.hardwareName : null as any;
        data["measuringPointState"] = this.measuringPointState !== undefined ? this.measuringPointState : null as any;
        data["measuringPointStateChangeSource"] = this.measuringPointStateChangeSource !== undefined ? this.measuringPointStateChangeSource : null as any;
        data["lastStateChanged"] = this.lastStateChanged ? this.lastStateChanged.toISOString() : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IMeasuringPointDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    hardwareName?: string;
    measuringPointState?: MeasuringPointState;
    measuringPointStateChangeSource?: MeasuringPointStateChangeSource;
    lastStateChanged?: Date | null;
    customerId?: string | null;
    serviceId?: string | null;
}

export enum MeasuringPointState {
    Unknown = "Unknown",
    Active = "Active",
    Inactive = "Inactive",
}

export enum MeasuringPointStateChangeSource {
    Unknown = "Unknown",
    Admin = "Admin",
    User = "User",
    Ewallet = "Ewallet",
    ImpulseDeactivation = "ImpulseDeactivation",
}

export class IotRegisterSearchCriteriaDto implements IIotRegisterSearchCriteriaDto {
    searchText?: string;
    language?: string;
    registerTypes?: RegisterType[] | null;
    measuringPointType?: MeasuringPointType | null;

    constructor(data?: IIotRegisterSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"] !== undefined ? _data["searchText"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            if (Array.isArray(_data["registerTypes"])) {
                this.registerTypes = [] as any;
                for (let item of _data["registerTypes"])
                    this.registerTypes!.push(item);
            }
            else {
                this.registerTypes = null as any;
            }
            this.measuringPointType = _data["measuringPointType"] !== undefined ? _data["measuringPointType"] : null as any;
        }
    }

    static fromJS(data: any): IotRegisterSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new IotRegisterSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText !== undefined ? this.searchText : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        if (Array.isArray(this.registerTypes)) {
            data["registerTypes"] = [];
            for (let item of this.registerTypes)
                data["registerTypes"].push(item);
        }
        data["measuringPointType"] = this.measuringPointType !== undefined ? this.measuringPointType : null as any;
        return data;
    }
}

export interface IIotRegisterSearchCriteriaDto {
    searchText?: string;
    language?: string;
    registerTypes?: RegisterType[] | null;
    measuringPointType?: MeasuringPointType | null;
}

export class InformationLightDto implements IInformationLightDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    publicationDate?: Date | null;
    nbTargetCustomers?: number;
    nbReads?: number;
    customerReadPercent?: number;
    informationState?: InformationState;

    constructor(data?: IInformationLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.nbTargetCustomers = _data["nbTargetCustomers"] !== undefined ? _data["nbTargetCustomers"] : null as any;
            this.nbReads = _data["nbReads"] !== undefined ? _data["nbReads"] : null as any;
            this.customerReadPercent = _data["customerReadPercent"] !== undefined ? _data["customerReadPercent"] : null as any;
            this.informationState = _data["informationState"] !== undefined ? _data["informationState"] : null as any;
        }
    }

    static fromJS(data: any): InformationLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["nbTargetCustomers"] = this.nbTargetCustomers !== undefined ? this.nbTargetCustomers : null as any;
        data["nbReads"] = this.nbReads !== undefined ? this.nbReads : null as any;
        data["customerReadPercent"] = this.customerReadPercent !== undefined ? this.customerReadPercent : null as any;
        data["informationState"] = this.informationState !== undefined ? this.informationState : null as any;
        return data;
    }
}

export interface IInformationLightDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    publicationDate?: Date | null;
    nbTargetCustomers?: number;
    nbReads?: number;
    customerReadPercent?: number;
    informationState?: InformationState;
}

export class InformationDto implements IInformationDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    contentFR?: string;
    contentDE?: string | null;
    contentIT?: string | null;
    contentEN?: string | null;
    illustrationUrl?: string | null;
    mailNotificationEnabled?: boolean;
    informationState?: InformationState;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    publicationNotificationSent?: boolean;
    isBannerActive?: boolean;
    bannerInformationLevel?: BannerInformationLevel;
    bannerDescriptionFR?: string | null;
    bannerDescriptionDE?: string | null;
    bannerDescriptionEN?: string | null;
    bannerDescriptionIT?: string | null;
    customRoles?: CustomRoleDto[];

    constructor(data?: IInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.contentFR = _data["contentFR"] !== undefined ? _data["contentFR"] : null as any;
            this.contentDE = _data["contentDE"] !== undefined ? _data["contentDE"] : null as any;
            this.contentIT = _data["contentIT"] !== undefined ? _data["contentIT"] : null as any;
            this.contentEN = _data["contentEN"] !== undefined ? _data["contentEN"] : null as any;
            this.illustrationUrl = _data["illustrationUrl"] !== undefined ? _data["illustrationUrl"] : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
            this.informationState = _data["informationState"] !== undefined ? _data["informationState"] : null as any;
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.endPublicationDate = _data["endPublicationDate"] ? new Date(_data["endPublicationDate"].toString()) : null as any;
            this.publicationNotificationSent = _data["publicationNotificationSent"] !== undefined ? _data["publicationNotificationSent"] : null as any;
            this.isBannerActive = _data["isBannerActive"] !== undefined ? _data["isBannerActive"] : null as any;
            this.bannerInformationLevel = _data["bannerInformationLevel"] !== undefined ? _data["bannerInformationLevel"] : null as any;
            this.bannerDescriptionFR = _data["bannerDescriptionFR"] !== undefined ? _data["bannerDescriptionFR"] : null as any;
            this.bannerDescriptionDE = _data["bannerDescriptionDE"] !== undefined ? _data["bannerDescriptionDE"] : null as any;
            this.bannerDescriptionEN = _data["bannerDescriptionEN"] !== undefined ? _data["bannerDescriptionEN"] : null as any;
            this.bannerDescriptionIT = _data["bannerDescriptionIT"] !== undefined ? _data["bannerDescriptionIT"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
        }
    }

    static fromJS(data: any): InformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["contentFR"] = this.contentFR !== undefined ? this.contentFR : null as any;
        data["contentDE"] = this.contentDE !== undefined ? this.contentDE : null as any;
        data["contentIT"] = this.contentIT !== undefined ? this.contentIT : null as any;
        data["contentEN"] = this.contentEN !== undefined ? this.contentEN : null as any;
        data["illustrationUrl"] = this.illustrationUrl !== undefined ? this.illustrationUrl : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        data["informationState"] = this.informationState !== undefined ? this.informationState : null as any;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["endPublicationDate"] = this.endPublicationDate ? this.endPublicationDate.toISOString() : null as any;
        data["publicationNotificationSent"] = this.publicationNotificationSent !== undefined ? this.publicationNotificationSent : null as any;
        data["isBannerActive"] = this.isBannerActive !== undefined ? this.isBannerActive : null as any;
        data["bannerInformationLevel"] = this.bannerInformationLevel !== undefined ? this.bannerInformationLevel : null as any;
        data["bannerDescriptionFR"] = this.bannerDescriptionFR !== undefined ? this.bannerDescriptionFR : null as any;
        data["bannerDescriptionDE"] = this.bannerDescriptionDE !== undefined ? this.bannerDescriptionDE : null as any;
        data["bannerDescriptionEN"] = this.bannerDescriptionEN !== undefined ? this.bannerDescriptionEN : null as any;
        data["bannerDescriptionIT"] = this.bannerDescriptionIT !== undefined ? this.bannerDescriptionIT : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInformationDto {
    id?: string;
    titleFR?: string;
    titleDE?: string;
    titleIT?: string;
    titleEN?: string;
    contentFR?: string;
    contentDE?: string | null;
    contentIT?: string | null;
    contentEN?: string | null;
    illustrationUrl?: string | null;
    mailNotificationEnabled?: boolean;
    informationState?: InformationState;
    publicationDate?: Date | null;
    endPublicationDate?: Date | null;
    publicationNotificationSent?: boolean;
    isBannerActive?: boolean;
    bannerInformationLevel?: BannerInformationLevel;
    bannerDescriptionFR?: string | null;
    bannerDescriptionDE?: string | null;
    bannerDescriptionEN?: string | null;
    bannerDescriptionIT?: string | null;
    customRoles?: CustomRoleDto[];
}

export enum BannerInformationLevel {
    Unknown = "Unknown",
    Information = "Information",
    Warning = "Warning",
    Incident = "Incident",
}

export class BannerDto implements IBannerDto {
    id?: string;
    bannerDescriptionFR?: string;
    bannerDescriptionDE?: string;
    bannerDescriptionEN?: string;
    bannerDescriptionIT?: string;
    bannerInformationLevel?: BannerInformationLevelDto;

    constructor(data?: IBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.bannerDescriptionFR = _data["bannerDescriptionFR"] !== undefined ? _data["bannerDescriptionFR"] : null as any;
            this.bannerDescriptionDE = _data["bannerDescriptionDE"] !== undefined ? _data["bannerDescriptionDE"] : null as any;
            this.bannerDescriptionEN = _data["bannerDescriptionEN"] !== undefined ? _data["bannerDescriptionEN"] : null as any;
            this.bannerDescriptionIT = _data["bannerDescriptionIT"] !== undefined ? _data["bannerDescriptionIT"] : null as any;
            this.bannerInformationLevel = _data["bannerInformationLevel"] !== undefined ? _data["bannerInformationLevel"] : null as any;
        }
    }

    static fromJS(data: any): BannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["bannerDescriptionFR"] = this.bannerDescriptionFR !== undefined ? this.bannerDescriptionFR : null as any;
        data["bannerDescriptionDE"] = this.bannerDescriptionDE !== undefined ? this.bannerDescriptionDE : null as any;
        data["bannerDescriptionEN"] = this.bannerDescriptionEN !== undefined ? this.bannerDescriptionEN : null as any;
        data["bannerDescriptionIT"] = this.bannerDescriptionIT !== undefined ? this.bannerDescriptionIT : null as any;
        data["bannerInformationLevel"] = this.bannerInformationLevel !== undefined ? this.bannerInformationLevel : null as any;
        return data;
    }
}

export interface IBannerDto {
    id?: string;
    bannerDescriptionFR?: string;
    bannerDescriptionDE?: string;
    bannerDescriptionEN?: string;
    bannerDescriptionIT?: string;
    bannerInformationLevel?: BannerInformationLevelDto;
}

export enum BannerInformationLevelDto {
    Unknown = "Unknown",
    Information = "Information",
    Warning = "Warning",
    Incident = "Incident",
}

export class InformationInputDto implements IInformationInputDto {
    titleFR?: string;
    titleDE?: string | null;
    titleIT?: string | null;
    titleEN?: string | null;
    contentFR?: string;
    contentDE?: string | null;
    contentIT?: string | null;
    contentEN?: string | null;
    customRoles?: CustomRoleDto[];

    constructor(data?: IInformationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleFR = _data["titleFR"] !== undefined ? _data["titleFR"] : null as any;
            this.titleDE = _data["titleDE"] !== undefined ? _data["titleDE"] : null as any;
            this.titleIT = _data["titleIT"] !== undefined ? _data["titleIT"] : null as any;
            this.titleEN = _data["titleEN"] !== undefined ? _data["titleEN"] : null as any;
            this.contentFR = _data["contentFR"] !== undefined ? _data["contentFR"] : null as any;
            this.contentDE = _data["contentDE"] !== undefined ? _data["contentDE"] : null as any;
            this.contentIT = _data["contentIT"] !== undefined ? _data["contentIT"] : null as any;
            this.contentEN = _data["contentEN"] !== undefined ? _data["contentEN"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
        }
    }

    static fromJS(data: any): InformationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleFR"] = this.titleFR !== undefined ? this.titleFR : null as any;
        data["titleDE"] = this.titleDE !== undefined ? this.titleDE : null as any;
        data["titleIT"] = this.titleIT !== undefined ? this.titleIT : null as any;
        data["titleEN"] = this.titleEN !== undefined ? this.titleEN : null as any;
        data["contentFR"] = this.contentFR !== undefined ? this.contentFR : null as any;
        data["contentDE"] = this.contentDE !== undefined ? this.contentDE : null as any;
        data["contentIT"] = this.contentIT !== undefined ? this.contentIT : null as any;
        data["contentEN"] = this.contentEN !== undefined ? this.contentEN : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInformationInputDto {
    titleFR?: string;
    titleDE?: string | null;
    titleIT?: string | null;
    titleEN?: string | null;
    contentFR?: string;
    contentDE?: string | null;
    contentIT?: string | null;
    contentEN?: string | null;
    customRoles?: CustomRoleDto[];
}

export class BannerInputDto implements IBannerInputDto {
    isBannerActive?: boolean;
    bannerDescriptionFR?: string | null;
    bannerDescriptionDE?: string | null;
    bannerDescriptionEN?: string | null;
    bannerDescriptionIT?: string | null;
    bannerInformationLevel?: BannerInformationLevelDto;
    force?: boolean;

    constructor(data?: IBannerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBannerActive = _data["isBannerActive"] !== undefined ? _data["isBannerActive"] : null as any;
            this.bannerDescriptionFR = _data["bannerDescriptionFR"] !== undefined ? _data["bannerDescriptionFR"] : null as any;
            this.bannerDescriptionDE = _data["bannerDescriptionDE"] !== undefined ? _data["bannerDescriptionDE"] : null as any;
            this.bannerDescriptionEN = _data["bannerDescriptionEN"] !== undefined ? _data["bannerDescriptionEN"] : null as any;
            this.bannerDescriptionIT = _data["bannerDescriptionIT"] !== undefined ? _data["bannerDescriptionIT"] : null as any;
            this.bannerInformationLevel = _data["bannerInformationLevel"] !== undefined ? _data["bannerInformationLevel"] : null as any;
            this.force = _data["force"] !== undefined ? _data["force"] : null as any;
        }
    }

    static fromJS(data: any): BannerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBannerActive"] = this.isBannerActive !== undefined ? this.isBannerActive : null as any;
        data["bannerDescriptionFR"] = this.bannerDescriptionFR !== undefined ? this.bannerDescriptionFR : null as any;
        data["bannerDescriptionDE"] = this.bannerDescriptionDE !== undefined ? this.bannerDescriptionDE : null as any;
        data["bannerDescriptionEN"] = this.bannerDescriptionEN !== undefined ? this.bannerDescriptionEN : null as any;
        data["bannerDescriptionIT"] = this.bannerDescriptionIT !== undefined ? this.bannerDescriptionIT : null as any;
        data["bannerInformationLevel"] = this.bannerInformationLevel !== undefined ? this.bannerInformationLevel : null as any;
        data["force"] = this.force !== undefined ? this.force : null as any;
        return data;
    }
}

export interface IBannerInputDto {
    isBannerActive?: boolean;
    bannerDescriptionFR?: string | null;
    bannerDescriptionDE?: string | null;
    bannerDescriptionEN?: string | null;
    bannerDescriptionIT?: string | null;
    bannerInformationLevel?: BannerInformationLevelDto;
    force?: boolean;
}

export class InformationPublishInputDto implements IInformationPublishInputDto {
    publicationDate?: Date;
    endPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;

    constructor(data?: IInformationPublishInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : null as any;
            this.endPublicationDate = _data["endPublicationDate"] ? new Date(_data["endPublicationDate"].toString()) : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
        }
    }

    static fromJS(data: any): InformationPublishInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationPublishInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : null as any;
        data["endPublicationDate"] = this.endPublicationDate ? this.endPublicationDate.toISOString() : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        return data;
    }
}

export interface IInformationPublishInputDto {
    publicationDate?: Date;
    endPublicationDate?: Date | null;
    mailNotificationEnabled?: boolean;
}

export class HydrowashWashingTrackDto implements IHydrowashWashingTrackDto {
    id?: string | null;
    name?: string;
    description?: string | null;
    isFree?: boolean | null;
    isError?: boolean | null;

    constructor(data?: IHydrowashWashingTrackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.isFree = _data["isFree"] !== undefined ? _data["isFree"] : null as any;
            this.isError = _data["isError"] !== undefined ? _data["isError"] : null as any;
        }
    }

    static fromJS(data: any): HydrowashWashingTrackDto {
        data = typeof data === 'object' ? data : {};
        let result = new HydrowashWashingTrackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["isFree"] = this.isFree !== undefined ? this.isFree : null as any;
        data["isError"] = this.isError !== undefined ? this.isError : null as any;
        return data;
    }
}

export interface IHydrowashWashingTrackDto {
    id?: string | null;
    name?: string;
    description?: string | null;
    isFree?: boolean | null;
    isError?: boolean | null;
}

export class HighlightedServiceDto implements IHighlightedServiceDto {
    id?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionEN?: string;
    descriptionIT?: string;
    iconURL?: string;

    constructor(data?: IHighlightedServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.iconURL = _data["iconURL"] !== undefined ? _data["iconURL"] : null as any;
        }
    }

    static fromJS(data: any): HighlightedServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HighlightedServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["iconURL"] = this.iconURL !== undefined ? this.iconURL : null as any;
        return data;
    }
}

export interface IHighlightedServiceDto {
    id?: string;
    nameFR?: string;
    nameDE?: string;
    nameEN?: string;
    nameIT?: string;
    descriptionFR?: string;
    descriptionDE?: string;
    descriptionEN?: string;
    descriptionIT?: string;
    iconURL?: string;
}

export class HighlightedServiceInputDto implements IHighlightedServiceInputDto {
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    iconURL?: string;

    constructor(data?: IHighlightedServiceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.iconURL = _data["iconURL"] !== undefined ? _data["iconURL"] : null as any;
        }
    }

    static fromJS(data: any): HighlightedServiceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new HighlightedServiceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["iconURL"] = this.iconURL !== undefined ? this.iconURL : null as any;
        return data;
    }
}

export interface IHighlightedServiceInputDto {
    nameFR?: string;
    nameDE?: string | null;
    nameEN?: string | null;
    nameIT?: string | null;
    descriptionFR?: string;
    descriptionDE?: string | null;
    descriptionEN?: string | null;
    descriptionIT?: string | null;
    iconURL?: string;
}

export class PagedResultDtoOfCustomerEwalletDto implements IPagedResultDtoOfCustomerEwalletDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerEwalletDto[];

    constructor(data?: IPagedResultDtoOfCustomerEwalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerEwalletDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerEwalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerEwalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCustomerEwalletDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerEwalletDto[];
}

export class CustomerEwalletDto implements ICustomerEwalletDto {
    customerId?: string;
    customerNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    rfidCards?: CardDto[];
    balance?: number;

    constructor(data?: ICustomerEwalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            if (Array.isArray(_data["rfidCards"])) {
                this.rfidCards = [] as any;
                for (let item of _data["rfidCards"])
                    this.rfidCards!.push(CardDto.fromJS(item));
            }
            else {
                this.rfidCards = null as any;
            }
            this.balance = _data["balance"] !== undefined ? _data["balance"] : null as any;
        }
    }

    static fromJS(data: any): CustomerEwalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEwalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        if (Array.isArray(this.rfidCards)) {
            data["rfidCards"] = [];
            for (let item of this.rfidCards)
                data["rfidCards"].push(item ? item.toJSON() : null as any);
        }
        data["balance"] = this.balance !== undefined ? this.balance : null as any;
        return data;
    }
}

export interface ICustomerEwalletDto {
    customerId?: string;
    customerNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string | null;
    rfidCards?: CardDto[];
    balance?: number;
}

export class PageableRequestDtoOfEwalletCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfEwalletCriteriaDto {
    criteria?: EwalletCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfEwalletCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? EwalletCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfEwalletCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfEwalletCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfEwalletCriteriaDto extends IPageableRequestDto {
    criteria?: EwalletCriteriaDto | null;
}

export class EwalletCriteriaDto implements IEwalletCriteriaDto {
    sortCriteria?: SortCriteriaDto;
    ewalletSearchCriteriaDto?: EwalletSearchCriteriaDto;

    constructor(data?: IEwalletCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
            this.ewalletSearchCriteriaDto = _data["ewalletSearchCriteriaDto"] ? EwalletSearchCriteriaDto.fromJS(_data["ewalletSearchCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): EwalletCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        data["ewalletSearchCriteriaDto"] = this.ewalletSearchCriteriaDto ? this.ewalletSearchCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface IEwalletCriteriaDto {
    sortCriteria?: SortCriteriaDto;
    ewalletSearchCriteriaDto?: EwalletSearchCriteriaDto;
}

export class EwalletSearchCriteriaDto implements IEwalletSearchCriteriaDto {
    customerId?: string | null;
    amountFrom?: number | null;
    amountTo?: number | null;
    cardNumber?: string | null;

    constructor(data?: IEwalletSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.amountFrom = _data["amountFrom"] !== undefined ? _data["amountFrom"] : null as any;
            this.amountTo = _data["amountTo"] !== undefined ? _data["amountTo"] : null as any;
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
        }
    }

    static fromJS(data: any): EwalletSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["amountFrom"] = this.amountFrom !== undefined ? this.amountFrom : null as any;
        data["amountTo"] = this.amountTo !== undefined ? this.amountTo : null as any;
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        return data;
    }
}

export interface IEwalletSearchCriteriaDto {
    customerId?: string | null;
    amountFrom?: number | null;
    amountTo?: number | null;
    cardNumber?: string | null;
}

export class EwalletClosureScheduleDto implements IEwalletClosureScheduleDto {
    id?: string;
    mode?: EwalletClosureScheduleMode;
    scheduledDateTime?: Date;

    constructor(data?: IEwalletClosureScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.scheduledDateTime = _data["scheduledDateTime"] ? new Date(_data["scheduledDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EwalletClosureScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletClosureScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["scheduledDateTime"] = this.scheduledDateTime ? this.scheduledDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IEwalletClosureScheduleDto {
    id?: string;
    mode?: EwalletClosureScheduleMode;
    scheduledDateTime?: Date;
}

export enum EwalletClosureScheduleMode {
    Scheduled = "Scheduled",
    Monthly = "Monthly",
    Annual = "Annual",
}

export class EwalletClosureScheduleInputDto implements IEwalletClosureScheduleInputDto {
    scheduledDateTime?: Date;

    constructor(data?: IEwalletClosureScheduleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledDateTime = _data["scheduledDateTime"] ? new Date(_data["scheduledDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EwalletClosureScheduleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletClosureScheduleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledDateTime"] = this.scheduledDateTime ? this.scheduledDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IEwalletClosureScheduleInputDto {
    scheduledDateTime?: Date;
}

export class EwalletClosurePeriodicModeDto implements IEwalletClosurePeriodicModeDto {
    mode?: EwalletClosureScheduleMode;
    enabled?: boolean;

    constructor(data?: IEwalletClosurePeriodicModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
        }
    }

    static fromJS(data: any): EwalletClosurePeriodicModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletClosurePeriodicModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        return data;
    }
}

export interface IEwalletClosurePeriodicModeDto {
    mode?: EwalletClosureScheduleMode;
    enabled?: boolean;
}

export class EwalletClosureDocumentDto implements IEwalletClosureDocumentDto {
    id?: string;
    mode?: EwalletClosureScheduleMode;
    date?: Date;

    constructor(data?: IEwalletClosureDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EwalletClosureDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletClosureDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }
}

export interface IEwalletClosureDocumentDto {
    id?: string;
    mode?: EwalletClosureScheduleMode;
    date?: Date;
}

export class EquipmentCategoryDto implements IEquipmentCategoryDto {
    id?: string | null;
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;

    constructor(data?: IEquipmentCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        return data;
    }
}

export interface IEquipmentCategoryDto {
    id?: string | null;
    labelFR?: string;
    labelDE?: string;
    labelIT?: string;
    labelEN?: string;
}

export class EquipmentContractDto implements IEquipmentContractDto {
    id?: string;
    enterprise?: string;
    contactName?: string;
    phone1?: string;
    phone2?: string | null;
    email?: string;

    constructor(data?: IEquipmentContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.enterprise = _data["enterprise"] !== undefined ? _data["enterprise"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.phone1 = _data["phone1"] !== undefined ? _data["phone1"] : null as any;
            this.phone2 = _data["phone2"] !== undefined ? _data["phone2"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["enterprise"] = this.enterprise !== undefined ? this.enterprise : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["phone1"] = this.phone1 !== undefined ? this.phone1 : null as any;
        data["phone2"] = this.phone2 !== undefined ? this.phone2 : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IEquipmentContractDto {
    id?: string;
    enterprise?: string;
    contactName?: string;
    phone1?: string;
    phone2?: string | null;
    email?: string;
}

export class EquipmentContractInputDto implements IEquipmentContractInputDto {
    id?: string | null;
    enterprise?: string;
    contactName?: string;
    phone1?: string;
    phone2?: string | null;
    email?: string;

    constructor(data?: IEquipmentContractInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.enterprise = _data["enterprise"] !== undefined ? _data["enterprise"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.phone1 = _data["phone1"] !== undefined ? _data["phone1"] : null as any;
            this.phone2 = _data["phone2"] !== undefined ? _data["phone2"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentContractInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentContractInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["enterprise"] = this.enterprise !== undefined ? this.enterprise : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["phone1"] = this.phone1 !== undefined ? this.phone1 : null as any;
        data["phone2"] = this.phone2 !== undefined ? this.phone2 : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IEquipmentContractInputDto {
    id?: string | null;
    enterprise?: string;
    contactName?: string;
    phone1?: string;
    phone2?: string | null;
    email?: string;
}

export enum ContractType {
    Maintenance = "Maintenance",
    Troubleshooting = "Troubleshooting",
}

export class PagedResultDtoOfEquipmentLightDto implements IPagedResultDtoOfEquipmentLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: EquipmentLightDto[];

    constructor(data?: IPagedResultDtoOfEquipmentLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EquipmentLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEquipmentLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEquipmentLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfEquipmentLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: EquipmentLightDto[];
}

export class EquipmentLightDto implements IEquipmentLightDto {
    id?: string;
    name?: string;
    location?: string;
    category?: EquipmentCategoryDto;
    nextEvent?: Date | null;
    nextEventId?: string | null;

    constructor(data?: IEquipmentLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.category = _data["category"] ? EquipmentCategoryDto.fromJS(_data["category"]) : null as any;
            this.nextEvent = _data["nextEvent"] ? new Date(_data["nextEvent"].toString()) : null as any;
            this.nextEventId = _data["nextEventId"] !== undefined ? _data["nextEventId"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["category"] = this.category ? this.category.toJSON() : null as any;
        data["nextEvent"] = this.nextEvent ? this.nextEvent.toISOString() : null as any;
        data["nextEventId"] = this.nextEventId !== undefined ? this.nextEventId : null as any;
        return data;
    }
}

export interface IEquipmentLightDto {
    id?: string;
    name?: string;
    location?: string;
    category?: EquipmentCategoryDto;
    nextEvent?: Date | null;
    nextEventId?: string | null;
}

export class PageableRequestDtoOfEquipmentCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfEquipmentCriteriaDto {
    criteria?: EquipmentCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfEquipmentCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? EquipmentCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfEquipmentCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfEquipmentCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfEquipmentCriteriaDto extends IPageableRequestDto {
    criteria?: EquipmentCriteriaDto | null;
}

export class EquipmentCriteriaDto implements IEquipmentCriteriaDto {
    searchCriteriaDto?: EquipmentSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;

    constructor(data?: IEquipmentCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? EquipmentSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

export interface IEquipmentCriteriaDto {
    searchCriteriaDto?: EquipmentSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
}

export class EquipmentSearchCriteriaDto implements IEquipmentSearchCriteriaDto {
    name?: string | null;
    location?: string | null;
    equipmentCategoryId?: string | null;
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IEquipmentSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.equipmentCategoryId = _data["equipmentCategoryId"] !== undefined ? _data["equipmentCategoryId"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EquipmentSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["equipmentCategoryId"] = this.equipmentCategoryId !== undefined ? this.equipmentCategoryId : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IEquipmentSearchCriteriaDto {
    name?: string | null;
    location?: string | null;
    equipmentCategoryId?: string | null;
    from?: Date | null;
    to?: Date | null;
}

export class EquipmentDto implements IEquipmentDto {
    id?: string;
    name?: string;
    location?: string;
    identificationNumber?: string | null;
    installationDate?: Date | null;
    brand?: string | null;
    productName?: string | null;
    supplierName?: string | null;
    supplierContact?: string | null;
    equipmentCategory?: EquipmentCategoryDto;
    maintenanceContract?: EquipmentContractDto | null;
    troubleshootingContract?: EquipmentContractDto | null;

    constructor(data?: IEquipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.identificationNumber = _data["identificationNumber"] !== undefined ? _data["identificationNumber"] : null as any;
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : null as any;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.supplierContact = _data["supplierContact"] !== undefined ? _data["supplierContact"] : null as any;
            this.equipmentCategory = _data["equipmentCategory"] ? EquipmentCategoryDto.fromJS(_data["equipmentCategory"]) : null as any;
            this.maintenanceContract = _data["maintenanceContract"] ? EquipmentContractDto.fromJS(_data["maintenanceContract"]) : null as any;
            this.troubleshootingContract = _data["troubleshootingContract"] ? EquipmentContractDto.fromJS(_data["troubleshootingContract"]) : null as any;
        }
    }

    static fromJS(data: any): EquipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["identificationNumber"] = this.identificationNumber !== undefined ? this.identificationNumber : null as any;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : null as any;
        data["brand"] = this.brand !== undefined ? this.brand : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["supplierContact"] = this.supplierContact !== undefined ? this.supplierContact : null as any;
        data["equipmentCategory"] = this.equipmentCategory ? this.equipmentCategory.toJSON() : null as any;
        data["maintenanceContract"] = this.maintenanceContract ? this.maintenanceContract.toJSON() : null as any;
        data["troubleshootingContract"] = this.troubleshootingContract ? this.troubleshootingContract.toJSON() : null as any;
        return data;
    }
}

export interface IEquipmentDto {
    id?: string;
    name?: string;
    location?: string;
    identificationNumber?: string | null;
    installationDate?: Date | null;
    brand?: string | null;
    productName?: string | null;
    supplierName?: string | null;
    supplierContact?: string | null;
    equipmentCategory?: EquipmentCategoryDto;
    maintenanceContract?: EquipmentContractDto | null;
    troubleshootingContract?: EquipmentContractDto | null;
}

export class EquipmentInputDto implements IEquipmentInputDto {
    name?: string;
    location?: string;
    identificationNumber?: string | null;
    installationDate?: Date | null;
    brand?: string | null;
    productName?: string | null;
    supplierName?: string | null;
    supplierContact?: string | null;
    equipmentCategoryId?: string;
    maintenanceContractId?: string | null;
    troubleshootingContractId?: string | null;

    constructor(data?: IEquipmentInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.identificationNumber = _data["identificationNumber"] !== undefined ? _data["identificationNumber"] : null as any;
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : null as any;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : null as any;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.supplierContact = _data["supplierContact"] !== undefined ? _data["supplierContact"] : null as any;
            this.equipmentCategoryId = _data["equipmentCategoryId"] !== undefined ? _data["equipmentCategoryId"] : null as any;
            this.maintenanceContractId = _data["maintenanceContractId"] !== undefined ? _data["maintenanceContractId"] : null as any;
            this.troubleshootingContractId = _data["troubleshootingContractId"] !== undefined ? _data["troubleshootingContractId"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["identificationNumber"] = this.identificationNumber !== undefined ? this.identificationNumber : null as any;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : null as any;
        data["brand"] = this.brand !== undefined ? this.brand : null as any;
        data["productName"] = this.productName !== undefined ? this.productName : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["supplierContact"] = this.supplierContact !== undefined ? this.supplierContact : null as any;
        data["equipmentCategoryId"] = this.equipmentCategoryId !== undefined ? this.equipmentCategoryId : null as any;
        data["maintenanceContractId"] = this.maintenanceContractId !== undefined ? this.maintenanceContractId : null as any;
        data["troubleshootingContractId"] = this.troubleshootingContractId !== undefined ? this.troubleshootingContractId : null as any;
        return data;
    }
}

export interface IEquipmentInputDto {
    name?: string;
    location?: string;
    identificationNumber?: string | null;
    installationDate?: Date | null;
    brand?: string | null;
    productName?: string | null;
    supplierName?: string | null;
    supplierContact?: string | null;
    equipmentCategoryId?: string;
    maintenanceContractId?: string | null;
    troubleshootingContractId?: string | null;
}

export class EquipmentEventLightDto implements IEquipmentEventLightDto {
    id?: string;
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    equipmentName?: string;

    constructor(data?: IEquipmentEventLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.equipmentId = _data["equipmentId"] !== undefined ? _data["equipmentId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
            this.equipmentName = _data["equipmentName"] !== undefined ? _data["equipmentName"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentEventLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentEventLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["equipmentId"] = this.equipmentId !== undefined ? this.equipmentId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["equipmentName"] = this.equipmentName !== undefined ? this.equipmentName : null as any;
        return data;
    }
}

export interface IEquipmentEventLightDto {
    id?: string;
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    equipmentName?: string;
}

export class EquipmentEventDto implements IEquipmentEventDto {
    id?: string;
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    comment?: string | null;
    internalContactName?: string;
    internalContactEmail?: string;
    reminderInDays?: number | null;

    constructor(data?: IEquipmentEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.equipmentId = _data["equipmentId"] !== undefined ? _data["equipmentId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.internalContactName = _data["internalContactName"] !== undefined ? _data["internalContactName"] : null as any;
            this.internalContactEmail = _data["internalContactEmail"] !== undefined ? _data["internalContactEmail"] : null as any;
            this.reminderInDays = _data["reminderInDays"] !== undefined ? _data["reminderInDays"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["equipmentId"] = this.equipmentId !== undefined ? this.equipmentId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["internalContactName"] = this.internalContactName !== undefined ? this.internalContactName : null as any;
        data["internalContactEmail"] = this.internalContactEmail !== undefined ? this.internalContactEmail : null as any;
        data["reminderInDays"] = this.reminderInDays !== undefined ? this.reminderInDays : null as any;
        return data;
    }
}

export interface IEquipmentEventDto {
    id?: string;
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    comment?: string | null;
    internalContactName?: string;
    internalContactEmail?: string;
    reminderInDays?: number | null;
}

export class EquipmentEventInputDto implements IEquipmentEventInputDto {
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    comment?: string | null;
    internalContactName?: string;
    internalContactEmail?: string;
    reminderInDays?: number | null;
    numberOfRecurrence?: number | null;
    eventRecurrence?: EquipmentEventRecurrence | null;

    constructor(data?: IEquipmentEventInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipmentId = _data["equipmentId"] !== undefined ? _data["equipmentId"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.internalContactName = _data["internalContactName"] !== undefined ? _data["internalContactName"] : null as any;
            this.internalContactEmail = _data["internalContactEmail"] !== undefined ? _data["internalContactEmail"] : null as any;
            this.reminderInDays = _data["reminderInDays"] !== undefined ? _data["reminderInDays"] : null as any;
            this.numberOfRecurrence = _data["numberOfRecurrence"] !== undefined ? _data["numberOfRecurrence"] : null as any;
            this.eventRecurrence = _data["eventRecurrence"] !== undefined ? _data["eventRecurrence"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentEventInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentEventInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipmentId"] = this.equipmentId !== undefined ? this.equipmentId : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["internalContactName"] = this.internalContactName !== undefined ? this.internalContactName : null as any;
        data["internalContactEmail"] = this.internalContactEmail !== undefined ? this.internalContactEmail : null as any;
        data["reminderInDays"] = this.reminderInDays !== undefined ? this.reminderInDays : null as any;
        data["numberOfRecurrence"] = this.numberOfRecurrence !== undefined ? this.numberOfRecurrence : null as any;
        data["eventRecurrence"] = this.eventRecurrence !== undefined ? this.eventRecurrence : null as any;
        return data;
    }
}

export interface IEquipmentEventInputDto {
    equipmentId?: string;
    description?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    comment?: string | null;
    internalContactName?: string;
    internalContactEmail?: string;
    reminderInDays?: number | null;
    numberOfRecurrence?: number | null;
    eventRecurrence?: EquipmentEventRecurrence | null;
}

export enum EquipmentEventRecurrence {
    Weekly = "Weekly",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Biannual = "Biannual",
    Annual = "Annual",
}

export class PagedResultDtoOfEquipmentInterventionLightDto implements IPagedResultDtoOfEquipmentInterventionLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: EquipmentInterventionLightDto[];

    constructor(data?: IPagedResultDtoOfEquipmentInterventionLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EquipmentInterventionLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEquipmentInterventionLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEquipmentInterventionLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfEquipmentInterventionLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: EquipmentInterventionLightDto[];
}

export class EquipmentInterventionLightDto implements IEquipmentInterventionLightDto {
    id?: string;
    equipmentName?: string;
    personInCharge?: string;
    monitoringPerson?: string;
    date?: Date;

    constructor(data?: IEquipmentInterventionLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.equipmentName = _data["equipmentName"] !== undefined ? _data["equipmentName"] : null as any;
            this.personInCharge = _data["personInCharge"] !== undefined ? _data["personInCharge"] : null as any;
            this.monitoringPerson = _data["monitoringPerson"] !== undefined ? _data["monitoringPerson"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EquipmentInterventionLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInterventionLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["equipmentName"] = this.equipmentName !== undefined ? this.equipmentName : null as any;
        data["personInCharge"] = this.personInCharge !== undefined ? this.personInCharge : null as any;
        data["monitoringPerson"] = this.monitoringPerson !== undefined ? this.monitoringPerson : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        return data;
    }
}

export interface IEquipmentInterventionLightDto {
    id?: string;
    equipmentName?: string;
    personInCharge?: string;
    monitoringPerson?: string;
    date?: Date;
}

export class PageableRequestDtoOfEquipmentInterventionCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfEquipmentInterventionCriteriaDto {
    criteria?: EquipmentInterventionCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfEquipmentInterventionCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? EquipmentInterventionCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfEquipmentInterventionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfEquipmentInterventionCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfEquipmentInterventionCriteriaDto extends IPageableRequestDto {
    criteria?: EquipmentInterventionCriteriaDto | null;
}

export class EquipmentInterventionCriteriaDto implements IEquipmentInterventionCriteriaDto {
    searchCriteriaDto?: EquipmentInterventionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: IEquipmentInterventionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? EquipmentInterventionSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): EquipmentInterventionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInterventionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface IEquipmentInterventionCriteriaDto {
    searchCriteriaDto?: EquipmentInterventionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class EquipmentInterventionSearchCriteriaDto implements IEquipmentInterventionSearchCriteriaDto {
    equipmentName?: string | null;
    personInCharge?: string | null;
    monitoringPerson?: string | null;
    from?: Date | null;
    to?: Date | null;

    constructor(data?: IEquipmentInterventionSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipmentName = _data["equipmentName"] !== undefined ? _data["equipmentName"] : null as any;
            this.personInCharge = _data["personInCharge"] !== undefined ? _data["personInCharge"] : null as any;
            this.monitoringPerson = _data["monitoringPerson"] !== undefined ? _data["monitoringPerson"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
        }
    }

    static fromJS(data: any): EquipmentInterventionSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInterventionSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipmentName"] = this.equipmentName !== undefined ? this.equipmentName : null as any;
        data["personInCharge"] = this.personInCharge !== undefined ? this.personInCharge : null as any;
        data["monitoringPerson"] = this.monitoringPerson !== undefined ? this.monitoringPerson : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        return data;
    }
}

export interface IEquipmentInterventionSearchCriteriaDto {
    equipmentName?: string | null;
    personInCharge?: string | null;
    monitoringPerson?: string | null;
    from?: Date | null;
    to?: Date | null;
}

export class EquipmentInterventionDto implements IEquipmentInterventionDto {
    id?: string;
    equipmentId?: string;
    equipmentName?: string;
    equipmentLocation?: string;
    date?: Date;
    description?: string;
    personInCharge?: string;
    monitoringPerson?: string;

    constructor(data?: IEquipmentInterventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.equipmentId = _data["equipmentId"] !== undefined ? _data["equipmentId"] : null as any;
            this.equipmentName = _data["equipmentName"] !== undefined ? _data["equipmentName"] : null as any;
            this.equipmentLocation = _data["equipmentLocation"] !== undefined ? _data["equipmentLocation"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.personInCharge = _data["personInCharge"] !== undefined ? _data["personInCharge"] : null as any;
            this.monitoringPerson = _data["monitoringPerson"] !== undefined ? _data["monitoringPerson"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentInterventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInterventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["equipmentId"] = this.equipmentId !== undefined ? this.equipmentId : null as any;
        data["equipmentName"] = this.equipmentName !== undefined ? this.equipmentName : null as any;
        data["equipmentLocation"] = this.equipmentLocation !== undefined ? this.equipmentLocation : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["personInCharge"] = this.personInCharge !== undefined ? this.personInCharge : null as any;
        data["monitoringPerson"] = this.monitoringPerson !== undefined ? this.monitoringPerson : null as any;
        return data;
    }
}

export interface IEquipmentInterventionDto {
    id?: string;
    equipmentId?: string;
    equipmentName?: string;
    equipmentLocation?: string;
    date?: Date;
    description?: string;
    personInCharge?: string;
    monitoringPerson?: string;
}

export class EquipmentInterventionInputDto implements IEquipmentInterventionInputDto {
    id?: string | null;
    equipmentId?: string;
    date?: Date;
    description?: string;
    personInCharge?: string;
    monitoringPerson?: string;

    constructor(data?: IEquipmentInterventionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.equipmentId = _data["equipmentId"] !== undefined ? _data["equipmentId"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.personInCharge = _data["personInCharge"] !== undefined ? _data["personInCharge"] : null as any;
            this.monitoringPerson = _data["monitoringPerson"] !== undefined ? _data["monitoringPerson"] : null as any;
        }
    }

    static fromJS(data: any): EquipmentInterventionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInterventionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["equipmentId"] = this.equipmentId !== undefined ? this.equipmentId : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["personInCharge"] = this.personInCharge !== undefined ? this.personInCharge : null as any;
        data["monitoringPerson"] = this.monitoringPerson !== undefined ? this.monitoringPerson : null as any;
        return data;
    }
}

export interface IEquipmentInterventionInputDto {
    id?: string | null;
    equipmentId?: string;
    date?: Date;
    description?: string;
    personInCharge?: string;
    monitoringPerson?: string;
}

export class CustomerCockpitDataDto implements ICustomerCockpitDataDto {
    measuringPointState?: MeasuringPointState;
    measuringPointStateChangeSource?: MeasuringPointStateChangeSource;
    totalEnergyConsumption?: number;
    actualIntensity?: MeasureDto | null;
    maximumDailyEnergyConsumption?: TemporalMeasureDto | null;
    consumptionMeasures?: TemporalMeasureDto[];
    assignment?: MeasuringPointAssignmentWithCustomerDto | null;

    constructor(data?: ICustomerCockpitDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measuringPointState = _data["measuringPointState"] !== undefined ? _data["measuringPointState"] : null as any;
            this.measuringPointStateChangeSource = _data["measuringPointStateChangeSource"] !== undefined ? _data["measuringPointStateChangeSource"] : null as any;
            this.totalEnergyConsumption = _data["totalEnergyConsumption"] !== undefined ? _data["totalEnergyConsumption"] : null as any;
            this.actualIntensity = _data["actualIntensity"] ? MeasureDto.fromJS(_data["actualIntensity"]) : null as any;
            this.maximumDailyEnergyConsumption = _data["maximumDailyEnergyConsumption"] ? TemporalMeasureDto.fromJS(_data["maximumDailyEnergyConsumption"]) : null as any;
            if (Array.isArray(_data["consumptionMeasures"])) {
                this.consumptionMeasures = [] as any;
                for (let item of _data["consumptionMeasures"])
                    this.consumptionMeasures!.push(TemporalMeasureDto.fromJS(item));
            }
            else {
                this.consumptionMeasures = null as any;
            }
            this.assignment = _data["assignment"] ? MeasuringPointAssignmentWithCustomerDto.fromJS(_data["assignment"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerCockpitDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCockpitDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measuringPointState"] = this.measuringPointState !== undefined ? this.measuringPointState : null as any;
        data["measuringPointStateChangeSource"] = this.measuringPointStateChangeSource !== undefined ? this.measuringPointStateChangeSource : null as any;
        data["totalEnergyConsumption"] = this.totalEnergyConsumption !== undefined ? this.totalEnergyConsumption : null as any;
        data["actualIntensity"] = this.actualIntensity ? this.actualIntensity.toJSON() : null as any;
        data["maximumDailyEnergyConsumption"] = this.maximumDailyEnergyConsumption ? this.maximumDailyEnergyConsumption.toJSON() : null as any;
        if (Array.isArray(this.consumptionMeasures)) {
            data["consumptionMeasures"] = [];
            for (let item of this.consumptionMeasures)
                data["consumptionMeasures"].push(item ? item.toJSON() : null as any);
        }
        data["assignment"] = this.assignment ? this.assignment.toJSON() : null as any;
        return data;
    }
}

export interface ICustomerCockpitDataDto {
    measuringPointState?: MeasuringPointState;
    measuringPointStateChangeSource?: MeasuringPointStateChangeSource;
    totalEnergyConsumption?: number;
    actualIntensity?: MeasureDto | null;
    maximumDailyEnergyConsumption?: TemporalMeasureDto | null;
    consumptionMeasures?: TemporalMeasureDto[];
    assignment?: MeasuringPointAssignmentWithCustomerDto | null;
}

export class MeasureDto implements IMeasureDto {
    id?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    measureType?: MeasureTypeDto;
    measuringPoint?: MeasuringPointDto;
    lastKnownValue?: number | null;
    lastValueChanged?: Date | null;
    lastResetDateTime?: Date | null;

    constructor(data?: IMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.measureType = _data["measureType"] ? MeasureTypeDto.fromJS(_data["measureType"]) : null as any;
            this.measuringPoint = _data["measuringPoint"] ? MeasuringPointDto.fromJS(_data["measuringPoint"]) : null as any;
            this.lastKnownValue = _data["lastKnownValue"] !== undefined ? _data["lastKnownValue"] : null as any;
            this.lastValueChanged = _data["lastValueChanged"] ? new Date(_data["lastValueChanged"].toString()) : null as any;
            this.lastResetDateTime = _data["lastResetDateTime"] ? new Date(_data["lastResetDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["measureType"] = this.measureType ? this.measureType.toJSON() : null as any;
        data["measuringPoint"] = this.measuringPoint ? this.measuringPoint.toJSON() : null as any;
        data["lastKnownValue"] = this.lastKnownValue !== undefined ? this.lastKnownValue : null as any;
        data["lastValueChanged"] = this.lastValueChanged ? this.lastValueChanged.toISOString() : null as any;
        data["lastResetDateTime"] = this.lastResetDateTime ? this.lastResetDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IMeasureDto {
    id?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    measureType?: MeasureTypeDto;
    measuringPoint?: MeasuringPointDto;
    lastKnownValue?: number | null;
    lastValueChanged?: Date | null;
    lastResetDateTime?: Date | null;
}

export class MeasureTypeDto implements IMeasureTypeDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    unit?: string;

    constructor(data?: IMeasureTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.numericId = _data["numericId"] !== undefined ? _data["numericId"] : null as any;
            this.technicalId = _data["technicalId"] !== undefined ? _data["technicalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
        }
    }

    static fromJS(data: any): MeasureTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasureTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["numericId"] = this.numericId !== undefined ? this.numericId : null as any;
        data["technicalId"] = this.technicalId !== undefined ? this.technicalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        return data;
    }
}

export interface IMeasureTypeDto {
    id?: string;
    numericId?: number | null;
    technicalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    unit?: string;
}

export class TemporalMeasureDto implements ITemporalMeasureDto {
    dateTime?: Date;
    value?: number;

    constructor(data?: ITemporalMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): TemporalMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface ITemporalMeasureDto {
    dateTime?: Date;
    value?: number;
}

export class MeasuringPointAssignmentWithCustomerDto implements IMeasuringPointAssignmentWithCustomerDto {
    id?: string;
    assignmentFrom?: Date;
    assignmentTo?: Date | null;
    customerId?: string;
    customerFirstName?: string;
    customerLastName?: string;
    measuringPointId?: string;

    constructor(data?: IMeasuringPointAssignmentWithCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.assignmentFrom = _data["assignmentFrom"] ? new Date(_data["assignmentFrom"].toString()) : null as any;
            this.assignmentTo = _data["assignmentTo"] ? new Date(_data["assignmentTo"].toString()) : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customerFirstName = _data["customerFirstName"] !== undefined ? _data["customerFirstName"] : null as any;
            this.customerLastName = _data["customerLastName"] !== undefined ? _data["customerLastName"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
        }
    }

    static fromJS(data: any): MeasuringPointAssignmentWithCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringPointAssignmentWithCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["assignmentFrom"] = this.assignmentFrom ? this.assignmentFrom.toISOString() : null as any;
        data["assignmentTo"] = this.assignmentTo ? this.assignmentTo.toISOString() : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customerFirstName"] = this.customerFirstName !== undefined ? this.customerFirstName : null as any;
        data["customerLastName"] = this.customerLastName !== undefined ? this.customerLastName : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        return data;
    }
}

export interface IMeasuringPointAssignmentWithCustomerDto {
    id?: string;
    assignmentFrom?: Date;
    assignmentTo?: Date | null;
    customerId?: string;
    customerFirstName?: string;
    customerLastName?: string;
    measuringPointId?: string;
}

export class AvailablePeriodRangeDto implements IAvailablePeriodRangeDto {
    from?: Date;
    to?: Date;
    customerId?: string;

    constructor(data?: IAvailablePeriodRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): AvailablePeriodRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePeriodRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IAvailablePeriodRangeDto {
    from?: Date;
    to?: Date;
    customerId?: string;
}

export class StateCockpitDataDto implements IStateCockpitDataDto {
    actualIntensity?: MeasureDto | null;
    maxIntensity15Min?: MeasureDto | null;
    actualPower?: MeasureDto | null;
    maxIntensityConfigured?: MeasureDto | null;

    constructor(data?: IStateCockpitDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualIntensity = _data["actualIntensity"] ? MeasureDto.fromJS(_data["actualIntensity"]) : null as any;
            this.maxIntensity15Min = _data["maxIntensity15Min"] ? MeasureDto.fromJS(_data["maxIntensity15Min"]) : null as any;
            this.actualPower = _data["actualPower"] ? MeasureDto.fromJS(_data["actualPower"]) : null as any;
            this.maxIntensityConfigured = _data["maxIntensityConfigured"] ? MeasureDto.fromJS(_data["maxIntensityConfigured"]) : null as any;
        }
    }

    static fromJS(data: any): StateCockpitDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateCockpitDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualIntensity"] = this.actualIntensity ? this.actualIntensity.toJSON() : null as any;
        data["maxIntensity15Min"] = this.maxIntensity15Min ? this.maxIntensity15Min.toJSON() : null as any;
        data["actualPower"] = this.actualPower ? this.actualPower.toJSON() : null as any;
        data["maxIntensityConfigured"] = this.maxIntensityConfigured ? this.maxIntensityConfigured.toJSON() : null as any;
        return data;
    }
}

export interface IStateCockpitDataDto {
    actualIntensity?: MeasureDto | null;
    maxIntensity15Min?: MeasureDto | null;
    actualPower?: MeasureDto | null;
    maxIntensityConfigured?: MeasureDto | null;
}

export class ConsumptionCockpitDataDto implements IConsumptionCockpitDataDto {
    measuringPointHardwareName?: string;
    totalEnergyConsumption?: number;
    maximumDailyEnergyConsumption?: TemporalMeasureDto | null;
    consumptionMeasures?: TemporalMeasureDto[];

    constructor(data?: IConsumptionCockpitDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measuringPointHardwareName = _data["measuringPointHardwareName"] !== undefined ? _data["measuringPointHardwareName"] : null as any;
            this.totalEnergyConsumption = _data["totalEnergyConsumption"] !== undefined ? _data["totalEnergyConsumption"] : null as any;
            this.maximumDailyEnergyConsumption = _data["maximumDailyEnergyConsumption"] ? TemporalMeasureDto.fromJS(_data["maximumDailyEnergyConsumption"]) : null as any;
            if (Array.isArray(_data["consumptionMeasures"])) {
                this.consumptionMeasures = [] as any;
                for (let item of _data["consumptionMeasures"])
                    this.consumptionMeasures!.push(TemporalMeasureDto.fromJS(item));
            }
            else {
                this.consumptionMeasures = null as any;
            }
        }
    }

    static fromJS(data: any): ConsumptionCockpitDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumptionCockpitDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measuringPointHardwareName"] = this.measuringPointHardwareName !== undefined ? this.measuringPointHardwareName : null as any;
        data["totalEnergyConsumption"] = this.totalEnergyConsumption !== undefined ? this.totalEnergyConsumption : null as any;
        data["maximumDailyEnergyConsumption"] = this.maximumDailyEnergyConsumption ? this.maximumDailyEnergyConsumption.toJSON() : null as any;
        if (Array.isArray(this.consumptionMeasures)) {
            data["consumptionMeasures"] = [];
            for (let item of this.consumptionMeasures)
                data["consumptionMeasures"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IConsumptionCockpitDataDto {
    measuringPointHardwareName?: string;
    totalEnergyConsumption?: number;
    maximumDailyEnergyConsumption?: TemporalMeasureDto | null;
    consumptionMeasures?: TemporalMeasureDto[];
}

export class DatatransPaymentRequestDto implements IDatatransPaymentRequestDto {
    datatransTransactionId?: string;

    constructor(data?: IDatatransPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datatransTransactionId = _data["datatransTransactionId"] !== undefined ? _data["datatransTransactionId"] : null as any;
        }
    }

    static fromJS(data: any): DatatransPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatatransPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datatransTransactionId"] = this.datatransTransactionId !== undefined ? this.datatransTransactionId : null as any;
        return data;
    }
}

export interface IDatatransPaymentRequestDto {
    datatransTransactionId?: string;
}

export class DatatransPaymentRequestInputDto implements IDatatransPaymentRequestInputDto {
    amount?: number;
    currency?: DatatransCurrency;
    language?: InitRequestLanguage;
    serviceType?: ServiceType | null;
    payload?: DatatransTransactionPayload | null;
    redirectUrl?: string;

    constructor(data?: IDatatransPaymentRequestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.payload = _data["payload"] ? DatatransTransactionPayload.fromJS(_data["payload"]) : null as any;
            this.redirectUrl = _data["redirectUrl"] !== undefined ? _data["redirectUrl"] : null as any;
        }
    }

    static fromJS(data: any): DatatransPaymentRequestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatatransPaymentRequestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["payload"] = this.payload ? this.payload.toJSON() : null as any;
        data["redirectUrl"] = this.redirectUrl !== undefined ? this.redirectUrl : null as any;
        return data;
    }
}

export interface IDatatransPaymentRequestInputDto {
    amount?: number;
    currency?: DatatransCurrency;
    language?: InitRequestLanguage;
    serviceType?: ServiceType | null;
    payload?: DatatransTransactionPayload | null;
    redirectUrl?: string;
}

export enum DatatransCurrency {
    Chf = "Chf",
}

export enum InitRequestLanguage {
    En = "en",
    De = "de",
    Fr = "fr",
    It = "it",
    Es = "es",
    El = "el",
    Fi = "fi",
    Hu = "hu",
    Ko = "ko",
    Nl = "nl",
    No = "no",
    Da = "da",
    Pl = "pl",
    Pt = "pt",
    Ru = "ru",
    Ja = "ja",
    Sk = "sk",
    Sl = "sl",
    Sv = "sv",
    Tr = "tr",
    Zh = "zh",
}

export class DatatransTransactionPayload implements IDatatransTransactionPayload {
    hydrowashTrackId?: string | null;
    activationInputDto?: ActivationInputDto | null;
    purchaseInputDto?: PurchaseInputDto | null;
    bookingInputDto?: BookingInputDto | null;
    craningBookingInputDto?: CraningBookingInputDto | null;
    consumeServicePayload?: ConsumeServicePayloadDtoOfChargingProcessInputDto | null;
    craningBookingSlotId?: number | null;
    craningBookingId?: number | null;

    constructor(data?: IDatatransTransactionPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hydrowashTrackId = _data["hydrowashTrackId"] !== undefined ? _data["hydrowashTrackId"] : null as any;
            this.activationInputDto = _data["activationInputDto"] ? ActivationInputDto.fromJS(_data["activationInputDto"]) : null as any;
            this.purchaseInputDto = _data["purchaseInputDto"] ? PurchaseInputDto.fromJS(_data["purchaseInputDto"]) : null as any;
            this.bookingInputDto = _data["bookingInputDto"] ? BookingInputDto.fromJS(_data["bookingInputDto"]) : null as any;
            this.craningBookingInputDto = _data["craningBookingInputDto"] ? CraningBookingInputDto.fromJS(_data["craningBookingInputDto"]) : null as any;
            this.consumeServicePayload = _data["consumeServicePayload"] ? ConsumeServicePayloadDtoOfChargingProcessInputDto.fromJS(_data["consumeServicePayload"]) : null as any;
            this.craningBookingSlotId = _data["craningBookingSlotId"] !== undefined ? _data["craningBookingSlotId"] : null as any;
            this.craningBookingId = _data["craningBookingId"] !== undefined ? _data["craningBookingId"] : null as any;
        }
    }

    static fromJS(data: any): DatatransTransactionPayload {
        data = typeof data === 'object' ? data : {};
        let result = new DatatransTransactionPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hydrowashTrackId"] = this.hydrowashTrackId !== undefined ? this.hydrowashTrackId : null as any;
        data["activationInputDto"] = this.activationInputDto ? this.activationInputDto.toJSON() : null as any;
        data["purchaseInputDto"] = this.purchaseInputDto ? this.purchaseInputDto.toJSON() : null as any;
        data["bookingInputDto"] = this.bookingInputDto ? this.bookingInputDto.toJSON() : null as any;
        data["craningBookingInputDto"] = this.craningBookingInputDto ? this.craningBookingInputDto.toJSON() : null as any;
        data["consumeServicePayload"] = this.consumeServicePayload ? this.consumeServicePayload.toJSON() : null as any;
        data["craningBookingSlotId"] = this.craningBookingSlotId !== undefined ? this.craningBookingSlotId : null as any;
        data["craningBookingId"] = this.craningBookingId !== undefined ? this.craningBookingId : null as any;
        return data;
    }
}

export interface IDatatransTransactionPayload {
    hydrowashTrackId?: string | null;
    activationInputDto?: ActivationInputDto | null;
    purchaseInputDto?: PurchaseInputDto | null;
    bookingInputDto?: BookingInputDto | null;
    craningBookingInputDto?: CraningBookingInputDto | null;
    consumeServicePayload?: ConsumeServicePayloadDtoOfChargingProcessInputDto | null;
    craningBookingSlotId?: number | null;
    craningBookingId?: number | null;
}

export class ActivationInputDto implements IActivationInputDto {
    serviceId?: string;
    measuringPointId?: string;
    customerId?: string | null;
    bookingId?: string | null;
    paymentType?: PaymentTypes;
    overridenImpulseDuration?: number | null;
    visitorContact?: VisitorContactDto | null;

    constructor(data?: IActivationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.overridenImpulseDuration = _data["overridenImpulseDuration"] !== undefined ? _data["overridenImpulseDuration"] : null as any;
            this.visitorContact = _data["visitorContact"] ? VisitorContactDto.fromJS(_data["visitorContact"]) : null as any;
        }
    }

    static fromJS(data: any): ActivationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["overridenImpulseDuration"] = this.overridenImpulseDuration !== undefined ? this.overridenImpulseDuration : null as any;
        data["visitorContact"] = this.visitorContact ? this.visitorContact.toJSON() : null as any;
        return data;
    }
}

export interface IActivationInputDto {
    serviceId?: string;
    measuringPointId?: string;
    customerId?: string | null;
    bookingId?: string | null;
    paymentType?: PaymentTypes;
    overridenImpulseDuration?: number | null;
    visitorContact?: VisitorContactDto | null;
}

export class VisitorContactDto implements IVisitorContactDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;

    constructor(data?: IVisitorContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): VisitorContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitorContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }
}

export interface IVisitorContactDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
}

export class BookingInputDto implements IBookingInputDto {
    reservationType?: ReservationType;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    recurring?: boolean;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    comment?: string | null;
    serviceId?: string;
    itemToBookId?: string;
    itemAnswers?: ItemToBookAnswerInputDto[];
    paymentType?: PaymentTypes | null;
    bookingSlotId?: number | null;

    constructor(data?: IBookingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationType = _data["reservationType"] !== undefined ? _data["reservationType"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.localStartTime = _data["localStartTime"] !== undefined ? _data["localStartTime"] : null as any;
            this.localEndTime = _data["localEndTime"] !== undefined ? _data["localEndTime"] : null as any;
            this.recurring = _data["recurring"] !== undefined ? _data["recurring"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.visitorContact = _data["visitorContact"] ? VisitorContactDto.fromJS(_data["visitorContact"]) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.itemToBookId = _data["itemToBookId"] !== undefined ? _data["itemToBookId"] : null as any;
            if (Array.isArray(_data["itemAnswers"])) {
                this.itemAnswers = [] as any;
                for (let item of _data["itemAnswers"])
                    this.itemAnswers!.push(ItemToBookAnswerInputDto.fromJS(item));
            }
            else {
                this.itemAnswers = null as any;
            }
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.bookingSlotId = _data["bookingSlotId"] !== undefined ? _data["bookingSlotId"] : null as any;
        }
    }

    static fromJS(data: any): BookingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationType"] = this.reservationType !== undefined ? this.reservationType : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["localStartTime"] = this.localStartTime !== undefined ? this.localStartTime : null as any;
        data["localEndTime"] = this.localEndTime !== undefined ? this.localEndTime : null as any;
        data["recurring"] = this.recurring !== undefined ? this.recurring : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["visitorContact"] = this.visitorContact ? this.visitorContact.toJSON() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["itemToBookId"] = this.itemToBookId !== undefined ? this.itemToBookId : null as any;
        if (Array.isArray(this.itemAnswers)) {
            data["itemAnswers"] = [];
            for (let item of this.itemAnswers)
                data["itemAnswers"].push(item ? item.toJSON() : null as any);
        }
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["bookingSlotId"] = this.bookingSlotId !== undefined ? this.bookingSlotId : null as any;
        return data;
    }
}

export interface IBookingInputDto {
    reservationType?: ReservationType;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    recurring?: boolean;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    comment?: string | null;
    serviceId?: string;
    itemToBookId?: string;
    itemAnswers?: ItemToBookAnswerInputDto[];
    paymentType?: PaymentTypes | null;
    bookingSlotId?: number | null;
}

export enum ReservationType {
    Blocking = "Blocking",
    Booking = "Booking",
}

export class ItemToBookAnswerInputDto implements IItemToBookAnswerInputDto {
    itemQuestionId?: string;
    answer?: string;

    constructor(data?: IItemToBookAnswerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemQuestionId = _data["itemQuestionId"] !== undefined ? _data["itemQuestionId"] : null as any;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : null as any;
        }
    }

    static fromJS(data: any): ItemToBookAnswerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemToBookAnswerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemQuestionId"] = this.itemQuestionId !== undefined ? this.itemQuestionId : null as any;
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        return data;
    }
}

export interface IItemToBookAnswerInputDto {
    itemQuestionId?: string;
    answer?: string;
}

export class CraningBookingInputDto implements ICraningBookingInputDto {
    customerId?: string | null;
    mooringPlaceId?: string | null;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    visitorBoatRegistrationNumber?: string | null;
    visitorBoatWeightInKg?: number | null;
    visitorBoatLengthInMeter?: number | null;
    visitorBoatWidthInMeter?: number | null;
    craningSelectedServices?: CraningSelectedServiceDto[];
    paymentType?: PaymentTypes | null;
    craningBookingSlotId?: number;
    isByExploitant?: boolean;
    isForBilling?: boolean;

    constructor(data?: ICraningBookingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.mooringPlaceId = _data["mooringPlaceId"] !== undefined ? _data["mooringPlaceId"] : null as any;
            this.visitorFirstName = _data["visitorFirstName"] !== undefined ? _data["visitorFirstName"] : null as any;
            this.visitorLastName = _data["visitorLastName"] !== undefined ? _data["visitorLastName"] : null as any;
            this.visitorEmail = _data["visitorEmail"] !== undefined ? _data["visitorEmail"] : null as any;
            this.visitorMobilePhone = _data["visitorMobilePhone"] !== undefined ? _data["visitorMobilePhone"] : null as any;
            this.visitorStreet = _data["visitorStreet"] !== undefined ? _data["visitorStreet"] : null as any;
            this.visitorPostalCode = _data["visitorPostalCode"] !== undefined ? _data["visitorPostalCode"] : null as any;
            this.visitorCity = _data["visitorCity"] !== undefined ? _data["visitorCity"] : null as any;
            this.visitorCountry = _data["visitorCountry"] !== undefined ? _data["visitorCountry"] : null as any;
            this.visitorBoatRegistrationNumber = _data["visitorBoatRegistrationNumber"] !== undefined ? _data["visitorBoatRegistrationNumber"] : null as any;
            this.visitorBoatWeightInKg = _data["visitorBoatWeightInKg"] !== undefined ? _data["visitorBoatWeightInKg"] : null as any;
            this.visitorBoatLengthInMeter = _data["visitorBoatLengthInMeter"] !== undefined ? _data["visitorBoatLengthInMeter"] : null as any;
            this.visitorBoatWidthInMeter = _data["visitorBoatWidthInMeter"] !== undefined ? _data["visitorBoatWidthInMeter"] : null as any;
            if (Array.isArray(_data["craningSelectedServices"])) {
                this.craningSelectedServices = [] as any;
                for (let item of _data["craningSelectedServices"])
                    this.craningSelectedServices!.push(CraningSelectedServiceDto.fromJS(item));
            }
            else {
                this.craningSelectedServices = null as any;
            }
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.craningBookingSlotId = _data["craningBookingSlotId"] !== undefined ? _data["craningBookingSlotId"] : null as any;
            this.isByExploitant = _data["isByExploitant"] !== undefined ? _data["isByExploitant"] : null as any;
            this.isForBilling = _data["isForBilling"] !== undefined ? _data["isForBilling"] : null as any;
        }
    }

    static fromJS(data: any): CraningBookingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["mooringPlaceId"] = this.mooringPlaceId !== undefined ? this.mooringPlaceId : null as any;
        data["visitorFirstName"] = this.visitorFirstName !== undefined ? this.visitorFirstName : null as any;
        data["visitorLastName"] = this.visitorLastName !== undefined ? this.visitorLastName : null as any;
        data["visitorEmail"] = this.visitorEmail !== undefined ? this.visitorEmail : null as any;
        data["visitorMobilePhone"] = this.visitorMobilePhone !== undefined ? this.visitorMobilePhone : null as any;
        data["visitorStreet"] = this.visitorStreet !== undefined ? this.visitorStreet : null as any;
        data["visitorPostalCode"] = this.visitorPostalCode !== undefined ? this.visitorPostalCode : null as any;
        data["visitorCity"] = this.visitorCity !== undefined ? this.visitorCity : null as any;
        data["visitorCountry"] = this.visitorCountry !== undefined ? this.visitorCountry : null as any;
        data["visitorBoatRegistrationNumber"] = this.visitorBoatRegistrationNumber !== undefined ? this.visitorBoatRegistrationNumber : null as any;
        data["visitorBoatWeightInKg"] = this.visitorBoatWeightInKg !== undefined ? this.visitorBoatWeightInKg : null as any;
        data["visitorBoatLengthInMeter"] = this.visitorBoatLengthInMeter !== undefined ? this.visitorBoatLengthInMeter : null as any;
        data["visitorBoatWidthInMeter"] = this.visitorBoatWidthInMeter !== undefined ? this.visitorBoatWidthInMeter : null as any;
        if (Array.isArray(this.craningSelectedServices)) {
            data["craningSelectedServices"] = [];
            for (let item of this.craningSelectedServices)
                data["craningSelectedServices"].push(item ? item.toJSON() : null as any);
        }
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["craningBookingSlotId"] = this.craningBookingSlotId !== undefined ? this.craningBookingSlotId : null as any;
        data["isByExploitant"] = this.isByExploitant !== undefined ? this.isByExploitant : null as any;
        data["isForBilling"] = this.isForBilling !== undefined ? this.isForBilling : null as any;
        return data;
    }
}

export interface ICraningBookingInputDto {
    customerId?: string | null;
    mooringPlaceId?: string | null;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    visitorBoatRegistrationNumber?: string | null;
    visitorBoatWeightInKg?: number | null;
    visitorBoatLengthInMeter?: number | null;
    visitorBoatWidthInMeter?: number | null;
    craningSelectedServices?: CraningSelectedServiceDto[];
    paymentType?: PaymentTypes | null;
    craningBookingSlotId?: number;
    isByExploitant?: boolean;
    isForBilling?: boolean;
}

export class CraningSelectedServiceDto implements ICraningSelectedServiceDto {
    craningServiceId?: string;
    answers?: CraningServiceAnswerDto[];

    constructor(data?: ICraningSelectedServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.craningServiceId = _data["craningServiceId"] !== undefined ? _data["craningServiceId"] : null as any;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(CraningServiceAnswerDto.fromJS(item));
            }
            else {
                this.answers = null as any;
            }
        }
    }

    static fromJS(data: any): CraningSelectedServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningSelectedServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningServiceId"] = this.craningServiceId !== undefined ? this.craningServiceId : null as any;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICraningSelectedServiceDto {
    craningServiceId?: string;
    answers?: CraningServiceAnswerDto[];
}

export class CraningServiceAnswerDto implements ICraningServiceAnswerDto {
    craningServiceQuestionId?: string;
    answer?: string;

    constructor(data?: ICraningServiceAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.craningServiceQuestionId = _data["craningServiceQuestionId"] !== undefined ? _data["craningServiceQuestionId"] : null as any;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : null as any;
        }
    }

    static fromJS(data: any): CraningServiceAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServiceAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningServiceQuestionId"] = this.craningServiceQuestionId !== undefined ? this.craningServiceQuestionId : null as any;
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        return data;
    }
}

export interface ICraningServiceAnswerDto {
    craningServiceQuestionId?: string;
    answer?: string;
}

export class ConsumeServicePayloadDtoOfChargingProcessInputDto implements IConsumeServicePayloadDtoOfChargingProcessInputDto {
    serviceId?: string;
    paymentType?: PaymentTypes;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    serviceInputPayload?: ChargingProcessInputDto | null;

    constructor(data?: IConsumeServicePayloadDtoOfChargingProcessInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.visitorContact = _data["visitorContact"] ? VisitorContactDto.fromJS(_data["visitorContact"]) : null as any;
            this.serviceInputPayload = _data["serviceInputPayload"] ? ChargingProcessInputDto.fromJS(_data["serviceInputPayload"]) : null as any;
        }
    }

    static fromJS(data: any): ConsumeServicePayloadDtoOfChargingProcessInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumeServicePayloadDtoOfChargingProcessInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["visitorContact"] = this.visitorContact ? this.visitorContact.toJSON() : null as any;
        data["serviceInputPayload"] = this.serviceInputPayload ? this.serviceInputPayload.toJSON() : null as any;
        return data;
    }
}

export interface IConsumeServicePayloadDtoOfChargingProcessInputDto {
    serviceId?: string;
    paymentType?: PaymentTypes;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    serviceInputPayload?: ChargingProcessInputDto | null;
}

export class ChargingProcessInputDto implements IChargingProcessInputDto {
    chargingStationId?: string;
    evseIndexNumber?: number;
    refno?: string | null;

    constructor(data?: IChargingProcessInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargingStationId = _data["chargingStationId"] !== undefined ? _data["chargingStationId"] : null as any;
            this.evseIndexNumber = _data["evseIndexNumber"] !== undefined ? _data["evseIndexNumber"] : null as any;
            this.refno = _data["refno"] !== undefined ? _data["refno"] : null as any;
        }
    }

    static fromJS(data: any): ChargingProcessInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingProcessInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargingStationId"] = this.chargingStationId !== undefined ? this.chargingStationId : null as any;
        data["evseIndexNumber"] = this.evseIndexNumber !== undefined ? this.evseIndexNumber : null as any;
        data["refno"] = this.refno !== undefined ? this.refno : null as any;
        return data;
    }
}

export interface IChargingProcessInputDto {
    chargingStationId?: string;
    evseIndexNumber?: number;
    refno?: string | null;
}

export class DatatransConfigurationDto implements IDatatransConfigurationDto {
    datatransJsUrl?: string;

    constructor(data?: IDatatransConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datatransJsUrl = _data["datatransJsUrl"] !== undefined ? _data["datatransJsUrl"] : null as any;
        }
    }

    static fromJS(data: any): DatatransConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatatransConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datatransJsUrl"] = this.datatransJsUrl !== undefined ? this.datatransJsUrl : null as any;
        return data;
    }
}

export interface IDatatransConfigurationDto {
    datatransJsUrl?: string;
}

export class EwalletDto implements IEwalletDto {
    id?: string;
    balance?: number;
    customerId?: string;

    constructor(data?: IEwalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): EwalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["balance"] = this.balance !== undefined ? this.balance : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IEwalletDto {
    id?: string;
    balance?: number;
    customerId?: string;
}

export class PageableRequestDtoOfCustomerTransactionCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfCustomerTransactionCriteriaDto {
    criteria?: CustomerTransactionCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfCustomerTransactionCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? CustomerTransactionCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfCustomerTransactionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfCustomerTransactionCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfCustomerTransactionCriteriaDto extends IPageableRequestDto {
    criteria?: CustomerTransactionCriteriaDto | null;
}

export class CustomerTransactionCriteriaDto implements ICustomerTransactionCriteriaDto {
    customerSearchCriteriaDto?: CustomerTransactionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: ICustomerTransactionCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerSearchCriteriaDto = _data["customerSearchCriteriaDto"] ? CustomerTransactionSearchCriteriaDto.fromJS(_data["customerSearchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerTransactionCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTransactionCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerSearchCriteriaDto"] = this.customerSearchCriteriaDto ? this.customerSearchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface ICustomerTransactionCriteriaDto {
    customerSearchCriteriaDto?: CustomerTransactionSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class CustomerTransactionSearchCriteriaDto implements ICustomerTransactionSearchCriteriaDto {
    ewalletBalanceFrom?: number | null;
    ewalletBalanceTo?: number | null;
    transactionSource?: TransactionSource | null;
    serviceId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;

    constructor(data?: ICustomerTransactionSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ewalletBalanceFrom = _data["ewalletBalanceFrom"] !== undefined ? _data["ewalletBalanceFrom"] : null as any;
            this.ewalletBalanceTo = _data["ewalletBalanceTo"] !== undefined ? _data["ewalletBalanceTo"] : null as any;
            this.transactionSource = _data["transactionSource"] !== undefined ? _data["transactionSource"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.amountFrom = _data["amountFrom"] !== undefined ? _data["amountFrom"] : null as any;
            this.amountTo = _data["amountTo"] !== undefined ? _data["amountTo"] : null as any;
        }
    }

    static fromJS(data: any): CustomerTransactionSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTransactionSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ewalletBalanceFrom"] = this.ewalletBalanceFrom !== undefined ? this.ewalletBalanceFrom : null as any;
        data["ewalletBalanceTo"] = this.ewalletBalanceTo !== undefined ? this.ewalletBalanceTo : null as any;
        data["transactionSource"] = this.transactionSource !== undefined ? this.transactionSource : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["amountFrom"] = this.amountFrom !== undefined ? this.amountFrom : null as any;
        data["amountTo"] = this.amountTo !== undefined ? this.amountTo : null as any;
        return data;
    }
}

export interface ICustomerTransactionSearchCriteriaDto {
    ewalletBalanceFrom?: number | null;
    ewalletBalanceTo?: number | null;
    transactionSource?: TransactionSource | null;
    serviceId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;
}

export class PagedResultDtoOfCustomerLightDto implements IPagedResultDtoOfCustomerLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerLightDto[];

    constructor(data?: IPagedResultDtoOfCustomerLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCustomerLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerLightDto[];
}

export class PageableRequestDtoOfCustomerCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfCustomerCriteriaDto {
    criteria?: CustomerCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfCustomerCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? CustomerCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfCustomerCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfCustomerCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfCustomerCriteriaDto extends IPageableRequestDto {
    criteria?: CustomerCriteriaDto | null;
}

export class CustomerCriteriaDto implements ICustomerCriteriaDto {
    searchCriteriaDto?: CustomerSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;

    constructor(data?: ICustomerCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? CustomerSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        return data;
    }
}

export interface ICustomerCriteriaDto {
    searchCriteriaDto?: CustomerSearchCriteriaDto;
    sortCriteria?: SortCriteriaDto;
}

export class CustomerSearchCriteriaDto implements ICustomerSearchCriteriaDto {
    customRoleKeys?: string[] | null;
    accountEnabled?: boolean | null;
    searchTerms?: string | null;
    siteCodes?: string[] | null;

    constructor(data?: ICustomerSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customRoleKeys"])) {
                this.customRoleKeys = [] as any;
                for (let item of _data["customRoleKeys"])
                    this.customRoleKeys!.push(item);
            }
            else {
                this.customRoleKeys = null as any;
            }
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
            this.searchTerms = _data["searchTerms"] !== undefined ? _data["searchTerms"] : null as any;
            if (Array.isArray(_data["siteCodes"])) {
                this.siteCodes = [] as any;
                for (let item of _data["siteCodes"])
                    this.siteCodes!.push(item);
            }
            else {
                this.siteCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CustomerSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customRoleKeys)) {
            data["customRoleKeys"] = [];
            for (let item of this.customRoleKeys)
                data["customRoleKeys"].push(item);
        }
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        data["searchTerms"] = this.searchTerms !== undefined ? this.searchTerms : null as any;
        if (Array.isArray(this.siteCodes)) {
            data["siteCodes"] = [];
            for (let item of this.siteCodes)
                data["siteCodes"].push(item);
        }
        return data;
    }
}

export interface ICustomerSearchCriteriaDto {
    customRoleKeys?: string[] | null;
    accountEnabled?: boolean | null;
    searchTerms?: string | null;
    siteCodes?: string[] | null;
}

export class CustomerInputDto implements ICustomerInputDto {
    id?: string | null;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    comment?: string | null;
    internalField1?: string | null;
    internalField2?: string | null;
    internalField3?: string | null;
    internalField4?: string | null;
    internalField5?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    customRoles?: CustomRoleDto[];
    accountEnabled?: boolean;
    customerNumber?: string;
    attentionTo?: string | null;
    householdSize?: number | null;
    cards?: CardDto[];
    sites?: SiteDto[];

    constructor(data?: ICustomerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.internalField1 = _data["internalField1"] !== undefined ? _data["internalField1"] : null as any;
            this.internalField2 = _data["internalField2"] !== undefined ? _data["internalField2"] : null as any;
            this.internalField3 = _data["internalField3"] !== undefined ? _data["internalField3"] : null as any;
            this.internalField4 = _data["internalField4"] !== undefined ? _data["internalField4"] : null as any;
            this.internalField5 = _data["internalField5"] !== undefined ? _data["internalField5"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.attentionTo = _data["attentionTo"] !== undefined ? _data["attentionTo"] : null as any;
            this.householdSize = _data["householdSize"] !== undefined ? _data["householdSize"] : null as any;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardDto.fromJS(item));
            }
            else {
                this.cards = null as any;
            }
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(SiteDto.fromJS(item));
            }
            else {
                this.sites = null as any;
            }
        }
    }

    static fromJS(data: any): CustomerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["internalField1"] = this.internalField1 !== undefined ? this.internalField1 : null as any;
        data["internalField2"] = this.internalField2 !== undefined ? this.internalField2 : null as any;
        data["internalField3"] = this.internalField3 !== undefined ? this.internalField3 : null as any;
        data["internalField4"] = this.internalField4 !== undefined ? this.internalField4 : null as any;
        data["internalField5"] = this.internalField5 !== undefined ? this.internalField5 : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["attentionTo"] = this.attentionTo !== undefined ? this.attentionTo : null as any;
        data["householdSize"] = this.householdSize !== undefined ? this.householdSize : null as any;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICustomerInputDto {
    id?: string | null;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    comment?: string | null;
    internalField1?: string | null;
    internalField2?: string | null;
    internalField3?: string | null;
    internalField4?: string | null;
    internalField5?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    customRoles?: CustomRoleDto[];
    accountEnabled?: boolean;
    customerNumber?: string;
    attentionTo?: string | null;
    householdSize?: number | null;
    cards?: CardDto[];
    sites?: SiteDto[];
}

export class CustomerNameDto implements ICustomerNameDto {
    firstName?: string;
    lastName?: string;

    constructor(data?: ICustomerNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): CustomerNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

export interface ICustomerNameDto {
    firstName?: string;
    lastName?: string;
}

export class PagedResultDtoOfCustomerAuditEntryDto implements IPagedResultDtoOfCustomerAuditEntryDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerAuditEntryDto[];

    constructor(data?: IPagedResultDtoOfCustomerAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerAuditEntryDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCustomerAuditEntryDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerAuditEntryDto[];
}

export class CustomerAuditEntryDto implements ICustomerAuditEntryDto {
    changeType?: CustomerAuditEntryPropertyChangeType;
    modificationUser?: string;
    modificationDate?: Date;
    properties?: CustomerAuditEntryPropertyDto[];
    roleLabelFR?: string | null;
    roleLabelEN?: string | null;
    roleLabelDE?: string | null;
    roleLabelIT?: string | null;
    rfidCardUid?: string | null;
    siteCode?: string | null;
    siteNameFR?: string | null;
    siteNameDE?: string | null;
    siteNameEN?: string | null;
    siteNameIT?: string | null;

    constructor(data?: ICustomerAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.modificationUser = _data["modificationUser"] !== undefined ? _data["modificationUser"] : null as any;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : null as any;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(CustomerAuditEntryPropertyDto.fromJS(item));
            }
            else {
                this.properties = null as any;
            }
            this.roleLabelFR = _data["roleLabelFR"] !== undefined ? _data["roleLabelFR"] : null as any;
            this.roleLabelEN = _data["roleLabelEN"] !== undefined ? _data["roleLabelEN"] : null as any;
            this.roleLabelDE = _data["roleLabelDE"] !== undefined ? _data["roleLabelDE"] : null as any;
            this.roleLabelIT = _data["roleLabelIT"] !== undefined ? _data["roleLabelIT"] : null as any;
            this.rfidCardUid = _data["rfidCardUid"] !== undefined ? _data["rfidCardUid"] : null as any;
            this.siteCode = _data["siteCode"] !== undefined ? _data["siteCode"] : null as any;
            this.siteNameFR = _data["siteNameFR"] !== undefined ? _data["siteNameFR"] : null as any;
            this.siteNameDE = _data["siteNameDE"] !== undefined ? _data["siteNameDE"] : null as any;
            this.siteNameEN = _data["siteNameEN"] !== undefined ? _data["siteNameEN"] : null as any;
            this.siteNameIT = _data["siteNameIT"] !== undefined ? _data["siteNameIT"] : null as any;
        }
    }

    static fromJS(data: any): CustomerAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["modificationUser"] = this.modificationUser !== undefined ? this.modificationUser : null as any;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : null as any);
        }
        data["roleLabelFR"] = this.roleLabelFR !== undefined ? this.roleLabelFR : null as any;
        data["roleLabelEN"] = this.roleLabelEN !== undefined ? this.roleLabelEN : null as any;
        data["roleLabelDE"] = this.roleLabelDE !== undefined ? this.roleLabelDE : null as any;
        data["roleLabelIT"] = this.roleLabelIT !== undefined ? this.roleLabelIT : null as any;
        data["rfidCardUid"] = this.rfidCardUid !== undefined ? this.rfidCardUid : null as any;
        data["siteCode"] = this.siteCode !== undefined ? this.siteCode : null as any;
        data["siteNameFR"] = this.siteNameFR !== undefined ? this.siteNameFR : null as any;
        data["siteNameDE"] = this.siteNameDE !== undefined ? this.siteNameDE : null as any;
        data["siteNameEN"] = this.siteNameEN !== undefined ? this.siteNameEN : null as any;
        data["siteNameIT"] = this.siteNameIT !== undefined ? this.siteNameIT : null as any;
        return data;
    }
}

export interface ICustomerAuditEntryDto {
    changeType?: CustomerAuditEntryPropertyChangeType;
    modificationUser?: string;
    modificationDate?: Date;
    properties?: CustomerAuditEntryPropertyDto[];
    roleLabelFR?: string | null;
    roleLabelEN?: string | null;
    roleLabelDE?: string | null;
    roleLabelIT?: string | null;
    rfidCardUid?: string | null;
    siteCode?: string | null;
    siteNameFR?: string | null;
    siteNameDE?: string | null;
    siteNameEN?: string | null;
    siteNameIT?: string | null;
}

export enum CustomerAuditEntryPropertyChangeType {
    Unknown = "Unknown",
    PropertyChange = "PropertyChange",
    RfidCardAssignment = "RfidCardAssignment",
    RfidCardUnassignment = "RfidCardUnassignment",
    RfidCardStateChange = "RfidCardStateChange",
    RoleAssignment = "RoleAssignment",
    RoleUnassignment = "RoleUnassignment",
    UserCreation = "UserCreation",
    VirtualCardRenewal = "VirtualCardRenewal",
    SiteAssignment = "SiteAssignment",
    SiteUnassignment = "SiteUnassignment",
}

export class CustomerAuditEntryPropertyDto implements ICustomerAuditEntryPropertyDto {
    propertyName?: string;
    oldValue?: string | null;
    newValue?: string | null;

    constructor(data?: ICustomerAuditEntryPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): CustomerAuditEntryPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAuditEntryPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }
}

export interface ICustomerAuditEntryPropertyDto {
    propertyName?: string;
    oldValue?: string | null;
    newValue?: string | null;
}

export class SearchCustomerDto implements ISearchCustomerDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    customerNumber?: string;
    email?: string;
    phone?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;

    constructor(data?: ISearchCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): SearchCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }
}

export interface ISearchCustomerDto {
    id?: string;
    firstName?: string;
    lastName?: string;
    customerNumber?: string;
    email?: string;
    phone?: string | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
}

export class CustomerMeInputDto implements ICustomerMeInputDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    cards?: CardDto[] | null;
    sites?: SiteDto[] | null;

    constructor(data?: ICustomerMeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardDto.fromJS(item));
            }
            else {
                this.cards = null as any;
            }
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(SiteDto.fromJS(item));
            }
            else {
                this.sites = null as any;
            }
        }
    }

    static fromJS(data: any): CustomerMeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICustomerMeInputDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    cards?: CardDto[] | null;
    sites?: SiteDto[] | null;
}

export class ImportCustomer implements IImportCustomer {
    index?: number;
    accountEnabled?: boolean;
    title?: Title | null;
    lastName?: string | null;
    firstName?: string | null;
    attentionTo?: string | null;
    customerNumber?: string | null;
    birthDate?: Date | null;
    address?: string | null;
    npa?: string | null;
    city?: string | null;
    country?: string | null;
    mail?: string | null;
    privatePhone?: string | null;
    mobilePhone?: string | null;
    professionalPhone?: string | null;
    remarks?: string | null;
    rfidCardNumbers?: string[] | null;
    customerCustomRoles?: string[] | null;
    siteCodes?: string[] | null;
    householdSize?: string | null;

    constructor(data?: IImportCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : null as any;
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.attentionTo = _data["attentionTo"] !== undefined ? _data["attentionTo"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.npa = _data["npa"] !== undefined ? _data["npa"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.mail = _data["mail"] !== undefined ? _data["mail"] : null as any;
            this.privatePhone = _data["privatePhone"] !== undefined ? _data["privatePhone"] : null as any;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null as any;
            this.professionalPhone = _data["professionalPhone"] !== undefined ? _data["professionalPhone"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            if (Array.isArray(_data["rfidCardNumbers"])) {
                this.rfidCardNumbers = [] as any;
                for (let item of _data["rfidCardNumbers"])
                    this.rfidCardNumbers!.push(item);
            }
            else {
                this.rfidCardNumbers = null as any;
            }
            if (Array.isArray(_data["customerCustomRoles"])) {
                this.customerCustomRoles = [] as any;
                for (let item of _data["customerCustomRoles"])
                    this.customerCustomRoles!.push(item);
            }
            else {
                this.customerCustomRoles = null as any;
            }
            if (Array.isArray(_data["siteCodes"])) {
                this.siteCodes = [] as any;
                for (let item of _data["siteCodes"])
                    this.siteCodes!.push(item);
            }
            else {
                this.siteCodes = null as any;
            }
            this.householdSize = _data["householdSize"] !== undefined ? _data["householdSize"] : null as any;
        }
    }

    static fromJS(data: any): ImportCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : null as any;
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["attentionTo"] = this.attentionTo !== undefined ? this.attentionTo : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["npa"] = this.npa !== undefined ? this.npa : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["mail"] = this.mail !== undefined ? this.mail : null as any;
        data["privatePhone"] = this.privatePhone !== undefined ? this.privatePhone : null as any;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null as any;
        data["professionalPhone"] = this.professionalPhone !== undefined ? this.professionalPhone : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        if (Array.isArray(this.rfidCardNumbers)) {
            data["rfidCardNumbers"] = [];
            for (let item of this.rfidCardNumbers)
                data["rfidCardNumbers"].push(item);
        }
        if (Array.isArray(this.customerCustomRoles)) {
            data["customerCustomRoles"] = [];
            for (let item of this.customerCustomRoles)
                data["customerCustomRoles"].push(item);
        }
        if (Array.isArray(this.siteCodes)) {
            data["siteCodes"] = [];
            for (let item of this.siteCodes)
                data["siteCodes"].push(item);
        }
        data["householdSize"] = this.householdSize !== undefined ? this.householdSize : null as any;
        return data;
    }
}

export interface IImportCustomer {
    index?: number;
    accountEnabled?: boolean;
    title?: Title | null;
    lastName?: string | null;
    firstName?: string | null;
    attentionTo?: string | null;
    customerNumber?: string | null;
    birthDate?: Date | null;
    address?: string | null;
    npa?: string | null;
    city?: string | null;
    country?: string | null;
    mail?: string | null;
    privatePhone?: string | null;
    mobilePhone?: string | null;
    professionalPhone?: string | null;
    remarks?: string | null;
    rfidCardNumbers?: string[] | null;
    customerCustomRoles?: string[] | null;
    siteCodes?: string[] | null;
    householdSize?: string | null;
}

export class EwalletCustomerInfoDto extends EwalletDto implements IEwalletCustomerInfoDto {
    firstName?: string;
    lastName?: string;

    constructor(data?: IEwalletCustomerInfoDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static override fromJS(data: any): EwalletCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EwalletCustomerInfoDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IEwalletCustomerInfoDto extends IEwalletDto {
    firstName?: string;
    lastName?: string;
}

export class PointOfSaleCustomerInfoDto implements IPointOfSaleCustomerInfoDto {
    customerId?: string;
    name?: string;
    balance?: number;
    isAuthorized?: boolean;
    serviceId?: string;
    ewalletId?: string;
    cardNumber?: string;
    posId?: string;
    posLabel?: string;

    constructor(data?: IPointOfSaleCustomerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.balance = _data["balance"] !== undefined ? _data["balance"] : null as any;
            this.isAuthorized = _data["isAuthorized"] !== undefined ? _data["isAuthorized"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.ewalletId = _data["ewalletId"] !== undefined ? _data["ewalletId"] : null as any;
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.posId = _data["posId"] !== undefined ? _data["posId"] : null as any;
            this.posLabel = _data["posLabel"] !== undefined ? _data["posLabel"] : null as any;
        }
    }

    static fromJS(data: any): PointOfSaleCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSaleCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["balance"] = this.balance !== undefined ? this.balance : null as any;
        data["isAuthorized"] = this.isAuthorized !== undefined ? this.isAuthorized : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["ewalletId"] = this.ewalletId !== undefined ? this.ewalletId : null as any;
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["posId"] = this.posId !== undefined ? this.posId : null as any;
        data["posLabel"] = this.posLabel !== undefined ? this.posLabel : null as any;
        return data;
    }
}

export interface IPointOfSaleCustomerInfoDto {
    customerId?: string;
    name?: string;
    balance?: number;
    isAuthorized?: boolean;
    serviceId?: string;
    ewalletId?: string;
    cardNumber?: string;
    posId?: string;
    posLabel?: string;
}

export class PagedResultDtoOfCustomerAlarmDto implements IPagedResultDtoOfCustomerAlarmDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerAlarmDto[];

    constructor(data?: IPagedResultDtoOfCustomerAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerAlarmDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCustomerAlarmDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CustomerAlarmDto[];
}

export class CustomerAlarmDto implements ICustomerAlarmDto {
    id?: number;
    customerAlarmSubscription?: CustomerAlarmSubscriptionDto;
    startDateTime?: Date;
    endDateTime?: Date | null;
    active?: boolean;

    constructor(data?: ICustomerAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerAlarmSubscription = _data["customerAlarmSubscription"] ? CustomerAlarmSubscriptionDto.fromJS(_data["customerAlarmSubscription"]) : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): CustomerAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerAlarmSubscription"] = this.customerAlarmSubscription ? this.customerAlarmSubscription.toJSON() : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }
}

export interface ICustomerAlarmDto {
    id?: number;
    customerAlarmSubscription?: CustomerAlarmSubscriptionDto;
    startDateTime?: Date;
    endDateTime?: Date | null;
    active?: boolean;
}

export class CustomerAlarmSubscriptionDto implements ICustomerAlarmSubscriptionDto {
    id?: string;
    iotRegisterId?: string;
    serviceId?: string;
    designation?: string;
    startDateTime?: Date;
    endDateTime?: Date | null;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    paymentType?: PaymentTypes;
    iotRegister?: IotRegisterDto;

    constructor(data?: ICustomerAlarmSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
            this.pushNotificationEnabled = _data["pushNotificationEnabled"] !== undefined ? _data["pushNotificationEnabled"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.iotRegister = _data["iotRegister"] ? IotRegisterDto.fromJS(_data["iotRegister"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerAlarmSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAlarmSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["designation"] = this.designation !== undefined ? this.designation : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        data["pushNotificationEnabled"] = this.pushNotificationEnabled !== undefined ? this.pushNotificationEnabled : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["iotRegister"] = this.iotRegister ? this.iotRegister.toJSON() : null as any;
        return data;
    }
}

export interface ICustomerAlarmSubscriptionDto {
    id?: string;
    iotRegisterId?: string;
    serviceId?: string;
    designation?: string;
    startDateTime?: Date;
    endDateTime?: Date | null;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    paymentType?: PaymentTypes;
    iotRegister?: IotRegisterDto;
}

export class PageableRequestDtoOfCustomerAlarmSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfCustomerAlarmSearchCriteriaDto {
    criteria?: CustomerAlarmSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfCustomerAlarmSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? CustomerAlarmSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfCustomerAlarmSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfCustomerAlarmSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfCustomerAlarmSearchCriteriaDto extends IPageableRequestDto {
    criteria?: CustomerAlarmSearchCriteriaDto | null;
}

export class CustomerAlarmSearchCriteriaDto implements ICustomerAlarmSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterIds?: string[] | null;
    designation?: string | null;
    startDateFrom?: Date | null;
    startDateTo?: Date | null;
    endDateFrom?: Date | null;
    endDateTo?: Date | null;
    active?: boolean | null;

    constructor(data?: ICustomerAlarmSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            if (Array.isArray(_data["iotRegisterIds"])) {
                this.iotRegisterIds = [] as any;
                for (let item of _data["iotRegisterIds"])
                    this.iotRegisterIds!.push(item);
            }
            else {
                this.iotRegisterIds = null as any;
            }
            this.designation = _data["designation"] !== undefined ? _data["designation"] : null as any;
            this.startDateFrom = _data["startDateFrom"] ? new Date(_data["startDateFrom"].toString()) : null as any;
            this.startDateTo = _data["startDateTo"] ? new Date(_data["startDateTo"].toString()) : null as any;
            this.endDateFrom = _data["endDateFrom"] ? new Date(_data["endDateFrom"].toString()) : null as any;
            this.endDateTo = _data["endDateTo"] ? new Date(_data["endDateTo"].toString()) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): CustomerAlarmSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAlarmSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        if (Array.isArray(this.iotRegisterIds)) {
            data["iotRegisterIds"] = [];
            for (let item of this.iotRegisterIds)
                data["iotRegisterIds"].push(item);
        }
        data["designation"] = this.designation !== undefined ? this.designation : null as any;
        data["startDateFrom"] = this.startDateFrom ? this.startDateFrom.toISOString() : null as any;
        data["startDateTo"] = this.startDateTo ? this.startDateTo.toISOString() : null as any;
        data["endDateFrom"] = this.endDateFrom ? this.endDateFrom.toISOString() : null as any;
        data["endDateTo"] = this.endDateTo ? this.endDateTo.toISOString() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }
}

export interface ICustomerAlarmSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterIds?: string[] | null;
    designation?: string | null;
    startDateFrom?: Date | null;
    startDateTo?: Date | null;
    endDateFrom?: Date | null;
    endDateTo?: Date | null;
    active?: boolean | null;
}

export class CustomerAlarmSubscriptionInputDto implements ICustomerAlarmSubscriptionInputDto {
    iotRegisterId?: string;
    serviceId?: string;
    designation?: string;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    paymentType?: PaymentTypes;

    constructor(data?: ICustomerAlarmSubscriptionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
            this.pushNotificationEnabled = _data["pushNotificationEnabled"] !== undefined ? _data["pushNotificationEnabled"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
        }
    }

    static fromJS(data: any): CustomerAlarmSubscriptionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAlarmSubscriptionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["designation"] = this.designation !== undefined ? this.designation : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        data["pushNotificationEnabled"] = this.pushNotificationEnabled !== undefined ? this.pushNotificationEnabled : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        return data;
    }
}

export interface ICustomerAlarmSubscriptionInputDto {
    iotRegisterId?: string;
    serviceId?: string;
    designation?: string;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    paymentType?: PaymentTypes;
}

export class CraningBookingToBillDto implements ICraningBookingToBillDto {
    craningBookingSlotId?: number;
    bookingDateTime?: Date;
    customerName?: string;
    boatRegistrationNumber?: string;

    constructor(data?: ICraningBookingToBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.craningBookingSlotId = _data["craningBookingSlotId"] !== undefined ? _data["craningBookingSlotId"] : null as any;
            this.bookingDateTime = _data["bookingDateTime"] ? new Date(_data["bookingDateTime"].toString()) : null as any;
            this.customerName = _data["customerName"] !== undefined ? _data["customerName"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
        }
    }

    static fromJS(data: any): CraningBookingToBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingToBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningBookingSlotId"] = this.craningBookingSlotId !== undefined ? this.craningBookingSlotId : null as any;
        data["bookingDateTime"] = this.bookingDateTime ? this.bookingDateTime.toISOString() : null as any;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        return data;
    }
}

export interface ICraningBookingToBillDto {
    craningBookingSlotId?: number;
    bookingDateTime?: Date;
    customerName?: string;
    boatRegistrationNumber?: string;
}

export class CraningBillingDto implements ICraningBillingDto {
    id?: number;
    billingNumber?: string;
    transactionId?: string | null;
    billingDateTime?: Date;
    paymentType?: PaymentTypes;
    paymentDateTime?: Date | null;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    boatRegistrationNumber?: string;
    boatWeightInKg?: number;
    boatLengthInMeter?: number;
    boatWidthInMeter?: number;
    serviceName?: string;
    serviceBookingDate?: Date;
    serviceBookingStartTime?: string;
    serviceBookingEndTime?: string;
    depositAmount?: number;
    depositDate?: Date | null;
    serviceTotalAmount?: number;
    craningItems?: CraningBillingItemDto[];

    constructor(data?: ICraningBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.billingNumber = _data["billingNumber"] !== undefined ? _data["billingNumber"] : null as any;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.billingDateTime = _data["billingDateTime"] ? new Date(_data["billingDateTime"].toString()) : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.paymentDateTime = _data["paymentDateTime"] ? new Date(_data["paymentDateTime"].toString()) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
            this.boatWeightInKg = _data["boatWeightInKg"] !== undefined ? _data["boatWeightInKg"] : null as any;
            this.boatLengthInMeter = _data["boatLengthInMeter"] !== undefined ? _data["boatLengthInMeter"] : null as any;
            this.boatWidthInMeter = _data["boatWidthInMeter"] !== undefined ? _data["boatWidthInMeter"] : null as any;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : null as any;
            this.serviceBookingDate = _data["serviceBookingDate"] ? new Date(_data["serviceBookingDate"].toString()) : null as any;
            this.serviceBookingStartTime = _data["serviceBookingStartTime"] !== undefined ? _data["serviceBookingStartTime"] : null as any;
            this.serviceBookingEndTime = _data["serviceBookingEndTime"] !== undefined ? _data["serviceBookingEndTime"] : null as any;
            this.depositAmount = _data["depositAmount"] !== undefined ? _data["depositAmount"] : null as any;
            this.depositDate = _data["depositDate"] ? new Date(_data["depositDate"].toString()) : null as any;
            this.serviceTotalAmount = _data["serviceTotalAmount"] !== undefined ? _data["serviceTotalAmount"] : null as any;
            if (Array.isArray(_data["craningItems"])) {
                this.craningItems = [] as any;
                for (let item of _data["craningItems"])
                    this.craningItems!.push(CraningBillingItemDto.fromJS(item));
            }
            else {
                this.craningItems = null as any;
            }
        }
    }

    static fromJS(data: any): CraningBillingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["billingNumber"] = this.billingNumber !== undefined ? this.billingNumber : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["billingDateTime"] = this.billingDateTime ? this.billingDateTime.toISOString() : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        data["boatWeightInKg"] = this.boatWeightInKg !== undefined ? this.boatWeightInKg : null as any;
        data["boatLengthInMeter"] = this.boatLengthInMeter !== undefined ? this.boatLengthInMeter : null as any;
        data["boatWidthInMeter"] = this.boatWidthInMeter !== undefined ? this.boatWidthInMeter : null as any;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : null as any;
        data["serviceBookingDate"] = this.serviceBookingDate ? this.serviceBookingDate.toISOString() : null as any;
        data["serviceBookingStartTime"] = this.serviceBookingStartTime !== undefined ? this.serviceBookingStartTime : null as any;
        data["serviceBookingEndTime"] = this.serviceBookingEndTime !== undefined ? this.serviceBookingEndTime : null as any;
        data["depositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null as any;
        data["depositDate"] = this.depositDate ? this.depositDate.toISOString() : null as any;
        data["serviceTotalAmount"] = this.serviceTotalAmount !== undefined ? this.serviceTotalAmount : null as any;
        if (Array.isArray(this.craningItems)) {
            data["craningItems"] = [];
            for (let item of this.craningItems)
                data["craningItems"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICraningBillingDto {
    id?: number;
    billingNumber?: string;
    transactionId?: string | null;
    billingDateTime?: Date;
    paymentType?: PaymentTypes;
    paymentDateTime?: Date | null;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    boatRegistrationNumber?: string;
    boatWeightInKg?: number;
    boatLengthInMeter?: number;
    boatWidthInMeter?: number;
    serviceName?: string;
    serviceBookingDate?: Date;
    serviceBookingStartTime?: string;
    serviceBookingEndTime?: string;
    depositAmount?: number;
    depositDate?: Date | null;
    serviceTotalAmount?: number;
    craningItems?: CraningBillingItemDto[];
}

export class CraningBillingItemDto implements ICraningBillingItemDto {
    craningItemLabelFR?: string;
    craningItemLabelDE?: string;
    craningItemLabelEN?: string;
    craningItemLabelIT?: string;
    craningItemAmount?: number;

    constructor(data?: ICraningBillingItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.craningItemLabelFR = _data["craningItemLabelFR"] !== undefined ? _data["craningItemLabelFR"] : null as any;
            this.craningItemLabelDE = _data["craningItemLabelDE"] !== undefined ? _data["craningItemLabelDE"] : null as any;
            this.craningItemLabelEN = _data["craningItemLabelEN"] !== undefined ? _data["craningItemLabelEN"] : null as any;
            this.craningItemLabelIT = _data["craningItemLabelIT"] !== undefined ? _data["craningItemLabelIT"] : null as any;
            this.craningItemAmount = _data["craningItemAmount"] !== undefined ? _data["craningItemAmount"] : null as any;
        }
    }

    static fromJS(data: any): CraningBillingItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBillingItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningItemLabelFR"] = this.craningItemLabelFR !== undefined ? this.craningItemLabelFR : null as any;
        data["craningItemLabelDE"] = this.craningItemLabelDE !== undefined ? this.craningItemLabelDE : null as any;
        data["craningItemLabelEN"] = this.craningItemLabelEN !== undefined ? this.craningItemLabelEN : null as any;
        data["craningItemLabelIT"] = this.craningItemLabelIT !== undefined ? this.craningItemLabelIT : null as any;
        data["craningItemAmount"] = this.craningItemAmount !== undefined ? this.craningItemAmount : null as any;
        return data;
    }
}

export interface ICraningBillingItemDto {
    craningItemLabelFR?: string;
    craningItemLabelDE?: string;
    craningItemLabelEN?: string;
    craningItemLabelIT?: string;
    craningItemAmount?: number;
}

export class CraningBillingInputDto implements ICraningBillingInputDto {
    craningBookingId?: number;
    serviceId?: string;
    paymentType?: PaymentTypes;
    miscellaneousService?: CraningBillingItemDto | null;

    constructor(data?: ICraningBillingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.craningBookingId = _data["craningBookingId"] !== undefined ? _data["craningBookingId"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.miscellaneousService = _data["miscellaneousService"] ? CraningBillingItemDto.fromJS(_data["miscellaneousService"]) : null as any;
        }
    }

    static fromJS(data: any): CraningBillingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBillingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningBookingId"] = this.craningBookingId !== undefined ? this.craningBookingId : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["miscellaneousService"] = this.miscellaneousService ? this.miscellaneousService.toJSON() : null as any;
        return data;
    }
}

export interface ICraningBillingInputDto {
    craningBookingId?: number;
    serviceId?: string;
    paymentType?: PaymentTypes;
    miscellaneousService?: CraningBillingItemDto | null;
}

export class CraningBookingDto implements ICraningBookingDto {
    id?: number;
    craningBookingSlotId?: number;
    craningBillingId?: number | null;
    customer?: CustomerContactDto | null;
    mooringPlace?: MooringPlaceBoatDto | null;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    visitorBoatRegistrationNumber?: string | null;
    visitorBoatWeightInKg?: number | null;
    visitorBoatLengthInMeter?: number | null;
    visitorBoatWidthInMeter?: number | null;
    depositPrice?: number | null;
    depositPaymentDateTime?: Date | null;
    craningSelectedServices?: CraningSelectedServiceDto[];

    constructor(data?: ICraningBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.craningBookingSlotId = _data["craningBookingSlotId"] !== undefined ? _data["craningBookingSlotId"] : null as any;
            this.craningBillingId = _data["craningBillingId"] !== undefined ? _data["craningBillingId"] : null as any;
            this.customer = _data["customer"] ? CustomerContactDto.fromJS(_data["customer"]) : null as any;
            this.mooringPlace = _data["mooringPlace"] ? MooringPlaceBoatDto.fromJS(_data["mooringPlace"]) : null as any;
            this.visitorFirstName = _data["visitorFirstName"] !== undefined ? _data["visitorFirstName"] : null as any;
            this.visitorLastName = _data["visitorLastName"] !== undefined ? _data["visitorLastName"] : null as any;
            this.visitorEmail = _data["visitorEmail"] !== undefined ? _data["visitorEmail"] : null as any;
            this.visitorMobilePhone = _data["visitorMobilePhone"] !== undefined ? _data["visitorMobilePhone"] : null as any;
            this.visitorStreet = _data["visitorStreet"] !== undefined ? _data["visitorStreet"] : null as any;
            this.visitorPostalCode = _data["visitorPostalCode"] !== undefined ? _data["visitorPostalCode"] : null as any;
            this.visitorCity = _data["visitorCity"] !== undefined ? _data["visitorCity"] : null as any;
            this.visitorCountry = _data["visitorCountry"] !== undefined ? _data["visitorCountry"] : null as any;
            this.visitorBoatRegistrationNumber = _data["visitorBoatRegistrationNumber"] !== undefined ? _data["visitorBoatRegistrationNumber"] : null as any;
            this.visitorBoatWeightInKg = _data["visitorBoatWeightInKg"] !== undefined ? _data["visitorBoatWeightInKg"] : null as any;
            this.visitorBoatLengthInMeter = _data["visitorBoatLengthInMeter"] !== undefined ? _data["visitorBoatLengthInMeter"] : null as any;
            this.visitorBoatWidthInMeter = _data["visitorBoatWidthInMeter"] !== undefined ? _data["visitorBoatWidthInMeter"] : null as any;
            this.depositPrice = _data["depositPrice"] !== undefined ? _data["depositPrice"] : null as any;
            this.depositPaymentDateTime = _data["depositPaymentDateTime"] ? new Date(_data["depositPaymentDateTime"].toString()) : null as any;
            if (Array.isArray(_data["craningSelectedServices"])) {
                this.craningSelectedServices = [] as any;
                for (let item of _data["craningSelectedServices"])
                    this.craningSelectedServices!.push(CraningSelectedServiceDto.fromJS(item));
            }
            else {
                this.craningSelectedServices = null as any;
            }
        }
    }

    static fromJS(data: any): CraningBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["craningBookingSlotId"] = this.craningBookingSlotId !== undefined ? this.craningBookingSlotId : null as any;
        data["craningBillingId"] = this.craningBillingId !== undefined ? this.craningBillingId : null as any;
        data["customer"] = this.customer ? this.customer.toJSON() : null as any;
        data["mooringPlace"] = this.mooringPlace ? this.mooringPlace.toJSON() : null as any;
        data["visitorFirstName"] = this.visitorFirstName !== undefined ? this.visitorFirstName : null as any;
        data["visitorLastName"] = this.visitorLastName !== undefined ? this.visitorLastName : null as any;
        data["visitorEmail"] = this.visitorEmail !== undefined ? this.visitorEmail : null as any;
        data["visitorMobilePhone"] = this.visitorMobilePhone !== undefined ? this.visitorMobilePhone : null as any;
        data["visitorStreet"] = this.visitorStreet !== undefined ? this.visitorStreet : null as any;
        data["visitorPostalCode"] = this.visitorPostalCode !== undefined ? this.visitorPostalCode : null as any;
        data["visitorCity"] = this.visitorCity !== undefined ? this.visitorCity : null as any;
        data["visitorCountry"] = this.visitorCountry !== undefined ? this.visitorCountry : null as any;
        data["visitorBoatRegistrationNumber"] = this.visitorBoatRegistrationNumber !== undefined ? this.visitorBoatRegistrationNumber : null as any;
        data["visitorBoatWeightInKg"] = this.visitorBoatWeightInKg !== undefined ? this.visitorBoatWeightInKg : null as any;
        data["visitorBoatLengthInMeter"] = this.visitorBoatLengthInMeter !== undefined ? this.visitorBoatLengthInMeter : null as any;
        data["visitorBoatWidthInMeter"] = this.visitorBoatWidthInMeter !== undefined ? this.visitorBoatWidthInMeter : null as any;
        data["depositPrice"] = this.depositPrice !== undefined ? this.depositPrice : null as any;
        data["depositPaymentDateTime"] = this.depositPaymentDateTime ? this.depositPaymentDateTime.toISOString() : null as any;
        if (Array.isArray(this.craningSelectedServices)) {
            data["craningSelectedServices"] = [];
            for (let item of this.craningSelectedServices)
                data["craningSelectedServices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICraningBookingDto {
    id?: number;
    craningBookingSlotId?: number;
    craningBillingId?: number | null;
    customer?: CustomerContactDto | null;
    mooringPlace?: MooringPlaceBoatDto | null;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    visitorBoatRegistrationNumber?: string | null;
    visitorBoatWeightInKg?: number | null;
    visitorBoatLengthInMeter?: number | null;
    visitorBoatWidthInMeter?: number | null;
    depositPrice?: number | null;
    depositPaymentDateTime?: Date | null;
    craningSelectedServices?: CraningSelectedServiceDto[];
}

export class CustomerContactDto extends VisitorContactDto implements ICustomerContactDto {
    id?: string;
    customerNumber?: string;

    constructor(data?: ICustomerContactDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.customerNumber = _data["customerNumber"] !== undefined ? _data["customerNumber"] : null as any;
        }
    }

    static override fromJS(data: any): CustomerContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["customerNumber"] = this.customerNumber !== undefined ? this.customerNumber : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerContactDto extends IVisitorContactDto {
    id?: string;
    customerNumber?: string;
}

export class CraningBookingWithSlotDto extends CraningBookingDto implements ICraningBookingWithSlotDto {
    craningBookingSlot?: CraningBookingSlotDto;

    constructor(data?: ICraningBookingWithSlotDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.craningBookingSlot = _data["craningBookingSlot"] ? CraningBookingSlotDto.fromJS(_data["craningBookingSlot"]) : null as any;
        }
    }

    static override fromJS(data: any): CraningBookingWithSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingWithSlotDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craningBookingSlot"] = this.craningBookingSlot ? this.craningBookingSlot.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICraningBookingWithSlotDto extends ICraningBookingDto {
    craningBookingSlot?: CraningBookingSlotDto;
}

export class CraningBookingSlotDto implements ICraningBookingSlotDto {
    id?: number;
    date?: Date;
    startTime?: string;
    endTime?: string;
    state?: CraningBookingSlotState;

    constructor(data?: ICraningBookingSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): CraningBookingSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface ICraningBookingSlotDto {
    id?: number;
    date?: Date;
    startTime?: string;
    endTime?: string;
    state?: CraningBookingSlotState;
}

export enum CraningBookingSlotState {
    Free = "Free",
    Booked = "Booked",
    Blocked = "Blocked",
    Paid = "Paid",
    PreBooked = "PreBooked",
}

export class CraningBookingSlotItemDto extends CraningBookingSlotDto implements ICraningBookingSlotItemDto {
    isMine?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    mobilePhone?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    boatRegistrationNumber?: string | null;

    constructor(data?: ICraningBookingSlotItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isMine = _data["isMine"] !== undefined ? _data["isMine"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
            this.boatRegistrationNumber = _data["boatRegistrationNumber"] !== undefined ? _data["boatRegistrationNumber"] : null as any;
        }
    }

    static override fromJS(data: any): CraningBookingSlotItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingSlotItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMine"] = this.isMine !== undefined ? this.isMine : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        data["boatRegistrationNumber"] = this.boatRegistrationNumber !== undefined ? this.boatRegistrationNumber : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICraningBookingSlotItemDto extends ICraningBookingSlotDto {
    isMine?: boolean;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    mobilePhone?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    boatRegistrationNumber?: string | null;
}

export class CraningBookingSlotAnonymousItemDto extends CraningBookingSlotDto implements ICraningBookingSlotAnonymousItemDto {

    constructor(data?: ICraningBookingSlotAnonymousItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CraningBookingSlotAnonymousItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingSlotAnonymousItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICraningBookingSlotAnonymousItemDto extends ICraningBookingSlotDto {
}

export class GeneratingCraningBookingSlotsOutputDto implements IGeneratingCraningBookingSlotsOutputDto {
    conflictingBookingSlots?: CraningBookingSlotDto[];
    success?: boolean;
    numberOfCreatedSlots?: number;

    constructor(data?: IGeneratingCraningBookingSlotsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conflictingBookingSlots"])) {
                this.conflictingBookingSlots = [] as any;
                for (let item of _data["conflictingBookingSlots"])
                    this.conflictingBookingSlots!.push(CraningBookingSlotDto.fromJS(item));
            }
            else {
                this.conflictingBookingSlots = null as any;
            }
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.numberOfCreatedSlots = _data["numberOfCreatedSlots"] !== undefined ? _data["numberOfCreatedSlots"] : null as any;
        }
    }

    static fromJS(data: any): GeneratingCraningBookingSlotsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratingCraningBookingSlotsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conflictingBookingSlots)) {
            data["conflictingBookingSlots"] = [];
            for (let item of this.conflictingBookingSlots)
                data["conflictingBookingSlots"].push(item ? item.toJSON() : null as any);
        }
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["numberOfCreatedSlots"] = this.numberOfCreatedSlots !== undefined ? this.numberOfCreatedSlots : null as any;
        return data;
    }
}

export interface IGeneratingCraningBookingSlotsOutputDto {
    conflictingBookingSlots?: CraningBookingSlotDto[];
    success?: boolean;
    numberOfCreatedSlots?: number;
}

export class GeneratingCraningBookingSlotsInputDto implements IGeneratingCraningBookingSlotsInputDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    lastStartTimeOfTheDay?: string;
    duration?: string;
    days?: Day[];
    state?: CraningBookingSlotState;

    constructor(data?: IGeneratingCraningBookingSlotsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.lastStartTimeOfTheDay = _data["lastStartTimeOfTheDay"] !== undefined ? _data["lastStartTimeOfTheDay"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): GeneratingCraningBookingSlotsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratingCraningBookingSlotsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["lastStartTimeOfTheDay"] = this.lastStartTimeOfTheDay !== undefined ? this.lastStartTimeOfTheDay : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IGeneratingCraningBookingSlotsInputDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    lastStartTimeOfTheDay?: string;
    duration?: string;
    days?: Day[];
    state?: CraningBookingSlotState;
}

export class CraningBookingSlotInputDto implements ICraningBookingSlotInputDto {
    startTime?: string;
    endTime?: string;
    state?: CraningBookingSlotState;

    constructor(data?: ICraningBookingSlotInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): CraningBookingSlotInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningBookingSlotInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface ICraningBookingSlotInputDto {
    startTime?: string;
    endTime?: string;
    state?: CraningBookingSlotState;
}

export class CraningServiceDto implements ICraningServiceDto {
    id?: string;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    pricings?: CraningServicePricingDto[];
    questions?: CraningServiceQuestionDto[];

    constructor(data?: ICraningServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
            if (Array.isArray(_data["pricings"])) {
                this.pricings = [] as any;
                for (let item of _data["pricings"])
                    this.pricings!.push(CraningServicePricingDto.fromJS(item));
            }
            else {
                this.pricings = null as any;
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(CraningServiceQuestionDto.fromJS(item));
            }
            else {
                this.questions = null as any;
            }
        }
    }

    static fromJS(data: any): CraningServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        if (Array.isArray(this.pricings)) {
            data["pricings"] = [];
            for (let item of this.pricings)
                data["pricings"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ICraningServiceDto {
    id?: string;
    labelFR?: string;
    labelDE?: string;
    labelEN?: string;
    labelIT?: string;
    pricings?: CraningServicePricingDto[];
    questions?: CraningServiceQuestionDto[];
}

export class CraningServicePricingDto implements ICraningServicePricingDto {
    id?: string;
    categoryNameFR?: string;
    categoryNameDE?: string;
    categoryNameEN?: string;
    categoryNameIT?: string;
    price?: number;
    min?: number | null;
    max?: number | null;
    pricingType?: CraningServicePricingType;

    constructor(data?: ICraningServicePricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.categoryNameFR = _data["categoryNameFR"] !== undefined ? _data["categoryNameFR"] : null as any;
            this.categoryNameDE = _data["categoryNameDE"] !== undefined ? _data["categoryNameDE"] : null as any;
            this.categoryNameEN = _data["categoryNameEN"] !== undefined ? _data["categoryNameEN"] : null as any;
            this.categoryNameIT = _data["categoryNameIT"] !== undefined ? _data["categoryNameIT"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.min = _data["min"] !== undefined ? _data["min"] : null as any;
            this.max = _data["max"] !== undefined ? _data["max"] : null as any;
            this.pricingType = _data["pricingType"] !== undefined ? _data["pricingType"] : null as any;
        }
    }

    static fromJS(data: any): CraningServicePricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServicePricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["categoryNameFR"] = this.categoryNameFR !== undefined ? this.categoryNameFR : null as any;
        data["categoryNameDE"] = this.categoryNameDE !== undefined ? this.categoryNameDE : null as any;
        data["categoryNameEN"] = this.categoryNameEN !== undefined ? this.categoryNameEN : null as any;
        data["categoryNameIT"] = this.categoryNameIT !== undefined ? this.categoryNameIT : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["min"] = this.min !== undefined ? this.min : null as any;
        data["max"] = this.max !== undefined ? this.max : null as any;
        data["pricingType"] = this.pricingType !== undefined ? this.pricingType : null as any;
        return data;
    }
}

export interface ICraningServicePricingDto {
    id?: string;
    categoryNameFR?: string;
    categoryNameDE?: string;
    categoryNameEN?: string;
    categoryNameIT?: string;
    price?: number;
    min?: number | null;
    max?: number | null;
    pricingType?: CraningServicePricingType;
}

export enum CraningServicePricingType {
    Flat = "Flat",
    Weight = "Weight",
    Length = "Length",
    Width = "Width",
    Area = "Area",
}

export class CraningServiceQuestionDto implements ICraningServiceQuestionDto {
    id?: string;
    questionFR?: string;
    questionDE?: string;
    questionIT?: string;
    questionEN?: string;
    answerType?: CraningServiceAnswerType;

    constructor(data?: ICraningServiceQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.questionFR = _data["questionFR"] !== undefined ? _data["questionFR"] : null as any;
            this.questionDE = _data["questionDE"] !== undefined ? _data["questionDE"] : null as any;
            this.questionIT = _data["questionIT"] !== undefined ? _data["questionIT"] : null as any;
            this.questionEN = _data["questionEN"] !== undefined ? _data["questionEN"] : null as any;
            this.answerType = _data["answerType"] !== undefined ? _data["answerType"] : null as any;
        }
    }

    static fromJS(data: any): CraningServiceQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServiceQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["questionFR"] = this.questionFR !== undefined ? this.questionFR : null as any;
        data["questionDE"] = this.questionDE !== undefined ? this.questionDE : null as any;
        data["questionIT"] = this.questionIT !== undefined ? this.questionIT : null as any;
        data["questionEN"] = this.questionEN !== undefined ? this.questionEN : null as any;
        data["answerType"] = this.answerType !== undefined ? this.answerType : null as any;
        return data;
    }
}

export interface ICraningServiceQuestionDto {
    id?: string;
    questionFR?: string;
    questionDE?: string;
    questionIT?: string;
    questionEN?: string;
    answerType?: CraningServiceAnswerType;
}

export enum CraningServiceAnswerType {
    Boolean = "Boolean",
    Text = "Text",
    Number = "Number",
}

export class CraningServiceInputDto implements ICraningServiceInputDto {
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;

    constructor(data?: ICraningServiceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelFR = _data["labelFR"] !== undefined ? _data["labelFR"] : null as any;
            this.labelDE = _data["labelDE"] !== undefined ? _data["labelDE"] : null as any;
            this.labelEN = _data["labelEN"] !== undefined ? _data["labelEN"] : null as any;
            this.labelIT = _data["labelIT"] !== undefined ? _data["labelIT"] : null as any;
        }
    }

    static fromJS(data: any): CraningServiceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServiceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelFR"] = this.labelFR !== undefined ? this.labelFR : null as any;
        data["labelDE"] = this.labelDE !== undefined ? this.labelDE : null as any;
        data["labelEN"] = this.labelEN !== undefined ? this.labelEN : null as any;
        data["labelIT"] = this.labelIT !== undefined ? this.labelIT : null as any;
        return data;
    }
}

export interface ICraningServiceInputDto {
    labelFR?: string;
    labelDE?: string | null;
    labelEN?: string | null;
    labelIT?: string | null;
}

export class CraningServicePricingInputDto implements ICraningServicePricingInputDto {
    categoryNameFR?: string;
    categoryNameDE?: string | null;
    categoryNameEN?: string | null;
    categoryNameIT?: string | null;
    price?: number;
    min?: number | null;
    max?: number | null;
    pricingType?: CraningServicePricingType;

    constructor(data?: ICraningServicePricingInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryNameFR = _data["categoryNameFR"] !== undefined ? _data["categoryNameFR"] : null as any;
            this.categoryNameDE = _data["categoryNameDE"] !== undefined ? _data["categoryNameDE"] : null as any;
            this.categoryNameEN = _data["categoryNameEN"] !== undefined ? _data["categoryNameEN"] : null as any;
            this.categoryNameIT = _data["categoryNameIT"] !== undefined ? _data["categoryNameIT"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.min = _data["min"] !== undefined ? _data["min"] : null as any;
            this.max = _data["max"] !== undefined ? _data["max"] : null as any;
            this.pricingType = _data["pricingType"] !== undefined ? _data["pricingType"] : null as any;
        }
    }

    static fromJS(data: any): CraningServicePricingInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServicePricingInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryNameFR"] = this.categoryNameFR !== undefined ? this.categoryNameFR : null as any;
        data["categoryNameDE"] = this.categoryNameDE !== undefined ? this.categoryNameDE : null as any;
        data["categoryNameEN"] = this.categoryNameEN !== undefined ? this.categoryNameEN : null as any;
        data["categoryNameIT"] = this.categoryNameIT !== undefined ? this.categoryNameIT : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["min"] = this.min !== undefined ? this.min : null as any;
        data["max"] = this.max !== undefined ? this.max : null as any;
        data["pricingType"] = this.pricingType !== undefined ? this.pricingType : null as any;
        return data;
    }
}

export interface ICraningServicePricingInputDto {
    categoryNameFR?: string;
    categoryNameDE?: string | null;
    categoryNameEN?: string | null;
    categoryNameIT?: string | null;
    price?: number;
    min?: number | null;
    max?: number | null;
    pricingType?: CraningServicePricingType;
}

export class CraningServiceQuestionInputDto implements ICraningServiceQuestionInputDto {
    questionFR?: string;
    questionDE?: string | null;
    questionIT?: string | null;
    questionEN?: string | null;
    answerType?: CraningServiceAnswerType;

    constructor(data?: ICraningServiceQuestionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionFR = _data["questionFR"] !== undefined ? _data["questionFR"] : null as any;
            this.questionDE = _data["questionDE"] !== undefined ? _data["questionDE"] : null as any;
            this.questionIT = _data["questionIT"] !== undefined ? _data["questionIT"] : null as any;
            this.questionEN = _data["questionEN"] !== undefined ? _data["questionEN"] : null as any;
            this.answerType = _data["answerType"] !== undefined ? _data["answerType"] : null as any;
        }
    }

    static fromJS(data: any): CraningServiceQuestionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CraningServiceQuestionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionFR"] = this.questionFR !== undefined ? this.questionFR : null as any;
        data["questionDE"] = this.questionDE !== undefined ? this.questionDE : null as any;
        data["questionIT"] = this.questionIT !== undefined ? this.questionIT : null as any;
        data["questionEN"] = this.questionEN !== undefined ? this.questionEN : null as any;
        data["answerType"] = this.answerType !== undefined ? this.answerType : null as any;
        return data;
    }
}

export interface ICraningServiceQuestionInputDto {
    questionFR?: string;
    questionDE?: string | null;
    questionIT?: string | null;
    questionEN?: string | null;
    answerType?: CraningServiceAnswerType;
}

export class CustomerConfigurationDto implements ICustomerConfigurationDto {
    languageConfiguration?: CustomerLanguageConfigurationDto;
    featureConfiguration?: CustomerFeatureConfigurationDto;
    customerNumberAutoIncrementEnabled?: boolean;
    householdSizeRequired?: boolean;
    minimumWalletCreditAmount?: number;
    maxParallelCraningBookings?: number;

    constructor(data?: ICustomerConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageConfiguration = _data["languageConfiguration"] ? CustomerLanguageConfigurationDto.fromJS(_data["languageConfiguration"]) : null as any;
            this.featureConfiguration = _data["featureConfiguration"] ? CustomerFeatureConfigurationDto.fromJS(_data["featureConfiguration"]) : null as any;
            this.customerNumberAutoIncrementEnabled = _data["customerNumberAutoIncrementEnabled"] !== undefined ? _data["customerNumberAutoIncrementEnabled"] : null as any;
            this.householdSizeRequired = _data["householdSizeRequired"] !== undefined ? _data["householdSizeRequired"] : null as any;
            this.minimumWalletCreditAmount = _data["minimumWalletCreditAmount"] !== undefined ? _data["minimumWalletCreditAmount"] : null as any;
            this.maxParallelCraningBookings = _data["maxParallelCraningBookings"] !== undefined ? _data["maxParallelCraningBookings"] : null as any;
        }
    }

    static fromJS(data: any): CustomerConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageConfiguration"] = this.languageConfiguration ? this.languageConfiguration.toJSON() : null as any;
        data["featureConfiguration"] = this.featureConfiguration ? this.featureConfiguration.toJSON() : null as any;
        data["customerNumberAutoIncrementEnabled"] = this.customerNumberAutoIncrementEnabled !== undefined ? this.customerNumberAutoIncrementEnabled : null as any;
        data["householdSizeRequired"] = this.householdSizeRequired !== undefined ? this.householdSizeRequired : null as any;
        data["minimumWalletCreditAmount"] = this.minimumWalletCreditAmount !== undefined ? this.minimumWalletCreditAmount : null as any;
        data["maxParallelCraningBookings"] = this.maxParallelCraningBookings !== undefined ? this.maxParallelCraningBookings : null as any;
        return data;
    }
}

export interface ICustomerConfigurationDto {
    languageConfiguration?: CustomerLanguageConfigurationDto;
    featureConfiguration?: CustomerFeatureConfigurationDto;
    customerNumberAutoIncrementEnabled?: boolean;
    householdSizeRequired?: boolean;
    minimumWalletCreditAmount?: number;
    maxParallelCraningBookings?: number;
}

export class CustomerLanguageConfigurationDto implements ICustomerLanguageConfigurationDto {
    englishEnabled?: boolean;
    germanEnabled?: boolean;
    italianEnabled?: boolean;

    constructor(data?: ICustomerLanguageConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.englishEnabled = _data["englishEnabled"] !== undefined ? _data["englishEnabled"] : null as any;
            this.germanEnabled = _data["germanEnabled"] !== undefined ? _data["germanEnabled"] : null as any;
            this.italianEnabled = _data["italianEnabled"] !== undefined ? _data["italianEnabled"] : null as any;
        }
    }

    static fromJS(data: any): CustomerLanguageConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerLanguageConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["englishEnabled"] = this.englishEnabled !== undefined ? this.englishEnabled : null as any;
        data["germanEnabled"] = this.germanEnabled !== undefined ? this.germanEnabled : null as any;
        data["italianEnabled"] = this.italianEnabled !== undefined ? this.italianEnabled : null as any;
        return data;
    }
}

export interface ICustomerLanguageConfigurationDto {
    englishEnabled?: boolean;
    germanEnabled?: boolean;
    italianEnabled?: boolean;
}

export class CustomerFeatureConfigurationDto implements ICustomerFeatureConfigurationDto {
    alarmsEnabled?: boolean;
    infrastructureEnabled?: boolean;
    cashMachineEnabled?: boolean;
    ePaymentEnabled?: boolean;
    eWalletEnabled?: boolean;
    externalBillingEnabled?: boolean;
    communicationChannelConfiguration?: CommunicationChannelConfigurationDto;

    constructor(data?: ICustomerFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmsEnabled = _data["alarmsEnabled"] !== undefined ? _data["alarmsEnabled"] : null as any;
            this.infrastructureEnabled = _data["infrastructureEnabled"] !== undefined ? _data["infrastructureEnabled"] : null as any;
            this.cashMachineEnabled = _data["cashMachineEnabled"] !== undefined ? _data["cashMachineEnabled"] : null as any;
            this.ePaymentEnabled = _data["ePaymentEnabled"] !== undefined ? _data["ePaymentEnabled"] : null as any;
            this.eWalletEnabled = _data["eWalletEnabled"] !== undefined ? _data["eWalletEnabled"] : null as any;
            this.externalBillingEnabled = _data["externalBillingEnabled"] !== undefined ? _data["externalBillingEnabled"] : null as any;
            this.communicationChannelConfiguration = _data["communicationChannelConfiguration"] ? CommunicationChannelConfigurationDto.fromJS(_data["communicationChannelConfiguration"]) : null as any;
        }
    }

    static fromJS(data: any): CustomerFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmsEnabled"] = this.alarmsEnabled !== undefined ? this.alarmsEnabled : null as any;
        data["infrastructureEnabled"] = this.infrastructureEnabled !== undefined ? this.infrastructureEnabled : null as any;
        data["cashMachineEnabled"] = this.cashMachineEnabled !== undefined ? this.cashMachineEnabled : null as any;
        data["ePaymentEnabled"] = this.ePaymentEnabled !== undefined ? this.ePaymentEnabled : null as any;
        data["eWalletEnabled"] = this.eWalletEnabled !== undefined ? this.eWalletEnabled : null as any;
        data["externalBillingEnabled"] = this.externalBillingEnabled !== undefined ? this.externalBillingEnabled : null as any;
        data["communicationChannelConfiguration"] = this.communicationChannelConfiguration ? this.communicationChannelConfiguration.toJSON() : null as any;
        return data;
    }
}

export interface ICustomerFeatureConfigurationDto {
    alarmsEnabled?: boolean;
    infrastructureEnabled?: boolean;
    cashMachineEnabled?: boolean;
    ePaymentEnabled?: boolean;
    eWalletEnabled?: boolean;
    externalBillingEnabled?: boolean;
    communicationChannelConfiguration?: CommunicationChannelConfigurationDto;
}

export class CommunicationChannelConfigurationDto implements ICommunicationChannelConfigurationDto {
    informationEnabled?: boolean;
    contactEnabled?: boolean;
    surveyEnabled?: boolean;

    constructor(data?: ICommunicationChannelConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.informationEnabled = _data["informationEnabled"] !== undefined ? _data["informationEnabled"] : null as any;
            this.contactEnabled = _data["contactEnabled"] !== undefined ? _data["contactEnabled"] : null as any;
            this.surveyEnabled = _data["surveyEnabled"] !== undefined ? _data["surveyEnabled"] : null as any;
        }
    }

    static fromJS(data: any): CommunicationChannelConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationChannelConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["informationEnabled"] = this.informationEnabled !== undefined ? this.informationEnabled : null as any;
        data["contactEnabled"] = this.contactEnabled !== undefined ? this.contactEnabled : null as any;
        data["surveyEnabled"] = this.surveyEnabled !== undefined ? this.surveyEnabled : null as any;
        return data;
    }
}

export interface ICommunicationChannelConfigurationDto {
    informationEnabled?: boolean;
    contactEnabled?: boolean;
    surveyEnabled?: boolean;
}

export class ContactConfigurationDto implements IContactConfigurationDto {
    id?: number | null;
    customRoles?: CustomRoleDto[];
    cguFR?: string;
    cguDE?: string | null;
    cguIT?: string | null;
    cguEN?: string | null;
    email?: string;

    constructor(data?: IContactConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["customRoles"])) {
                this.customRoles = [] as any;
                for (let item of _data["customRoles"])
                    this.customRoles!.push(CustomRoleDto.fromJS(item));
            }
            else {
                this.customRoles = null as any;
            }
            this.cguFR = _data["cguFR"] !== undefined ? _data["cguFR"] : null as any;
            this.cguDE = _data["cguDE"] !== undefined ? _data["cguDE"] : null as any;
            this.cguIT = _data["cguIT"] !== undefined ? _data["cguIT"] : null as any;
            this.cguEN = _data["cguEN"] !== undefined ? _data["cguEN"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ContactConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.customRoles)) {
            data["customRoles"] = [];
            for (let item of this.customRoles)
                data["customRoles"].push(item ? item.toJSON() : null as any);
        }
        data["cguFR"] = this.cguFR !== undefined ? this.cguFR : null as any;
        data["cguDE"] = this.cguDE !== undefined ? this.cguDE : null as any;
        data["cguIT"] = this.cguIT !== undefined ? this.cguIT : null as any;
        data["cguEN"] = this.cguEN !== undefined ? this.cguEN : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IContactConfigurationDto {
    id?: number | null;
    customRoles?: CustomRoleDto[];
    cguFR?: string;
    cguDE?: string | null;
    cguIT?: string | null;
    cguEN?: string | null;
    email?: string;
}

export class CguDto implements ICguDto {
    cguFR?: string;
    cguDE?: string | null;
    cguIT?: string | null;
    cguEN?: string | null;

    constructor(data?: ICguDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cguFR = _data["cguFR"] !== undefined ? _data["cguFR"] : null as any;
            this.cguDE = _data["cguDE"] !== undefined ? _data["cguDE"] : null as any;
            this.cguIT = _data["cguIT"] !== undefined ? _data["cguIT"] : null as any;
            this.cguEN = _data["cguEN"] !== undefined ? _data["cguEN"] : null as any;
        }
    }

    static fromJS(data: any): CguDto {
        data = typeof data === 'object' ? data : {};
        let result = new CguDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cguFR"] = this.cguFR !== undefined ? this.cguFR : null as any;
        data["cguDE"] = this.cguDE !== undefined ? this.cguDE : null as any;
        data["cguIT"] = this.cguIT !== undefined ? this.cguIT : null as any;
        data["cguEN"] = this.cguEN !== undefined ? this.cguEN : null as any;
        return data;
    }
}

export interface ICguDto {
    cguFR?: string;
    cguDE?: string | null;
    cguIT?: string | null;
    cguEN?: string | null;
}

export class ContactMailDto implements IContactMailDto {
    message?: string;

    constructor(data?: IContactMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): ContactMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

export interface IContactMailDto {
    message?: string;
}

export class ChargingStationDto implements IChargingStationDto {
    id?: string;
    externalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;

    constructor(data?: IChargingStationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): ChargingStationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingStationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IChargingStationDto {
    id?: string;
    externalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;
}

export class ChargingStationEvseStateDto implements IChargingStationEvseStateDto {
    id?: string;
    externalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    numberOfFreeEvse?: number;
    numberOfEvse?: number;
    evseStatuses?: { [key: string]: ChargingStationEvseStatus; };

    constructor(data?: IChargingStationEvseStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.numberOfFreeEvse = _data["numberOfFreeEvse"] !== undefined ? _data["numberOfFreeEvse"] : null as any;
            this.numberOfEvse = _data["numberOfEvse"] !== undefined ? _data["numberOfEvse"] : null as any;
            if (_data["evseStatuses"]) {
                this.evseStatuses = {} as any;
                for (let key in _data["evseStatuses"]) {
                    if (_data["evseStatuses"].hasOwnProperty(key))
                        (this.evseStatuses as any)![key] = _data["evseStatuses"][key] !== undefined ? _data["evseStatuses"][key] : null as any;
                }
            }
            else {
                this.evseStatuses = null as any;
            }
        }
    }

    static fromJS(data: any): ChargingStationEvseStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingStationEvseStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["numberOfFreeEvse"] = this.numberOfFreeEvse !== undefined ? this.numberOfFreeEvse : null as any;
        data["numberOfEvse"] = this.numberOfEvse !== undefined ? this.numberOfEvse : null as any;
        if (this.evseStatuses) {
            data["evseStatuses"] = {};
            for (let key in this.evseStatuses) {
                if (this.evseStatuses.hasOwnProperty(key))
                    (data["evseStatuses"] as any)[key] = this.evseStatuses[key] !== undefined ? this.evseStatuses[key] : null as any;
            }
        }
        return data;
    }
}

export interface IChargingStationEvseStateDto {
    id?: string;
    externalId?: string;
    nameFR?: string;
    nameDE?: string;
    nameIT?: string;
    nameEN?: string;
    numberOfFreeEvse?: number;
    numberOfEvse?: number;
    evseStatuses?: { [key: string]: ChargingStationEvseStatus; };
}

export enum ChargingStationEvseStatus {
    Unknown = "Unknown",
    Free = "Free",
    Occupied = "Occupied",
    Error = "Error",
}

export class ChargingStationInputDto implements IChargingStationInputDto {
    externalId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;

    constructor(data?: IChargingStationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.nameFR = _data["nameFR"] !== undefined ? _data["nameFR"] : null as any;
            this.nameDE = _data["nameDE"] !== undefined ? _data["nameDE"] : null as any;
            this.nameIT = _data["nameIT"] !== undefined ? _data["nameIT"] : null as any;
            this.nameEN = _data["nameEN"] !== undefined ? _data["nameEN"] : null as any;
            this.descriptionFR = _data["descriptionFR"] !== undefined ? _data["descriptionFR"] : null as any;
            this.descriptionDE = _data["descriptionDE"] !== undefined ? _data["descriptionDE"] : null as any;
            this.descriptionIT = _data["descriptionIT"] !== undefined ? _data["descriptionIT"] : null as any;
            this.descriptionEN = _data["descriptionEN"] !== undefined ? _data["descriptionEN"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): ChargingStationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingStationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["nameFR"] = this.nameFR !== undefined ? this.nameFR : null as any;
        data["nameDE"] = this.nameDE !== undefined ? this.nameDE : null as any;
        data["nameIT"] = this.nameIT !== undefined ? this.nameIT : null as any;
        data["nameEN"] = this.nameEN !== undefined ? this.nameEN : null as any;
        data["descriptionFR"] = this.descriptionFR !== undefined ? this.descriptionFR : null as any;
        data["descriptionDE"] = this.descriptionDE !== undefined ? this.descriptionDE : null as any;
        data["descriptionIT"] = this.descriptionIT !== undefined ? this.descriptionIT : null as any;
        data["descriptionEN"] = this.descriptionEN !== undefined ? this.descriptionEN : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IChargingStationInputDto {
    externalId?: string;
    nameFR?: string;
    nameDE?: string | null;
    nameIT?: string | null;
    nameEN?: string | null;
    descriptionFR?: string | null;
    descriptionDE?: string | null;
    descriptionIT?: string | null;
    descriptionEN?: string | null;
    serviceId?: string;
}

export class PagedResultDtoOfChargingProcessDto implements IPagedResultDtoOfChargingProcessDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: ChargingProcessDto[];

    constructor(data?: IPagedResultDtoOfChargingProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ChargingProcessDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChargingProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChargingProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfChargingProcessDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: ChargingProcessDto[];
}

export class ChargingProcessDto implements IChargingProcessDto {
    id?: string;
    evseIndexNumber?: number;
    chargeProcessId?: number | null;
    chargeStartDateTime?: Date;
    chargeEndDateTime?: Date | null;
    paymentType?: PaymentTypes;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorPhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    chargeConsumptionKwh?: number | null;
    chargeDuration?: string | null;
    chargingProcessStatus?: ChargingProcessStatus;
    lastStateUpdate?: Date | null;
    serviceId?: string;
    chargingStationId?: string | null;
    chargingStationNameFR?: string;
    chargingStationNameDE?: string;
    chargingStationNameEN?: string;
    chargingStationNameIT?: string;
    customerId?: string | null;
    customer?: string | null;

    constructor(data?: IChargingProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.evseIndexNumber = _data["evseIndexNumber"] !== undefined ? _data["evseIndexNumber"] : null as any;
            this.chargeProcessId = _data["chargeProcessId"] !== undefined ? _data["chargeProcessId"] : null as any;
            this.chargeStartDateTime = _data["chargeStartDateTime"] ? new Date(_data["chargeStartDateTime"].toString()) : null as any;
            this.chargeEndDateTime = _data["chargeEndDateTime"] ? new Date(_data["chargeEndDateTime"].toString()) : null as any;
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
            this.visitorFirstName = _data["visitorFirstName"] !== undefined ? _data["visitorFirstName"] : null as any;
            this.visitorLastName = _data["visitorLastName"] !== undefined ? _data["visitorLastName"] : null as any;
            this.visitorEmail = _data["visitorEmail"] !== undefined ? _data["visitorEmail"] : null as any;
            this.visitorPhone = _data["visitorPhone"] !== undefined ? _data["visitorPhone"] : null as any;
            this.visitorStreet = _data["visitorStreet"] !== undefined ? _data["visitorStreet"] : null as any;
            this.visitorPostalCode = _data["visitorPostalCode"] !== undefined ? _data["visitorPostalCode"] : null as any;
            this.visitorCity = _data["visitorCity"] !== undefined ? _data["visitorCity"] : null as any;
            this.visitorCountry = _data["visitorCountry"] !== undefined ? _data["visitorCountry"] : null as any;
            this.chargeConsumptionKwh = _data["chargeConsumptionKwh"] !== undefined ? _data["chargeConsumptionKwh"] : null as any;
            this.chargeDuration = _data["chargeDuration"] !== undefined ? _data["chargeDuration"] : null as any;
            this.chargingProcessStatus = _data["chargingProcessStatus"] !== undefined ? _data["chargingProcessStatus"] : null as any;
            this.lastStateUpdate = _data["lastStateUpdate"] ? new Date(_data["lastStateUpdate"].toString()) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.chargingStationId = _data["chargingStationId"] !== undefined ? _data["chargingStationId"] : null as any;
            this.chargingStationNameFR = _data["chargingStationNameFR"] !== undefined ? _data["chargingStationNameFR"] : null as any;
            this.chargingStationNameDE = _data["chargingStationNameDE"] !== undefined ? _data["chargingStationNameDE"] : null as any;
            this.chargingStationNameEN = _data["chargingStationNameEN"] !== undefined ? _data["chargingStationNameEN"] : null as any;
            this.chargingStationNameIT = _data["chargingStationNameIT"] !== undefined ? _data["chargingStationNameIT"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
        }
    }

    static fromJS(data: any): ChargingProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["evseIndexNumber"] = this.evseIndexNumber !== undefined ? this.evseIndexNumber : null as any;
        data["chargeProcessId"] = this.chargeProcessId !== undefined ? this.chargeProcessId : null as any;
        data["chargeStartDateTime"] = this.chargeStartDateTime ? this.chargeStartDateTime.toISOString() : null as any;
        data["chargeEndDateTime"] = this.chargeEndDateTime ? this.chargeEndDateTime.toISOString() : null as any;
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        data["visitorFirstName"] = this.visitorFirstName !== undefined ? this.visitorFirstName : null as any;
        data["visitorLastName"] = this.visitorLastName !== undefined ? this.visitorLastName : null as any;
        data["visitorEmail"] = this.visitorEmail !== undefined ? this.visitorEmail : null as any;
        data["visitorPhone"] = this.visitorPhone !== undefined ? this.visitorPhone : null as any;
        data["visitorStreet"] = this.visitorStreet !== undefined ? this.visitorStreet : null as any;
        data["visitorPostalCode"] = this.visitorPostalCode !== undefined ? this.visitorPostalCode : null as any;
        data["visitorCity"] = this.visitorCity !== undefined ? this.visitorCity : null as any;
        data["visitorCountry"] = this.visitorCountry !== undefined ? this.visitorCountry : null as any;
        data["chargeConsumptionKwh"] = this.chargeConsumptionKwh !== undefined ? this.chargeConsumptionKwh : null as any;
        data["chargeDuration"] = this.chargeDuration !== undefined ? this.chargeDuration : null as any;
        data["chargingProcessStatus"] = this.chargingProcessStatus !== undefined ? this.chargingProcessStatus : null as any;
        data["lastStateUpdate"] = this.lastStateUpdate ? this.lastStateUpdate.toISOString() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["chargingStationId"] = this.chargingStationId !== undefined ? this.chargingStationId : null as any;
        data["chargingStationNameFR"] = this.chargingStationNameFR !== undefined ? this.chargingStationNameFR : null as any;
        data["chargingStationNameDE"] = this.chargingStationNameDE !== undefined ? this.chargingStationNameDE : null as any;
        data["chargingStationNameEN"] = this.chargingStationNameEN !== undefined ? this.chargingStationNameEN : null as any;
        data["chargingStationNameIT"] = this.chargingStationNameIT !== undefined ? this.chargingStationNameIT : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        return data;
    }
}

export interface IChargingProcessDto {
    id?: string;
    evseIndexNumber?: number;
    chargeProcessId?: number | null;
    chargeStartDateTime?: Date;
    chargeEndDateTime?: Date | null;
    paymentType?: PaymentTypes;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorPhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
    chargeConsumptionKwh?: number | null;
    chargeDuration?: string | null;
    chargingProcessStatus?: ChargingProcessStatus;
    lastStateUpdate?: Date | null;
    serviceId?: string;
    chargingStationId?: string | null;
    chargingStationNameFR?: string;
    chargingStationNameDE?: string;
    chargingStationNameEN?: string;
    chargingStationNameIT?: string;
    customerId?: string | null;
    customer?: string | null;
}

export enum ChargingProcessStatus {
    Unknown = "Unknown",
    InProgress = "InProgress",
    Occupied = "Occupied",
    Terminated = "Terminated",
}

export class PageableRequestDtoOfChargingProcessSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfChargingProcessSearchCriteriaDto {
    criteria?: ChargingProcessSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfChargingProcessSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? ChargingProcessSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfChargingProcessSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfChargingProcessSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfChargingProcessSearchCriteriaDto extends IPageableRequestDto {
    criteria?: ChargingProcessSearchCriteriaDto | null;
}

export class ChargingProcessSearchCriteriaDto implements IChargingProcessSearchCriteriaDto {
    from?: Date | null;
    to?: Date | null;
    serviceId?: string;
    chargingStationId?: string | null;
    customerId?: string | null;
    status?: ChargingProcessStatus | null;
    sortCriteria?: SortCriteriaDto | null;

    constructor(data?: IChargingProcessSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.chargingStationId = _data["chargingStationId"] !== undefined ? _data["chargingStationId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
        }
    }

    static fromJS(data: any): ChargingProcessSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingProcessSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["chargingStationId"] = this.chargingStationId !== undefined ? this.chargingStationId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        return data;
    }
}

export interface IChargingProcessSearchCriteriaDto {
    from?: Date | null;
    to?: Date | null;
    serviceId?: string;
    chargingStationId?: string | null;
    customerId?: string | null;
    status?: ChargingProcessStatus | null;
    sortCriteria?: SortCriteriaDto | null;
}

export class CardLightDto implements ICardLightDto {
    cardNumber?: string;
    uid?: string;

    constructor(data?: ICardLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
        }
    }

    static fromJS(data: any): CardLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        return data;
    }
}

export interface ICardLightDto {
    cardNumber?: string;
    uid?: string;
}

export class PagedResultDtoOfCardDto implements IPagedResultDtoOfCardDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CardDto[];

    constructor(data?: IPagedResultDtoOfCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CardDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfCardDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: CardDto[];
}

export class PageableRequestDtoOfRfidCardCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfRfidCardCriteriaDto {
    criteria?: RfidCardCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfRfidCardCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? RfidCardCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfRfidCardCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfRfidCardCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfRfidCardCriteriaDto extends IPageableRequestDto {
    criteria?: RfidCardCriteriaDto | null;
}

export class RfidCardCriteriaDto implements IRfidCardCriteriaDto {
    rfidCardSearchCriteriaDto?: RfidCardSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: IRfidCardCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rfidCardSearchCriteriaDto = _data["rfidCardSearchCriteriaDto"] ? RfidCardSearchCriteriaDto.fromJS(_data["rfidCardSearchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): RfidCardCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfidCardCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rfidCardSearchCriteriaDto"] = this.rfidCardSearchCriteriaDto ? this.rfidCardSearchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface IRfidCardCriteriaDto {
    rfidCardSearchCriteriaDto?: RfidCardSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class RfidCardSearchCriteriaDto implements IRfidCardSearchCriteriaDto {
    cardNumber?: string | null;
    uid?: string | null;
    assigned?: CardState[] | null;
    customerId?: string | null;

    constructor(data?: IRfidCardSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            if (Array.isArray(_data["assigned"])) {
                this.assigned = [] as any;
                for (let item of _data["assigned"])
                    this.assigned!.push(item);
            }
            else {
                this.assigned = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
        }
    }

    static fromJS(data: any): RfidCardSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfidCardSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        if (Array.isArray(this.assigned)) {
            data["assigned"] = [];
            for (let item of this.assigned)
                data["assigned"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        return data;
    }
}

export interface IRfidCardSearchCriteriaDto {
    cardNumber?: string | null;
    uid?: string | null;
    assigned?: CardState[] | null;
    customerId?: string | null;
}

export class VirtualCardDto implements IVirtualCardDto {
    cardNumber?: string;
    uid?: string;
    customerId?: string | null;
    qrCodeData?: string;

    constructor(data?: IVirtualCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.qrCodeData = _data["qrCodeData"] !== undefined ? _data["qrCodeData"] : null as any;
        }
    }

    static fromJS(data: any): VirtualCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["uid"] = this.uid !== undefined ? this.uid : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["qrCodeData"] = this.qrCodeData !== undefined ? this.qrCodeData : null as any;
        return data;
    }
}

export interface IVirtualCardDto {
    cardNumber?: string;
    uid?: string;
    customerId?: string | null;
    qrCodeData?: string;
}

export class BookingDto implements IBookingDto {
    id?: string;
    reservationType?: ReservationType;
    recurring?: boolean;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    customerContact?: CustomerContactDto | null;
    comment?: string | null;
    itemToBook?: ItemToBookDto;
    answers?: ItemToBookAnswerDto[];
    paymentType?: PaymentTypes | null;

    constructor(data?: IBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reservationType = _data["reservationType"] !== undefined ? _data["reservationType"] : null as any;
            this.recurring = _data["recurring"] !== undefined ? _data["recurring"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.localStartTime = _data["localStartTime"] !== undefined ? _data["localStartTime"] : null as any;
            this.localEndTime = _data["localEndTime"] !== undefined ? _data["localEndTime"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.visitorContact = _data["visitorContact"] ? VisitorContactDto.fromJS(_data["visitorContact"]) : null as any;
            this.customerContact = _data["customerContact"] ? CustomerContactDto.fromJS(_data["customerContact"]) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.itemToBook = _data["itemToBook"] ? ItemToBookDto.fromJS(_data["itemToBook"]) : null as any;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ItemToBookAnswerDto.fromJS(item));
            }
            else {
                this.answers = null as any;
            }
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : null as any;
        }
    }

    static fromJS(data: any): BookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reservationType"] = this.reservationType !== undefined ? this.reservationType : null as any;
        data["recurring"] = this.recurring !== undefined ? this.recurring : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["localStartTime"] = this.localStartTime !== undefined ? this.localStartTime : null as any;
        data["localEndTime"] = this.localEndTime !== undefined ? this.localEndTime : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["visitorContact"] = this.visitorContact ? this.visitorContact.toJSON() : null as any;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["itemToBook"] = this.itemToBook ? this.itemToBook.toJSON() : null as any;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : null as any);
        }
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : null as any;
        return data;
    }
}

export interface IBookingDto {
    id?: string;
    reservationType?: ReservationType;
    recurring?: boolean;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    customerContact?: CustomerContactDto | null;
    comment?: string | null;
    itemToBook?: ItemToBookDto;
    answers?: ItemToBookAnswerDto[];
    paymentType?: PaymentTypes | null;
}

export class ItemToBookAnswerDto implements IItemToBookAnswerDto {
    itemQuestionId?: string;
    answer?: string;

    constructor(data?: IItemToBookAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemQuestionId = _data["itemQuestionId"] !== undefined ? _data["itemQuestionId"] : null as any;
            this.answer = _data["answer"] !== undefined ? _data["answer"] : null as any;
        }
    }

    static fromJS(data: any): ItemToBookAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemToBookAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemQuestionId"] = this.itemQuestionId !== undefined ? this.itemQuestionId : null as any;
        data["answer"] = this.answer !== undefined ? this.answer : null as any;
        return data;
    }
}

export interface IItemToBookAnswerDto {
    itemQuestionId?: string;
    answer?: string;
}

export class BookingLightDto implements IBookingLightDto {
    id?: string;
    reservationType?: ReservationType;
    recurring?: boolean;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    comment?: string | null;
    itemToBook?: ItemToBookDto;
    paymentTypes?: PaymentTypes;

    constructor(data?: IBookingLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reservationType = _data["reservationType"] !== undefined ? _data["reservationType"] : null as any;
            this.recurring = _data["recurring"] !== undefined ? _data["recurring"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.localStartTime = _data["localStartTime"] !== undefined ? _data["localStartTime"] : null as any;
            this.localEndTime = _data["localEndTime"] !== undefined ? _data["localEndTime"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.visitorContact = _data["visitorContact"] ? VisitorContactDto.fromJS(_data["visitorContact"]) : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.itemToBook = _data["itemToBook"] ? ItemToBookDto.fromJS(_data["itemToBook"]) : null as any;
            this.paymentTypes = _data["paymentTypes"] !== undefined ? _data["paymentTypes"] : null as any;
        }
    }

    static fromJS(data: any): BookingLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reservationType"] = this.reservationType !== undefined ? this.reservationType : null as any;
        data["recurring"] = this.recurring !== undefined ? this.recurring : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["localStartTime"] = this.localStartTime !== undefined ? this.localStartTime : null as any;
        data["localEndTime"] = this.localEndTime !== undefined ? this.localEndTime : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["visitorContact"] = this.visitorContact ? this.visitorContact.toJSON() : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["itemToBook"] = this.itemToBook ? this.itemToBook.toJSON() : null as any;
        data["paymentTypes"] = this.paymentTypes !== undefined ? this.paymentTypes : null as any;
        return data;
    }
}

export interface IBookingLightDto {
    id?: string;
    reservationType?: ReservationType;
    recurring?: boolean;
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
    days?: Day[] | null;
    customerId?: string | null;
    visitorContact?: VisitorContactDto | null;
    comment?: string | null;
    itemToBook?: ItemToBookDto;
    paymentTypes?: PaymentTypes;
}

export class BookingConflictDto implements IBookingConflictDto {
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;

    constructor(data?: IBookingConflictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.localStartTime = _data["localStartTime"] !== undefined ? _data["localStartTime"] : null as any;
            this.localEndTime = _data["localEndTime"] !== undefined ? _data["localEndTime"] : null as any;
        }
    }

    static fromJS(data: any): BookingConflictDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingConflictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["localStartTime"] = this.localStartTime !== undefined ? this.localStartTime : null as any;
        data["localEndTime"] = this.localEndTime !== undefined ? this.localEndTime : null as any;
        return data;
    }
}

export interface IBookingConflictDto {
    startDate?: Date;
    endDate?: Date;
    localStartTime?: string;
    localEndTime?: string;
}

export class BookingServiceConfigDto implements IBookingServiceConfigDto {
    id?: string;
    serviceId?: string;
    bookingMode?: BookingMode;
    initialBookingDuration?: number;
    maxBookingDuration?: number;
    bookingTimeUnit?: BookingTimeUnit;
    maxNumberOfSimultaneousBookingByCustomer?: number;
    maxNumberOfPlannedBookingByCustomer?: number;
    deadlineForUpdatingBeforeBookingPeriod?: number;
    deadlineForUpdatingBeforeBookingPeriodTimeUnit?: BookingTimeUnit;
    maximumBookingAdvanceTimeInDay?: number | null;
    recurrentBookingAvailable?: boolean;
    defaultCalendarDisplayMode?: BookingCalendarMode;
    displayCustomerCards?: boolean;
    displayCustomerBoats?: boolean;

    constructor(data?: IBookingServiceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.bookingMode = _data["bookingMode"] !== undefined ? _data["bookingMode"] : null as any;
            this.initialBookingDuration = _data["initialBookingDuration"] !== undefined ? _data["initialBookingDuration"] : null as any;
            this.maxBookingDuration = _data["maxBookingDuration"] !== undefined ? _data["maxBookingDuration"] : null as any;
            this.bookingTimeUnit = _data["bookingTimeUnit"] !== undefined ? _data["bookingTimeUnit"] : null as any;
            this.maxNumberOfSimultaneousBookingByCustomer = _data["maxNumberOfSimultaneousBookingByCustomer"] !== undefined ? _data["maxNumberOfSimultaneousBookingByCustomer"] : null as any;
            this.maxNumberOfPlannedBookingByCustomer = _data["maxNumberOfPlannedBookingByCustomer"] !== undefined ? _data["maxNumberOfPlannedBookingByCustomer"] : null as any;
            this.deadlineForUpdatingBeforeBookingPeriod = _data["deadlineForUpdatingBeforeBookingPeriod"] !== undefined ? _data["deadlineForUpdatingBeforeBookingPeriod"] : null as any;
            this.deadlineForUpdatingBeforeBookingPeriodTimeUnit = _data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] !== undefined ? _data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] : null as any;
            this.maximumBookingAdvanceTimeInDay = _data["maximumBookingAdvanceTimeInDay"] !== undefined ? _data["maximumBookingAdvanceTimeInDay"] : null as any;
            this.recurrentBookingAvailable = _data["recurrentBookingAvailable"] !== undefined ? _data["recurrentBookingAvailable"] : null as any;
            this.defaultCalendarDisplayMode = _data["defaultCalendarDisplayMode"] !== undefined ? _data["defaultCalendarDisplayMode"] : null as any;
            this.displayCustomerCards = _data["displayCustomerCards"] !== undefined ? _data["displayCustomerCards"] : null as any;
            this.displayCustomerBoats = _data["displayCustomerBoats"] !== undefined ? _data["displayCustomerBoats"] : null as any;
        }
    }

    static fromJS(data: any): BookingServiceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingServiceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["bookingMode"] = this.bookingMode !== undefined ? this.bookingMode : null as any;
        data["initialBookingDuration"] = this.initialBookingDuration !== undefined ? this.initialBookingDuration : null as any;
        data["maxBookingDuration"] = this.maxBookingDuration !== undefined ? this.maxBookingDuration : null as any;
        data["bookingTimeUnit"] = this.bookingTimeUnit !== undefined ? this.bookingTimeUnit : null as any;
        data["maxNumberOfSimultaneousBookingByCustomer"] = this.maxNumberOfSimultaneousBookingByCustomer !== undefined ? this.maxNumberOfSimultaneousBookingByCustomer : null as any;
        data["maxNumberOfPlannedBookingByCustomer"] = this.maxNumberOfPlannedBookingByCustomer !== undefined ? this.maxNumberOfPlannedBookingByCustomer : null as any;
        data["deadlineForUpdatingBeforeBookingPeriod"] = this.deadlineForUpdatingBeforeBookingPeriod !== undefined ? this.deadlineForUpdatingBeforeBookingPeriod : null as any;
        data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] = this.deadlineForUpdatingBeforeBookingPeriodTimeUnit !== undefined ? this.deadlineForUpdatingBeforeBookingPeriodTimeUnit : null as any;
        data["maximumBookingAdvanceTimeInDay"] = this.maximumBookingAdvanceTimeInDay !== undefined ? this.maximumBookingAdvanceTimeInDay : null as any;
        data["recurrentBookingAvailable"] = this.recurrentBookingAvailable !== undefined ? this.recurrentBookingAvailable : null as any;
        data["defaultCalendarDisplayMode"] = this.defaultCalendarDisplayMode !== undefined ? this.defaultCalendarDisplayMode : null as any;
        data["displayCustomerCards"] = this.displayCustomerCards !== undefined ? this.displayCustomerCards : null as any;
        data["displayCustomerBoats"] = this.displayCustomerBoats !== undefined ? this.displayCustomerBoats : null as any;
        return data;
    }
}

export interface IBookingServiceConfigDto {
    id?: string;
    serviceId?: string;
    bookingMode?: BookingMode;
    initialBookingDuration?: number;
    maxBookingDuration?: number;
    bookingTimeUnit?: BookingTimeUnit;
    maxNumberOfSimultaneousBookingByCustomer?: number;
    maxNumberOfPlannedBookingByCustomer?: number;
    deadlineForUpdatingBeforeBookingPeriod?: number;
    deadlineForUpdatingBeforeBookingPeriodTimeUnit?: BookingTimeUnit;
    maximumBookingAdvanceTimeInDay?: number | null;
    recurrentBookingAvailable?: boolean;
    defaultCalendarDisplayMode?: BookingCalendarMode;
    displayCustomerCards?: boolean;
    displayCustomerBoats?: boolean;
}

export enum BookingMode {
    Free = "Free",
    Slots = "Slots",
}

export enum BookingTimeUnit {
    Minute = "Minute",
    Hour = "Hour",
    Day = "Day",
    Month = "Month",
    Year = "Year",
}

export enum BookingCalendarMode {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Planning = "Planning",
}

export class BookingServiceConfigInputDto implements IBookingServiceConfigInputDto {
    bookingMode?: BookingMode;
    initialBookingDuration?: number;
    maxBookingDuration?: number;
    bookingTimeUnit?: BookingTimeUnit;
    maxNumberOfSimultaneousBookingByCustomer?: number;
    maxNumberOfPlannedBookingByCustomer?: number;
    deadlineForUpdatingBeforeBookingPeriod?: number;
    deadlineForUpdatingBeforeBookingPeriodTimeUnit?: BookingTimeUnit;
    maximumBookingAdvanceTimeInDay?: number | null;
    recurrentBookingAvailable?: boolean;
    defaultCalendarDisplayMode?: BookingCalendarMode;
    displayCustomerCards?: boolean;
    displayCustomerBoats?: boolean;

    constructor(data?: IBookingServiceConfigInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingMode = _data["bookingMode"] !== undefined ? _data["bookingMode"] : null as any;
            this.initialBookingDuration = _data["initialBookingDuration"] !== undefined ? _data["initialBookingDuration"] : null as any;
            this.maxBookingDuration = _data["maxBookingDuration"] !== undefined ? _data["maxBookingDuration"] : null as any;
            this.bookingTimeUnit = _data["bookingTimeUnit"] !== undefined ? _data["bookingTimeUnit"] : null as any;
            this.maxNumberOfSimultaneousBookingByCustomer = _data["maxNumberOfSimultaneousBookingByCustomer"] !== undefined ? _data["maxNumberOfSimultaneousBookingByCustomer"] : null as any;
            this.maxNumberOfPlannedBookingByCustomer = _data["maxNumberOfPlannedBookingByCustomer"] !== undefined ? _data["maxNumberOfPlannedBookingByCustomer"] : null as any;
            this.deadlineForUpdatingBeforeBookingPeriod = _data["deadlineForUpdatingBeforeBookingPeriod"] !== undefined ? _data["deadlineForUpdatingBeforeBookingPeriod"] : null as any;
            this.deadlineForUpdatingBeforeBookingPeriodTimeUnit = _data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] !== undefined ? _data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] : null as any;
            this.maximumBookingAdvanceTimeInDay = _data["maximumBookingAdvanceTimeInDay"] !== undefined ? _data["maximumBookingAdvanceTimeInDay"] : null as any;
            this.recurrentBookingAvailable = _data["recurrentBookingAvailable"] !== undefined ? _data["recurrentBookingAvailable"] : null as any;
            this.defaultCalendarDisplayMode = _data["defaultCalendarDisplayMode"] !== undefined ? _data["defaultCalendarDisplayMode"] : null as any;
            this.displayCustomerCards = _data["displayCustomerCards"] !== undefined ? _data["displayCustomerCards"] : null as any;
            this.displayCustomerBoats = _data["displayCustomerBoats"] !== undefined ? _data["displayCustomerBoats"] : null as any;
        }
    }

    static fromJS(data: any): BookingServiceConfigInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingServiceConfigInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingMode"] = this.bookingMode !== undefined ? this.bookingMode : null as any;
        data["initialBookingDuration"] = this.initialBookingDuration !== undefined ? this.initialBookingDuration : null as any;
        data["maxBookingDuration"] = this.maxBookingDuration !== undefined ? this.maxBookingDuration : null as any;
        data["bookingTimeUnit"] = this.bookingTimeUnit !== undefined ? this.bookingTimeUnit : null as any;
        data["maxNumberOfSimultaneousBookingByCustomer"] = this.maxNumberOfSimultaneousBookingByCustomer !== undefined ? this.maxNumberOfSimultaneousBookingByCustomer : null as any;
        data["maxNumberOfPlannedBookingByCustomer"] = this.maxNumberOfPlannedBookingByCustomer !== undefined ? this.maxNumberOfPlannedBookingByCustomer : null as any;
        data["deadlineForUpdatingBeforeBookingPeriod"] = this.deadlineForUpdatingBeforeBookingPeriod !== undefined ? this.deadlineForUpdatingBeforeBookingPeriod : null as any;
        data["deadlineForUpdatingBeforeBookingPeriodTimeUnit"] = this.deadlineForUpdatingBeforeBookingPeriodTimeUnit !== undefined ? this.deadlineForUpdatingBeforeBookingPeriodTimeUnit : null as any;
        data["maximumBookingAdvanceTimeInDay"] = this.maximumBookingAdvanceTimeInDay !== undefined ? this.maximumBookingAdvanceTimeInDay : null as any;
        data["recurrentBookingAvailable"] = this.recurrentBookingAvailable !== undefined ? this.recurrentBookingAvailable : null as any;
        data["defaultCalendarDisplayMode"] = this.defaultCalendarDisplayMode !== undefined ? this.defaultCalendarDisplayMode : null as any;
        data["displayCustomerCards"] = this.displayCustomerCards !== undefined ? this.displayCustomerCards : null as any;
        data["displayCustomerBoats"] = this.displayCustomerBoats !== undefined ? this.displayCustomerBoats : null as any;
        return data;
    }
}

export interface IBookingServiceConfigInputDto {
    bookingMode?: BookingMode;
    initialBookingDuration?: number;
    maxBookingDuration?: number;
    bookingTimeUnit?: BookingTimeUnit;
    maxNumberOfSimultaneousBookingByCustomer?: number;
    maxNumberOfPlannedBookingByCustomer?: number;
    deadlineForUpdatingBeforeBookingPeriod?: number;
    deadlineForUpdatingBeforeBookingPeriodTimeUnit?: BookingTimeUnit;
    maximumBookingAdvanceTimeInDay?: number | null;
    recurrentBookingAvailable?: boolean;
    defaultCalendarDisplayMode?: BookingCalendarMode;
    displayCustomerCards?: boolean;
    displayCustomerBoats?: boolean;
}

export class BookingSlotDto implements IBookingSlotDto {
    id?: number;
    itemToBookId?: string;
    booking?: BookingLightDto | null;
    date?: Date;
    startTime?: string;
    endTime?: string;
    state?: BookingSlotState;

    constructor(data?: IBookingSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.itemToBookId = _data["itemToBookId"] !== undefined ? _data["itemToBookId"] : null as any;
            this.booking = _data["booking"] ? BookingLightDto.fromJS(_data["booking"]) : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): BookingSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["itemToBookId"] = this.itemToBookId !== undefined ? this.itemToBookId : null as any;
        data["booking"] = this.booking ? this.booking.toJSON() : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IBookingSlotDto {
    id?: number;
    itemToBookId?: string;
    booking?: BookingLightDto | null;
    date?: Date;
    startTime?: string;
    endTime?: string;
    state?: BookingSlotState;
}

export enum BookingSlotState {
    Free = "Free",
    Booked = "Booked",
    Blocked = "Blocked",
    Paid = "Paid",
    PreBooked = "PreBooked",
}

export class BookingSlotInputDto implements IBookingSlotInputDto {
    startTime?: string;
    endTime?: string;
    state?: BookingSlotState;

    constructor(data?: IBookingSlotInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): BookingSlotInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSlotInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IBookingSlotInputDto {
    startTime?: string;
    endTime?: string;
    state?: BookingSlotState;
}

export class GeneratingBookingSlotsOutputDto implements IGeneratingBookingSlotsOutputDto {
    numberOfCreatedSlots?: number;
    numberOfAbortedSlots?: number;

    constructor(data?: IGeneratingBookingSlotsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfCreatedSlots = _data["numberOfCreatedSlots"] !== undefined ? _data["numberOfCreatedSlots"] : null as any;
            this.numberOfAbortedSlots = _data["numberOfAbortedSlots"] !== undefined ? _data["numberOfAbortedSlots"] : null as any;
        }
    }

    static fromJS(data: any): GeneratingBookingSlotsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratingBookingSlotsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfCreatedSlots"] = this.numberOfCreatedSlots !== undefined ? this.numberOfCreatedSlots : null as any;
        data["numberOfAbortedSlots"] = this.numberOfAbortedSlots !== undefined ? this.numberOfAbortedSlots : null as any;
        return data;
    }
}

export interface IGeneratingBookingSlotsOutputDto {
    numberOfCreatedSlots?: number;
    numberOfAbortedSlots?: number;
}

export class GeneratingBookingSlotsInputDto implements IGeneratingBookingSlotsInputDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    lastStartTimeOfTheDay?: string;
    duration?: string;
    days?: Day[];
    state?: BookingSlotState;

    constructor(data?: IGeneratingBookingSlotsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.lastStartTimeOfTheDay = _data["lastStartTimeOfTheDay"] !== undefined ? _data["lastStartTimeOfTheDay"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            else {
                this.days = null as any;
            }
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): GeneratingBookingSlotsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratingBookingSlotsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["lastStartTimeOfTheDay"] = this.lastStartTimeOfTheDay !== undefined ? this.lastStartTimeOfTheDay : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IGeneratingBookingSlotsInputDto {
    startDate?: Date;
    endDate?: Date;
    startTime?: string;
    lastStartTimeOfTheDay?: string;
    duration?: string;
    days?: Day[];
    state?: BookingSlotState;
}

export class PagedResultDtoOfBillingDto implements IPagedResultDtoOfBillingDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: BillingDto[];

    constructor(data?: IPagedResultDtoOfBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BillingDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfBillingDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: BillingDto[];
}

export class BillingDto implements IBillingDto {
    id?: string;
    transactionId?: string;
    customerId?: string | null;
    customer?: string | null;
    codeBillingNumber?: string | null;
    toBillDate?: Date | null;
    billedDate?: Date | null;
    paidDate?: Date | null;
    cancelledDate?: Date | null;
    state?: BillingState;
    amount?: number;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;

    constructor(data?: IBillingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.codeBillingNumber = _data["codeBillingNumber"] !== undefined ? _data["codeBillingNumber"] : null as any;
            this.toBillDate = _data["toBillDate"] ? new Date(_data["toBillDate"].toString()) : null as any;
            this.billedDate = _data["billedDate"] ? new Date(_data["billedDate"].toString()) : null as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : null as any;
            this.cancelledDate = _data["cancelledDate"] ? new Date(_data["cancelledDate"].toString()) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.visitorFirstName = _data["visitorFirstName"] !== undefined ? _data["visitorFirstName"] : null as any;
            this.visitorLastName = _data["visitorLastName"] !== undefined ? _data["visitorLastName"] : null as any;
            this.visitorEmail = _data["visitorEmail"] !== undefined ? _data["visitorEmail"] : null as any;
            this.visitorMobilePhone = _data["visitorMobilePhone"] !== undefined ? _data["visitorMobilePhone"] : null as any;
            this.visitorStreet = _data["visitorStreet"] !== undefined ? _data["visitorStreet"] : null as any;
            this.visitorPostalCode = _data["visitorPostalCode"] !== undefined ? _data["visitorPostalCode"] : null as any;
            this.visitorCity = _data["visitorCity"] !== undefined ? _data["visitorCity"] : null as any;
            this.visitorCountry = _data["visitorCountry"] !== undefined ? _data["visitorCountry"] : null as any;
        }
    }

    static fromJS(data: any): BillingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["codeBillingNumber"] = this.codeBillingNumber !== undefined ? this.codeBillingNumber : null as any;
        data["toBillDate"] = this.toBillDate ? this.toBillDate.toISOString() : null as any;
        data["billedDate"] = this.billedDate ? this.billedDate.toISOString() : null as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : null as any;
        data["cancelledDate"] = this.cancelledDate ? this.cancelledDate.toISOString() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["visitorFirstName"] = this.visitorFirstName !== undefined ? this.visitorFirstName : null as any;
        data["visitorLastName"] = this.visitorLastName !== undefined ? this.visitorLastName : null as any;
        data["visitorEmail"] = this.visitorEmail !== undefined ? this.visitorEmail : null as any;
        data["visitorMobilePhone"] = this.visitorMobilePhone !== undefined ? this.visitorMobilePhone : null as any;
        data["visitorStreet"] = this.visitorStreet !== undefined ? this.visitorStreet : null as any;
        data["visitorPostalCode"] = this.visitorPostalCode !== undefined ? this.visitorPostalCode : null as any;
        data["visitorCity"] = this.visitorCity !== undefined ? this.visitorCity : null as any;
        data["visitorCountry"] = this.visitorCountry !== undefined ? this.visitorCountry : null as any;
        return data;
    }
}

export interface IBillingDto {
    id?: string;
    transactionId?: string;
    customerId?: string | null;
    customer?: string | null;
    codeBillingNumber?: string | null;
    toBillDate?: Date | null;
    billedDate?: Date | null;
    paidDate?: Date | null;
    cancelledDate?: Date | null;
    state?: BillingState;
    amount?: number;
    visitorFirstName?: string | null;
    visitorLastName?: string | null;
    visitorEmail?: string | null;
    visitorMobilePhone?: string | null;
    visitorStreet?: string | null;
    visitorPostalCode?: string | null;
    visitorCity?: string | null;
    visitorCountry?: string | null;
}

export enum BillingState {
    ToBill = "ToBill",
    Billed = "Billed",
    Paid = "Paid",
    Cancelled = "Cancelled",
}

export class PageableRequestDtoOfBillingCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfBillingCriteriaDto {
    criteria?: BillingCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfBillingCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? BillingCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfBillingCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfBillingCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfBillingCriteriaDto extends IPageableRequestDto {
    criteria?: BillingCriteriaDto | null;
}

export class BillingCriteriaDto implements IBillingCriteriaDto {
    searchCriteriaDto?: BillingSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;

    constructor(data?: IBillingCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCriteriaDto = _data["searchCriteriaDto"] ? BillingSearchCriteriaDto.fromJS(_data["searchCriteriaDto"]) : null as any;
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
        }
    }

    static fromJS(data: any): BillingCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCriteriaDto"] = this.searchCriteriaDto ? this.searchCriteriaDto.toJSON() : null as any;
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        return data;
    }
}

export interface IBillingCriteriaDto {
    searchCriteriaDto?: BillingSearchCriteriaDto | null;
    sortCriteriaDto?: SortCriteriaDto | null;
}

export class BillingSearchCriteriaDto implements IBillingSearchCriteriaDto {
    codeBillingNumber?: string | null;
    state?: BillingState | null;
    customerId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;

    constructor(data?: IBillingSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeBillingNumber = _data["codeBillingNumber"] !== undefined ? _data["codeBillingNumber"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.amountFrom = _data["amountFrom"] !== undefined ? _data["amountFrom"] : null as any;
            this.amountTo = _data["amountTo"] !== undefined ? _data["amountTo"] : null as any;
        }
    }

    static fromJS(data: any): BillingSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeBillingNumber"] = this.codeBillingNumber !== undefined ? this.codeBillingNumber : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["amountFrom"] = this.amountFrom !== undefined ? this.amountFrom : null as any;
        data["amountTo"] = this.amountTo !== undefined ? this.amountTo : null as any;
        return data;
    }
}

export interface IBillingSearchCriteriaDto {
    codeBillingNumber?: string | null;
    state?: BillingState | null;
    customerId?: string | null;
    from?: Date | null;
    to?: Date | null;
    amountFrom?: number | null;
    amountTo?: number | null;
}

export class BillingStateDto implements IBillingStateDto {
    id?: string;
    dateTime?: Date;
    state?: BillingState;

    constructor(data?: IBillingStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
        }
    }

    static fromJS(data: any): BillingStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        return data;
    }
}

export interface IBillingStateDto {
    id?: string;
    dateTime?: Date;
    state?: BillingState;
}

export class SearchBackofficeDto implements ISearchBackofficeDto {
    id?: string;
    firstName?: string;
    lastName?: string;

    constructor(data?: ISearchBackofficeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): SearchBackofficeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBackofficeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

export interface ISearchBackofficeDto {
    id?: string;
    firstName?: string;
    lastName?: string;
}

export class SearchBackofficeCriteriaDto implements ISearchBackofficeCriteriaDto {
    searchTerm?: string | null;
    permissionKeys?: string[];

    constructor(data?: ISearchBackofficeCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : null as any;
            if (Array.isArray(_data["permissionKeys"])) {
                this.permissionKeys = [] as any;
                for (let item of _data["permissionKeys"])
                    this.permissionKeys!.push(item);
            }
            else {
                this.permissionKeys = null as any;
            }
        }
    }

    static fromJS(data: any): SearchBackofficeCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchBackofficeCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : null as any;
        if (Array.isArray(this.permissionKeys)) {
            data["permissionKeys"] = [];
            for (let item of this.permissionKeys)
                data["permissionKeys"].push(item);
        }
        return data;
    }
}

export interface ISearchBackofficeCriteriaDto {
    searchTerm?: string | null;
    permissionKeys?: string[];
}

export class BackofficeInputDto implements IBackofficeInputDto {
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    accountEnabled?: boolean;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    birthDate?: Date | null;
    phonePrivate?: string | null;
    phoneMobile?: string | null;
    phoneProfessional?: string | null;
    comment?: string | null;
    permissions?: PermissionDto[];

    constructor(data?: IBackofficeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.accountEnabled = _data["accountEnabled"] !== undefined ? _data["accountEnabled"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): BackofficeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["accountEnabled"] = this.accountEnabled !== undefined ? this.accountEnabled : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBackofficeInputDto {
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    accountEnabled?: boolean;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    birthDate?: Date | null;
    phonePrivate?: string | null;
    phoneMobile?: string | null;
    phoneProfessional?: string | null;
    comment?: string | null;
    permissions?: PermissionDto[];
}

export class BackofficeMeDto implements IBackofficeMeDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    superAdmin?: boolean;
    permissions?: PermissionDto[];

    constructor(data?: IBackofficeMeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
            this.superAdmin = _data["superAdmin"] !== undefined ? _data["superAdmin"] : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDto.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): BackofficeMeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeMeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        data["superAdmin"] = this.superAdmin !== undefined ? this.superAdmin : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBackofficeMeDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
    superAdmin?: boolean;
    permissions?: PermissionDto[];
}

export class PagedResultDtoOfBackofficeAuditEntryDto implements IPagedResultDtoOfBackofficeAuditEntryDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: BackofficeAuditEntryDto[];

    constructor(data?: IPagedResultDtoOfBackofficeAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BackofficeAuditEntryDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBackofficeAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBackofficeAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfBackofficeAuditEntryDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: BackofficeAuditEntryDto[];
}

export class BackofficeAuditEntryDto implements IBackofficeAuditEntryDto {
    changeType?: BackofficeAuditEntryPropertyChangeType;
    modificationUser?: string;
    modificationDate?: Date;
    properties?: BackofficeAuditEntryPropertyDto[];
    permissionKey?: string | null;
    permissionLabelFR?: string | null;
    permissionLabelEN?: string | null;
    permissionLabelDE?: string | null;
    permissionLabelIT?: string | null;

    constructor(data?: IBackofficeAuditEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeType = _data["changeType"] !== undefined ? _data["changeType"] : null as any;
            this.modificationUser = _data["modificationUser"] !== undefined ? _data["modificationUser"] : null as any;
            this.modificationDate = _data["modificationDate"] ? new Date(_data["modificationDate"].toString()) : null as any;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(BackofficeAuditEntryPropertyDto.fromJS(item));
            }
            else {
                this.properties = null as any;
            }
            this.permissionKey = _data["permissionKey"] !== undefined ? _data["permissionKey"] : null as any;
            this.permissionLabelFR = _data["permissionLabelFR"] !== undefined ? _data["permissionLabelFR"] : null as any;
            this.permissionLabelEN = _data["permissionLabelEN"] !== undefined ? _data["permissionLabelEN"] : null as any;
            this.permissionLabelDE = _data["permissionLabelDE"] !== undefined ? _data["permissionLabelDE"] : null as any;
            this.permissionLabelIT = _data["permissionLabelIT"] !== undefined ? _data["permissionLabelIT"] : null as any;
        }
    }

    static fromJS(data: any): BackofficeAuditEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeAuditEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeType"] = this.changeType !== undefined ? this.changeType : null as any;
        data["modificationUser"] = this.modificationUser !== undefined ? this.modificationUser : null as any;
        data["modificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : null as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : null as any);
        }
        data["permissionKey"] = this.permissionKey !== undefined ? this.permissionKey : null as any;
        data["permissionLabelFR"] = this.permissionLabelFR !== undefined ? this.permissionLabelFR : null as any;
        data["permissionLabelEN"] = this.permissionLabelEN !== undefined ? this.permissionLabelEN : null as any;
        data["permissionLabelDE"] = this.permissionLabelDE !== undefined ? this.permissionLabelDE : null as any;
        data["permissionLabelIT"] = this.permissionLabelIT !== undefined ? this.permissionLabelIT : null as any;
        return data;
    }
}

export interface IBackofficeAuditEntryDto {
    changeType?: BackofficeAuditEntryPropertyChangeType;
    modificationUser?: string;
    modificationDate?: Date;
    properties?: BackofficeAuditEntryPropertyDto[];
    permissionKey?: string | null;
    permissionLabelFR?: string | null;
    permissionLabelEN?: string | null;
    permissionLabelDE?: string | null;
    permissionLabelIT?: string | null;
}

export enum BackofficeAuditEntryPropertyChangeType {
    Unknown = "Unknown",
    PropertyChange = "PropertyChange",
    PermissionAssignment = "PermissionAssignment",
    PermissionUnassignment = "PermissionUnassignment",
    BackofficeCreation = "BackofficeCreation",
}

export class BackofficeAuditEntryPropertyDto implements IBackofficeAuditEntryPropertyDto {
    propertyName?: string;
    oldValue?: string | null;
    newValue?: string | null;

    constructor(data?: IBackofficeAuditEntryPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"] !== undefined ? _data["propertyName"] : null as any;
            this.oldValue = _data["oldValue"] !== undefined ? _data["oldValue"] : null as any;
            this.newValue = _data["newValue"] !== undefined ? _data["newValue"] : null as any;
        }
    }

    static fromJS(data: any): BackofficeAuditEntryPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeAuditEntryPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName !== undefined ? this.propertyName : null as any;
        data["oldValue"] = this.oldValue !== undefined ? this.oldValue : null as any;
        data["newValue"] = this.newValue !== undefined ? this.newValue : null as any;
        return data;
    }
}

export interface IBackofficeAuditEntryPropertyDto {
    propertyName?: string;
    oldValue?: string | null;
    newValue?: string | null;
}

export class BackofficeMeInputDto implements IBackofficeMeInputDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;

    constructor(data?: IBackofficeMeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.phoneMobile = _data["phoneMobile"] !== undefined ? _data["phoneMobile"] : null as any;
            this.phonePrivate = _data["phonePrivate"] !== undefined ? _data["phonePrivate"] : null as any;
            this.phoneProfessional = _data["phoneProfessional"] !== undefined ? _data["phoneProfessional"] : null as any;
        }
    }

    static fromJS(data: any): BackofficeMeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackofficeMeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["phoneMobile"] = this.phoneMobile !== undefined ? this.phoneMobile : null as any;
        data["phonePrivate"] = this.phonePrivate !== undefined ? this.phonePrivate : null as any;
        data["phoneProfessional"] = this.phoneProfessional !== undefined ? this.phoneProfessional : null as any;
        return data;
    }
}

export interface IBackofficeMeInputDto {
    id?: string;
    title?: Title;
    firstName?: string;
    lastName?: string;
    email?: string;
    birthDate?: Date | null;
    street?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    phoneMobile?: string | null;
    phonePrivate?: string | null;
    phoneProfessional?: string | null;
}

export class PagedResultDtoOfAlertLightDto implements IPagedResultDtoOfAlertLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertLightDto[];

    constructor(data?: IPagedResultDtoOfAlertLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlertLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlertLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlertLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlertLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertLightDto[];
}

export class AlertLightDto implements IAlertLightDto {
    id?: number;
    alertClassification?: AlarmClassification;
    appearedDateTime?: Date;
    deviceDesignationFR?: string;
    deviceDesignationDE?: string;
    deviceDesignationEN?: string;
    deviceDesignationIT?: string;
    location?: string;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;

    constructor(data?: IAlertLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.alertClassification = _data["alertClassification"] !== undefined ? _data["alertClassification"] : null as any;
            this.appearedDateTime = _data["appearedDateTime"] ? new Date(_data["appearedDateTime"].toString()) : null as any;
            this.deviceDesignationFR = _data["deviceDesignationFR"] !== undefined ? _data["deviceDesignationFR"] : null as any;
            this.deviceDesignationDE = _data["deviceDesignationDE"] !== undefined ? _data["deviceDesignationDE"] : null as any;
            this.deviceDesignationEN = _data["deviceDesignationEN"] !== undefined ? _data["deviceDesignationEN"] : null as any;
            this.deviceDesignationIT = _data["deviceDesignationIT"] !== undefined ? _data["deviceDesignationIT"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
        }
    }

    static fromJS(data: any): AlertLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["alertClassification"] = this.alertClassification !== undefined ? this.alertClassification : null as any;
        data["appearedDateTime"] = this.appearedDateTime ? this.appearedDateTime.toISOString() : null as any;
        data["deviceDesignationFR"] = this.deviceDesignationFR !== undefined ? this.deviceDesignationFR : null as any;
        data["deviceDesignationDE"] = this.deviceDesignationDE !== undefined ? this.deviceDesignationDE : null as any;
        data["deviceDesignationEN"] = this.deviceDesignationEN !== undefined ? this.deviceDesignationEN : null as any;
        data["deviceDesignationIT"] = this.deviceDesignationIT !== undefined ? this.deviceDesignationIT : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        return data;
    }
}

export interface IAlertLightDto {
    id?: number;
    alertClassification?: AlarmClassification;
    appearedDateTime?: Date;
    deviceDesignationFR?: string;
    deviceDesignationDE?: string;
    deviceDesignationEN?: string;
    deviceDesignationIT?: string;
    location?: string;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
}

export enum AlarmClassification {
    Unknown = "Unknown",
    Urgent = "Urgent",
    NotUrgent = "NotUrgent",
    Event = "Event",
}

export enum AlertComparisonSymbol {
    Unknown = "Unknown",
    LessThan = "LessThan",
    Equal = "Equal",
    NotEqual = "NotEqual",
    GreaterThan = "GreaterThan",
}

export class PageableRequestDtoOfAlertSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlertSearchCriteriaDto {
    criteria?: AlertSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlertSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlertSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlertSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlertSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlertSearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlertSearchCriteriaDto | null;
}

export class AlertSearchCriteriaDto implements IAlertSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    from?: Date | null;
    to?: Date | null;
    designation?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    threshold?: number | null;
    comparisonSymbol?: AlertComparisonSymbol | null;

    constructor(data?: IAlertSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
        }
    }

    static fromJS(data: any): AlertSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["designation"] = this.designation !== undefined ? this.designation : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        return data;
    }
}

export interface IAlertSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    from?: Date | null;
    to?: Date | null;
    designation?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    threshold?: number | null;
    comparisonSymbol?: AlertComparisonSymbol | null;
}

export class PagedResultDtoOfAlertHistoryLightDto implements IPagedResultDtoOfAlertHistoryLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertHistoryLightDto[];

    constructor(data?: IPagedResultDtoOfAlertHistoryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlertHistoryLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlertHistoryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlertHistoryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlertHistoryLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertHistoryLightDto[];
}

export class AlertHistoryLightDto implements IAlertHistoryLightDto {
    id?: number;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    equipmentFR?: string;
    equipmentDE?: string;
    equipmentEN?: string;
    equipmentIT?: string;
    appearedDateTime?: Date;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    releasedDateTime?: Date;
    releasedBackoffice?: string | null;

    constructor(data?: IAlertHistoryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.designationFR = _data["designationFR"] !== undefined ? _data["designationFR"] : null as any;
            this.designationDE = _data["designationDE"] !== undefined ? _data["designationDE"] : null as any;
            this.designationEN = _data["designationEN"] !== undefined ? _data["designationEN"] : null as any;
            this.designationIT = _data["designationIT"] !== undefined ? _data["designationIT"] : null as any;
            this.equipmentFR = _data["equipmentFR"] !== undefined ? _data["equipmentFR"] : null as any;
            this.equipmentDE = _data["equipmentDE"] !== undefined ? _data["equipmentDE"] : null as any;
            this.equipmentEN = _data["equipmentEN"] !== undefined ? _data["equipmentEN"] : null as any;
            this.equipmentIT = _data["equipmentIT"] !== undefined ? _data["equipmentIT"] : null as any;
            this.appearedDateTime = _data["appearedDateTime"] ? new Date(_data["appearedDateTime"].toString()) : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.releasedDateTime = _data["releasedDateTime"] ? new Date(_data["releasedDateTime"].toString()) : null as any;
            this.releasedBackoffice = _data["releasedBackoffice"] !== undefined ? _data["releasedBackoffice"] : null as any;
        }
    }

    static fromJS(data: any): AlertHistoryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertHistoryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["designationFR"] = this.designationFR !== undefined ? this.designationFR : null as any;
        data["designationDE"] = this.designationDE !== undefined ? this.designationDE : null as any;
        data["designationEN"] = this.designationEN !== undefined ? this.designationEN : null as any;
        data["designationIT"] = this.designationIT !== undefined ? this.designationIT : null as any;
        data["equipmentFR"] = this.equipmentFR !== undefined ? this.equipmentFR : null as any;
        data["equipmentDE"] = this.equipmentDE !== undefined ? this.equipmentDE : null as any;
        data["equipmentEN"] = this.equipmentEN !== undefined ? this.equipmentEN : null as any;
        data["equipmentIT"] = this.equipmentIT !== undefined ? this.equipmentIT : null as any;
        data["appearedDateTime"] = this.appearedDateTime ? this.appearedDateTime.toISOString() : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["releasedDateTime"] = this.releasedDateTime ? this.releasedDateTime.toISOString() : null as any;
        data["releasedBackoffice"] = this.releasedBackoffice !== undefined ? this.releasedBackoffice : null as any;
        return data;
    }
}

export interface IAlertHistoryLightDto {
    id?: number;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    equipmentFR?: string;
    equipmentDE?: string;
    equipmentEN?: string;
    equipmentIT?: string;
    appearedDateTime?: Date;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    releasedDateTime?: Date;
    releasedBackoffice?: string | null;
}

export class PageableRequestDtoOfAlertHistorySearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlertHistorySearchCriteriaDto {
    criteria?: AlertHistorySearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlertHistorySearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlertHistorySearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlertHistorySearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlertHistorySearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlertHistorySearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlertHistorySearchCriteriaDto | null;
}

export class AlertHistorySearchCriteriaDto implements IAlertHistorySearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    language?: string | null;
    appearedFrom?: Date | null;
    appearedTo?: Date | null;
    releasedFrom?: Date | null;
    releasedTo?: Date | null;
    releasedBackofficeId?: string | null;
    threshold?: number | null;
    comparisonSymbol?: AlertComparisonSymbol | null;

    constructor(data?: IAlertHistorySearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.appearedFrom = _data["appearedFrom"] ? new Date(_data["appearedFrom"].toString()) : null as any;
            this.appearedTo = _data["appearedTo"] ? new Date(_data["appearedTo"].toString()) : null as any;
            this.releasedFrom = _data["releasedFrom"] ? new Date(_data["releasedFrom"].toString()) : null as any;
            this.releasedTo = _data["releasedTo"] ? new Date(_data["releasedTo"].toString()) : null as any;
            this.releasedBackofficeId = _data["releasedBackofficeId"] !== undefined ? _data["releasedBackofficeId"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
        }
    }

    static fromJS(data: any): AlertHistorySearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertHistorySearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["appearedFrom"] = this.appearedFrom ? this.appearedFrom.toISOString() : null as any;
        data["appearedTo"] = this.appearedTo ? this.appearedTo.toISOString() : null as any;
        data["releasedFrom"] = this.releasedFrom ? this.releasedFrom.toISOString() : null as any;
        data["releasedTo"] = this.releasedTo ? this.releasedTo.toISOString() : null as any;
        data["releasedBackofficeId"] = this.releasedBackofficeId !== undefined ? this.releasedBackofficeId : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        return data;
    }
}

export interface IAlertHistorySearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    language?: string | null;
    appearedFrom?: Date | null;
    appearedTo?: Date | null;
    releasedFrom?: Date | null;
    releasedTo?: Date | null;
    releasedBackofficeId?: string | null;
    threshold?: number | null;
    comparisonSymbol?: AlertComparisonSymbol | null;
}

export class AlertDeviceDto implements IAlertDeviceDto {
    id?: string;
    iotRegisterId?: string;
    classification?: AlarmClassification;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    unit?: string;
    location?: string;
    comment?: string;
    active?: boolean;
    iotRegister?: IotRegisterDto;

    constructor(data?: IAlertDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.iotRegister = _data["iotRegister"] ? IotRegisterDto.fromJS(_data["iotRegister"]) : null as any;
        }
    }

    static fromJS(data: any): AlertDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["iotRegister"] = this.iotRegister ? this.iotRegister.toJSON() : null as any;
        return data;
    }
}

export interface IAlertDeviceDto {
    id?: string;
    iotRegisterId?: string;
    classification?: AlarmClassification;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    unit?: string;
    location?: string;
    comment?: string;
    active?: boolean;
    iotRegister?: IotRegisterDto;
}

export class AlertDeviceInputDto implements IAlertDeviceInputDto {
    iotRegisterId?: string;
    classification?: AlarmClassification;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    unit?: string;
    location?: string;
    comment?: string;
    active?: boolean;

    constructor(data?: IAlertDeviceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): AlertDeviceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDeviceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["unit"] = this.unit !== undefined ? this.unit : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }
}

export interface IAlertDeviceInputDto {
    iotRegisterId?: string;
    classification?: AlarmClassification;
    comparisonSymbol?: AlertComparisonSymbol;
    threshold?: number;
    unit?: string;
    location?: string;
    comment?: string;
    active?: boolean;
}

export class PagedResultDtoOfAlertDeviceDto implements IPagedResultDtoOfAlertDeviceDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertDeviceDto[];

    constructor(data?: IPagedResultDtoOfAlertDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlertDeviceDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlertDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlertDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlertDeviceDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlertDeviceDto[];
}

export class PageableRequestDtoOfAlertDeviceSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlertDeviceSearchCriteriaDto {
    criteria?: AlertDeviceSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlertDeviceSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlertDeviceSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlertDeviceSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlertDeviceSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlertDeviceSearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlertDeviceSearchCriteriaDto | null;
}

export class AlertDeviceSearchCriteriaDto implements IAlertDeviceSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    comparisonSymbol?: AlertComparisonSymbol | null;
    threshold?: number | null;
    active?: boolean | null;

    constructor(data?: IAlertDeviceSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.comparisonSymbol = _data["comparisonSymbol"] !== undefined ? _data["comparisonSymbol"] : null as any;
            this.threshold = _data["threshold"] !== undefined ? _data["threshold"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): AlertDeviceSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDeviceSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["comparisonSymbol"] = this.comparisonSymbol !== undefined ? this.comparisonSymbol : null as any;
        data["threshold"] = this.threshold !== undefined ? this.threshold : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }
}

export interface IAlertDeviceSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    comparisonSymbol?: AlertComparisonSymbol | null;
    threshold?: number | null;
    active?: boolean | null;
}

export class AlarmDto implements IAlarmDto {
    id?: number;
    appearedDateTime?: Date;
    inProgressDateTime?: Date | null;
    releasedDateTime?: Date | null;
    alarmState?: AlarmState;
    code?: string | null;
    description?: string | null;
    value?: string | null;
    alarmDevice?: AlarmDeviceDto;
    alarmEvents?: AlarmEventDto[];
    technicalEvents?: AlarmTechnicalEventDto[];

    constructor(data?: IAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.appearedDateTime = _data["appearedDateTime"] ? new Date(_data["appearedDateTime"].toString()) : null as any;
            this.inProgressDateTime = _data["inProgressDateTime"] ? new Date(_data["inProgressDateTime"].toString()) : null as any;
            this.releasedDateTime = _data["releasedDateTime"] ? new Date(_data["releasedDateTime"].toString()) : null as any;
            this.alarmState = _data["alarmState"] !== undefined ? _data["alarmState"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.alarmDevice = _data["alarmDevice"] ? AlarmDeviceDto.fromJS(_data["alarmDevice"]) : null as any;
            if (Array.isArray(_data["alarmEvents"])) {
                this.alarmEvents = [] as any;
                for (let item of _data["alarmEvents"])
                    this.alarmEvents!.push(AlarmEventDto.fromJS(item));
            }
            else {
                this.alarmEvents = null as any;
            }
            if (Array.isArray(_data["technicalEvents"])) {
                this.technicalEvents = [] as any;
                for (let item of _data["technicalEvents"])
                    this.technicalEvents!.push(AlarmTechnicalEventDto.fromJS(item));
            }
            else {
                this.technicalEvents = null as any;
            }
        }
    }

    static fromJS(data: any): AlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["appearedDateTime"] = this.appearedDateTime ? this.appearedDateTime.toISOString() : null as any;
        data["inProgressDateTime"] = this.inProgressDateTime ? this.inProgressDateTime.toISOString() : null as any;
        data["releasedDateTime"] = this.releasedDateTime ? this.releasedDateTime.toISOString() : null as any;
        data["alarmState"] = this.alarmState !== undefined ? this.alarmState : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["alarmDevice"] = this.alarmDevice ? this.alarmDevice.toJSON() : null as any;
        if (Array.isArray(this.alarmEvents)) {
            data["alarmEvents"] = [];
            for (let item of this.alarmEvents)
                data["alarmEvents"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.technicalEvents)) {
            data["technicalEvents"] = [];
            for (let item of this.technicalEvents)
                data["technicalEvents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAlarmDto {
    id?: number;
    appearedDateTime?: Date;
    inProgressDateTime?: Date | null;
    releasedDateTime?: Date | null;
    alarmState?: AlarmState;
    code?: string | null;
    description?: string | null;
    value?: string | null;
    alarmDevice?: AlarmDeviceDto;
    alarmEvents?: AlarmEventDto[];
    technicalEvents?: AlarmTechnicalEventDto[];
}

export enum AlarmState {
    Unknown = "Unknown",
    Active = "Active",
    InProgress = "InProgress",
    Solved = "Solved",
}

export class AlarmDeviceDto implements IAlarmDeviceDto {
    id?: string;
    iotRegisterId?: string;
    classification?: AlarmClassification;
    location?: string;
    comment?: string | null;
    active?: boolean;
    delayBetweenNotificationsInMinutes?: number;
    notificationLoop?: boolean;
    iotRegister?: IotRegisterDto;
    alarmDeviceReceivers?: AlarmDeviceReceiverDto[];

    constructor(data?: IAlarmDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.delayBetweenNotificationsInMinutes = _data["delayBetweenNotificationsInMinutes"] !== undefined ? _data["delayBetweenNotificationsInMinutes"] : null as any;
            this.notificationLoop = _data["notificationLoop"] !== undefined ? _data["notificationLoop"] : null as any;
            this.iotRegister = _data["iotRegister"] ? IotRegisterDto.fromJS(_data["iotRegister"]) : null as any;
            if (Array.isArray(_data["alarmDeviceReceivers"])) {
                this.alarmDeviceReceivers = [] as any;
                for (let item of _data["alarmDeviceReceivers"])
                    this.alarmDeviceReceivers!.push(AlarmDeviceReceiverDto.fromJS(item));
            }
            else {
                this.alarmDeviceReceivers = null as any;
            }
        }
    }

    static fromJS(data: any): AlarmDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["delayBetweenNotificationsInMinutes"] = this.delayBetweenNotificationsInMinutes !== undefined ? this.delayBetweenNotificationsInMinutes : null as any;
        data["notificationLoop"] = this.notificationLoop !== undefined ? this.notificationLoop : null as any;
        data["iotRegister"] = this.iotRegister ? this.iotRegister.toJSON() : null as any;
        if (Array.isArray(this.alarmDeviceReceivers)) {
            data["alarmDeviceReceivers"] = [];
            for (let item of this.alarmDeviceReceivers)
                data["alarmDeviceReceivers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAlarmDeviceDto {
    id?: string;
    iotRegisterId?: string;
    classification?: AlarmClassification;
    location?: string;
    comment?: string | null;
    active?: boolean;
    delayBetweenNotificationsInMinutes?: number;
    notificationLoop?: boolean;
    iotRegister?: IotRegisterDto;
    alarmDeviceReceivers?: AlarmDeviceReceiverDto[];
}

export class AlarmDeviceReceiverInputDto implements IAlarmDeviceReceiverInputDto {
    alarmDeviceId?: string;
    contactName?: string;
    email?: string;
    officeHourEnabled?: boolean;
    outsideOfficeHourEnabled?: boolean;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    receiverPosition?: number;

    constructor(data?: IAlarmDeviceReceiverInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmDeviceId = _data["alarmDeviceId"] !== undefined ? _data["alarmDeviceId"] : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.officeHourEnabled = _data["officeHourEnabled"] !== undefined ? _data["officeHourEnabled"] : null as any;
            this.outsideOfficeHourEnabled = _data["outsideOfficeHourEnabled"] !== undefined ? _data["outsideOfficeHourEnabled"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.mailNotificationEnabled = _data["mailNotificationEnabled"] !== undefined ? _data["mailNotificationEnabled"] : null as any;
            this.pushNotificationEnabled = _data["pushNotificationEnabled"] !== undefined ? _data["pushNotificationEnabled"] : null as any;
            this.receiverPosition = _data["receiverPosition"] !== undefined ? _data["receiverPosition"] : null as any;
        }
    }

    static fromJS(data: any): AlarmDeviceReceiverInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDeviceReceiverInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmDeviceId"] = this.alarmDeviceId !== undefined ? this.alarmDeviceId : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["officeHourEnabled"] = this.officeHourEnabled !== undefined ? this.officeHourEnabled : null as any;
        data["outsideOfficeHourEnabled"] = this.outsideOfficeHourEnabled !== undefined ? this.outsideOfficeHourEnabled : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["mailNotificationEnabled"] = this.mailNotificationEnabled !== undefined ? this.mailNotificationEnabled : null as any;
        data["pushNotificationEnabled"] = this.pushNotificationEnabled !== undefined ? this.pushNotificationEnabled : null as any;
        data["receiverPosition"] = this.receiverPosition !== undefined ? this.receiverPosition : null as any;
        return data;
    }
}

export interface IAlarmDeviceReceiverInputDto {
    alarmDeviceId?: string;
    contactName?: string;
    email?: string;
    officeHourEnabled?: boolean;
    outsideOfficeHourEnabled?: boolean;
    active?: boolean;
    mailNotificationEnabled?: boolean;
    pushNotificationEnabled?: boolean;
    receiverPosition?: number;
}

export class AlarmDeviceReceiverDto extends AlarmDeviceReceiverInputDto implements IAlarmDeviceReceiverDto {
    id?: string;

    constructor(data?: IAlarmDeviceReceiverDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static override fromJS(data: any): AlarmDeviceReceiverDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDeviceReceiverDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IAlarmDeviceReceiverDto extends IAlarmDeviceReceiverInputDto {
    id?: string;
}

export class AlarmEventDto implements IAlarmEventDto {
    id?: number;
    alarmEventType?: AlarmEventType;
    dateTime?: Date;
    contactName?: string | null;
    contactEmail?: string | null;
    backoffice?: BackofficeLightDto | null;

    constructor(data?: IAlarmEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.alarmEventType = _data["alarmEventType"] !== undefined ? _data["alarmEventType"] : null as any;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : null as any;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null as any;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : null as any;
            this.backoffice = _data["backoffice"] ? BackofficeLightDto.fromJS(_data["backoffice"]) : null as any;
        }
    }

    static fromJS(data: any): AlarmEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["alarmEventType"] = this.alarmEventType !== undefined ? this.alarmEventType : null as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : null as any;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null as any;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null as any;
        data["backoffice"] = this.backoffice ? this.backoffice.toJSON() : null as any;
        return data;
    }
}

export interface IAlarmEventDto {
    id?: number;
    alarmEventType?: AlarmEventType;
    dateTime?: Date;
    contactName?: string | null;
    contactEmail?: string | null;
    backoffice?: BackofficeLightDto | null;
}

export enum AlarmEventType {
    Unknown = "Unknown",
    Appeared = "Appeared",
    InProgress = "InProgress",
    Released = "Released",
    NotificationEmail = "NotificationEmail",
    NotificationPush = "NotificationPush",
}

export class AlarmTechnicalEventDto implements IAlarmTechnicalEventDto {
    sourceEventId?: string;
    creationDateTime?: Date;
    technicalCode?: string;
    description?: string | null;
    value?: string | null;
    originatorComponentName?: string | null;
    originatorComponentId?: string | null;

    constructor(data?: IAlarmTechnicalEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEventId = _data["sourceEventId"] !== undefined ? _data["sourceEventId"] : null as any;
            this.creationDateTime = _data["creationDateTime"] ? new Date(_data["creationDateTime"].toString()) : null as any;
            this.technicalCode = _data["technicalCode"] !== undefined ? _data["technicalCode"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.originatorComponentName = _data["originatorComponentName"] !== undefined ? _data["originatorComponentName"] : null as any;
            this.originatorComponentId = _data["originatorComponentId"] !== undefined ? _data["originatorComponentId"] : null as any;
        }
    }

    static fromJS(data: any): AlarmTechnicalEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmTechnicalEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEventId"] = this.sourceEventId !== undefined ? this.sourceEventId : null as any;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : null as any;
        data["technicalCode"] = this.technicalCode !== undefined ? this.technicalCode : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["originatorComponentName"] = this.originatorComponentName !== undefined ? this.originatorComponentName : null as any;
        data["originatorComponentId"] = this.originatorComponentId !== undefined ? this.originatorComponentId : null as any;
        return data;
    }
}

export interface IAlarmTechnicalEventDto {
    sourceEventId?: string;
    creationDateTime?: Date;
    technicalCode?: string;
    description?: string | null;
    value?: string | null;
    originatorComponentName?: string | null;
    originatorComponentId?: string | null;
}

export class PagedResultDtoOfAlarmLightDto implements IPagedResultDtoOfAlarmLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmLightDto[];

    constructor(data?: IPagedResultDtoOfAlarmLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlarmLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlarmLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlarmLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlarmLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmLightDto[];
}

export class AlarmLightDto implements IAlarmLightDto {
    id?: number;
    alarmClassification?: AlarmClassification;
    appearedDateTime?: Date;
    alarmState?: AlarmState;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    location?: string;

    constructor(data?: IAlarmLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.alarmClassification = _data["alarmClassification"] !== undefined ? _data["alarmClassification"] : null as any;
            this.appearedDateTime = _data["appearedDateTime"] ? new Date(_data["appearedDateTime"].toString()) : null as any;
            this.alarmState = _data["alarmState"] !== undefined ? _data["alarmState"] : null as any;
            this.designationFR = _data["designationFR"] !== undefined ? _data["designationFR"] : null as any;
            this.designationDE = _data["designationDE"] !== undefined ? _data["designationDE"] : null as any;
            this.designationEN = _data["designationEN"] !== undefined ? _data["designationEN"] : null as any;
            this.designationIT = _data["designationIT"] !== undefined ? _data["designationIT"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
        }
    }

    static fromJS(data: any): AlarmLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["alarmClassification"] = this.alarmClassification !== undefined ? this.alarmClassification : null as any;
        data["appearedDateTime"] = this.appearedDateTime ? this.appearedDateTime.toISOString() : null as any;
        data["alarmState"] = this.alarmState !== undefined ? this.alarmState : null as any;
        data["designationFR"] = this.designationFR !== undefined ? this.designationFR : null as any;
        data["designationDE"] = this.designationDE !== undefined ? this.designationDE : null as any;
        data["designationEN"] = this.designationEN !== undefined ? this.designationEN : null as any;
        data["designationIT"] = this.designationIT !== undefined ? this.designationIT : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        return data;
    }
}

export interface IAlarmLightDto {
    id?: number;
    alarmClassification?: AlarmClassification;
    appearedDateTime?: Date;
    alarmState?: AlarmState;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    location?: string;
}

export class PageableRequestDtoOfAlarmSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlarmSearchCriteriaDto {
    criteria?: AlarmSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlarmSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlarmSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlarmSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlarmSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlarmSearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlarmSearchCriteriaDto | null;
}

export class AlarmSearchCriteriaDto implements IAlarmSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    from?: Date | null;
    to?: Date | null;
    designation?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    states?: AlarmState[] | null;

    constructor(data?: IAlarmSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.designation = _data["designation"] !== undefined ? _data["designation"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(item);
            }
            else {
                this.states = null as any;
            }
        }
    }

    static fromJS(data: any): AlarmSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["designation"] = this.designation !== undefined ? this.designation : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item);
        }
        return data;
    }
}

export interface IAlarmSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    from?: Date | null;
    to?: Date | null;
    designation?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    states?: AlarmState[] | null;
}

export class PagedResultDtoOfAlarmHistoryLightDto implements IPagedResultDtoOfAlarmHistoryLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmHistoryLightDto[];

    constructor(data?: IPagedResultDtoOfAlarmHistoryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlarmHistoryLightDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlarmHistoryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlarmHistoryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlarmHistoryLightDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmHistoryLightDto[];
}

export class AlarmHistoryLightDto implements IAlarmHistoryLightDto {
    id?: number;
    appearedDateTime?: Date;
    inProgressDateTime?: Date | null;
    releasedDateTime?: Date | null;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    equipmentFR?: string;
    equipmentDE?: string;
    equipmentEN?: string;
    equipmentIT?: string;
    releasedBackoffice?: string;

    constructor(data?: IAlarmHistoryLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.appearedDateTime = _data["appearedDateTime"] ? new Date(_data["appearedDateTime"].toString()) : null as any;
            this.inProgressDateTime = _data["inProgressDateTime"] ? new Date(_data["inProgressDateTime"].toString()) : null as any;
            this.releasedDateTime = _data["releasedDateTime"] ? new Date(_data["releasedDateTime"].toString()) : null as any;
            this.designationFR = _data["designationFR"] !== undefined ? _data["designationFR"] : null as any;
            this.designationDE = _data["designationDE"] !== undefined ? _data["designationDE"] : null as any;
            this.designationEN = _data["designationEN"] !== undefined ? _data["designationEN"] : null as any;
            this.designationIT = _data["designationIT"] !== undefined ? _data["designationIT"] : null as any;
            this.equipmentFR = _data["equipmentFR"] !== undefined ? _data["equipmentFR"] : null as any;
            this.equipmentDE = _data["equipmentDE"] !== undefined ? _data["equipmentDE"] : null as any;
            this.equipmentEN = _data["equipmentEN"] !== undefined ? _data["equipmentEN"] : null as any;
            this.equipmentIT = _data["equipmentIT"] !== undefined ? _data["equipmentIT"] : null as any;
            this.releasedBackoffice = _data["releasedBackoffice"] !== undefined ? _data["releasedBackoffice"] : null as any;
        }
    }

    static fromJS(data: any): AlarmHistoryLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmHistoryLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["appearedDateTime"] = this.appearedDateTime ? this.appearedDateTime.toISOString() : null as any;
        data["inProgressDateTime"] = this.inProgressDateTime ? this.inProgressDateTime.toISOString() : null as any;
        data["releasedDateTime"] = this.releasedDateTime ? this.releasedDateTime.toISOString() : null as any;
        data["designationFR"] = this.designationFR !== undefined ? this.designationFR : null as any;
        data["designationDE"] = this.designationDE !== undefined ? this.designationDE : null as any;
        data["designationEN"] = this.designationEN !== undefined ? this.designationEN : null as any;
        data["designationIT"] = this.designationIT !== undefined ? this.designationIT : null as any;
        data["equipmentFR"] = this.equipmentFR !== undefined ? this.equipmentFR : null as any;
        data["equipmentDE"] = this.equipmentDE !== undefined ? this.equipmentDE : null as any;
        data["equipmentEN"] = this.equipmentEN !== undefined ? this.equipmentEN : null as any;
        data["equipmentIT"] = this.equipmentIT !== undefined ? this.equipmentIT : null as any;
        data["releasedBackoffice"] = this.releasedBackoffice !== undefined ? this.releasedBackoffice : null as any;
        return data;
    }
}

export interface IAlarmHistoryLightDto {
    id?: number;
    appearedDateTime?: Date;
    inProgressDateTime?: Date | null;
    releasedDateTime?: Date | null;
    designationFR?: string;
    designationDE?: string;
    designationEN?: string;
    designationIT?: string;
    equipmentFR?: string;
    equipmentDE?: string;
    equipmentEN?: string;
    equipmentIT?: string;
    releasedBackoffice?: string;
}

export class PageableRequestDtoOfAlarmHistorySearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlarmHistorySearchCriteriaDto {
    criteria?: AlarmHistorySearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlarmHistorySearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlarmHistorySearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlarmHistorySearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlarmHistorySearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlarmHistorySearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlarmHistorySearchCriteriaDto | null;
}

export class AlarmHistorySearchCriteriaDto implements IAlarmHistorySearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    releasedBackofficeId?: string | null;
    appearedFrom?: Date | null;
    appearedTo?: Date | null;
    inProgressFrom?: Date | null;
    inProgressTo?: Date | null;
    releasedFrom?: Date | null;
    releasedTo?: Date | null;

    constructor(data?: IAlarmHistorySearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.releasedBackofficeId = _data["releasedBackofficeId"] !== undefined ? _data["releasedBackofficeId"] : null as any;
            this.appearedFrom = _data["appearedFrom"] ? new Date(_data["appearedFrom"].toString()) : null as any;
            this.appearedTo = _data["appearedTo"] ? new Date(_data["appearedTo"].toString()) : null as any;
            this.inProgressFrom = _data["inProgressFrom"] ? new Date(_data["inProgressFrom"].toString()) : null as any;
            this.inProgressTo = _data["inProgressTo"] ? new Date(_data["inProgressTo"].toString()) : null as any;
            this.releasedFrom = _data["releasedFrom"] ? new Date(_data["releasedFrom"].toString()) : null as any;
            this.releasedTo = _data["releasedTo"] ? new Date(_data["releasedTo"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AlarmHistorySearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmHistorySearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["releasedBackofficeId"] = this.releasedBackofficeId !== undefined ? this.releasedBackofficeId : null as any;
        data["appearedFrom"] = this.appearedFrom ? this.appearedFrom.toISOString() : null as any;
        data["appearedTo"] = this.appearedTo ? this.appearedTo.toISOString() : null as any;
        data["inProgressFrom"] = this.inProgressFrom ? this.inProgressFrom.toISOString() : null as any;
        data["inProgressTo"] = this.inProgressTo ? this.inProgressTo.toISOString() : null as any;
        data["releasedFrom"] = this.releasedFrom ? this.releasedFrom.toISOString() : null as any;
        data["releasedTo"] = this.releasedTo ? this.releasedTo.toISOString() : null as any;
        return data;
    }
}

export interface IAlarmHistorySearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    language?: string | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    releasedBackofficeId?: string | null;
    appearedFrom?: Date | null;
    appearedTo?: Date | null;
    inProgressFrom?: Date | null;
    inProgressTo?: Date | null;
    releasedFrom?: Date | null;
    releasedTo?: Date | null;
}

export class PagedResultDtoOfAlarmDeviceDto implements IPagedResultDtoOfAlarmDeviceDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmDeviceDto[];

    constructor(data?: IPagedResultDtoOfAlarmDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AlarmDeviceDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAlarmDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAlarmDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfAlarmDeviceDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: AlarmDeviceDto[];
}

export class PageableRequestDtoOfAlarmDeviceSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfAlarmDeviceSearchCriteriaDto {
    criteria?: AlarmDeviceSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfAlarmDeviceSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? AlarmDeviceSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfAlarmDeviceSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfAlarmDeviceSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfAlarmDeviceSearchCriteriaDto extends IPageableRequestDto {
    criteria?: AlarmDeviceSearchCriteriaDto | null;
}

export class AlarmDeviceSearchCriteriaDto implements IAlarmDeviceSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    active?: boolean | null;

    constructor(data?: IAlarmDeviceSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCriteriaDto = _data["sortCriteriaDto"] ? SortCriteriaDto.fromJS(_data["sortCriteriaDto"]) : null as any;
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
        }
    }

    static fromJS(data: any): AlarmDeviceSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDeviceSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCriteriaDto"] = this.sortCriteriaDto ? this.sortCriteriaDto.toJSON() : null as any;
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        return data;
    }
}

export interface IAlarmDeviceSearchCriteriaDto {
    sortCriteriaDto?: SortCriteriaDto | null;
    iotRegisterId?: string | null;
    measuringPointId?: string | null;
    location?: string | null;
    classification?: AlarmClassification | null;
    active?: boolean | null;
}

export class AlarmDeviceInputDto implements IAlarmDeviceInputDto {
    iotRegisterId?: string;
    classification?: AlarmClassification;
    location?: string;
    comment?: string;
    active?: boolean;
    delayBetweenNotificationsInMinutes?: number;
    notificationLoop?: boolean;

    constructor(data?: IAlarmDeviceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iotRegisterId = _data["iotRegisterId"] !== undefined ? _data["iotRegisterId"] : null as any;
            this.classification = _data["classification"] !== undefined ? _data["classification"] : null as any;
            this.location = _data["location"] !== undefined ? _data["location"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.delayBetweenNotificationsInMinutes = _data["delayBetweenNotificationsInMinutes"] !== undefined ? _data["delayBetweenNotificationsInMinutes"] : null as any;
            this.notificationLoop = _data["notificationLoop"] !== undefined ? _data["notificationLoop"] : null as any;
        }
    }

    static fromJS(data: any): AlarmDeviceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDeviceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iotRegisterId"] = this.iotRegisterId !== undefined ? this.iotRegisterId : null as any;
        data["classification"] = this.classification !== undefined ? this.classification : null as any;
        data["location"] = this.location !== undefined ? this.location : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["delayBetweenNotificationsInMinutes"] = this.delayBetweenNotificationsInMinutes !== undefined ? this.delayBetweenNotificationsInMinutes : null as any;
        data["notificationLoop"] = this.notificationLoop !== undefined ? this.notificationLoop : null as any;
        return data;
    }
}

export interface IAlarmDeviceInputDto {
    iotRegisterId?: string;
    classification?: AlarmClassification;
    location?: string;
    comment?: string;
    active?: boolean;
    delayBetweenNotificationsInMinutes?: number;
    notificationLoop?: boolean;
}

export class PagedResultDtoOfActivationDto implements IPagedResultDtoOfActivationDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: ActivationDto[];

    constructor(data?: IPagedResultDtoOfActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.rowCount = _data["rowCount"] !== undefined ? _data["rowCount"] : null as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ActivationDto.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["rowCount"] = this.rowCount !== undefined ? this.rowCount : null as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPagedResultDtoOfActivationDto {
    currentPage?: number;
    pageCount?: number;
    pageSize?: number;
    rowCount?: number;
    results?: ActivationDto[];
}

export class ActivationDto implements IActivationDto {
    id?: string;
    firstActivationDateTime?: Date;
    endActivationDateTime?: Date | null;
    activationDuration?: string | null;
    activationConsumption?: number | null;
    customer?: string;
    measuringPointNameFR?: string;
    measuringPointNameDE?: string;
    measuringPointNameIT?: string;
    measuringPointNameEN?: string;

    constructor(data?: IActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstActivationDateTime = _data["firstActivationDateTime"] ? new Date(_data["firstActivationDateTime"].toString()) : null as any;
            this.endActivationDateTime = _data["endActivationDateTime"] ? new Date(_data["endActivationDateTime"].toString()) : null as any;
            this.activationDuration = _data["activationDuration"] !== undefined ? _data["activationDuration"] : null as any;
            this.activationConsumption = _data["activationConsumption"] !== undefined ? _data["activationConsumption"] : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.measuringPointNameFR = _data["measuringPointNameFR"] !== undefined ? _data["measuringPointNameFR"] : null as any;
            this.measuringPointNameDE = _data["measuringPointNameDE"] !== undefined ? _data["measuringPointNameDE"] : null as any;
            this.measuringPointNameIT = _data["measuringPointNameIT"] !== undefined ? _data["measuringPointNameIT"] : null as any;
            this.measuringPointNameEN = _data["measuringPointNameEN"] !== undefined ? _data["measuringPointNameEN"] : null as any;
        }
    }

    static fromJS(data: any): ActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstActivationDateTime"] = this.firstActivationDateTime ? this.firstActivationDateTime.toISOString() : null as any;
        data["endActivationDateTime"] = this.endActivationDateTime ? this.endActivationDateTime.toISOString() : null as any;
        data["activationDuration"] = this.activationDuration !== undefined ? this.activationDuration : null as any;
        data["activationConsumption"] = this.activationConsumption !== undefined ? this.activationConsumption : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["measuringPointNameFR"] = this.measuringPointNameFR !== undefined ? this.measuringPointNameFR : null as any;
        data["measuringPointNameDE"] = this.measuringPointNameDE !== undefined ? this.measuringPointNameDE : null as any;
        data["measuringPointNameIT"] = this.measuringPointNameIT !== undefined ? this.measuringPointNameIT : null as any;
        data["measuringPointNameEN"] = this.measuringPointNameEN !== undefined ? this.measuringPointNameEN : null as any;
        return data;
    }
}

export interface IActivationDto {
    id?: string;
    firstActivationDateTime?: Date;
    endActivationDateTime?: Date | null;
    activationDuration?: string | null;
    activationConsumption?: number | null;
    customer?: string;
    measuringPointNameFR?: string;
    measuringPointNameDE?: string;
    measuringPointNameIT?: string;
    measuringPointNameEN?: string;
}

export class PageableRequestDtoOfActivationSearchCriteriaDto extends PageableRequestDto implements IPageableRequestDtoOfActivationSearchCriteriaDto {
    criteria?: ActivationSearchCriteriaDto | null;

    constructor(data?: IPageableRequestDtoOfActivationSearchCriteriaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.criteria = _data["criteria"] ? ActivationSearchCriteriaDto.fromJS(_data["criteria"]) : null as any;
        }
    }

    static override fromJS(data: any): PageableRequestDtoOfActivationSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableRequestDtoOfActivationSearchCriteriaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteria"] = this.criteria ? this.criteria.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPageableRequestDtoOfActivationSearchCriteriaDto extends IPageableRequestDto {
    criteria?: ActivationSearchCriteriaDto | null;
}

export class ActivationSearchCriteriaDto implements IActivationSearchCriteriaDto {
    from?: Date | null;
    to?: Date | null;
    serviceId?: string;
    measuringPointId?: string | null;
    customerId?: string | null;
    active?: boolean | null;
    sortCriteria?: SortCriteriaDto | null;

    constructor(data?: IActivationSearchCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
            this.measuringPointId = _data["measuringPointId"] !== undefined ? _data["measuringPointId"] : null as any;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.sortCriteria = _data["sortCriteria"] ? SortCriteriaDto.fromJS(_data["sortCriteria"]) : null as any;
        }
    }

    static fromJS(data: any): ActivationSearchCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationSearchCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        data["measuringPointId"] = this.measuringPointId !== undefined ? this.measuringPointId : null as any;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["sortCriteria"] = this.sortCriteria ? this.sortCriteria.toJSON() : null as any;
        return data;
    }
}

export interface IActivationSearchCriteriaDto {
    from?: Date | null;
    to?: Date | null;
    serviceId?: string;
    measuringPointId?: string | null;
    customerId?: string | null;
    active?: boolean | null;
    sortCriteria?: SortCriteriaDto | null;
}

export class MorpheanDoorGroupDto implements IMorpheanDoorGroupDto {
    doorGroupId!: number;
    name?: string;
    serviceId?: string | null;

    constructor(data?: IMorpheanDoorGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doorGroupId = _data["doorGroupId"] !== undefined ? _data["doorGroupId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.serviceId = _data["serviceId"] !== undefined ? _data["serviceId"] : null as any;
        }
    }

    static fromJS(data: any): MorpheanDoorGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MorpheanDoorGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doorGroupId"] = this.doorGroupId !== undefined ? this.doorGroupId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["serviceId"] = this.serviceId !== undefined ? this.serviceId : null as any;
        return data;
    }
}

export interface IMorpheanDoorGroupDto {
    doorGroupId: number;
    name?: string;
    serviceId?: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}